<template lang="html">
  <div>
    <p><strong>CONTRATO MARCO PARA LA PRESTACI&Oacute;N DE SERVICIOS DE TELECOMUNICACIONES </strong>de fecha 7 de diciembre de 2021 (el &ldquo;<strong>Contrato</strong>&rdquo;) que celebran <strong>ALT&Aacute;N REDES, S.A.P.I. DE C.V. </strong>(en lo sucesivo &ldquo;<strong>Alt&aacute;n</strong>&rdquo;) representada en este acto por Gabriel Cejudo Funes, y ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V (en&nbsp;&nbsp;&nbsp; lo sucesivo el &ldquo;<strong>Cliente</strong>&rdquo;), representada en este acto por Miguel Adri&aacute;n &Aacute;lvarez Manzo, cada una de ellas designada individualmente como una&nbsp; &ldquo;<strong>Parte</strong>&rdquo;&nbsp; o&nbsp; colectivamente como las &ldquo;<strong>Partes</strong>&rdquo;, conforme a lo establecido en los siguientes Fundamentos, Declaraciones y Cl&aacute;usulas:</p>
<p>&nbsp;</p>
<h4><u>FUNDAMENTOS</u></h4>
<ol>
<li>El 11 de junio de 2013, se public&oacute; en el Diario Oficial de la Federaci&oacute;n (&ldquo;<strong>DOF</strong>&rdquo;) el &ldquo;Decreto por el que se reforman y adicionan diversas disposiciones de los Art&iacute;culos 6, 7, 27, 28, 73, 78, 94 y 105 de la Constituci&oacute;n Pol&iacute;tica de los Estados Unidos Mexicanos, en materia de telecomunicaciones&rdquo;, en cuyo Art&iacute;culo D&eacute;cimo Sexto Transitorio se establece que el Estado garantizar&aacute; la instalaci&oacute;n de una red p&uacute;blica compartida de telecomunicaciones que impulse el acceso efectivo de la poblaci&oacute;n a la comunicaci&oacute;n de banda ancha y a los servicios de telecomunicaciones a trav&eacute;s del aprovechamiento de al menos 90 MHz del espectro liberado por la transici&oacute;n a la televisi&oacute;n digital terrestre (banda 700 MHz) y de los recursos de la red troncal de fibra &oacute;ptica (&ldquo;<strong>Red Compartida</strong>&rdquo;).</li>
</ol>
<p>&nbsp;</p>
<ol start="2">
<li>El 24 de enero de 2017, Alt&aacute;n celebr&oacute; el Contrato de Asociaci&oacute;n P&uacute;blico-Privada (el &ldquo;<strong>Contrato de APP</strong>&rdquo;) con el Organismo Promotor de Inversiones en Telecomunicaciones (&ldquo;<strong>PROMTEL</strong>&rdquo;) y con Telecomunicaciones de M&eacute;xico (&ldquo;<strong>TELECOMM</strong>&rdquo;) para establecer el esquema, los t&eacute;rminos y las condiciones de la asociaci&oacute;n p&uacute;blico-privada bajo las cuales Alt&aacute;n deber&aacute; dise&ntilde;ar, instalar, desplegar, operar, mantener y actualizar la Red Compartida y comercializar el servicio mayorista de telecomunicaciones a trav&eacute;s de la misma.</li>
</ol>
<p>&nbsp;</p>
<ol start="3">
<li>El 24 de enero de 2017, el Instituto Federal de Telecomunicaciones (en lo sucesivo &ldquo;<strong>IFT</strong>&rdquo;) otorg&oacute; a Alt&aacute;n una Concesi&oacute;n para el Uso Comercial de la Red Compartida, habilitando a Alt&aacute;n a comercializar capacidad, infraestructura y/o servicios de telecomunicaciones al mayoreo a Concesionarios o Comercializadoras para que estos &uacute;ltimos a su vez provean servicios de telecomunicaciones a sus Usuarios Finales o a otros Concesionarios o Comercializadoras (en adelante la &ldquo;<strong>Concesi&oacute;n de Alt&aacute;n</strong>&rdquo;).</li>
</ol>
<p>&nbsp;</p>
<ol start="4">
<li>Al amparo del principio de libertad tarifaria establecido en el art&iacute;culo 204 de la LFTR y la Cl&aacute;usula 15 del Contrato de APP, las Tarifas de los Servicios ser&aacute;n acordadas libremente entre Alt&aacute;n y sus clientes, siempre y cuando sea en forma no discriminatoria.</li>
</ol>
<p>&nbsp;</p>
<ol start="5">
<li>De conformidad con la Condici&oacute;n 12 de la Concesi&oacute;n de Alt&aacute;n, Alt&aacute;n est&aacute; obligada a presentar al IFT para su aprobaci&oacute;n y registro la oferta de referencia de servicios mayoristas de telecomunicaciones, funciones e infraestructura sobre bases de transparencia y no discriminaci&oacute;n, en los t&eacute;rminos ah&iacute; establecidos (en lo sucesivo la &ldquo;<strong>Oferta de Referencia</strong>&rdquo;).</li>
</ol>
<p>&nbsp;</p>
<ol start="6">
<li>De acuerdo con el &uacute;ltimo p&aacute;rrafo de la Condici&oacute;n 12 de la Concesi&oacute;n de Alt&aacute;n, Alt&aacute;n presentar&aacute; al IFT los contratos y/o convenios suscritos con sus clientes para la prestaci&oacute;n de los Servicios, en un plazo de 30 (treinta) D&iacute;as H&aacute;biles posteriores a su formalizaci&oacute;n, para su inscripci&oacute;n en el Registro P&uacute;blico de Concesiones. Para prop&oacute;sitos de esta inscripci&oacute;n, se considerar&aacute;n como confidenciales las Tarifas y/o condiciones t&eacute;cnicas o comerciales que sean identificados por Alt&aacute;n y sus clientes con tal car&aacute;cter, con el fin de preservar la posici&oacute;n competitiva de sus clientes.</li>
</ol>
<ol start="7">
<li>En la medida en que Alt&aacute;n firme contratos o convenios con nuevas Tarifas y/o condiciones con otros clientes, Alt&aacute;n habilitar&aacute; la Plataforma Web de Tarifas con acceso seguro para sus clientes y el IFT en donde adicionar&aacute; cada actualizaci&oacute;n de las condiciones y/o Tarifas y las har&aacute; disponibles a todos sus clientes que tengan contratados los mismos Servicios, de forma inmediata bajo el principio de no discriminaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol start="8">
<li>Adicionalmente, Alt&aacute;n har&aacute; disponible al IFT la versi&oacute;n &iacute;ntegra de todos los contratos y/o convenios que firme para la prestaci&oacute;n de servicios mayoristas de telecomunicaciones, as&iacute; como sus modificaciones, para que el IFT pueda verificar en todo momento el cumplimiento de las obligaciones de no discriminaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<h4><u>DECLARACIONES</u></h4>
<p><strong>&nbsp;</strong></p>
<p>
  Declara Alt&aacute;n, por conducto de su representante legal, que:
</p>
<p>&nbsp;</p>
<ol>
<li>Es una sociedad mercantil constituida y existente conforme a las leyes de M&eacute;xico seg&uacute;n consta en escritura p&uacute;blica n&uacute;mero 54,710, de fecha 5 de diciembre de 2016 otorgada ante la fe del licenciado Marco Antonio Espinoza Rommyngth, titular de la notar&iacute;a p&uacute;blica n&uacute;mero 97 de la Ciudad de M&eacute;xico, cuyo primer testimonio se encuentra inscrito en el Registro P&uacute;blico de Comercio de dicha entidad bajo el folio mercantil N-2016039232.</li>
<li>Su apoderado cuenta con poderes y facultades suficientes para representarlo y obligarlo en t&eacute;rminos de este Contrato, y dichos poderes y facultades no le han sido suspendidos, revocados o limitados en forma alguna a la fecha de firma del presente</li>
<li>Se encuentra debidamente inscrita ante la Secretar&iacute;a de Hacienda y Cr&eacute;dito P&uacute;blico, en el Registro Federal de Contribuyentes con la clave n&uacute;mero ARE161205BX8.</li>
<li>La celebraci&oacute;n y cumplimiento de este Contrato est&aacute;n permitidas por su objeto social y no derivan ni derivar&aacute;n en violaci&oacute;n a o incumplimiento de (i) cualquier disposici&oacute;n de sus estatutos sociales; (ii) cualquier contrato, convenio, acuerdo, licencia u orden a la cual Alt&aacute;n est&eacute; sujeto o cualquiera de sus activos; o (iii) cualquier Ley Aplicable.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>No se encuentra: (i) sujeto a un procedimiento de quiebra;(ii) en un procedimiento de disoluci&oacute;n o liquidaci&oacute;n; o (iii) en incumplimiento con los t&eacute;rminos y disposiciones contenidos en las Leyes en Materia de Anticorrupci&oacute;n.</li>
<li>Es su voluntad celebrar el presente Contrato con el Cliente para establecer los t&eacute;rminos y condiciones bajo los cuales Alt&aacute;n prestar&aacute; los Servicios al Cliente.</li>
</ol>
<p>Declara el Cliente, por conducto de su representante legal, que:</p>
<p>&nbsp;</p>
<ol>
<li>Es una sociedad mercantil legalmente constituida de acuerdo con la legislaci&oacute;n mexicana, seg&uacute;n se desprende de la escritura p&uacute;blica n&uacute;mero 4,092 de fecha 8 de junio de 2021, otorgada ante la fe de Roberto Auber Zenil, Notario P&uacute;blico n&uacute;mero 36 de Nuevo Le&oacute;n, e inscrita en el Registro P&uacute;blico de Comercio de Monterrey, el 22 de junio de 2021 bajo el folio mercantil electr&oacute;nico n&uacute;mero N-2021043029.</li>
<li>Su apoderado cuenta con poderes y facultades suficientes para representarlo y obligarlo en t&eacute;rminos de este Contrato, y dichos poderes y facultades no le han sido suspendidos, revocados o limitados en forma alguna a la fecha de firma del presente</li>
<li>Se encuentra debidamente inscrita ante la Secretar&iacute;a de Hacienda y Cr&eacute;dito P&uacute;blico, en el Registro Federal de Contribuyentes con la clave n&uacute;mero EMM2106088A5.</li>
<li>La celebraci&oacute;n y cumplimiento de este Contrato est&aacute;n permitidas por su objeto social y no derivan ni derivar&aacute;n en violaci&oacute;n a o incumplimiento de: (i) cualquier disposici&oacute;n de sus estatutos sociales; (ii) cualquier contrato, convenio, acuerdo, licencia, sentencia, resoluci&oacute;n u orden a la cual est&eacute; sujeta o cualquiera de sus activos, o del que este sea parte; o (iii) cualquier Ley Aplicable.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>No se encuentra: (i) en estado de insolvencia o sujeto a un procedimiento de quiebra o concurso mercantil en cualesquiera de sus etapas; (ii) en incumplimiento general de sus obligaciones; (iii) en un procedimiento de disoluci&oacute;n, liquidaci&oacute;n o alg&uacute;n otro de naturaleza an&aacute;loga; o (iv) en incumplimiento con los t&eacute;rminos y disposiciones contenidos en las Leyes en Materia de Anticorrupci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Es su voluntad celebrar el presente Contrato con el objeto de recibir por parte de Alt&aacute;n los Servicios, con el fin de comercializar dichos Servicios a Usuarios Finales o a otros Concesionarios o Comercializadoras, actuando a su riesgo y nombre propio.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Previo a la recepci&oacute;n de los Servicios cumplir&aacute; con todos los requisitos y contar&aacute; con todas las Autorizaciones Gubernamentales necesarias para contratar los Servicios y a su vez prestar servicios de telecomunicaciones a sus Usuarios Finales o a otros Concesionarios o</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Cuenta con la organizaci&oacute;n, experiencia, personal y dem&aacute;s elementos necesarios y apropiados para cumplir con sus obligaciones bajo este Contrato.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Declaran ambas Partes, por conducto de sus representantes legales que:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Es su voluntad obligarse en t&eacute;rminos del presente Contrato con el fin de establecer los t&eacute;rminos y condiciones generales que regir&aacute;n su relaci&oacute;n con respecto a la prestaci&oacute;n de los Servicios por parte de Alt&aacute;n al Cliente con el fin de que el Cliente, actuando a su propio nombre y riesgo, pueda comercializar dichos Servicios a sus Usuarios Finales o a otros Concesionarios o Comercializadoras.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Se reconocen mutuamente la personalidad con la que comparecen a la celebraci&oacute;n del presente</li>
</ol>
<p>&nbsp;</p>
<p>Expuestos los Fundamentos y con base en las Declaraciones anteriores, las Partes convienen en obligarse de conformidad con las siguientes:</p>
<p>&nbsp;</p>
<h4><u>CL&Aacute;USULAS</u></h4>
<p><strong>&nbsp;</strong></p>
<h4>PRIMERA. Anexos y Ap&eacute;ndices; Glosario de T&eacute;rminos; Interpretaci&oacute;n; Orden de Prioridad.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Anexos y Ap&eacute;ndices.</strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<p>El presente Contrato est&aacute; compuesto por los t&eacute;rminos y condiciones establecidos en el cuerpo del mismo, y los siguientes Anexos, incluyendo los Ap&eacute;ndices de dichos Anexos:</p>
<p>&nbsp;</p>
<ul>
<li>Anexo 1 &ldquo;Facturaci&oacute;n y Garant&iacute;as&rdquo;</li>
<li>Anexo 2 &ldquo;Procedimientos Operativos&rdquo;</li>
<li>Anexo 3 &ldquo;Glosario de T&eacute;rminos&rdquo;</li>
<li>Anexo 4 &ldquo;Solicitud de Servicios&rdquo;</li>
<li>Anexo 5 &ldquo;Servicios Movilidad SIM ALT&Aacute;N&rdquo;, no aplicable a la fecha de firma del presente</li>
<li>Anexo 6 &ldquo;Servicios Movilidad SIM CLIENTE&rdquo;, no aplicable a la fecha de firma del presente</li>
<li>Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;
<ul>
<li>Ap&eacute;ndice 1&nbsp;&nbsp;&nbsp; &ldquo;Alcance&nbsp;&nbsp;&nbsp; T&eacute;cnico&nbsp;&nbsp;&nbsp; INTERNET&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; HOGAR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
</ul>
</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Ap&eacute;ndice 7.2 &ldquo;T&eacute;rminos Comerciales y Estructuras Tarifarias INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 7.3 &ldquo;Tarifa INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 7.4 &ldquo;Plan de Proyecto e Implementaci&oacute;n INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 7.5 &ldquo;Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 7.6 &ldquo;Proyecciones INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 7.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
</ul>
<ul>
<li>Anexo 8 &ldquo;Servicios INTERNET HOGAR SIM CLIENTE&rdquo;, no aplicable a la fecha de firma del presente</li>
<li>Anexo 9 &ldquo;Servicios Movilidad SIM ALT&Aacute;N CONTROL CLIENTE&rdquo;, no aplicable a la fecha de firma del presente</li>
<li>Anexo 10 &ldquo;Servicio de Datos Priorizados en Movilidad SIM CLIENTE&rdquo;, no aplicable a la fecha de firma del presente</li>
<li>Anexo 11 &ldquo;Servicios Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo&rdquo;
<ul>
<li>Ap&eacute;ndice 11.1 &ldquo;Alcance T&eacute;cnico Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo&rdquo;</li>
<li>Ap&eacute;ndice 11.2 &ldquo;T&eacute;rminos Comerciales y Estructuras Tarifarias Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo&rdquo;</li>
<li>Ap&eacute;ndice 3 &ldquo;Tarifas Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo&rdquo;</li>
<li>Ap&eacute;ndice 4 &ldquo;Plan de Proyecto e Implementaci&oacute;n Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo&rdquo;</li>
<li>Ap&eacute;ndice 11.5 &ldquo;Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo&rdquo;</li>
<li>Ap&eacute;ndice 11.6 &ldquo;Proyecciones Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo&rdquo;</li>
<li>Ap&eacute;ndice 11.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo&rdquo;</li>
</ul>
</li>
<li>Anexo 12 &ldquo;Servicio de Datos Priorizados en Movilidad SIM ALT&Aacute;N&rdquo;, no aplicable a la fecha de firma del presente</li>
<li>Anexo 13 &ldquo;Servicios INTERNET DE LAS COSAS SIM ALT&Aacute;N&rdquo;, no aplicable a la fecha de firma del presente</li>
<li>Anexo 14 &ldquo;Servicio de Capacidad de Red de Acceso de Radio&rdquo;, no aplicable a la fecha de firma del presente</li>
</ul>
<ul>
<li>Anexo 15 &ldquo;Servicios Conectividad SIM ALT&Aacute;N&rdquo;, no aplicable a la fecha de firma del presente</li>
<li>Anexo 16 &ldquo;Servicios LAN to LAN LTE y Telefon&iacute;a SIM ALT&Aacute;N&rdquo;, no aplicable a la fecha de firma del presente</li>
</ul>
<p>&nbsp;</p>
<h4>1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Glosario de T&eacute;rminos.</h4>
<p><strong>&nbsp;</strong></p>
<p>Salvo que expresamente se indique lo contrario, los t&eacute;rminos con may&uacute;scula inicial aqu&iacute; utilizados, inclusive en el apartado de Fundamentos y Declaraciones, tendr&aacute;n los significados que se les atribuye en el Anexo &ldquo;Glosario de T&eacute;rminos&rdquo;. Las palabras t&eacute;cnicas, abreviaciones y acr&oacute;nimos usados en el presente Contrato, tendr&aacute;n el significado que se les atribuye en la LFTR, y en su defecto, el que se les acostumbre dar en la industria de las telecomunicaciones, salvo que expresamente se definan o se indique de otra manera en el presente Contrato.</p>
<p>&nbsp;</p>
<h4>1.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Interpretaci&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>Los t&eacute;rminos definidos en el Anexo &ldquo;Glosario de T&eacute;rminos&rdquo; ser&aacute;n aplicables, tanto a la forma singular como al plural de dichos t&eacute;rminos. Cuando el contexto as&iacute; lo requiera, cualquier pronombre incluir&aacute; la forma masculina, femenina o neutral correspondiente. Salvo que expresamente se establezca lo contrario, todas las referencias al Proemio, Fundamentos, Declaraciones, Cl&aacute;usulas, Subcl&aacute;usulas, p&aacute;rrafos, incisos, sub-incisos, o numerales de Cl&aacute;usulas, se refieren al Proemio, Fundamentos, Cl&aacute;usulas, Subcl&aacute;usulas, p&aacute;rrafos, incisos, sub-incisos o numerales de este Contrato, y todas las referencias a los Anexos y Ap&eacute;ndices se refieren a Anexos adjuntos e incorporados por referencia al presente Contrato, y los Ap&eacute;ndices que se adjuntan a dichos Anexos. Los encabezados de cada una de las Cl&aacute;usulas de este Contrato son &uacute;nicamente para fines de referencia y no afectar&aacute;n el significado o interpretaci&oacute;n de este Contrato. Se entender&aacute; que las palabras (i) &ldquo;en el presente&rdquo;, &ldquo;del presente&rdquo;, &ldquo;conforme al presente&rdquo;, &ldquo;m&aacute;s adelante en el presente&rdquo; y otras de significado similar hacen referencia a este Contrato en su conjunto y no a alguna Cl&aacute;usula, p&aacute;rrafo, inciso, sub-inciso o numeral en espec&iacute;fico del Contrato, e (ii) &ldquo;incluyen&rdquo;, &ldquo;incluye&rdquo;, &ldquo;incluyendo&rdquo; e &ldquo;inclusive&rdquo; van seguidas de la frase &ldquo;sin limitaci&oacute;n alguna&rdquo;, salvo que se establezca expresamente lo contrario. La referencia a cualquier ley, reglamento o normatividad se entender&aacute; seg&uacute;n la misma sea reformada, o en caso de ser abrogada, a la que la sustituya.</p>
<p>&nbsp;</p>
<h4>1.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Orden de Prioridad.</h4>
<p><strong>&nbsp;</strong></p>
<p>En caso de discrepancia o inconsistencia entre las estipulaciones de cualesquiera de los documentos que forman parte del presente Contrato, tendr&aacute; prioridad y prevalecer&aacute; la estipulaci&oacute;n del documento que tenga mayor orden de prioridad y prevalencia conforme a lo siguiente:</p>
<p>&nbsp;</p>
<ul>
<li>Los t&eacute;rminos y condiciones del cuerpo del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los t&eacute;rminos y condiciones de los Anexos, prevaleciendo las estipulaciones de los Anexos de Servicios y sus Ap&eacute;ndices sobre las estipulaciones de los Anexos</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los t&eacute;rminos y condiciones de los Ap&eacute;ndices respecto de los Anexos de los que forman parte.</li>
</ul>
<p>&nbsp;</p>
<p>Lo anterior en el entendido de que una disposici&oacute;n de un documento con una menor prioridad podr&aacute; tener prioridad y prevalecer&aacute; sobre los t&eacute;rminos y condiciones del que conforme a lo anterior debe prevalecer si dicha disposici&oacute;n expresamente establece que debe prevalecer sobre los t&eacute;rminos y condiciones de la que tiene mayor orden de prioridad.</p>
<p>&nbsp;</p>
<h4>SEGUNDA. Objeto; Servicios; Servicios Adicionales.</h4>
<p><strong>&nbsp;</strong></p>
<p>El objeto del presente Contrato es establecer los t&eacute;rminos y condiciones conforme a los cuales Alt&aacute;n prestar&aacute; en favor del Cliente los Servicios, a cambio de las contraprestaciones m&aacute;s adelante establecidas, con el fin de que el Cliente, actuando a nombre y riesgo propios, pueda comercializar dichos Servicios a sus Usuarios Finales o a otros Concesionarios o Comercializadoras.</p>
<p>&nbsp;</p>
<h4>2.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Servicios.</h4>
<p><strong>&nbsp;</strong></p>
<p>Los Servicios objeto del presente Contrato, su alcance t&eacute;cnico, t&eacute;rminos comerciales y plan de implementaci&oacute;n se describen y establecen en los Anexos de Servicios y Ap&eacute;ndices correspondientes.</p>
<p>&nbsp;</p>
<h4>2.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Servicios Adicionales.</h4>
<p><strong>&nbsp;</strong></p>
<p>Durante la vigencia del presente Contrato, las Partes podr&aacute;n incorporar Servicios Adicionales mediante la suscripci&oacute;n de los Anexos y Ap&eacute;ndices correspondientes, y a partir de dicho momento dichos Servicios Adicionales estar&aacute;n sujetos a los t&eacute;rminos y condiciones del presente Contrato. Alt&aacute;n presentar&aacute; al IFT los Anexos y Ap&eacute;ndices suscritos con el Cliente conforme a esta Cl&aacute;usula 2.3, en un plazo de 30 (treinta) D&iacute;as H&aacute;biles posteriores a su formalizaci&oacute;n, para su inscripci&oacute;n en el Registro P&uacute;blico de Concesiones.</p>
<p>&nbsp;</p>
<h4>2.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Procedimientos Operativos.</h4>
<p><strong>&nbsp;</strong></p>
<p>El Anexo &ldquo;Procedimientos Operativos&rdquo; establece el modelo de gobierno y operativo conforme al cual las Partes gestionar&aacute;n y administrar&aacute;n su relaci&oacute;n bajo el presente Contrato y la ejecuci&oacute;n de los Servicios.</p>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n se obliga, y el Cliente reconoce y acepta, que no obstante cualquier estipulaci&oacute;n en contrario de este Contrato, Alt&aacute;n prestar&aacute; los Servicios en los t&eacute;rminos y condiciones que le impone la Ley Aplicable, incluyendo el Contrato de APP, la Concesi&oacute;n de Alt&aacute;n y la Oferta de</li>
</ul>
<p>&nbsp;</p>
<h4>2.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Calidad y Acuerdos de Nivel de Servicio.</h4>
<p><strong>&nbsp;</strong></p>
<p>Las especificaciones de calidad de los Servicios, incluyendo los Acuerdos de Nivel de Servicio, se establecen en los propios Anexos de Servicios y sus Ap&eacute;ndices. Sin perjuicio de lo anterior, el Cliente reconoce y acepta que los Servicios pueden verse afectados o sufrir interrupciones, interferencia, corte o suspensi&oacute;n por diversas razones fuera del control de Alt&aacute;n y que no significan un incumplimiento del presente Contrato o del Acuerdo de Nivel de Servicio correspondiente por parte de Alt&aacute;n, tales como fen&oacute;menos atmosf&eacute;ricos, uso de equipos terminales en el interior de inmuebles, subterr&aacute;neos, t&uacute;neles u otros lugares con similares caracter&iacute;sticas donde no existe se&ntilde;al o &eacute;sta es d&eacute;bil, y cualquier otra circunstancia que afecte las transmisiones inal&aacute;mbricas. No obstante lo anterior, Alt&aacute;n prestar&aacute; los Servicios conforme a los Acuerdos de Nivel de Servicios establecidos en los Ap&eacute;ndices de &ldquo;Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias&rdquo; del Anexo de Servicios correspondiente de este Contrato.</p>
<p>&nbsp;</p>
<h4>2.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Monitoreo, Supervisi&oacute;n y Revisi&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El Cliente reconoce y acepta que Alt&aacute;n podr&aacute; monitorear o supervisar el uso que el Cliente le d&eacute; o permita que se le d&eacute; a los Servicios, debiendo el Cliente abstenerse de realizar cualquier acci&oacute;n que impida dicho monitoreo o supervisi&oacute;n; en el entendido de que Alt&aacute;n no acceder&aacute; a la informaci&oacute;n enviada a trav&eacute;s de los Servicios de manera ilegal y no violar&aacute; los derechos de privacidad de las comunicaciones de los Usuarios El monitoreo o supervisi&oacute;n que realice Alt&aacute;n podr&aacute; consistir en revisiones de patrones de tr&aacute;fico cursado por el Cliente y/o sus Usuarios Finales en ciertas zonas geogr&aacute;ficas, an&aacute;lisis de concentraci&oacute;n de tr&aacute;fico en puntos espec&iacute;ficos de la Red Compartida, supervisi&oacute;n de los modelos de equipos terminales usados en la Red Compartida, entre otros m&eacute;todos empleados en la industria de las telecomunicaciones, con el prop&oacute;sito de comprobar que el uso que se le d&eacute; a los Servicios sea el autorizado en t&eacute;rminos de este Contrato, para medir el consumo de los Servicios y calcular la facturaci&oacute;n de los mismos, as&iacute; como para planear la gesti&oacute;n de la Red Compartida, entre otros. El monitoreo o la supervisi&oacute;n por parte de Alt&aacute;n o la ausencia de &eacute;stos no limita o condiciona de manera alguna la responsabilidad del Cliente al amparo del presente Contrato.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En adici&oacute;n a lo anterior, Alt&aacute;n se reserva el derecho a revisar el cumplimiento de cualquiera de las obligaciones del Cliente frente a Alt&aacute;n</li>
</ul>
<p>&nbsp;</p>
<p>bajo este Contrato, para lo cual podr&aacute; realizar solicitudes de informaci&oacute;n al Cliente, pero no podr&aacute; llevar a cabo visitas a sus instalaciones. Este derecho de revisi&oacute;n no afecta y no sustituye, de manera alguna, las facultades de revisi&oacute;n, inspecci&oacute;n o supervisi&oacute;n de cualquier Autoridad Gubernamental respecto el cumplimiento de las Leyes Aplicables por cualquiera de las Partes.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n deber&aacute; dar aviso al Cliente de cualquier solicitud de informaci&oacute;n para realizar una revisi&oacute;n, por lo menos 10 (diez) D&iacute;as H&aacute;biles de anticipaci&oacute;n a la fecha en la que el Cliente deba entregar la informaci&oacute;n solicitada para que Alt&aacute;n pueda realizar la revisi&oacute;n de que se trate, indicando la o las obligaciones del Cliente cuyo cumplimiento ser&aacute; objeto de revisi&oacute;n. El Cliente deber&aacute; proporcionar a Alt&aacute;n (y a las personas que &eacute;ste designe) toda la informaci&oacute;n requerida para comprobar el cumplimiento de sus obligaciones bajo este Contrato frente Alt&aacute;n y, en su caso, deber&aacute; subsanar cualquier incumplimiento que haya sido detectado durante la revisi&oacute;n, conforme a lo previsto en este Contrato.</p>
<p>&nbsp;</p>
<ul>
<li>El Cliente podr&aacute; realizar a Alt&aacute;n solicitudes de informaci&oacute;n relacionadas con el presente Contrato a trav&eacute;s del Responsable Comercial, conforme a lo establecido en la Cl&aacute;usula 3.1.2 del Anexo 2 &ldquo;Procedimientos Operativos&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<h4>TERCERA. Uso de la Red Compartida, Hardware; Software.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Alt&aacute;n es responsable de la instalaci&oacute;n, operaci&oacute;n y mantenimiento de su equipo, hardware y software que forme parte del alcance de los Servicios (seg&uacute;n se establezca en los Anexos de Servicios correspondientes) y de la Red Por su parte, el Cliente es responsable por la instalaci&oacute;n, operaci&oacute;n y mantenimiento del equipo, hardware y software que no sea proporcionado por Alt&aacute;n para la prestaci&oacute;n de los Servicios.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente ser&aacute; responsable por la selecci&oacute;n, uso y compatibilidad del equipo, hardware y software que no sea proporcionado por Alt&aacute;n como parte de los Servicios. Si dicho equipo, hardware o software impide o pudiera impedir el uso de los Servicios por parte del Cliente, causar un peligro, interferencia u obstrucci&oacute;n de servicios, Alt&aacute;n se lo notificar&aacute; al Cliente a trav&eacute;s de los canales se&ntilde;alados en el Anexo de &ldquo;Procedimientos Operativos&rdquo; y conforme al Anexo de Servicios correspondiente, quien deber&aacute; eliminar dicho peligro, interferencia u obstrucci&oacute;n inmediatamente y en ning&uacute;n caso en m&aacute;s de 48 (cuarenta y ocho)</li>
</ul>
<p>&nbsp;</p>
<p><strong>3.3.&nbsp;&nbsp;&nbsp; </strong>Cualquier equipo terminal proporcionado por el Cliente, antes de ser utilizado en la Red Compartida o cualquier Infraestructura de Alt&aacute;n o utilizado para la prestaci&oacute;n o interfaz de los Servicios, deber&aacute; ser homologado conforme a los</p>
<p>&nbsp;</p>
<p>requerimientos establecidos en las Leyes Aplicables y el Cliente deber&aacute; entregar copia del certificado correspondiente a Alt&aacute;n a trav&eacute;s de los canales se&ntilde;alados en el Anexo de &ldquo;Procedimientos Operativos&rdquo; y conforme al Anexo de Servicios correspondiente.</p>
<p>&nbsp;</p>
<ul>
<li>Si como parte de los Servicios, Alt&aacute;n proporciona equipo, hardware o software, Alt&aacute;n se asegurar&aacute; que dicho equipo, hardware y software sea seguro, durable y compatible para su conexi&oacute;n y uso en la Red Compartida y dem&aacute;s Infraestructura de Alt&aacute;n correspondiente. El Cliente se obliga a usar el equipo, hardware y software de Alt&aacute;n &uacute;nica y exclusivamente para los fines de este</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente conviene en apoyar a Alt&aacute;n en salvaguardar la Red Compartida y dem&aacute;s Infraestructura de Alt&aacute;n. Sin perjuicio de la generalidad del enunciado anterior, el Cliente conviene en dar acceso razonable a Alt&aacute;n (y a las personas que &eacute;ste designe) a sus instalaciones para que Alt&aacute;n, sujeto a los t&eacute;rminos y condiciones establecidos en el Anexo &ldquo;Procedimientos Operativos&rdquo;, pueda realizar la atenci&oacute;n de cualquier falla o el remplazo de cualquier equipo de Alt&aacute;n ubicado en las instalaciones del Asimismo, el Cliente conviene en seguir las instrucciones y direcciones razonables de Alt&aacute;n al interconectar o instalar cualquier equipo, hardware o software a la Red Compartida o Infraestructura de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n es responsable por la operaci&oacute;n segura y actualizaci&oacute;n de la Red Compartida de tal forma que no ponga en peligro la seguridad o salud del Cliente y su personal y contratistas, as&iacute; como la integridad del equipo, hardware y software del Cliente en la medida en que el Cliente cumpla con sus obligaciones y responsabilidades bajo el presente</li>
</ul>
<p>&nbsp;</p>
<h4>CUARTA. Estructuras Tarifarias; Tarifas; Medici&oacute;n; Penalidades; Facturaci&oacute;n; Garant&iacute;as.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Como contraprestaci&oacute;n de los Servicios, el Cliente pagar&aacute; a Alt&aacute;n las Tarifas que se aplican a las Estructuras Tarifarias se&ntilde;aladas en el Anexo de Servicios correspondiente.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La medici&oacute;n de los Servicios se llevar&aacute; a cabo de conformidad con el Anexo de Servicios correspondiente.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Partes se obligan a pagar las penalidades que por incumplimiento en sus respectivas obligaciones se establezcan en los Anexos de Servicios correspondientes.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La facturaci&oacute;n de los Servicios y cualquier otro concepto pagadero a Alt&aacute;n bajo este Contrato se llevar&aacute; a cabo de conformidad con el Anexo &ldquo;Facturaci&oacute;n y Garant&iacute;as&rdquo; y el Anexo de Servicios</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Para garantizar el cumplimiento de sus obligaciones al amparo del presente Contrato, el Cliente se obliga a otorgar y mantener las garant&iacute;as que se indican en el Anexo &ldquo;Facturaci&oacute;n y Garant&iacute;as&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<h4>QUINTA. Seguros.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Cada una de las Partes se obliga a contratar y mantener vigente durante la duraci&oacute;n del presente Contrato un seguro de responsabilidad civil que incluya da&ntilde;os a terceros que cubra los riesgos de la instalaci&oacute;n, operaci&oacute;n y aprovechamiento de servicios de</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Para el cumplimiento de la obligaci&oacute;n establecida en la Cl&aacute;usula anterior, el Cliente podr&aacute; utilizar una p&oacute;liza de seguro corporativa, cuya cobertura espec&iacute;fica deber&aacute; ser aceptable a plena satisfacci&oacute;n de Alt&aacute;n. A efecto de que Alt&aacute;n pueda determinar si la p&oacute;liza antes mencionada es o no aceptable, el Cliente deber&aacute; proporcionar a Alt&aacute;n una copia de la totalidad del texto de la p&oacute;liza de seguro respectiva.</li>
</ul>
<p>&nbsp;</p>
<h4>SEXTA. Responsabilidad; Indemnizaci&oacute;n; L&iacute;mites de Responsabilidad.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Responsabilidad de las </strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<p>Cada una de las Partes cumplir&aacute; y responder&aacute; por las obligaciones y responsabilidades, tanto contractuales como extracontractuales, que les correspondan por el ejercicio de sus respectivas actividades y negocios, mismas que en ning&uacute;n caso ser&aacute;n asumidas o atribuibles a la otra Parte como consecuencia de la celebraci&oacute;n y cumplimiento del presente Contrato. Sin limitar la generalidad del enunciado anterior, cada Parte ejecutar&aacute; bajo su propia responsabilidad las obligaciones establecidas en el presente Contrato y las que le sean impuestas por la Ley Aplicable, y cada Parte ser&aacute; responsable del pago de cualesquiera sanciones, liquidaciones, multas y/o penalizaciones que les sean impuestas derivado de lo anterior.</p>
<p>&nbsp;</p>
<h4>6.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Indemnizaci&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>Cada una de las Partes (la &ldquo;<strong>Parte Indemnizante</strong>&rdquo;) indemnizar&aacute;, defender&aacute; y mantendr&aacute; en paz y a salvo a la otra Parte, sus Afiliadas y sus directores, funcionarios, empleados, agentes, contratistas y causahabientes (las &ldquo;<strong>Partes Indemnizadas</strong>&rdquo;) de los da&ntilde;os, p&eacute;rdidas, responsabilidades, multas, penalizaciones y costos relacionados que resulten de reclamaciones, demandas, procedimientos o cualquier acci&oacute;n de cualquier tercero (las &ldquo;<strong>Reclamaciones</strong>&rdquo;) en la medida en que dicha Reclamaci&oacute;n resulte de:</p>
<p>&nbsp;</p>
<ul>
<li>el incumplimiento del presente Contrato por la Parte Indemnizante;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>lesiones o muerte de personas, o da&ntilde;os en propiedad, en la medida que sea causada por la culpa, negligencia o bajo responsabilidad de la Parte Indemnizante;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>actos u omisiones culpables, negligentes o bajo responsabilidad de la Parte Indemnizante;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>en el caso de Alt&aacute;n como Parte Indemnizante, cualquier Reclamaci&oacute;n en el sentido de que los Servicios infringen derechos de Propiedad Industrial de terceros; o</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>en el caso del Cliente como Parte Indemnizante, por el uso inadecuado o ilegal de los Servicios, o por la informaci&oacute;n transmitida por la Red Compartida o la Infraestructura de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<h4>6.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Da&ntilde;os Indirectos y Exclusi&oacute;n de Responsabilidad.</h4>
<p><strong>&nbsp;</strong></p>
<p>Ninguna de las Partes ser&aacute; responsable por da&ntilde;os (i) indirectos, incidentales o consecuenciales, incluyendo da&ntilde;os punitivos, da&ntilde;os por perjuicio a negocios, o por ahorros perdidos, o (ii) que resulten o sean causados por el incumplimiento, culpa o negligencia de la otra Parte Indemnizada.</p>
<p>&nbsp;</p>
<h4>6.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; L&iacute;mite de Responsabilidad.</h4>
<p><strong>&nbsp;</strong></p>
<p>La responsabilidad total, m&aacute;xima y acumulada de una Parte frente a la otra y cualquier tercero bajo el presente Contrato y por actos u omisiones relacionadas con este Contrato estar&aacute; limitada a un monto equivalente al total de contraprestaciones devengadas en favor de Alt&aacute;n conforme a las facturas emitidas bajo este Contrato durante los 3 (tres) meses anteriores a la fecha en que incurra el incidente que d&eacute; lugar a la responsabilidad de una Parte; en el entendido de que si dicha responsabilidad surge durante los primeros 3 (tres) meses de vigencia del presente Contrato, dicho monto ser&aacute; el que razonablemente se espera que se devengue en favor de Alt&aacute;n bajo este Contrato durante dichos 3 (tres) meses de acuerdo con el Plan de Negocios detallado en el Ap&eacute;ndice de Proyecciones del Anexo de Servicios correspondiente y en el formulario de Proyecciones a 12 (doce) meses de cada Servicio.</p>
<p>&nbsp;</p>
<p>No obstante lo establecido en el p&aacute;rrafo anterior, las Partes acuerdan que el l&iacute;mite de responsabilidad no ser&aacute; aplicable en los siguientes supuestos:</p>
<p>&nbsp;</p>
<ol>
<li>Para la responsabilidad del Cliente respecto: (i) del pago de las Tarifas y dem&aacute;s contraprestaciones a favor de Alt&aacute;n, as&iacute; como de los intereses aplicables, que se pudieran generar bajo este Contrato; (ii) de los da&ntilde;os ocasionados a la Red Compartida; y/o (iii) de cualquier uso no autorizado de los Servicios bajo el presente Contrato, incluyendo el uso fraudulento y/o ilegal de los mismos; ni</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Para la responsabilidad de Alt&aacute;n respecto a las penalizaciones a su cargo establecidas en el Ap&eacute;ndice de Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias del Anexo de Servicios correspondiente, en caso de sanciones impuestas por PROFECO o por un tribunal civil competente al Cliente por fallas en los Servicios atribuibles exclusivamente a Alt&aacute;n que afecten a uno o varios Usuarios Finales. Sin embargo, la aplicabilidad y el c&aacute;lculo de dichas penalizaciones estar&aacute;n siempre sujetos a los requerimientos establecidos en el Ap&eacute;ndice antes referido y a las estipulaciones de la Ley</li>
</ol>
<p>&nbsp;</p>
<h4>6.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No obligaciones o responsabilidad de PROMTEL y TELECOMM.</h4>
<p><strong>&nbsp;</strong></p>
<p>Las Partes reconocen y aceptan que las obligaciones derivadas del presente Contrato son exclusivas entre las Partes y de ninguna manera obligaciones a cargo de PROMTEL y/o TELECOMM, por lo que el Cliente reconoce y acepta que no tendr&aacute; acci&oacute;n o recurso alguno en contra de PROMTEL o TELECOMM bajo este Contrato, y estos &uacute;ltimos no tienen o tendr&aacute;n responsabilidad u obligaci&oacute;n alguna bajo el presente Contrato.</p>
<p>&nbsp;</p>
<h4>S&Eacute;PTIMA. Vigencia; Suspensi&oacute;n; Terminaci&oacute;n y Rescisi&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>El presente Contrato tendr&aacute; una vigencia de 3 (tres) a&ntilde;os contados a partir de su fecha de firma, salvo por terminaci&oacute;n anticipada conforme a lo establecido en esta Cl&aacute;usula, y se prorrogar&aacute; autom&aacute;ticamente por periodos sucesivos de 1 (un) a&ntilde;o, a menos que cualquiera de las Partes notifique por escrito su deseo de no prorrogarlo con por lo menos 6 (seis) meses de anticipaci&oacute;n a la fecha de expiraci&oacute;n del plazo inicial de vigencia o de la pr&oacute;rroga vigente, seg&uacute;n sea el caso.</p>
<p>&nbsp;</p>
<p>En caso de que el Cliente decida terminar anticipadamente los Servicios de forma unilateral antes del vencimiento de la vigencia o alguna de sus prorrogas, salvo por el derecho de negarse a alguna pr&oacute;rroga conforme a lo anterior, el Cliente, quedar&aacute; obligado a pagar a Alt&aacute;n una pena convencional igual al consumo pendiente de ser realizado para los Servicios contratados hasta la expiraci&oacute;n de la vigencia de este Contrato o la pr&oacute;rroga vigente, tomando en cuenta para el c&aacute;lculo el consumo medio realizado de cada Servicio durante los 3 (tres) meses de m&aacute;s alto consumo dentro de los 12 (doce) meses anteriores a que surta efectos la terminaci&oacute;n anticipada.</p>
<p>&nbsp;</p>
<ul>
<li>Los Anexos de Servicios y sus Ap&eacute;ndices tendr&aacute;n la vigencia que se establezca en los mismos, y en ausencia de estipulaci&oacute;n al respecto, tendr&aacute;n la vigencia del presente Contrato; en el entendido de que la vigencia de cualquier Anexo de Servicios y sus Ap&eacute;ndices concluir&aacute; al terminar el presente</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La terminaci&oacute;n del presente Contrato o cualquier Anexo de Servicios, cualquiera que sea su causa, de ninguna manera afectar&aacute; la vigencia de aquellas</li>
</ul>
<p>&nbsp;</p>
<p>estipulaciones que por su naturaleza deban subsistir dicha terminaci&oacute;n, incluyendo la obligaci&oacute;n del Cliente de pagar aquellas contraprestaciones en favor de Alt&aacute;n que se hayan devengado de conformidad con el presente Contrato.</p>
<p>&nbsp;</p>
<h4>7.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Suspensi&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>En adici&oacute;n a los eventos y casos en los que los Servicios pueden llegar a suspenderse de conformidad con lo establecido en los Anexos, Alt&aacute;n tendr&aacute; el derecho a suspender total o parcialmente los Servicios en los siguientes casos, previa notificaci&oacute;n al Cliente de la causa que dio origen a la suspensi&oacute;n, a trav&eacute;s de los canales se&ntilde;alados en el Anexo &ldquo;Procedimientos Operativos&rdquo;:</p>
<p>&nbsp;</p>
<ul>
<li>si fuere requerido por orden de Autoridad Gubernamental;</li>
<li>si el uso de los Servicios por parte del Cliente incumple, viola o es contrario a lo establecido en el presente Contrato y/o la Ley Aplicable;</li>
<li>si el uso de los Servicios por parte del Cliente resulta en o presenta una amenaza de ocasionar da&ntilde;o a la Red Compartida o a la Infraestructura de Alt&aacute;n; o</li>
<li>si ocurre un Evento de Incumplimiento del cliente.</li>
</ul>
<p>&nbsp;</p>
<p>En la determinaci&oacute;n de la necesidad de suspender total o parcialmente los Servicios, Alt&aacute;n tomar&aacute; en cuenta, entre otros factores, la gravedad de la causa que dio origen a la suspensi&oacute;n, las afectaciones que pueden causarse a Alt&aacute;n, a la Red Compartida, a la Infraestructura de Alt&aacute;n y a los Usuarios Finales, as&iacute; como las repercusiones que puede tener dicha suspensi&oacute;n. En cualquier caso, Alt&aacute;n deber&aacute; aplicar al Cliente una modalidad de suspensi&oacute;n que sea proporcional al evento o caso que le dio origen y que tenga el menor impacto posible sobre los Usuarios Finales, por lo que si la causa que dio origen a la suspensi&oacute;n est&aacute; relacionada con uno o varios Usuarios Finales identificables y acotada exclusivamente a ellos, Alt&aacute;n podr&aacute; suspender los Servicios &uacute;nicamente para el Usuario Final o los Usuarios Finales involucrados y no para el resto de los Usuarios Finales.</p>
<p>&nbsp;</p>
<p>Una vez remediada o subsanada la causa de suspensi&oacute;n de Servicios, Alt&aacute;n reanudar&aacute; los Servicios tan pronto como le sea posible. En caso de que la suspensi&oacute;n de los Servicios sea consecuencia de alg&uacute;n incumplimiento del Cliente a sus obligaciones conforme a este Contrato, el Cliente tendr&aacute; derecho a subsanar el incumplimiento de que se trate en los plazos y casos establecidos para tales efectos en la Cl&aacute;usula 7.7 de este Contrato.</p>
<p>&nbsp;</p>
<h4>7.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Terminaci&oacute;n Autom&aacute;tica.</h4>
<p><strong>&nbsp;</strong></p>
<p>Este Contrato se dar&aacute; por terminado autom&aacute;ticamente en el momento en que el Contrato de APP y/o la Concesi&oacute;n de Alt&aacute;n se den por terminados, ya sea porque haya concluido su vigencia sin prorrogarse o por cualquier otra causa; sin perjuicio</p>
<p>&nbsp;</p>
<p>de que el Cliente pueda continuar recibiendo cualesquiera de los servicios objeto de este Contrato a trav&eacute;s de la Red Compartida, bajo el t&iacute;tulo o causa que corresponda.</p>
<p>&nbsp;</p>
<h4>7.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Rescisi&oacute;n por el Cliente.</h4>
<p><strong>&nbsp;</strong></p>
<p>El Cliente podr&aacute; rescindir el presente Contrato, sin necesidad de declaraci&oacute;n judicial, mediante notificaci&oacute;n a Alt&aacute;n, en caso que:</p>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n incumpla con cualquiera de sus obligaciones bajo el presente Contrato, y dicho incumplimiento no sea subsanado o remediado dentro de los 90 (noventa) D&iacute;as siguientes a que haya sido notificado por el Cliente a Alt&aacute;n;</li>
<li>Cualquier declaraci&oacute;n de Alt&aacute;n bajo el presente Contrato resulte ser falsa o incorrecta; o</li>
<li>Alt&aacute;n se disuelva, o sea declarada en quiebra o liquidaci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<h4>7.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Rescisi&oacute;n por Alt&aacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>Alt&aacute;n podr&aacute; rescindir el presente Contrato, sin necesidad de declaraci&oacute;n judicial, mediante notificaci&oacute;n al Cliente en caso que:</p>
<p>&nbsp;</p>
<ul>
<li>el Cliente incumpla con cualquier obligaci&oacute;n de pago y dicho incumplimiento no es subsanado dentro de los 15 (quince) D&iacute;as siguientes a su vencimiento;</li>
<li>el Cliente incumpla con cualquier de sus obligaciones bajo la Cl&aacute;usula D&eacute;cimo Quinta (<em>Cumplimiento de Leyes; Mejores Pr&aacute;cticas</em>);</li>
<li>el Cliente incumpla con cualquier de sus obligaciones bajo la Cl&aacute;usula D&eacute;cima (<em>Derechos de Propiedad Industrial</em>);</li>
<li>cualquier incumplimiento o evento considerado como un Evento de Incumplimiento bajo cualquier Anexo y/o Ap&eacute;ndice;</li>
<li>el Cliente incumpla con cualquier otra obligaci&oacute;n (excepto por las se&ntilde;aladas anteriormente), y si dicho incumplimiento pudiere ser subsanado, no es subsanado o remediado dentro de los 90 (noventa) D&iacute;as siguientes a que haya sido notificado por Alt&aacute;n al Cliente;</li>
<li>cualquier declaraci&oacute;n del Cliente bajo el presente Contrato o bajo cualquier otra forma otorgada a Alt&aacute;n resulte ser falsa;</li>
<li>el Cliente no obtenga o mantenga en vigor las Autorizaciones Gubernamentales necesarias para recibir los Servicios y a su vez prestar servicios de telecomunicaciones a sus Usuarios Finales o a otros Concesionarios o Comercializadoras; o</li>
<li>el Cliente se disuelva, solicite ser declarado o sea declarado en concurso mercantil, insolvente, en suspensi&oacute;n de pagos, quiebra o liquidaci&oacute;n (o figura similar).</li>
</ul>
<p>&nbsp;</p>
<p>En los escenarios descritos en los incisos (i), (ii), (iii), (iv), (vi), (vii) y (viii) anteriores la rescisi&oacute;n surtir&aacute; efectos a partir de que sea hecha la notificaci&oacute;n respectiva.</p>
<p>&nbsp;</p>
<p>Los supuestos de incumplimiento del Cliente y las causales de suspensi&oacute;n no son excluyentes entre s&iacute;, por lo que en caso de que el Cliente incurra en una causal que amerite una suspensi&oacute;n conforme a la Cl&aacute;usula 7.4 de este Contrato y que tambi&eacute;n sea considerada como un incumplimiento de acuerdo con los incisos (i) a</p>
<ul>
<li>de esta Cl&aacute;usula 7, Alt&aacute;n estar&aacute; facultada para suspender los Servicios hasta que el Cliente subsane la causa respectiva dentro del plazo establecido para tal efecto en esta Cl&aacute;usula, en caso de que el mismo sea subsanable, o se rescinda el presente Contrato por causas atribuibles al Cliente.</li>
</ul>
<p>&nbsp;</p>
<h4>7.8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Terminaci&oacute;n por Fuerza Mayor.</h4>
<p><strong>&nbsp;</strong></p>
<p>Cualquiera de las Partes podr&aacute; dar por terminado el presente Contrato mediante notificaci&oacute;n a la otra Parte si una Fuerza Mayor impide el cumplimiento del presente Contrato por un periodo de m&aacute;s de 180 (ciento ochenta) D&iacute;as.</p>
<p>&nbsp;</p>
<h4>OCTAVA. Fuerza Mayor.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Salvo que se establezca expresamente lo contrario en el presente Contrato (inclusive sus Anexos), ninguna de las Partes ser&aacute; responsable por el incumplimiento de sus obligaciones (excepto por las obligaciones de pago) si dicho incumplimiento es causado por Fuerza Mayor y siempre y cuando se haya dado cumplimiento a lo establecido en la presente Cl&aacute;usula.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Para efectos del presente Contrato, &ldquo;<strong>Fuerza Mayor</strong>&rdquo; significa cualquier evento o circunstancia imprevisible o irresistible que impida que una Parte cumpla con una, algunas o todas sus obligaciones bajo este Contrato, en la medida que dicho evento o circunstancia:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>no se encuentre razonablemente dentro del control de la Parte afectada;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>no haya podido ser superado, evitado o resistido por la Parte afectada mediante el empleo de diligencias razonables; y</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>no sea el resultado directo o indirecto de un incumplimiento a este Contrato por la Parte que se dice estar afectada por dicho evento o</li>
</ul>
<ul>
<li>En la medida que las condiciones anteriores hayan sido satisfechas, Fuerza Mayor incluye lo siguiente:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>fuego, explosi&oacute;n y hechos de la naturaleza, incluyendo sequ&iacute;a, inundaci&oacute;n, perturbaci&oacute;n atmosf&eacute;rica, rel&aacute;mpagos, tormentas, tifones, huracanes, ciclones, tornados, terremotos, tsunamis, deslizamientos, erosi&oacute;n del suelo, hundimientos, desastres o epidemias;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>fallas en el suministro de energ&iacute;a el&eacute;ctrica por parte de la empresa distribuidora que conecta las instalaciones, una vez agotada la energ&iacute;a de respaldo;</li>
<li>huelga (pero no de los empleados de la Parte afectada); y</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>guerra u otro conflicto armado, estado de emergencia nacional, revuelta, insurrecci&oacute;n o</li>
</ul>
<ul>
<li>En los casos en los que se haya producido una Fuerza Mayor, la Parte que alega que ha sido afectada por dicha ocurrencia deber&aacute; notificar la incidencia de la misma a la otra Parte de conformidad con este Dicha notificaci&oacute;n deber&aacute; realizarse en un plazo m&aacute;ximo de diez (10) D&iacute;as H&aacute;biles de ocurrido el suceso, debiendo aportar en el mismo momento, la informaci&oacute;n necesaria que acredite la ocurrencia del mismo, su gravedad, su duraci&oacute;n y el impacto que dicha causa genera en el respectivo incumplimiento.</li>
</ul>
<p>&nbsp;</p>
<p>Las Partes:</p>
<p>&nbsp;</p>
<ul>
<li>deber&aacute;n hacer todos los esfuerzos razonables para prevenir, reducir al m&iacute;nimo y mitigar el efecto de cualquier retraso ocasionado por alguna Fuerza Mayor;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>deber&aacute;n hacer todos los esfuerzos razonables para asegurar la reanudaci&oacute;n del cumplimiento normal de este Contrato despu&eacute;s de la cesaci&oacute;n de cualquier Fuerza Mayor; y</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>deber&aacute;n cumplir de cualquier forma alternativa con sus obligaciones bajo este Contrato, en la mayor medida de lo</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Si la Parte que alegare una Fuerza Mayor no cumple con los procedimientos impuestos bajo la presente Cl&aacute;usula, entonces se entender&aacute; que irrevocablemente ha renunciado a su derecho de excusar su incumplimiento alegando una Fuerza</li>
</ul>
<p>&nbsp;</p>
<h4>NOVENA. Aspectos Regulatorios.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El Cliente conoce las obligaciones de Alt&aacute;n bajo la Concesi&oacute;n de Alt&aacute;n y el Contrato de APP, y conviene en que el cumplimiento de las mismas por ning&uacute;n motivo ser&aacute; considerado un incumplimiento por parte de Alt&aacute;n a sus obligaciones bajo el presente</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Sin limitar la generalidad de la Subcl&aacute;usula 9.1 anterior, el Cliente reconoce y acepta que de conformidad con la Concesi&oacute;n de Alt&aacute;n y el Contrato de APP:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El IFT podr&aacute; determinar modificaciones a las condiciones t&eacute;cnicas de la Concesi&oacute;n de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente no podr&aacute;, directa o indirectamente, o a trav&eacute;s de cualquier Persona que forme parte de su Grupo de Inter&eacute;s Econ&oacute;mico tener influencia alguna en la operaci&oacute;n de la Red</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Ofertas de Referencia, y sus modificaciones posteriores, respecto de los Servicios, deber&aacute;n hacerse extensivas al Cliente bajo condiciones de no discriminaci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las &uacute;ltimas Tarifas y/o condiciones que Alt&aacute;n acuerde con otros clientes en igualdad de circunstancias respecto de los Servicios, mediante la suscripci&oacute;n de los contratos o convenios correspondientes, se har&aacute;n extensivas al Cliente previa solicitud por su</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Para dar a conocer la informaci&oacute;n mencionada en los incisos (iii) y (iv) anteriores, Alt&aacute;n habilitar&aacute; al Cliente la Plataforma Web de Tarifas, en la que se publicar&aacute;n las Ofertas de Referencia, sus modificaciones y adicionar&aacute; las Tarifas y/o condiciones de prestaci&oacute;n de los Servicios contratados, y se enviar&aacute; un correo electr&oacute;nico a la cuenta especificada por el</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n presentar&aacute; este Contrato y cualquiera de sus modificaciones, incluyendo los Servicios Adicionales, al IFT para su inscripci&oacute;n en el Registro P&uacute;blico de Concesiones en un plazo de 30 (treinta) D&iacute;as H&aacute;biles posteriores a su formalizaci&oacute;n. Para prop&oacute;sitos de esta inscripci&oacute;n, se considerar&aacute;n como confidenciales las Tarifas y/o las condiciones t&eacute;cnicas o comerciales que sean identificados por el Cliente y Alt&aacute;n con tal car&aacute;cter, con el fin de preservar la posici&oacute;n competitiva del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n est&aacute; sujeto a la supervisi&oacute;n y verificaci&oacute;n de IFT y PROMTEL, por lo que Alt&aacute;n podr&iacute;a estar obligado a proporcionar al IFT y PROMTEL informaci&oacute;n relacionada con el Cliente y el presente</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>PROMTEL tiene la facultad de intervenir la Red Compartida, directamente o a trav&eacute;s de</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El presente Contrato ser&aacute; inscrito en el Registro P&uacute;blico de</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n prestar&aacute; los Servicios sobre una base de cliente m&aacute;s favorecido por lo que deber&aacute; de ofrecer trato igualitario y no discriminatorio al Cliente y deber&aacute; hacer disponibles al Cliente las &uacute;ltimas Tarifas y/o condiciones que acuerde con otros clientes en igualdad de circunstancias para los Servicios que el Cliente tenga contratados con Alt&aacute;n en cada</li>
</ul>
<p>&nbsp;</p>
<p>El Cliente podr&aacute; verificar el cumplimento de lo establecido en el p&aacute;rrafo anterior a trav&eacute;s de la Plataforma Web de Tarifas, a la cual tendr&aacute; acceso mediante un</p>
<p>&nbsp;</p>
<p>usuario y contrase&ntilde;a y en la cual se publicar&aacute;n las &uacute;ltimas Tarifas y/o condiciones conforme a lo establecido en la Cl&aacute;usula 9.2, inciso (v) anterior.</p>
<p>&nbsp;</p>
<p>La Plataforma Web de Tarifas le otorga al Cliente y al IFT un acceso seguro para revisar las Tarifas y/o condiciones acordadas por Alt&aacute;n con otros clientes, asegurando as&iacute; que los Servicios sean prestados al Cliente sobre bases de transparencia y no discriminaci&oacute;n y facultando al Cliente para poder solicitar, de una manera igualitaria y no discriminatoria, las mejores condiciones y Tarifas que Alt&aacute;n acuerde con otros clientes en igualdad de circunstancias conforme a lo previsto en la Cl&aacute;usula 9.2, inciso (iv) de este Contrato, mientras que, al mismo tiempo, se asegura la confidencialidad de las Tarifas para preservar la competitividad y viabilidad del Cliente.-</p>
<p>&nbsp;</p>
<h4>D&Eacute;CIMA. Derechos de Propiedad Industrial.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Salvo por lo expresamente establecido en este Contrato (i) cualquier Propiedad Industrial creada o de la que sea titular Alt&aacute;n se mantendr&aacute; bajo la titularidad de Alt&aacute;n, y cualquier Propiedad Industrial creada o de la que sea titular el Cliente se mantendr&aacute; bajo la titularidad del Cliente; (ii) este Contrato no constituye cesi&oacute;n, derecho, t&iacute;tulo o licencia de la Propiedad Industrial de cualquiera de las Partes a la otra Parte, ni restringe los derechos de Alt&aacute;n o del Cliente para mantener, usar, gozar otorgar licencias, ceder o transferir su propia Propiedad</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Toda la Propiedad Industrial que se desarrolle o resulte de la prestaci&oacute;n, mejoras o cambios a los Servicios corresponder&aacute; a Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente prestar&aacute; los servicios a sus Usuarios Finales u otros Concesionarios o Comercializadoras utilizando su propia marca y nunca bajo las marcas o Propiedad Industrial de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<h4>D&Eacute;CIMO PRIMERA. Confidencialidad y Protecci&oacute;n de Datos.</h4>
<p><strong>&nbsp;</strong></p>
<p>Para los efectos del presente Contrato, &ldquo;<strong>Informaci&oacute;n Confidencial</strong>&rdquo; significa, conjunta e individualmente, toda o cualquier informaci&oacute;n, de cualquier naturaleza, bien sea verbal, escrita o en forma electr&oacute;nica, relativa a cualquiera de las Partes, su negocio, tecnolog&iacute;a, clientes y/o proveedores, incluyendo, sin car&aacute;cter limitativo, el funcionamiento, configuraci&oacute;n, caracter&iacute;sticas y/o especificaciones de las instalaciones, equipos, e infraestructuras de cada una de las Partes, (i) proporcionada por una de las Partes (o sus empleados, consultores o asesores de cualquier tipo) (en adelante &ldquo;<strong>Parte Proveedora</strong>&rdquo;), en cualquier momento, a la otra Parte (en lo sucesivo &ldquo;<strong>Parte Receptora</strong>&rdquo;), (ii) as&iacute; como cualesquiera registros o copias o extractos de la misma en cualquier medio (bien por escrito o en formato electr&oacute;nico) y (iii) cualquier an&aacute;lisis, compilaci&oacute;n, estudio, resumen, extracto o documento de cualquier clase desarrollado por cualquiera de las Partes o</p>
<p>&nbsp;</p>
<p>conjuntamente por ellas sobre la base de la informaci&oacute;n referida anteriormente. Las Partes se comprometen a guardar y a tratar toda la Informaci&oacute;n Confidencial como estrictamente confidencial.</p>
<p>&nbsp;</p>
<ul>
<li>No obstante lo anterior, no se entender&aacute; por Informaci&oacute;n Confidencial aquella informaci&oacute;n de las Partes que</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Sea del dominio p&uacute;blico en el momento de su comunicaci&oacute;n;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Se haga p&uacute;blica por una causa distinta al incumplimiento del deber de confidencialidad previsto en el presente Contrato, en el entendido de que el hecho de que sea previsible o posible que la informaci&oacute;n se haga p&uacute;blica en un momento posterior a su recepci&oacute;n no le otorga a la Parte Receptora el derecho de revelarla, sino hasta despu&eacute;s de que ocurra el evento que la haga p&uacute;blica sin mediar incumplimiento alguno de la Parte Receptora;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Ya estuviera en posesi&oacute;n de la Parte Receptora de manera leg&iacute;tima con antelaci&oacute;n a que le fuera suministrada por la Parte Proveedora y no est&eacute; sujeta a otro acuerdo de confidencialidad;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Sea recibida a trav&eacute;s de terceros sin restricciones y sin que implique el incumplimiento del presente Contrato;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Sea divulgada de forma masiva y sin limitaci&oacute;n alguna por su creador leg&iacute;timo;</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Sea independientemente desarrollada por la Parte Receptora sin basarse en la Informaci&oacute;n Confidencial; y/o</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Deba ser revelada para dar cumplimiento a una orden de naturaleza judicial o administrativa en los t&eacute;rminos que se indican en esta Cl&aacute;usula.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>No se considerar&aacute; que se ha incumplido con las obligaciones de confidencialidad aqu&iacute; establecidas en los siguientes supuestos:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Cuando la divulgaci&oacute;n de la Informaci&oacute;n Confidencial se autorice por escrito por la Parte Proveedora; o,</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Cuando se comunique Informaci&oacute;n Confidencial en cumplimiento de un mandato legal o de los requerimientos de cualquier Autoridad Gubernamental. En el caso de que la Ley Aplicable o Autoridad Gubernamental requieran a cualquiera de las Partes comunicar parte o toda la Informaci&oacute;n Confidencial, la Parte requerida se compromete a divulgar &uacute;nicamente la Informaci&oacute;n Confidencial que le haya sido requerida.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Este Contrato no otorga a la Parte Receptora m&aacute;s derechos ni impone m&aacute;s obligaciones que aquellas expresamente establecidas en el presente Contrato, y no se entender&aacute; que supone el otorgamiento a la Parte Receptora de cualquier clase de derechos de propiedad intelectual o cualesquiera otros derechos en relaci&oacute;n con la Informaci&oacute;n Confidencial y su uso</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>A petici&oacute;n de la Parte Proveedora, la Informaci&oacute;n Confidencial, en cualquier forma que la haya recibido u obtenido la Parte Receptora de la Parte Proveedora, ser&aacute; devuelta o, si no fuera posible, ser&aacute; destruida en el plazo de treinta (30) D&iacute;as contados desde que se recibi&oacute; el requerimiento, sin conservar la Parte Receptora copia, dato, extracto o reproducci&oacute;n alguna de la Informaci&oacute;n Confidencial (salvo por aqu&eacute;lla que deba ser mantenida en respaldos), siempre que dicha informaci&oacute;n no sea necesaria para el cumplimiento del presente Contrato o su conservaci&oacute;n sea exigida por la Ley Aplicable o Autoridad</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las obligaciones de confidencialidad establecidas en esta Cl&aacute;usula permanecer&aacute;n vigentes durante la vigencia de este Contrato, as&iacute; como durante los dos (2) a&ntilde;os siguientes a su expiraci&oacute;n por cualquier</li>
</ul>
<p>&nbsp;</p>
<h4>11.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Protecci&oacute;n de Datos.</h4>
<p><strong>&nbsp;</strong></p>
<p>El tratamiento de aquellos datos personales que se realice al amparo del presente Contrato se regir&aacute; por lo dispuesto en la Ley Federal de Protecci&oacute;n de Datos Personales en Posesi&oacute;n de los Particulares, su reglamento, lineamientos y cualquier otra disposici&oacute;n aplicable, as&iacute; como de conformidad con los t&eacute;rminos y condiciones establecidos en el Aviso de Privacidad respectivo de las Partes.</p>
<p>&nbsp;</p>
<h4>D&Eacute;CIMO SEGUNDA. Notificaciones.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Salvo que se establezca expresamente de otra forma en el Anexo &ldquo;Procedimientos Operativos&rdquo;, todos los avisos y notificaciones entre las Partes deber&aacute;n realizarse por escrito y ser entregados ya sea (i) personalmente; (ii) por mensajer&iacute;a especializada o por correo certificado con acuse de recibo y porte pagado; o (iii) por correo electr&oacute;nico, en los domicilios o direcciones de correo electr&oacute;nico (con la funci&oacute;n de confirmaci&oacute;n de recepci&oacute;n activada) se&ntilde;alados m&aacute;s</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los avisos y notificaciones entre las Partes se considerar&aacute;n efectivamente recibidos por su destinatario, (i) si se entregan personalmente, al momento de dicha entrega; (ii) si se env&iacute;an por correo certificado, en la fecha que el acuse de recibo se&ntilde;ale; y (iii) si se env&iacute;an por correo electr&oacute;nico, a partir del momento en que el sistema de correo electr&oacute;nico confirme su recepci&oacute;n a trav&eacute;s de la funci&oacute;n de confirmaci&oacute;n de recepci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Cualquier cambio de domicilio o direcci&oacute;n de correo electr&oacute;nico deber&aacute; notificarse por escrito con por lo menos 5 (cinco) D&iacute;as de anticipaci&oacute;n, en caso contrario, todos los avisos, comunicaciones y notificaciones que se realicen en el &uacute;ltimo</li>
</ul>
<p>&nbsp;</p>
<p>domicilio o direcci&oacute;n de correo electr&oacute;nico designados, surtir&aacute;n plenamente sus efectos.</p>
<p>&nbsp;</p>
<ul>
<li>Para los efectos de este Contrato, las Partes se&ntilde;alan como sus respectivos domicilios convencionales, los siguientes:</li>
</ul>
<p>&nbsp;</p>
<p>Si al Cliente:</p>
<p>Albino Espinosa Ote. 829, Colonia Centro, Monterrey,</p>
<p>Nuevo Le&oacute;n, C&oacute;digo Postal 64000 Tel: 33-1022-5555</p>
<p>Correo electr&oacute;nico: <u><a href="mailto:miguel@elux.com.mx">miguel@elux.com.mx</a></u> Atenci&oacute;n: Representante Legal</p>
<p>&nbsp;</p>
<p>Si a ALT&Aacute;N:</p>
<p>Lago Alberto 319, Piso 14</p>
<p>Colonia Granada, Alcald&iacute;a Miguel Hidalgo Ciudad de M&eacute;xico, C&oacute;digo Postal 11520 Tel: +52 (1) 55 8852 6600</p>
<p>Correo electr&oacute;nico: <u><a href="mailto:gabriel.cejudo@altanredes.com">gabriel.cejudo@altanredes.com</a></u> Atenci&oacute;n: Direcci&oacute;n Comercial</p>
<p>&nbsp;</p>
<p>Con copia obligatoria para el Responsable Comercial. Correo electr&oacute;nico: <u><a href="mailto:contactocliente@altanredes.com">contactocliente@altanredes.com</a></u></p>
<p>&nbsp;</p>
<p>Con una notificaci&oacute;n adicional para:</p>
<p>Lago Alberto 319, Piso 14</p>
<p>Colonia Granada, Alcald&iacute;a Miguel Hidalgo Ciudad de M&eacute;xico, C&oacute;digo Postal 11520 Atenci&oacute;n: Direcci&oacute;n de Asesor&iacute;a Jur&iacute;dica</p>
<p>&nbsp;</p>
<h4>D&Eacute;CIMO TERCERA. Cesi&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Ninguna de las Partes podr&aacute; ceder o transmitir de forma alguna sus derechos y obligaciones bajo el presente Contrato, salvo que cuenten con el consentimiento previo y por escrito de la otra Parte. Cualquier cesi&oacute;n o transmisi&oacute;n de derechos y obligaciones en contravenci&oacute;n a lo anterior ser&aacute; nula de pleno derecho y no surtir&aacute; efectos legales ni</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>No obstante lo anterior, previa notificaci&oacute;n por escrito de Alt&aacute;n al Cliente con 15 (quince) D&iacute;as de anticipaci&oacute;n a la fecha efectiva de la cesi&oacute;n, el Cliente en este acto autoriza y consiente a que Alt&aacute;n ceda u otorgue en garant&iacute;a, inclusive a trav&eacute;s de fideicomiso, todos sus derechos derivados del presente Contrato (inclusive sus derechos de cobro), para los efectos o conforme a los requerimientos del Contrato de APP y/o en favor de los bancos, instituciones financieras y dem&aacute;s entidades (o sus agentes) que financian o refinancien el proyecto conocido como &ldquo;Red Compartida&rdquo; de Alt&aacute;n en el entendido que cualquiera que fuera el cesionario permitido bajo la presente Cl&aacute;usula, en ning&uacute;n caso y bajo cualquier circunstancia ser&aacute;: (i) una Comercializadora o un Concesionario; ni (ii) un competidor directo del Cliente que preste los mismos servicios que los contratados por el Cliente bajo el presente Contrato. El Cliente se obliga a cooperar con Alt&aacute;n en todo lo que resulte razonablemente necesario para perfeccionar la cesi&oacute;n o garant&iacute;a correspondiente y atender cualquier requerimiento razonable de PROMTEL, TELECOMM o dichos acreedores.</li>
</ul>
<ul>
<li>Sin perjuicio de lo previamente establecido, el Cliente podr&aacute; ceder todos sus derechos y obligaciones bajo este Contrato, sin necesidad de obtener el consentimiento de Alt&aacute;n, siempre y cuando notifique a Alt&aacute;n la cesi&oacute;n con al menos 30 (treinta) D&iacute;as H&aacute;biles de anticipaci&oacute;n a la fecha efectiva de la cesi&oacute;n y acredite ante Alt&aacute;n el cumplimiento de las siguientes condiciones: (i) que la cesionaria sea una afiliada del Cliente (para efectos de esta Cl&aacute;usula &ldquo;afiliada&rdquo; significa una empresa que controle al Cliente, una empresa que se encuentre y permanezca bajo el control del Cliente o una empresa que se encuentre y permanezca bajo el contol com&uacute;n del Cliente y &ldquo;control&rdquo; tiene el significado que se le atribuye en la fracci&oacute;n III del art&iacute;culo 2 de la Ley del Mercado de Valores, es decir, la capacidad del Cliente de: (a) imponer, directa o indirectamente, decisiones en las asambleas generales de accionistas, de socios u &oacute;rganos equivalentes, o nombrar o destituir a la mayor&iacute;a de los consejeros, administradores o sus equivalentes, de la cesionaria; (b) mantener la titularidad de derechos que permitan, directa o indirectamente, ejercer el voto respecto de m&aacute;s del 50% (cincuenta por ciento) del capital social de la cesionaria; o (c) dirigir, directa o indirectamente, la administraci&oacute;n, la estrategia o las principales pol&iacute;ticas de la cesionaria, ya sea a trav&eacute;s de la propiedad de valores, por contrato o de cualquier otra forma); (ii) que la cesionaria cuente con un t&iacute;tulo de concesi&oacute;n o un t&iacute;tulo de autorizaci&oacute;n otorgado v&aacute;lidamente por el IFT para recibir los Servicios y a su vez prestarlos a otros Concesionarios o Comercializadoras o a sus Usuarios Finales; y (iii) que la cesionaria cumpla con todas las condiciones, representaciones, declaraciones y requisitos establecidos bajo el presente Contrato para el Cliente (incluyendo sin limitar, solvencia, capacidades, garant&iacute;as, seguros, proyecciones, entre otras).</li>
</ul>
<p>&nbsp;</p>
<h4>D&Eacute;CIMO CUARTA. Modificaciones y Renuncias.</h4>
<ul>
<li>Cualquier modificaci&oacute;n a los t&eacute;rminos del Contrato deber&aacute; constar por escrito firmado por ambas</li>
</ul>
<ul>
<li>Cualquier modificaci&oacute;n a los t&eacute;rminos del Contrato que suponga, a su vez, una modificaci&oacute;n sustancial a la Oferta de Referencia, s&oacute;lo ser&aacute; v&aacute;lida y surtir&aacute; efectos una vez que el IFT haya aprobado la correspondiente modificaci&oacute;n de la Oferta de Referencia. Por modificaci&oacute;n sustancial se entiende aquella que cambie materialmente la estructura de la Oferta de Referencia, un t&eacute;rmino esencial de la misma o la mayor parte de esta. Para efectos de esta Cl&aacute;usula, las modificaciones a los Ap&eacute;ndices 5.2, 6.2, 7.2, 8.2, 9.2, 10.2, 11.2, 12.2, 13.2. 14.2, 15.2 y 16.2
correspondientes a T&eacute;rminos Comerciales y Estructuras Tarifarias de cada Servicio estar&aacute;n sujetos a la aprobaci&oacute;n del IFT. Por el contrario, los cambios a los Ap&eacute;ndices 5.3, 6.3, 7.3, 8.3, 9.3, 10.3, 11.3, 12.3, 13.3, 14.3, 15.3 y 16.3
relativos a las Tarifas de cada Servicio no se considerar&aacute;n una modificaci&oacute;n sustancial a la Oferta de Referencia, por lo que &uacute;nicamente requieren ser presentados para su registro ante IFT previo a que sean v&aacute;lidos y surtan efectos.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Salvo por disposici&oacute;n expresa en contrario en el presente Contrato, la falta o retraso de cualquiera de las Partes en exigir en cualquier momento el cumplimiento con cualquiera de las estipulaciones de este Contrato, o de requerir en cualquier momento el cumplimiento por la otra Parte de cualquier disposici&oacute;n de este Contrato, no deber&aacute; ser interpretado como una renuncia o dispensa al cumplimiento de dicha disposici&oacute;n, ni afectar&aacute; la validez del presente Contrato o cualquier parte del mismo, ni tampoco el derecho de tal Parte a exigir posteriormente el cumplimiento de cada una de dichas</li>
</ul>

<h4>D&Eacute;CIMO QUINTA. Cumplimiento de Leyes; Mejores Pr&aacute;cticas.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Mejores Pr&aacute;cticas en Materia de Anticorrupci&oacute;n.</strong></li>
<li>Cada una de las Partes deber&aacute; cumplir con las mejores pr&aacute;cticas en materia de anticorrupci&oacute;n, sanciones y pol&iacute;ticas, procedimientos y gu&iacute;as en materia de prevenci&oacute;n de lavado de</li>
<li>Cada una de las Partes deber&aacute; garantizar que sus empleados y personal cumplan con dichas pol&iacute;ticas, procedimientos y gu&iacute;as.</li>
</ul>
<h4>15.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Obligaciones Anticorrupci&oacute;n.</h4>
<ul>
<li>Cada una de las Partes declara que, independientemente de la jurisdicci&oacute;n aplicable a la cual dicha Parte y/o (a) sus accionistas o socios, (b) sus Afiliadas, y (c) sus directores, funcionarios, agentes, miembros, empleados y apoderados (&ldquo;<strong>Partes Relacionadas</strong>&rdquo;) est&eacute;n legalmente sometidas, cada Parte y las Partes Relacionadas que est&eacute;n involucradas en el cumplimiento este Contrato deber&aacute;n cumplir con los t&eacute;rminos y disposiciones de todas las leyes vigentes en materia de anticorrupci&oacute;n, incluyendo la Ley General del Sistema Nacional Anticorrupci&oacute;n, Ley General de Responsabilidades Administrativas y cualesquiera otras leyes similares aplicables a cada una de las Partes y a sus Partes Relacionadas en materia de combate, prevenci&oacute;n o sanci&oacute;n de corrupci&oacute;n o soborno (conjuntamente, &ldquo;<strong>Leyes en Materia de Anticorrupci&oacute;n</strong>&rdquo;) y deber&aacute;n cumplir con los principios, disposiciones y requisitos previstos en dichas leyes. Por este medio, cada una de las Partes acuerda que ni &eacute;sta ni sus Partes Relacionadas involucradas en el cumplimiento de este Contrato han llevado o llevar&aacute;n a cabo actos prohibidos por las Leyes en Materia de Anticorrupci&oacute;n, y que no han ofrecido u otorgado ni ofrecer&aacute;n u otorgar&aacute;n ventaja alguna, ya sea financiera o de cualquier otra naturaleza, a persona alguna, ya sean Funcionarios P&uacute;blicos o particulares: con el fin de inducirlos o de inducir a alg&uacute;n tercero a llevar a cabo sus funciones o actividades de manera indebida, o con el fin de premiar dicho actuar; o a sabiendas o con la sospecha de que la aceptaci&oacute;n de dicha ventaja constituir&iacute;a, por s&iacute; misma, un actuar indebido; asimismo, las Partes y sus Partes Relacionadas se obligan a no ofrecer u otorgar a alg&uacute;n Funcionario P&uacute;blico ventaja alguna que no est&eacute; permitida o no sea requerida por la ley aplicable de manera escrita, en favor de dicho Funcionario P&uacute;blico, con el fin de (1) influir en su calidad de Funcionario P&uacute;blico y (2) obtener o mantener un negocio o una ventaja<br />
En adici&oacute;n a lo anterior, cada una de las Partes deber&aacute; establecer con sus Partes Relacionadas requisitos contractuales similares a los de esta Cl&aacute;usula, de manera escrita, para asegurar el cumplimiento de las obligaciones en materia de anticorrupci&oacute;n y de prevenci&oacute;n de lavado de dinero por sus Partes Relacionadas, y deber&aacute; verificar y mantener registros de dicha verificaci&oacute;n, a efecto de que todas sus Partes Relacionadas cumplan con todos los requerimientos de las Leyes en Materia de Anticorrupci&oacute;n y que no realizan acciones relacionadas bajo el presente Contrato que pudieren resultar en que cualquiera de las Partes estuviera sujeta a cualquier acci&oacute;n, pena (ya sea civil o penal) o perjuicio bajo las Leyes en Materia de Anticorrupci&oacute;n.</li>
</ul>
<ul>
<li>Sin perjuicio de lo previsto en el p&aacute;rrafo anterior, ninguna de las Partes ni cualquiera de las Partes Relacionadas podr&aacute;n, ya sea directa o indirectamente, ofrecer, pagar, prometer pagar o autorizar el pago o permitir que alg&uacute;n representante, ya sea directa o indirectamente, ofrezca, pague, prometa pagar o autorice el pago de, cualquier contraprestaci&oacute;n monetaria o en especie, tales como entregar regalos o entretenimiento, a cualesquiera funcionarios, empleados, representantes o personas que act&uacute;en en representaci&oacute;n de cualquier gobierno u entidad gubernamental, dependencia o agencia (incluyendo empresas de participaci&oacute;n estatal mayoritaria o empresas controladas por el estado), ni a cualesquiera organizaciones internacionales de derecho p&uacute;blico, partidos pol&iacute;ticos o funcionarios de partidos pol&iacute;ticos, as&iacute; como candidatos a alg&uacute;n cargo p&uacute;blico o personas que detenten alguna posici&oacute;n de cualquier otra naturaleza, ya sea oficial u honoraria, en un gobierno o cualquiera de sus agencias, ni a cualquier otra persona que tenga una relaci&oacute;n de parentesco por consanguinidad en l&iacute;nea recta, por afinidad o civil con los funcionarios anteriormente listados (&ldquo;<strong>Funcionario P&uacute;blico</strong>&rdquo;) con el fin de (a) influir en cualquier acto o decisi&oacute;n de cualquier Funcionario P&uacute;blico, (b) inducir a dicho Funcionario P&uacute;blico a realizar u omitir realizar cualquier acto, en contravenci&oacute;n al debido cumplimiento de sus funciones, o (c) inducir a dicho Funcionario P&uacute;blico a utilizar sus influencias frente a un gobierno o dependencia a fin de afectar o influir en alg&uacute;n acto o decisi&oacute;n de dicho gobierno o dependencia, con el fin de apoyar a cualquiera de las Partes o a cualquier Parte Relacionada en la obtenci&oacute;n o retenci&oacute;n de negocios, dirigir negocios a dicha persona o apoyar a dicha persona en la obtenci&oacute;n de alguna ventaja indebida. Cualquiera de las Partes podr&aacute; solicitar ocasionalmente que la otra Parte certifique a la Parte solicitante la veracidad de estas declaraciones en cualquier momento, as&iacute; como el cumplimiento continuo de sus obligaciones anteriormente descritas.</li>
</ul>
<ul>
<li>En adici&oacute;n a lo anterior, cada una de las Partes declara que ni &eacute;sta ni cualquiera de sus Partes Relacionadas involucradas en el cumplimiento de este Contrato ha pagado, ofrecido, prometido o acordado pagar, o ha hecho que se pague, ofrezca, prometa o acuerde pagar, ni deber&aacute; pagar, ofrecer, prometer o acordar pagar, ya sea directa o indirectamente, contribuci&oacute;n, cuota o comisi&oacute;n alguna, as&iacute; como cualesquiera otras ventajas en favor de alg&uacute;n ente privado que resulte o derive en un pago indebido o alg&uacute;n otro tipo de Cada una de las Partes declara que, de conformidad con sus procesos de control, no existe evidencia o indicio de riesgos particulares con respecto a las Partes Relacionadas involucradas en el cumplimiento del presente Contrato en relaci&oacute;n con incumplimientos en materia &eacute;tica o de las Leyes en Materia de Anticorrupci&oacute;n relativos al cumplimiento con el presente Contrato. Asimismo, cada una de las Partes declara que, ni &eacute;sta ni cualquiera de sus Partes Relacionadas involucradas en el cumplimiento de este Contrato es un Funcionario P&uacute;blico; en el entendido que, en caso de que durante la vigencia del presente Contrato, una Parte o cualquiera de sus Partes Relacionadas con &eacute;ste se convierta en un Funcionario P&uacute;blico deber&aacute; de notificar inmediatamente a la otra Parte respecto de dicha circunstancia y deber&aacute; actualizar la presente declaraci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Cada una de las Partes se obliga a hacer que sus representantes, funcionarios, directivos y empleados, que llegaren a interactuar con Funcionarios P&uacute;blicos, participen en sesiones de capacitaci&oacute;n impartidas por cada una de &eacute;stas para capacitar a dichos representantes en materia de las Leyes en Materia de Anticorrupci&oacute;n anteriormente descritas. Cada Parte har&aacute; que dichos representantes hagan constar su participaci&oacute;n en dichas sesiones de capacitaci&oacute;n a trav&eacute;s de la firma de</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Partes se obligan a mantener y conservar los libros y registros que sean necesarios para documentar de manera completa y precisa cualquier transacci&oacute;n o uso de fondos relacionado con este Contrato. Las Partes deber&aacute;n conservar los libros y registros durante un periodo m&iacute;nimo de tres (3) a&ntilde;os despu&eacute;s de la terminaci&oacute;n del presente Contrato, o por un periodo de tiempo mayor si fuera requerido bajo la ley aplicable.</li>
</ul>
<ul>
<li>El Cliente deber&aacute; informar de manera inmediata a la Alt&aacute;n en caso de detectar que alguna de las declaraciones de la presente Subcl&aacute;usula 15.2 pierda su exactitud o integridad. En caso de que, de conformidad con la opini&oacute;n razonada de Alt&aacute;n y con base en cualquier fuente de informaci&oacute;n, el Cliente o cualquiera de las Partes Relacionadas que participen en los Servicios relacionados con el presente Contrato causen alguna preocupaci&oacute;n respecto del cumplimiento de normas de &eacute;tica o de las Leyes en Materia de Anticorrupci&oacute;n, Alt&aacute;n tendr&aacute; el derecho de solicitar que se lleven a cabo las medidas razonables necesarias, incluyendo reemplazar a la Parte Relacionada respecto del Cliente por una persona o entidad aceptable para Alt&aacute;n sin perjuicio de cualquier otra medida de conformidad con el presente</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Sin perjuicio de lo anterior, cada una de las Partes declara que cuenta con un c&oacute;digo de conducta o &eacute;tica (o similar), aplicable a sus empleados, personal y contratistas, y se obliga a cumplir y hacer que el mismo se cumpla.</li>
</ul>
<p>&nbsp;</p>
<h4>15.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Obligaciones en Materia de Comercio Internacional.</h4>
<p><strong>&nbsp;</strong></p>
<p>Cada una de las Partes o cualquiera de sus Partes Relacionadas involucradas en el cumplimiento del presente Contrato han cumplido y se obligan a cumplir con el r&eacute;gimen de sanciones econ&oacute;micas y comerciales, leyes y reglamentos nacionales o internacionales que sean aplicables a cada una de las Partes, respectivamente, y cualesquiera otro decreto, reglas y disposiciones relacionadas. Ninguna de las Partes ni cualquiera de las Partes Relacionadas involucradas en el cumplimiento del presente Contrato ha participado ni participar&aacute; en alg&uacute;n acuerdo u operaci&oacute;n con cualquiera de las personas que est&eacute; en cualquier lista de sanciones existente o en cualesquier otras listas de sanciones que en su momento sean emitidas, de ser el caso, por cualquier autoridad gubernamental (&ldquo;<strong>Lista de Sanciones</strong>&rdquo;). Ni las Partes ni sus Partes Relacionadas son personas listadas en cualquier Lista de Sanciones.</p>
<p>&nbsp;</p>
<h4>15.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Obligaciones en Materia de Antilavado de Dinero.</h4>
<p><strong>&nbsp;</strong></p>
<p>Las operaciones de cada una de las Partes y cualquiera de sus Partes Relacionadas que tienen relaci&oacute;n con el cumplimiento del presente Contrato han sido y ser&aacute;n conducidas en todo momento en cumplimiento de las Leyes</p>
<p>&nbsp;</p>
<p>Aplicables a cada una de las Partes, respectivamente, en materia de reporte y mantenimiento de informaci&oacute;n financiera, transmisi&oacute;n de divisas y prevenci&oacute;n de lavado de dinero, as&iacute; como todas las reglas relativas al &ldquo;conocimiento de clientes&rdquo; (know your customer) y cualesquiera otras regulaciones aplicables, incluyendo, sin limitar, la Ley Federal para la Prevenci&oacute;n e Identificaci&oacute;n de Operaciones con Recursos de Procedencia Il&iacute;cita seg&uacute;n la misma se encuentre vigente en determinando momento. En caso de que cualquiera de las Partes presente cualquier informaci&oacute;n o reportes a una autoridad gubernamental, dicha Parte deber&aacute; notificar a la otra inmediatamente y proporcionarle copias de la misma.</p>
<h4>15.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No Violaci&oacute;n o Investigaci&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>Cada Parte declara y garantiza que, previo a la fecha de firma del presente Contrato, no ha ejercido u omitido ejercer acci&oacute;n legal alguna en relaci&oacute;n con la Red Compartida, cuyo acto u omisi&oacute;n hubiere resultado o resulte en una violaci&oacute;n de la presente Cl&aacute;usula. En adici&oacute;n, cada Parte declara y garantiza que, previo a la fecha de firma del presente Contrato, no ha sido sujeto de investigaci&oacute;n alguna por parte de alguna autoridad gubernamental en relaci&oacute;n con las obligaciones de cumplimiento descritas en las Subcl&aacute;usulas 15.2, 15.3 y 15.4 del presente Contrato. Cada Parte deber&aacute; notificar de manera oportuna a la otra Parte cuando tenga conocimiento de alguna investigaci&oacute;n relacionada con el cumplimiento por parte de dicha Parte o alguna de sus partes relacionadas en conexi&oacute;n con lo anterior.</p>
<p>&nbsp;</p>
<h4>15.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Discriminaci&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>Cada una de las Partes no discriminar&aacute; de manera indebida dentro del alcance y significado previsto en cualquier Ley Aplicable en materia de discriminaci&oacute;n (ya sea de raza, g&eacute;nero, religi&oacute;n, discapacidad, edad, orientaci&oacute;n sexual o de cualquier otro tipo) en el empleo. Cada una de las Partes deber&aacute; tomar los pasos razonablemente necesarios para garantizar la observancia de esta disposici&oacute;n por parte de los servidores, empleados o funcionarios, y los subcontratistas de cada uno &eacute;stas.</p>
<h4>15.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Indemnizaci&oacute;n por incumplimiento a la Ley Aplicable.</h4>
<p><strong>&nbsp;</strong></p>
<p>La Parte incumplida se obliga a eximir de responsabilidad a la Parte afectada y a indemnizarla por cualquier costo o gasto erogado, as&iacute; como a responder a cualquier acci&oacute;n, demanda, notificaci&oacute;n, reclamo, orden, citaci&oacute;n, litigio, investigaci&oacute;n o procedimiento que est&eacute; directamente relacionado con el incumplimiento de cualquier obligaci&oacute;n prevista en esta Cl&aacute;usula, incluyendo a cualesquiera declaraciones y garant&iacute;as hechas a la firma del presente Contrato, as&iacute; como el incumplimiento de la Ley Aplicable, siempre y cuando este incumplimiento afecte materialmente la validez, legalidad, naturaleza obligatoria o exigibilidad de este Contrato.</p>
<p>&nbsp;</p>
<h4>D&Eacute;CIMO SEXTA. Miscel&aacute;neos.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Cambio en </strong></li>
</ul>
<h4>16.1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Cambio en Ley.</h4>
<p>Las Partes convienen que en caso de un cambio o modificaci&oacute;n a la Ley Aplicable (incluyendo la entrada en vigor de nuevas disposiciones legales o reglamentarias y la modificaci&oacute;n o abrogaci&oacute;n de las existentes) con posterioridad a la fecha de firma del presente Contrato que afecten de forma significativa a cualquiera de las Partes en el cumplimiento de sus obligaciones bajo el presente Contrato, las Partes discutir&aacute;n y negociar&aacute;n de buena fe a fin de convenir, en una forma comercialmente razonable, la forma en la que cualquier monto a ser pagado por las Partes bajo el presente Contrato deba ser ajustado a fin de considerar los nuevos costos que implique para la Parte respectiva las modificaciones a la Ley Aplicable antes se&ntilde;aladas.</p>
<p><strong>&nbsp;</strong></p>
<h4>16.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No Relaci&oacute;n Laboral.</h4>
<p>Las Partes aceptan y reconocen que este Contrato no constituye ni constituir&aacute; relaci&oacute;n alguna de tipo laboral entre ellas, su personal, empleados, funcionarios, contratistas, asesores y agentes, motivo por el cual, cada Parte ser&aacute; responsable por la relaci&oacute;n laboral y de cualquier otro tipo que exista con su propio personal, empleados, funcionarios, contratistas, asesores y agentes y se obliga a indemnizar y mantener en paz y a salvo la una de la otra.</p>
<p>&nbsp;</p>
<h4>16.3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Acuerdo Total.</h4>
<p>Las Partes acuerdan que este Contrato constituye el acuerdo total entre ellas y que deja sin efectos cualesquier otros acuerdos, declaraciones o manifestaciones, orales o por escrito entre las Partes, relacionados con el objeto del presente Contrato.</p>
<p><strong>&nbsp;</strong></p>
<h4>16.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Autonom&iacute;a de las Estipulaciones.</h4>
<p>En caso que cualquier cl&aacute;usula del presente Contrato llegare a ser determinada como inv&aacute;lida o inejecutable, la misma deber&aacute; ser considerada como si no se hubiere insertado, sin que esto altere o modifique la validez del resto del Contrato o del acto jur&iacute;dico correspondiente, el cual permanecer&aacute; v&aacute;lido y deber&aacute; ser interpretado para obtener el resultado m&aacute;s cercano a la intenci&oacute;n original de las partes al celebrarlo.</p>
<p><strong>&nbsp;</strong></p>
<h4>16.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No Asociaci&oacute;n.</h4>
<p>Nada de lo dispuesto en este Contrato se interpretar&aacute; en el sentido de que exista entre las Partes una sociedad, asociaci&oacute;n, alianza, agencia, relaci&oacute;n fiduciaria o cualquier otra relaci&oacute;n jur&iacute;dica o econ&oacute;mica distinta a la derivada del objeto del presente Contrato.</p>
<p>&nbsp;</p>
<h4>16.6&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; No Exclusividad.</h4>
<p>Las Partes convienen que el presente Contrato no constituye un acuerdo de exclusividad entre ellas, por lo que tendr&aacute;n las Partes el derecho de celebrar contratos con terceros con el mismo objeto, o similar, que el del presente Contrato, sin restricci&oacute;n alguna.</p>
<p>&nbsp;</p>
<h4>16.7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Impuestos.</h4>
<p>Cada una de las Partes deber&aacute; cumplir con sus obligaciones en materia fiscal o tributaria a su cargo de conformidad con la Ley Aplicable.</p>
<p>&nbsp;</p>
<h4>16.8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ejemplares.</h4>
<p>El presente Contrato y cualquiera de sus Anexos podr&aacute;n celebrarse en uno o varios ejemplares, cada uno de los cuales es un original, pero constituyen el mismo Contrato.</p>
<p>&nbsp;</p>
<h4>D&Eacute;CIMO S&Eacute;PTIMA. Ley Aplicable; Jurisdicci&oacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El presente Contrato se regir&aacute; e interpretar&aacute; conforme a las leyes federales de M&eacute;xico.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de cualquier controversia o disputa en relaci&oacute;n con el presente Contrato, las Partes se someten a la jurisdicci&oacute;n de los tribunales competentes con sede en la Ciudad de M&eacute;xico, por lo que renuncian expresamente a cualquier otra jurisdicci&oacute;n que pudiera corresponderles en virtud de su domicilio presente o futuro o por cualquier otra raz&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<p><strong>EN TESTIMONIO DE LO ANTERIOR, </strong>las Partes celebran el presente Contrato en la fecha indicada en el Proemio.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>

<p>&nbsp;</p>
<p>ANEXO 1 FACTURACION Y GARANTIAS</p>
<p>El presente documento es el Anexo 1 &ldquo;Facturaci&oacute;n y Garant&iacute;as&rdquo; al que se refiere el Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Anexo tienen el significado que se les atribuye en el Contrato o en el propio Anexo,&nbsp; seg&uacute;n&nbsp; corresponda. Para la interpretaci&oacute;n del presente Anexo, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Objeto</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Este Anexo tiene por objeto describir:</p>
<ul>
<li>El procedimiento para llevar a cabo la facturaci&oacute;n de los Servicios;</li>
<li>Establecer los t&eacute;rminos y condiciones de pago de las facturas que emita Alt&aacute;n por los Servicios y cualquier otro concepto bajo el Contrato;</li>
<li>El procedimiento a seguir para el intercambio de informaci&oacute;n entre las Partes acerca del detalle del consumo de los Servicios por el Cliente; y</li>
<li>El procedimiento para atender objeciones a los c&aacute;lculos de montos facturados.</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Introducci&oacute;n</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Los conceptos y tr&aacute;fico a los que se refiere el proceso de facturaci&oacute;n y pago descrito en el presente Anexo corresponden a cada periodo de facturaci&oacute;n de los Servicios contratados por el Cliente, cuyos periodos de facturaci&oacute;n, tarifas y condiciones econ&oacute;micas se establecen en los Anexos de Servicios. En caso de que cualquier Anexo de Servicios no prevea un periodo de facturaci&oacute;n, &eacute;ste ser&aacute; de 1 (un) mes</li>
<li>Alt&aacute;n facturar&aacute; los Servicios utilizando la informaci&oacute;n generada en su red y sistemas relacionados con los Servicios</li>
</ul>
<p>&nbsp;</p>
<h4><u>TERCERA. Procedimiento de Facturaci&oacute;n y Pago</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>La factura de los Servicios prestados al Cliente durante cada periodo de facturaci&oacute;n y de cualquier otro concepto que se genere durante dicho periodo de facturaci&oacute;n, se emitir&aacute; dentro de los primeros 5 (cinco) D&iacute;as H&aacute;biles siguientes al t&eacute;rmino del periodo de facturaci&oacute;n que corresponda. En caso de que, por alguna raz&oacute;n, Alt&aacute;n no emita la factura respectiva dentro del plazo antes mencionado, Alt&aacute;n informar&aacute; al Cliente de dicho retraso al correo electr&oacute;nico indicado por el Cliente para el env&iacute;o de las facturas en el apartado 3.2</li>
<li>Para la facturaci&oacute;n de los Servicios, Alt&aacute;n tomar&aacute; como base los CDR/TAP y EDR o registros de consumos de tr&aacute;fico generados por los sistemas de Alt&aacute;n. Toda factura se enviar&aacute; por Alt&aacute;n al Cliente por correo electr&oacute;nico a<u><a href="mailto:miguel@elux.com.mx"> miguel@elux.com.mx</a></u>. Tanto las facturas como las notas de cr&eacute;dito emitidas</li>
</ul>
<p>&nbsp;</p>
<p>contendr&aacute;n especificado el producto, unidades, importe y en el caso de las notas de cr&eacute;dito, el concepto del descuento o promoci&oacute;n.</p>
<ul>
<li>Con objeto de mantener al Cliente informado sobre el consumo de Servicios, Alt&aacute;n pondr&aacute; diariamente a disposici&oacute;n del Cliente un archivo para cada Servicio con todos los CDR/TAP y EDR generados el D&iacute;a anterior por sus Usuarios Finales o registros de consumos de tr&aacute;fico (o de los Concesionarios o Comercializadoras). Estos CDR/TAP y EDR no tasados o registros de consumos de tr&aacute;fico estar&aacute;n disponibles al Cliente para su descarga por medio de sFTP. La hora de corte de informaci&oacute;n para dichos archivos es las 00:00 hrs. Tanto el repositorio de los archivos en el sFTP como el formato de los CDR/TAP y EDR ser&aacute;n informados por Alt&aacute;n durante la Puesta en Marcha de los</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente los reportes mensuales de soporte de la facturaci&oacute;n, la cual ser&aacute; depositada en el sFTP en formato CSV. En caso de que a consideraci&oacute;n del Cliente exista informaci&oacute;n faltante o por aclarar en los reportes mensuales de soporte de la facturaci&oacute;n, el Cliente podr&aacute; iniciar el procedimiento de objeciones en los t&eacute;rminos de la Cl&aacute;usula Cuarta del presente Anexo.</p>
<ul>
<li>Salvo que se establezca expresamente otro plazo de pago en el Ap&eacute;ndice &ldquo;T&eacute;rminos Comerciales&rdquo; de alg&uacute;n Servicio, el Cliente deber&aacute; pagar cada factura &iacute;ntegramente a Alt&aacute;n, sin compensaci&oacute;n, deducci&oacute;n o retenci&oacute;n alguna, dentro del plazo de 20 (veinte) D&iacute;as siguientes a la fecha de entrega de la factura de que se trate.</li>
<li>El Cliente efectuar&aacute; todos los pagos en favor de Alt&aacute;n mediante transferencia electr&oacute;nica a la siguiente cuenta bancaria:</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n deber&aacute; notificar al Cliente por escrito con 30 (treinta) D&iacute;as de anticipaci&oacute;n cualquier cambio en la cuenta bancaria indicada para el pago.</p>
<ul>
<li>De conformidad con lo establecido en el Plan T&eacute;cnico Fundamental de Numeraci&oacute;n vigente, Alt&aacute;n expresamente autoriza al Cliente a utilizar el IDO asignado a Alt&aacute;n, para dar cumplimiento a las disposiciones aplicables del Plan T&eacute;cnico Fundamental de Numeraci&oacute;n vigente, as&iacute; como cualquier otra disposici&oacute;n que lo modifique o</li>
<li>Para el Servicio de Capacidad de Red de Acceso de Radio, el Cliente ser&aacute; el &uacute;nico responsable de realizar la solicitud de obtenenci&oacute;n del c&oacute;digo IDO ante el Instituto Federal de</li>
<li>
  <p>A solicitud expresa del Cliente, Alt&aacute;n podr&aacute; enviar y/o cargar la factura correspondiente al portal en l&iacute;nea, sitio web o sistema que para estos efectos sea establecido por el Cliente, siempre que se cumplan los siguientes requisitos:</p>
  <ul>
    <li>El uso de dicho portal, sitio web o sistema no deber&aacute; generar costo alguno para Alt&aacute;n; en caso de que exista alg&uacute;n costo, este deber&aacute; ser a cuenta y cargo del</li>
    <li>Los plazos de pago de las facturas son los indicados en el Inciso 3.4 de esta Cl&aacute;usula con independencia de la fecha en que Alt&aacute;n env&iacute;e o cargue la factura en el portal, sitio web o sistema solicitado por el</li>
    <li>El acceso al portal, sitio web o sistema para carga de facturas no deber&aacute; solicitar informaci&oacute;n que pueda considerarse confidencial o de propiedad exclusiva de Alt&aacute;n.</li>
    <li>La incapacidad, por cualquier motivo del uso del portal en l&iacute;na, sitio web o sistema del Cliente, no modificar&aacute; los plazos de pago del Cliente, ni har&aacute; inv&aacute;lido el env&iacute;o de la factura v&iacute;a correo electr&oacute;nico como indica el presente Anexo.</li>
  </ul>
</li>
</ul>
<p>&nbsp;</p>
<h4><u>CUARTA. Procedimiento de objeciones de factura</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>De conformidad con lo establecido en el apartado 3.3 de este Anexo, el Cliente podr&aacute; verificar mensualmente los consumos de los Servicios mediante de los CDR/TAP, EDR y/o medios que Alt&aacute;n pone a su disposici&oacute;n. En caso de existir alguna discrepancia, a partir de la fecha de entrega de cada factura y durante los 20 (veinte) D&iacute;as siguientes, el Cliente podr&aacute; presentar a Alt&aacute;n objeciones con respecto a las cantidades de los registros de consumos de tr&aacute;fico, CDR/TAP y/o EDR facturados y/o a los c&aacute;lculos realizados para la determinaci&oacute;n de los montos a pagar por el Cliente en dicha factura, expresando detalladamente el Servicio sobre el que se realiza la objeci&oacute;n, las cantidades y/o los c&aacute;lculos objetados, el per&iacute;odo de tiempo correspondiente a la objeci&oacute;n y las causas en las que se fundamenta. Dicha objeci&oacute;n deber&aacute; acompa&ntilde;arse de los CDR/TAP y/o EDR o registros de consumos de tr&aacute;fico contemplados en la objeci&oacute;n. En caso de que no se presenten objeciones con la informaci&oacute;n de soporte antes se&ntilde;alada y dentro de dicho plazo, se considerar&aacute; que el Cliente acepta la factura y renuncia a presentar cualquier objeci&oacute;n, salvo que resulte alguna diferencia en la conciliaci&oacute;n que cada 6 (seis) meses las Partes har&aacute;n de todas las facturas emitidas por Alt&aacute;n conforme a lo establecido en el apartado 4.3 de esta misma Cl&aacute;usula.</li>
</ul>
<p>La presentaci&oacute;n de una objeci&oacute;n conforme a lo anterior no dar&aacute; derecho al Cliente de retener, deducir o compensar monto alguno o de negarse al pago de cualquier factura, por lo que el Cliente deber&aacute; realizar el pago de la(s) factura(s) que sea(n) objetada(s) en los t&eacute;rminos establecidos este Anexo y en Ap&eacute;ndice de T&eacute;rminos Comerciales del Servicio correspondiente, de lo contrario incurrir&aacute; en un incumplimiento de pago. En caso de que la objeci&oacute;n se resuelva a favor del Cliente, Alt&aacute;n emitir&aacute; una nota de cr&eacute;dito a favor del Cliente, de acuerdo con lo establecido en el apartado 4.2 siguiente, la cual ser&aacute; aplicada en la factura siguiente del mismo Servicio.</p>
<ul>
<li>Las objeciones referentes a la facturaci&oacute;n deber&aacute;n ser enviadas a Alt&aacute;n por escrito a la direcci&oacute;n establecida en el Contrato y al correo electr&oacute;nico<u><a href="mailto:facturasclientes@altanredes.com"> facturasclientes@altanredes.com</a></u>.<br />
  Alt&aacute;n dispondr&aacute; de un plazo de 15 (quince) D&iacute;as, desde la notificaci&oacute;n de la objeci&oacute;n por parte del Cliente, para realizar las verificaciones necesarias. Para dicha revisi&oacute;n, Alt&aacute;n utilizar&aacute; sus propios registros de consumos de tr&aacute;fico, &oacute; CDR/TAP y/o EDR generados en la Red Compartida, as&iacute; como sus propios sistemas, pudiendo el Cliente aportar sus propios registros para que sean considerados por Alt&aacute;n en la revisi&oacute;n antes mencionada. Una vez realizada la verificaci&oacute;n, Alt&aacute;n determinar&aacute; y notificar&aacute; al Cliente lo correspondiente y en caso de que resulte que se facturaron montos adicionales y no procedentes al Cliente, Alt&aacute;n emitir&aacute; una nota de cr&eacute;dito en favor del Cliente por el monto correspondiente para ser aplicada en la factura siguiente del mismo Servicio.
</li>
</ul>
<ul>
<li>El Cliente podr&aacute; iniciar el procedimiento de objeci&oacute;n aqu&iacute; previsto respecto de las facturas mensuales emitidas por Alt&aacute;n, si las diferencias entre los montos facturados por Alt&aacute;n y los montos registrados por el Cliente son mayores al 3% (tres por ciento) del monto de la factura. No obstante lo anterior, cada 6 (seis) meses contados a partir de la fecha de firma de este Contrato, las Partes se reunir&aacute;n para realizar una conciliaci&oacute;n de todas las facturas emitidas por Alt&aacute;n durante los 6 (seis) meses anteriores, incluso aquellas facturas que presenten diferencias menores al 3% (tres por ciento). Cualquier objeci&oacute;n que el Cliente inicie como parte de la conciliaci&oacute;n, estar&aacute; sujeta al procedimiento previsto en esta Cl&aacute;usula. Lo anterior, sin perjuicio de que el Cliente pueda recurrir a los mecanismos de soluci&oacute;n de controversias previstos en el</li>
<li>Las objeciones que el Cliente presente conforme a lo aqu&iacute; establecido &uacute;nicamente podr&aacute;n versar respecto a las cantidades de CDR/TAP y/o EDR &oacute; los registros de consumos de tr&aacute;fico facturados y/o a los c&aacute;lculos realizados para determinar el monto facturado y no con respecto a las Tarifas aplicadas, ya que &eacute;stas ser&aacute;n las establecidas en los Ap&eacute;ndices de T&eacute;rminos Comerciales del Servicio correspondiente.</li>
</ul>
<p>&nbsp;</p>
<h4><u>QUINTA. Retrasos en registros y correcciones de periodos anteriores</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En supuestos derivados de retrasos en la puesta a disposici&oacute;n del Cliente de los CDR/TAP y/o EDR &oacute; registros de consumos de tr&aacute;fico necesarios para la facturaci&oacute;n, Alt&aacute;n har&aacute; sus mejores esfuerzos para informar al Cliente de las incidencias, pudiendo facturar los Servicios prestados durante periodos de facturaci&oacute;n anteriores junto con la factura de Servicios prestados durante periodos de facturaci&oacute;n posteriores, sin repercutir costo financiero alguno para el CLIENTE como resultado de dicho</li>
<li>Alt&aacute;n podr&aacute; presentar facturas complementarias respecto de cualquier periodo de facturaci&oacute;n dentro de los 6 (seis) meses siguientes a la expiraci&oacute;n del periodo de facturaci&oacute;n de que se</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEXTA. Intereses Moratorios</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Sin perjuicio de cualquier otro derecho o estipulaci&oacute;n del Contrato, en caso de que el Cliente no pague a su vencimiento cualquier factura en favor de Alt&aacute;n, se causar&aacute;n intereses moratorios sobre la cantidad insoluta a una tasa equivalente a la &uacute;ltima Tasa de Inter&eacute;s Interbancaria de Equilibrio (TIIE) a 28 D&iacute;as publicada por el Banco de M&eacute;xico en la fecha m&aacute;s reciente anterior al incumplimiento de las obligaciones de pago de que se trate, multiplicada por 2 (dos).</li>
<li>Los intereses moratorios se devengar&aacute;n de forma diaria (sobre la base de un a&ntilde;o de 360 D&iacute;as) desde la fecha de vencimiento y hasta la fecha de pago total de la cantidad facturada, y la tasa se recalcular&aacute; mensualmente, siendo dichos intereses moratorios inmediatamente pagaderos y exigibles.</li>
</ul>
<ul>
<li>El Cliente reconoce y acepta que los pagos realizados ser&aacute;n aplicados en primera instancia a los intereses moratorios y posteriormente a los importes facturados de los Servicios de que se</li>
<li>ALT&Aacute;N emitir&aacute; una factura desglosando los intereses moratorios, m&aacute;s el Impuesto al Valor Agregado (IVA) y cualquier otro</li>
</ul>
<p>&nbsp;</p>
<h4><u>S&Eacute;PTIMA. Cumplimiento de las obligaciones de pago</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Con la finalidad de garantizar el pago puntual y oportuno de los Servicios contratados al amparo del Contrato, las Partes acuerdan que en caso de que el Cliente no subsane el incumplimiento al pago de la Contraprestaci&oacute;n en los 15 (quince) D&iacute;as posteriores al vencimiento del plazo establecido en el numeral 3.4 del presente Anexo, Alt&aacute;n podr&aacute; realizar la suspensi&oacute;n de Altas de Usuarios Finales del Cliente, sin necesidad de notificaci&oacute;n judicial o administrativa alguna, hasta en tanto el Cliente realice el pago total del monto de las cantidades adeudadas, m&aacute;s los Intereses Moratorios calculados en t&eacute;rminos de la Cl&aacute;usula Sexta del presente</li>
<li>Los pagos que realicen los Clientes se abonar&aacute;n en el orden siguiente:
<ul>
<li>A los intereses moratorios, si existieran;</li>
<li>A la pena convencional descrita en el Contrato, en su caso;</li>
<li>A los servicios mayoristas de telecomunicaciones contratados de conformidad con el presente Contrato y sus respectivos Convenios Modificatorios.</li>
</ul>
</li>
</ul>
<p>Considerando el orden de pago anterior, cualquier pago se aplicar&aacute; a la deuda m&aacute;s antigua.</p>
<p>&nbsp;</p>
<h4><u>OCTAVA. Promociones</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Alt&aacute;n podr&aacute; ofrecer de forma no discriminatoria promociones a sus Clientes conforme a los Servicios que estos tienen</li>
<li>El Cliente ser&aacute; beneficiario de las promociones cuando se cumplan todas las condiciones requeridas por la promoci&oacute;n, en este caso, el beneficio para el Cliente le ser&aacute; entregado a trav&eacute;s de una o varias notas de cr&eacute;dito.</li>
<li>La o las notas de cr&eacute;dito podr&aacute;n ser aplicadas en la factura correspondiente al mismo per&iacute;odo de facturaci&oacute;n o al siguiente, pero en ning&uacute;n caso estar&aacute; permitido aplicar las notas de cr&eacute;dito a un per&iacute;odo de facturaci&oacute;n</li>
</ul>
<p>&nbsp;</p>
<h4><u>NOVENA. Consideraciones generales</u></h4>
<p><strong>&nbsp;</strong></p>
<p>En caso de que el Cliente solicite que Alt&aacute;n como proveedor obtenga alg&uacute;n tipo de certificaci&oacute;n para poder proveerle Servicios de Telecomunicaciones, Alt&aacute;n realizar&aacute; el an&aacute;lisis previo de esta solicitud y le informar&aacute; al Cliente si Alt&aacute;n realizar&aacute; o no dicha certificaci&oacute;n. En ning&uacute;n caso el Cliente podr&aacute; condicionar el cumplimiento de cualquier</p>
<p>&nbsp;</p>
<p>cl&aacute;usula de este Contrato a la obtenci&oacute;n de cualquier tipo de certificaci&oacute;n por parte de Alt&aacute;n.</p>
<p>La certificaci&oacute;n a la que se refiere el p&aacute;rrafo anterior no podr&aacute; solicitar informaci&oacute;n o documentaci&oacute;n que pueda considerarse confidencial o de propiedad exclusiva de Alt&aacute;n y la entidad certificadora o el Cliente, en su caso, deber&aacute; cumplir con lo dispuesto en la Ley Federal de Protecci&oacute;n de Datos Personales en Posesi&oacute;n de los Particulares, as&iacute; como la Cl&aacute;usula D&eacute;cimo Primera del Contrato.</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Anexo, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>ANEXO 2 PROCEDIMIENTOS OPERATIVOS</p>
<p>El presente documento es el Anexo 2 &ldquo;Procedimientos Operativos&rdquo; al que se refiere el Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Anexo tienen el significado que se les atribuye en el Contrato o en el propio Anexo,&nbsp; seg&uacute;n&nbsp; corresponda. Para la interpretaci&oacute;n del presente Anexo, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Introducci&oacute;n</u></h4>
<p><strong>&nbsp;</strong></p>
<p><strong>1.1&nbsp;&nbsp; </strong>El presente Anexo establece el modelo de gobierno y operativo conforme al cual las Partes gestionar&aacute;n y administrar&aacute;n su relaci&oacute;n bajo el Contrato y la ejecuci&oacute;n de los Servicios.</p>
<p>&nbsp;</p>
<p>Para tales efectos, se consideran las siguientes fases o etapas para la prestaci&oacute;n de los Servicios en la relaci&oacute;n entre Alt&aacute;n y el Cliente:</p>
<p>&nbsp;</p>
<ol>
<li>Puesta en Marcha de los</li>
<li>Gesti&oacute;n Operativa y Comercial de los</li>
</ol>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Puesta en Marcha de los Servicios; Comit&eacute; de Puesta en Marcha; LLD.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>La Puesta en Marcha de los Servicios, incluir&aacute; las actividades, acciones, pruebas t&eacute;cnicas y de servicio, desarrolladas conjuntamente entre Alt&aacute;n y el Cliente, que resulten necesarias para la gesti&oacute;n operativa de los</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Para la correcta gesti&oacute;n y ejecuci&oacute;n de la Puesta en Marcha de los Servicios, las Partes formar&aacute;n un Comit&eacute; de Puesta en Marcha integrado por al menos 1 (un) representante de cada una de las Dichos representantes deber&aacute;n ser nombrados dentro de los 10 (diez) D&iacute;as siguientes a la fecha de firma del Contrato y podr&aacute;n ser sustituidos por las Partes, mediante notificaci&oacute;n a la otra Parte con al menos 10 (diez) D&iacute;as de anticipaci&oacute;n a la fecha efectiva de la sustituci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>El Comit&eacute; de Puesta en Marcha se reunir&aacute; por lo menos una vez a la semana desde la fecha de firma del Contrato y hasta lograr la Puesta en Marcha de los Servicios objeto del Contrato.</p>
<p>&nbsp;</p>
<ul>
<li>Las principales actividades a desarrollar durante la Puesta en Marcha de los Servicios, las cuales deber&aacute;n ser validadas y aprobadas por el Comit&eacute; de Puesta en Marcha, son las siguientes:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Revisi&oacute;n y modificaci&oacute;n, en caso de que proceda, del Plan de Proyecto del Servicio respectivo.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Revisi&oacute;n del alcance de la soluci&oacute;n t&eacute;cnica y funcional incluida en el Ap&eacute;ndice de Alcance T&eacute;cnico aplicable al Servicio</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Preparaci&oacute;n por parte de Alt&aacute;n del Documento del <em>Low Level Design </em>(&ldquo;LLD&rdquo;) para cada uno de los Servicios contratados, el cual incluir&aacute;, entre otras, cosas:</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Requerimientos de negocio y funcionales por parte de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Detalle de las integraciones t&eacute;cnicas e interfaces, escenarios y casos de llamada en</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Matriz de</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Requerimientos de negocio y funcionales por parte del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Plan de pruebas y de aceptaci&oacute;n de los Servicios</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Seguimiento de la implantaci&oacute;n de los Planes de Proyecto de los Servicios, debiendo identificar posibles desviaciones en la planificaci&oacute;n y alcance, as&iacute; como propuestas de planes de acci&oacute;n para corregir dichas</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Realizaci&oacute;n de pruebas t&eacute;cnicas y comerciales de los</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Realizaci&oacute;n de pruebas de aceptaci&oacute;n de los</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Para la elaboraci&oacute;n del LLD, Alt&aacute;n tomar&aacute; como documentaci&oacute;n base los Ap&eacute;ndices T&eacute;cnicos y Comerciales aplicables al Servicio que corresponda y la documentaci&oacute;n t&eacute;cnica asociada a dicho Servicio.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente entregar&aacute;, en un plazo no mayor a 15 (quince) D&iacute;as siguientes a la firma del Contrato, un documento de &ldquo;Especificaciones Funcionales y de Servicio&rdquo; que deber&aacute; contener, entre otras cosas: (i) las especificaciones funcionales de los Servicios;</li>
</ul>
<p>(ii) la definici&oacute;n de los flujos de trabajo, procesos de negocio, interfaces e integraciones con terceras partes (e.g. <em>Call Center</em>) que quisiera tener disponibles para la realizaci&oacute;n de las pruebas de aceptaci&oacute;n de los Servicios.</p>
<p>&nbsp;</p>
<ul>
<li>En caso de que Cliente no entregue las &ldquo;Especificaciones Funcionales y de Servicio&rdquo; en el plazo antes mencionado, el Cliente acepta que Alt&aacute;n desarrollar&aacute; el LLD &uacute;nicamente con base en lo establecido en los Ap&eacute;ndices de Alcance T&eacute;cnico y de T&eacute;rminos Comerciales aplicables al Servicio respectivo y la documentaci&oacute;n t&eacute;cnica asociada a dicho Servicio.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n proceder&aacute; al estudio y an&aacute;lisis de las Especificaciones Funcionales y de Servicio entregadas por el Cliente y lo incorporar&aacute; al LLD de cada uno de los Servicios. Si como resultado de la evaluaci&oacute;n se identifica que para alguno de los Servicios hay alg&uacute;n cambio esencial que requiera una extensi&oacute;n del Plan de Proyecto o de los costos de Puesta en Marcha ya contemplados, las Partes deber&aacute;n seguir el procedimiento descrito en la Cl&aacute;usula Cuarta de este Anexo para acordar los cambios</li>
</ul>
<p>&nbsp;</p>
<h4><u>TERCERA. Gesti&oacute;n Operativa y Comercial del Cliente</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Una vez lograda la Puesta en Marcha del Servicio correspondiente, iniciar&aacute; la fase de Gesti&oacute;n Operativa y Comercial para dicho Servicio. Para la Gesti&oacute;n Operativa y Comercial, Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Centro de Operaciones (&ldquo;NOC&rdquo;), para la gesti&oacute;n de incidencias que se puedan producir en la actividad diaria del Cliente; y</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Un Responsable Comercial, encargado de gestionar las solicitudes comerciales y t&eacute;cnicas del Cliente que se puedan producir durante la prestaci&oacute;n de los Servicios.</li>
</ul>
<p>&nbsp;</p>
<h4>3.1.1.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Centro de Operaciones (NOC)</h4>
<p><strong>&nbsp;</strong></p>
<p>El NOC de Alt&aacute;n, se encargar&aacute; de la atenci&oacute;n de incidencias t&eacute;cnicas y del soporte continuo al Cliente en los procesos operativos y de mantenimiento.</p>
<p>&nbsp;</p>
<p>Por su parte, el Cliente deber&aacute; contar con sus propios canales de atenci&oacute;n de incidencias y/o reclamaciones de los Usuarios Finales. El Cliente no podr&aacute; dirigir solicitudes de atenci&oacute;n de incidencias y/o reclamaciones de sus Usuarios Finales a Alt&aacute;n.</p>
<p>&nbsp;</p>
<ul>
<li>
  <strong>Organizaci&oacute;n Centro de Operaciones (en adelante &ldquo;<strong>NOC</strong>&rdquo;).<br /></strong>
</li>
<p>Los procesos para la gesti&oacute;n de incidencias dentro del NOC se describen en el Ap&eacute;ndice de Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias del Servicio correspondiente. Alt&aacute;n facilitar&aacute; al Cliente un sistema de <em>trouble-ticketing </em>y un tel&eacute;fono de contacto, seg&uacute;n dichas herramientas sean modificadas de tiempo en tiempo, donde el Cliente podr&aacute; abrir nuevas incidencias, as&iacute; como realizar el seguimiento de las existentes. El medio de comunicaci&oacute;n de incidencias que el Cliente deber&aacute; usar preferentemente es el sistema de <em>trouble-ticketing</em>, por lo que el tel&eacute;fono de contacto &uacute;nicamente es una alternativa que el Cliente puede usar en caso de que el sistema de <em>trouble-ticketing </em>no se encuentre disponible al momento de la comunicaci&oacute;n de la incidencia respectiva.</p>
<p>&nbsp;</p>
<p>En caso de que el Cliente comunique alguna incidencia por medio del tel&eacute;fono de contacto, el NOC abrir&aacute; un <em>trouble-ticket </em>en el sistema de <em>trouble-ticketing </em>para que el Cliente pueda dar seguimiento a las incidencias existentes y para que Alt&aacute;n pueda proporcionar cualquier respuesta al Cliente respecto a las mismas, a trav&eacute;s del sistema de <em>trouble-ticketing</em>. El Cliente reconoce y acepta que las llamadas que realice al tel&eacute;fono de contacto del NOC ser&aacute;n grabadas y ser&aacute;n registradas con fecha y hora con la finalidad de controlar la calidad de los servicios prestados por el NOC y de brindar seguridad a ambas partes en el manejo de las incidencias que se lleguen a presentar.</p>
<p>&nbsp;</p>
<p>Adicionalmente, para aquellas Incidencias Cr&iacute;ticas, Alt&aacute;n dispondr&aacute; de un soporte de incidencias 24x7.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n proporcionar&aacute; al Cliente capacitaci&oacute;n para la gesti&oacute;n de incidencias ante el NOC sin costo alguno para el Cliente, la cual deber&aacute; ser prestada conforme a los t&eacute;rminos, requerimientos y condiciones establecidos por Alt&aacute;n para tal efecto. Las fechas y lugares de dicha capacitaci&oacute;n ser&aacute;n definidas en el Plan de Proyecto.</p>
<p>&nbsp;</p>
</ul>
<ul>
<li><strong>Funciones del NOC</strong></li>
</ul>
<p>El NOC &uacute;nicamente prestar&aacute; servicios al Cliente y no a sus Usuarios Finales u otros Concesionarios o Comercializadoras, por lo que &uacute;nicamente los representantes o la mesa de servicio designados por el Cliente podr&aacute;n hacer uso del NOC.</p>
<p>&nbsp;</p>
<p>El NOC gestionar&aacute; toda la relaci&oacute;n operativa entre el Cliente y Alt&aacute;n y ser&aacute; el medio de comunicaci&oacute;n al Cliente de los trabajos de mantenimiento, tanto preventivos como correctivos, que impacten los Servicios, as&iacute; como aquellas incidencias que pudieran causar afectaci&oacute;n a los Servicios, facilitando un tiempo esperado de respuesta y soluci&oacute;n.</p>
<p>&nbsp;</p>
<ul>
<li><strong>Programas de Mantenimiento</strong></li>
</ul>
<p>&nbsp;</p>
<ul>
<li><strong>Mantenimientos Preventivos:</strong></li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n realizar&aacute; una planificaci&oacute;n del mantenimiento preventivo de sus distintos Servicios, as&iacute; como de los tiempos de no-disponibilidad programada de los mismos.</p>
<p>&nbsp;</p>
<p>Asimismo, Alt&aacute;n realizar&aacute; una planificaci&oacute;n del mantenimiento preventivo de la Infraestructura de Alt&aacute;n, con fechas previstas de inicio y fin de los trabajos de mantenimiento. Esta planificaci&oacute;n ser&aacute; comunicada por Alt&aacute;n al Cliente para que &eacute;ste pueda llevar a cabo de forma m&aacute;s eficiente la gesti&oacute;n de su negocio.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n llevar&aacute; a cabo la ejecuci&oacute;n de los trabajos de mantenimiento preventivo en la ventana horaria nocturna de 23:00h a 05:00h para minimizar la afectaci&oacute;n a los Servicios. Sin embargo, en algunos casos los trabajos de mantenimiento programados se realizar&aacute;n fuera de esta ventana de tiempo.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n, por medio del NOC o cualquier otro medio que acuerden las Partes, comunicar&aacute; al Cliente el programa de mantenimiento, una vez completada su planificaci&oacute;n, al menos con 5 (cinco) D&iacute;as H&aacute;biles de anticipaci&oacute;n a que inicie el programa de mantenimiento correspondiente. En caso de que el mantenimiento no sea cr&iacute;tico o general, el Cliente podr&aacute; proponer a Alt&aacute;n fechas distintas para realizarlo dentro del plazo antes mencionado, en cuyo caso Alt&aacute;n confirmar&aacute; si dichas fechas son aceptables o no a trav&eacute;s del NOC o del medio que hayan acordado las Partes. Si el Cliente no hace propuesta alguna dentro de dicho plazo, se entender&aacute; que est&aacute; de acuerdo con el programa de mantenimiento. Los mantenimientos cr&iacute;ticos o generales deber&aacute;n ser realizados en las fechas propuestas por Alt&aacute;n.</p>
<p>&nbsp;</p>
<p>Alt&aacute;n se compromete a comunicar al Cliente los trabajos de mantenimiento preventivo con la mayor antelaci&oacute;n posible, previo a la ejecuci&oacute;n de los mismos.</p>
<p>&nbsp;</p>
<ul>
<li><strong>Mantenimientos Correctivos:</strong></li>
</ul>
<p>&nbsp;</p>
<p>Los trabajos de mantenimiento correctivo que no puedan ser planificados con antelaci&oacute;n, tendr&aacute;n ejecuci&oacute;n inmediata y ser&aacute;n comunicados al Cliente a trav&eacute;s del NOC o cualquier otro medio que acuerden las Partes, siempre buscando el menor impacto para los Usuarios Finales. Aquellos trabajos de mantenimiento correctivo que si puedan ser planificados, ser&aacute;n comunicados por Alt&aacute;n al Cliente con la anticipaci&oacute;n que sea factible en cada caso.</p>
<p>&nbsp;</p>
<h4>3.1.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Responsable Comercial.</h4>
<p><strong>&nbsp;</strong></p>
<p>Alt&aacute;n designar&aacute; un Responsable Comercial que estar&aacute; encargado de recibir y gestionar internamente las consultas y solicitudes relativas al cumplimiento de este Contrato por parte de Alt&aacute;n que realice el Cliente, as&iacute; como de comunicar la respuesta a esas consultas o solicitudes.</p>
<p>&nbsp;</p>
<p>El Responsable Comercial &uacute;nicamente prestar&aacute; servicios al Cliente y no a sus Usuarios Finales u otros Concesionarios o Comercializadoras a los que el Cliente preste servicios, por lo que &uacute;nicamente los representantes o la mesa de servicio designados por el Cliente podr&aacute;n contactar con &eacute;l.</p>
<p>&nbsp;</p>
<p>Las consultas y solicitudes que se presenten al Representante Comercial deber&aacute;n ser realizadas conforme a los requerimientos establecidos en la Cl&aacute;usula &ldquo;Notificaciones&rdquo; del Contrato. En caso de que cualquier otra Cl&aacute;usula de este Anexo, el Contrato sus Anexos y/o Ap&eacute;ndices establezcan cualquier otro medio o herramienta de notificaci&oacute;n, las Partes convienen en utilizar dicho medio o herramienta para realizar las notificaciones respectivas. En el supuesto de que las consultas y solicitudes no sean enviadas conforme a lo anterior, se tendr&aacute;n como no realizadas.</p>
<p>&nbsp;</p>
<ul>
<li>Funciones y Facultades del Responsable Comercial</li>
</ul>
<p>&nbsp;</p>
<p>El Responsable Comercial tendr&aacute; las siguientes facultades y atribuciones:</p>
<p>&nbsp;</p>
<ul>
<li>Ser interlocutor y gestionar la relaci&oacute;n comercial y t&eacute;cnica entre el Cliente y Alt&aacute;n.</li>
<li>Gestionar el proceso de facturaci&oacute;n con el</li>
<li>Gestionar el proceso de actualizaci&oacute;n de las proyecciones de tr&aacute;fico y Usuarios Finales.</li>
<li>Para el Servicio de Capacidad de Red de Acceso de Radio, gestionar el proceso de actualizaci&oacute;n de las proyecciones de tr&aacute;fico y asignaci&oacute;n o reasignaci&oacute;n de bloques de capacidad por sitio de</li>
<li>Recibir las solicitudes de Servicios Adicionales. Una vez recibida la solicitud, el Responsable Comercial informar&aacute; por escrito de la viabilidad t&eacute;cnica o no de la prestaci&oacute;n de tales Servicios, as&iacute; como de los requerimientos t&eacute;cnicos y Tarifas de dichos Servicios y la planificaci&oacute;n para la Puesta en</li>
<li>Atenci&oacute;n de requerimientos relativos a la transparencia en la administraci&oacute;n de la Red</li>
<li>Entregar al Cliente la informaci&oacute;n que &eacute;ste le solicite de acuerdo con lo establecido en la Cl&aacute;usula 3.1.2 anterior y que est&eacute; relacionada con el cumplimiento de las obligaciones de Alt&aacute;n conforme al Contrato y/o sus Anexos y Ap&eacute;ndices.</li>
</ul>
<p>&nbsp;</p>
<h4><u>CUARTA. Gesti&oacute;n de Cambios</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Las Solicitudes de Cambio pueden ser generadas por el Cliente en 2 (dos) fases:</li>
</ul>
<p>(i) durante la Puesta en Marcha de los Servicios; o (ii) durante la gesti&oacute;n operativa y comercial del Cliente.</p>
<p>&nbsp;</p>
<ul>
<li>Para las Solicitudes de Cambios realizadas durante la Puesta en Marcha de los Servicios, el Cliente comunicar&aacute; a Alt&aacute;n las modificaciones que requiera respecto de los Ap&eacute;ndices de T&eacute;rminos Comerciales y Alcance T&eacute;cnico aplicables al Servicio que corresponda y la documentaci&oacute;n t&eacute;cnica asociada a dicho Servicio. Alt&aacute;n evaluar&aacute; la solicitud hecha por el Cliente y brindar&aacute; una propuesta t&eacute;cnica y/o econ&oacute;mica al Cliente dentro de los siguientes 15 (quince) D&iacute;as H&aacute;biles. El Cliente dispondr&aacute; de 7 (siete) D&iacute;as H&aacute;biles para aceptar las modificaciones propuestas por Alt&aacute;n o rechazarlas. En caso de aceptarlas, Alt&aacute;n las incorporar&aacute; al LLD y a la revisi&oacute;n del Plan de Proyecto del Servicio respectivo. En caso de no aceptarlas, ambas Partes acuerdan sujetarse a los t&eacute;rminos y condiciones establecidos originalmente para la prestaci&oacute;n del Servicio de que se trate.</li>
</ul>
<ul>
<li>Para las Solicitudes de Cambios realizadas durante la gesti&oacute;n operativa y comercial del Cliente, este &uacute;ltimo realizar&aacute; una solicitud a Alt&aacute;n describiendo claramente el alcance de dicha solicitud. Alt&aacute;n evaluar&aacute; la solicitud hecha por el Cliente y brindar&aacute; una propuesta t&eacute;cnica y/o econ&oacute;mica al Cliente dentro de los siguientes 15 (quince) D&iacute;as H&aacute;biles. El Cliente dispondr&aacute; de 7 (siete) D&iacute;as H&aacute;biles para aceptar las modificaciones propuestas por Alt&aacute;n o rechazarlas. En caso de aceptarlas, las Partes las incorporar&aacute;n a los Ap&eacute;ndices de T&eacute;rminos Comerciales y/o Alcance T&eacute;cnico del Servicio respectivo mediante la firma del acuerdo modificatorio En caso de no aceptarlas, ambas Partes acuerdan sujetarse a los t&eacute;rminos y condiciones establecidos originalmente para la prestaci&oacute;n del Servicio de que se trate.</li>
</ul>
<p>&nbsp;</p>
<h4><u>QUINTA. Mecanismos de Intercambio de Informaci&oacute;n para el Cumplimiento de</u> <u>Requerimientos del IFT</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En caso de que alguna de las Partes reciba un requerimiento del IFT para presentar informaci&oacute;n relacionada con el Contrato y/o los Servicios, la Parte que reciba dicho requerimiento deber&aacute; analizarlo y determinar si puede solventar o no la solicitud de informaci&oacute;n del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de que la Parte que recibi&oacute; la solicitud de informaci&oacute;n requiera de informaci&oacute;n de la otra Parte, la Parte que reciba el requerimiento deber&aacute; enviar una solicitud por escrito a la otra: (i) indicando espec&iacute;ficamente la informaci&oacute;n que requiere para cumplir con la solicitud del IFT; (ii) justificando la necesidad y uso que se dar&aacute; a la misma; (iii) especificando el plazo para la presentaci&oacute;n de la informaci&oacute;n, el cual no podr&aacute; ser menor a 5 (cinco) D&iacute;as H&aacute;biles (salvo que se exija un plazo menor para cumplir con el requerimiento correspondiente); y (iv) acompa&ntilde;ando una copia simple del requerimiento del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La Parte que reciba la solicitud de informaci&oacute;n de la otra conforme a lo establecido en el p&aacute;rrafo anterior, tendr&aacute; 5 (cinco) D&iacute;as H&aacute;biles para entregar la misma y proporcionar una contestaci&oacute;n, salvo que la Ley Aplicable y/o cualquier autoridad exija un plazo menor. En caso de que determine procedente entregar la informaci&oacute;n requerida, proporcionar&aacute; la misma por escrito a la Parte solicitante dentro del plazo antes establecido, debiendo indicar si la informaci&oacute;n debe ser clasificada como reservada o confidencial y las razones para ello. Sin embargo, en el supuesto de que no considere procedente la solicitud de informaci&oacute;n de la Parte requirente, deber&aacute; proporcionar su contestaci&oacute;n dentro del plazo se&ntilde;alado para tal efecto en este p&aacute;rrafo, debiendo justificar las razones para no entregar la informaci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Cualquier discrepancia respecto a una solicitud de informaci&oacute;n de parte del IFT deber&aacute; ser resuelta por el Responsable</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEXTA. Transparencia en la Gesti&oacute;n del Trafico</u></h4>
<p><strong>&nbsp;</strong></p>
<p><strong>6.1 </strong>Alt&aacute;n proporcionar&aacute; al Cliente la&nbsp; informaci&oacute;n relativa&nbsp; a la gesti&oacute;n del tr&aacute;fico&nbsp; cursado a trav&eacute;s de los Servicios mediante los CDR y EDR, o registros de consumo de tr&aacute;fico que Alt&aacute;n pone a disposici&oacute;n del Cliente para efectos de facturaci&oacute;n de las Tarifas de los Servicios, de conformidad con lo establecido en el Anexo 1 &ldquo;Facturaci&oacute;n y Garant&iacute;as&rdquo; del Contrato.</p>
<p>&nbsp;</p>
<h4><u>S&Eacute;PTIMA. Transparencia en la Administraci&oacute;n de la Red Compartida</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En caso de que el Cliente requiera informaci&oacute;n en materia de administraci&oacute;n de red respecto a la Red Compartida, podr&aacute; presentar una solicitud al Responsable Comercial conforme a la Cl&aacute;usula 3.1.2 de este Anexo. El Responsable Comercial analizar&aacute; la solicitud del Cliente y le proporcionar&aacute; la informaci&oacute;n que estime</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente no podr&aacute;, directa o indirectamente, o a trav&eacute;s de cualquier Persona que forme parte de su Grupo de Inter&eacute;s Econ&oacute;mico, tener influencia alguna en la operaci&oacute;n de la Red</li>
</ul>
<p>&nbsp;</p>
<h4><u>OCTAVA.&nbsp;&nbsp; Colaboraci&oacute;n&nbsp;&nbsp;&nbsp; con&nbsp;&nbsp;&nbsp; las&nbsp;&nbsp;&nbsp; Instancias&nbsp;&nbsp;&nbsp; de&nbsp;&nbsp;&nbsp; Seguridad,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Procuraci&oacute;n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; y</u> <u>Administraci&oacute;n de Justicia</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En caso de que una de las Partes reciba un requerimiento de una Autoridad Gubernamental en materia de seguridad, procuraci&oacute;n y administraci&oacute;n de justicia (e.g. geolocalizaci&oacute;n o interceptaci&oacute;n legal), las Partes se coordinar&aacute;n para atender dicho requerimiento de acuerdo con lo establecido para tal efecto en el Ap&eacute;ndice de Alcance T&eacute;cnico del Servicio</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia no es aplicable al Servicio de Capacidad de Red de Acceso de</li>
</ul>
<p>&nbsp;</p>
<h4><u>NOVENA. Mecanismos de Informaci&oacute;n sobre Planificaci&oacute;n de Modificaci&oacute;n de la</u> <u>Red Compartida</u></h4>
<p><strong>&nbsp;</strong></p>
<p><strong>9.1 </strong>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente una herramienta&nbsp; de&nbsp; consulta&nbsp; de&nbsp; la cobertura de la Red Compartida, la cual habilitar&aacute; dentro de los 90 (noventa) D&iacute;as siguientes a la Puesta en Marcha del Servicio correspondiente por primera vez, en la cual podr&aacute; consultar la informaci&oacute;n relativa a los planes de modificaci&oacute;n de la Red Compartida. La informaci&oacute;n contenida en dicha herramienta de consulta ser&aacute; actualizada en la misma medida en que sea necesario presentar la informaci&oacute;n de Cobertura al IFT, es decir, de forma trimestral.</p>
<p>&nbsp;</p>
<p>[EL RESTO DE LA P&Aacute;GINA ES INTENCIONALMENTE DEJADO EN BLANCO; SIGUE P&Aacute;GINA DE FIRMAS]</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Anexo, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>ANEXO 3 GLOSARIO DE T&Eacute;RMINOS</p>
<p>El presente documento es el Anexo 3 &ldquo;Glosario de T&eacute;rminos&rdquo; al que se refiere el Contrato</p>
<p>Marco&nbsp; de&nbsp; Prestaci&oacute;n&nbsp; de&nbsp; Servicios&nbsp; de&nbsp; Telecomunicaciones&nbsp; (junto&nbsp; con&nbsp; sus&nbsp; Anexos&nbsp;&nbsp;&nbsp;&nbsp; y Ap&eacute;ndices, el &ldquo;Contrato&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos definidos en el presente Anexo tienen el significado que se les atribuye en este Anexo. Para la interpretaci&oacute;n del presente Anexo, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<p><strong>&ldquo;ABD&rdquo; </strong>es el Administrador de la Base de Datos de Portabilidad.</p>
<p><strong>&ldquo;ACS&rdquo; </strong>se refiere a Access Control Service.</p>
<p><strong>&ldquo;Acuerdos de Nivel de Servicio&rdquo; </strong>significan los acuerdos de nivel de servicios establecidos para cada tipo de Servicio en el Anexo de Servicios correspondiente.</p>
<p><strong>&ldquo;Acuerdo de Usuario Visitante&rdquo; </strong>significa un acuerdo de Alt&aacute;n que celebra con otro operador de red m&oacute;vil para el uso de servicios de acceso en las zonas de cobertura que determina Alt&aacute;n bajo los t&eacute;rminos y condiciones que el proveedor de dichos servicios presta a Alt&aacute;n.</p>
<p><strong>&ldquo;Afiliada&rdquo; </strong>significa una empresa que controle al Cliente, una empresa que se encuentre y permanezca bajo el control del Cliente o una empresa que se encuentre y permanezca bajo el control com&uacute;n del Cliente.</p>
<p><strong>&ldquo;Agente Econ&oacute;mico Preponderante&rdquo; </strong>se considerar&aacute; como aquel agente econ&oacute;mico que preste servicios de Telecomunicaciones, que cuente directa o indirectamente, con una participaci&oacute;n nacional mayor al 50%, medido este porcentaje ya sea por el n&uacute;mero de usuarios, suscriptores, audiencia, por el tr&aacute;fico en sus redes o por la capacidad utilizada de las mismas, de acuerdo con los datos con que disponga el IFT.</p>
<p><strong>&ldquo;Alta de Usuarios Finales&rdquo; </strong>es el proceso en virtud del cual el Usuario Final pasa de un Estado Pre-Activo a un Estado Activo.</p>
<p><strong>&ldquo;Alt&aacute;n&rdquo; </strong>tiene el significado que se le atribuye en el Proemio, e incluye a sus cesionarios o causahabientes permitidos conforme a los t&eacute;rminos del Contrato.</p>
<p><strong>&ldquo;AMR&rdquo; </strong>se refiere al CODEC de Voz denominado Adaptive Multi Rate.</p>
<p><strong>&ldquo;AMR-WB&rdquo; </strong>se refiere al CODEC de Voz denominado Adaptive Multi Rate Wideband.</p>
<p><strong>&ldquo;Anexos&rdquo; </strong>significa los Anexos Generales y los Anexos de Servicios, junto con sus respectivos Ap&eacute;ndices.</p>
<p><strong>&ldquo;Anexos de Servicios&rdquo; </strong>significa los Anexos (excepto por los Anexos Generales) y sus Ap&eacute;ndices.</p>
<p><strong>&ldquo;Anexos Generales&rdquo; </strong>significa los Anexos de &ldquo;Facturaci&oacute;n y Garant&iacute;as&rdquo;, &ldquo;Procedimientos Operativos&rdquo; y &ldquo;Glosario de T&eacute;rminos&rdquo;.</p>
<p>&nbsp;</p>
<p><strong>&ldquo;Ap&eacute;ndices&rdquo; </strong>significan los Ap&eacute;ndices a los Anexos de Servicios.</p>
<p><strong>&ldquo;ATP&rdquo; </strong>Hom&oacute;nimo del ingl&eacute;s Acceptance Test Protocol. Documento que se genera al realizar las pruebas de un nodo seg&uacute;n el protocolo definido para su aceptaci&oacute;n.</p>
<p><strong>&ldquo;API-GW&rdquo; </strong>se refiere a Application Programming Interface Gateway.</p>
<p><strong>&ldquo;APN&rdquo; </strong>se refiere a Access Point Name.</p>
<p><strong>&ldquo;Applet Multi-IMSI&rdquo; </strong>se refiere a un componente applet para permitir la configuraci&oacute;n de m&uacute;ltiples IMSIs en la misma SIM.</p>
<p><strong>&ldquo;ASCII&rdquo; </strong>se refiere a American Standard Code for Information Interchange.</p>
<p><strong>&ldquo;ASL&rdquo; </strong>se refiere a las &Aacute;reas de Servicio Local definidas por IFT.</p>
<p><strong>&ldquo;Autoridad Gubernamental&rdquo; </strong>significa cualquier gobierno o subdivisi&oacute;n pol&iacute;tica de &eacute;ste, sea federal, estatal o municipal, cualquiera de los poderes ejecutivo, legislativo o judicial, y cualquier agencia de gobierno, autoridad, dependencia, organismo descentralizado, tribunal, banco central u otra entidad que ejerza funciones de gobierno ejecutivas, legislativas o judiciales.</p>
<p><strong>&ldquo;Autorizaci&oacute;n Gubernamental&rdquo; </strong>significa cualquier autorizaci&oacute;n, aprobaci&oacute;n, licencia, concesi&oacute;n, permiso, registro, requerimiento, sentencia, resoluci&oacute;n, orden, decreto, publicaci&oacute;n o notificaci&oacute;n de cualquier Autoridad Gubernamental.</p>
<p><strong>&ldquo;Aviso de Privacidad&rdquo; </strong>es el documento emitido por cada una de las Partes y que establece la forma de recopilar, tratar y manejar los datos personales que les sean proporcionados, el cual deber&aacute; cumplir con las disposiciones de la Ley Federal de Protecci&oacute;n de Datos Personales en Posesi&oacute;n de los Particulares, su reglamento, lineamientos y cualquier otra disposici&oacute;n aplicable.</p>
<p><strong>&ldquo;BB&rdquo; </strong>Acr&oacute;nimo de Backbone. Es la soluci&oacute;n definida por los operadores m&oacute;viles para la conexi&oacute;n de redes de larga distancia incluyendo gesti&oacute;n de tr&aacute;fico que puede ser de diferentes tecnolog&iacute;as como IP o DWDM.</p>
<p><strong>&ldquo;BBH&rdquo; </strong>se refiere a Hotel de Banda Base (Base Band Hotel), punto de alojamiento f&iacute;sico de infraestructura para intercambio de datos entre dos redes</p>
<p><strong>&ldquo;BH&rdquo; </strong>se refiere a BackHaul, conexi&oacute;n entre un punto de acceso de trafico de una red hacia un punto de transporte Backbone o CORE. Considera las redes metropolitanas de acceso y agregaci&oacute;n para la gesti&oacute;n del tr&aacute;fico.</p>
<p><strong>&ldquo;BSS&rdquo; </strong>se refiere a Business Support Systems.</p>
<p><strong>&ldquo;Cadenas de Recarga&rdquo; </strong>se refiere al canal mediante el cual se comercializan las recargas electr&oacute;nicas.</p>
<p><strong>&ldquo;Call Center&rdquo; </strong>es un centro de llamadas telef&oacute;nicas.</p>
<p><strong>&ldquo;Camel&rdquo; </strong>se refiere a Customized Applications for Mobile network Enhanced Logic.</p>
<p><strong>&ldquo;Campa&ntilde;as&rdquo; </strong>se refiere a una plataforma tecnol&oacute;gica que permite definir las estrategias de mercado minorista para promoci&oacute;n del servicio de telecomunicaciones.</p>
<p><strong>&ldquo;CDR&rdquo; </strong>se refiere a Call Detail Record, los cuales son archivos que contienen la informaci&oacute;n detallada de cada evento de servicio en la Red Compartida. Estos registros contienen la informaci&oacute;n m&iacute;nima requerida para los eventos de servicio y puede contener, por ejemplo, IMSI, MSISDN, fecha de inicio de evento, duraci&oacute;n del evento, adem&aacute;s de otra informaci&oacute;n para cada Servicio (VoIP, VoLTE, Datos o SMS).</p>
<p><strong>&ldquo;CG-NAT&rdquo; </strong>se refiere a Carrier Grade Network Address Translation.</p>
<p><strong>&ldquo;Cliente&rdquo; </strong>tiene el significado que se le atribuye en el Proemio, e incluye a sus cesionarios o causahabientes permitidos conforme a los t&eacute;rminos del Contrato.</p>
<p><strong>&ldquo;CNI&rdquo; </strong>Certificado de No Interferencia, documento emitido por el IFT (Instituto Federal de Telecomunicaciones), mismo que avala la instalaci&oacute;n y operaci&oacute;n de un enlace inal&aacute;mbrico utilizando una banda determinada del espectro radioel&eacute;ctrico.</p>
<p><strong>&ldquo;Cobertura&rdquo; </strong>se refiere a la regi&oacute;n geogr&aacute;fica en la que se dispone el serviciode telecomunicaciones m&oacute;viles de acuerdo al titulo de concesi&oacute;n del prestador de servicios..</p>
<p><strong>&ldquo;CODEC&rdquo; </strong>se refiere a coder/decoder.</p>
<p><strong>&ldquo;Comercializadora&rdquo; </strong>tiene el significado que se le atribuye en la LFTR.</p>
<p><strong>&ldquo;Comit&eacute; de Puesta en Marcha&rdquo; </strong>tiene el significado que se la atribuye en el Anexo de Procedimientos Operativos.</p>
<p><strong>&ldquo;Concesi&oacute;n de Alt&aacute;n&rdquo; </strong>tiene el significado que se le atribuye en el apartado de Fundamentos.</p>
<p><strong>&ldquo;Concesionario&rdquo; </strong>tiene el significado que se le atribuye en la LFTR.</p>
<p><strong>&ldquo;Conectividad&rdquo; </strong>es la capacidad de un dispositivo de poder ser conectado a una red. <strong>&ldquo;Contrato de APP&rdquo; </strong>tiene el significado que se le atribuye en el apartado de Fundamentos. <strong>&ldquo;Contrato&rdquo; </strong>tiene el significado que se le atribuye en el Proemio.</p>
<p><strong>&ldquo;Control&rdquo; </strong>tiene el significado que se le atribuye en la fracci&oacute;n III del art&iacute;culo 2 de la Ley del Mercado de Valores, es decir, la capacidad del Cliente de: (a) imponer, directa o indirectamente, decisiones en las asambleas generales de accionistas, de socios u &oacute;rganos equivalentes, o nombrar o destituir a la mayor&iacute;a de los consejeros, administradores o sus equivalentes, de la afiliada; (b) mantener la titularidad de derechos que permitan, directa o indirectamente, ejercer el voto respecto de m&aacute;s del 50% (cincuenta por ciento) del capital social de la afiliada; o (c) dirigir, directa o indirectamente, la administraci&oacute;n, la estrategia o las principales pol&iacute;ticas de la afiliada, ya sea a trav&eacute;s de la propiedad de valores, por contrato o de cualquier otra forma).</p>
<p><strong>&ldquo;Core&rdquo; </strong>es la capa de red encargada de proporcionar conectividad entre los distintos puntos de acceso.</p>
<p><strong>&ldquo;CSFB&rdquo; </strong>Se refiere a Circuit Switch FallBack, es el proceso de redirecci&oacute;n a 3G cuando se solicita una llamada en LTE.</p>
<p><strong>&ldquo;C-RAN&rdquo; </strong>Se refiere a Centralized RAN, es la Configuraci&oacute;n Centralizada de la Red de Acceso.</p>
<p><strong>&ldquo;CW&rdquo; </strong>Se refiere a Civil Work, es la actividad de Obra Civil que se realiza como parte de una soluci&oacute;n del proveedor de Torres.</p>
<p><strong>&ldquo;Datacenter&rdquo; </strong>Es un centro de procesamiento de datos, una instalaci&oacute;n empleada para albergar un sistema de informaci&oacute;n de componentes asociados, como telecomunicaciones y los sistemas de almacenamientos donde generalmente incluyen fuentes de alimentaci&oacute;n redundante o de respaldo.</p>
<p><strong>&ldquo;Datos&rdquo; </strong>se refiere a la informaci&oacute;n que se transmite por medios inal&aacute;mbricos y que se puede medir en unidades similares a las unidades de c&oacute;mputo. e.g. byte, Kbyte, Mbyte, etc.</p>
<p><strong>&ldquo;DEA&rdquo; </strong>se refiere a Diameter Edge Agent.</p>
<p><strong>&ldquo;D&iacute;a&rdquo; </strong>significa un d&iacute;a de calendario.</p>
<p><strong>&ldquo;D&iacute;a H&aacute;bil&rdquo; </strong>significa cualquier D&iacute;a, excepto por (i) s&aacute;bados y domingos, (ii) aquellos que sean considerados como de descanso obligatorio por la Ley Federal del Trabajo, y (iii) aquellos en que las entidades financieras sujetas a la supervisi&oacute;n de la Comisi&oacute;n Nacional Bancaria y de Valores deban cerrar sus puertas y suspender operaciones, as&iacute; como la prestaci&oacute;n de servicios al p&uacute;blico en M&eacute;xico.</p>
<p><strong>&ldquo;DNS&rdquo; </strong>se refiere a Domain Name System.</p>
<p><strong>&ldquo;DOF&rdquo; </strong>tiene el significado que se le atribuye en el apartado de Fundamentos. <strong>&ldquo;DRB&rdquo; </strong>Se refiere a Dedicated Radio Bearer (Enlace Dedicado de Radio). <strong>&ldquo;DPI&rdquo; </strong>se refiere a Deep Packet Inspection.</p>
<p><strong>&ldquo;DRA&rdquo; </strong>se refiere a Diameter Routing Agent.</p>
<p>&ldquo;<strong>DSCP</strong>&rdquo; se refiere a Differentiated Service Code Point.</p>
<p>&ldquo;<strong>DWDM</strong>&rdquo; se refiere a Dense Wavelength Division Multiplexing, el cual es una t&eacute;cnica de transmisi&oacute;n de se&ntilde;ales a trav&eacute;s de fibra &oacute;ptica de un punto a otro; t&eacute;cnicamente significa multiplexaci&oacute;n por divisi&oacute;n en longitudes de onda de luz.</p>
<p><strong>&ldquo;e-CGI&rdquo; </strong>Se refiere a E-UTRAN Cell Global Identifier &ndash; Identificador Global de Celda y eNB.</p>
<p><strong>&ldquo;ECI&rdquo; </strong>Se refiere a E-UTRAN Cell Identifier.</p>
<p><strong>&ldquo;EDR&rdquo; </strong>se refiere a Event Data Record, los cuales son archivos que contienen las transacciones para ciertos Servicios como, por ejemplo, IMSI, MSISDN, fecha del evento, altas, bajas, suspensiones y otros eventos que afectan directamente a los estados de suscripci&oacute;n de los Usuarios Finales. Estos archivos se utilizar&aacute;n, entre otras cosas, para cuantificar las altas, en el entendido de que todos los eventos y transacciones contemplados en esta definici&oacute;n ser&aacute;n considerados por Alt&aacute;n para la facturaci&oacute;n que realizar&aacute; al Cliente de manera mensual.</p>
<p><strong>&ldquo;EIR&rdquo; </strong>se refiere a Equipment Identity Register.</p>
<p><strong>&ldquo;eNB&rdquo; </strong>se refiere a Evolved Node B.</p>
<p><strong>&ldquo;EPC&rdquo; </strong>se refiere a Evolved Packet Core.</p>
<p><strong>&ldquo;ERP&rdquo; </strong>se refiere a Enterprise Resource Planning.</p>
<p><strong>&ldquo;Especificaciones Funcionales y de Servicio&rdquo; </strong>es el t&eacute;rmino que se le atribuye en el Anexo de Procedimientos Operativos.</p>
<p><strong>&ldquo;Estado Activo&rdquo;. </strong>Un Usuario Final ser&aacute; considerado como Activo desde el momento en el que el Cliente lo declare v&iacute;a API, o se registre y genere tr&aacute;fico en la Red.</p>
<p><strong>&ldquo;Estado Pre-Activo&rdquo; </strong>es el estado en el cual nacen las SIM Cards. En este estado, el Usuario Final no podr&aacute; emitir y/o recibir Datos y/o Voz y/o SMS.</p>
<p><strong>&ldquo;Estructura Tarifaria&rdquo; </strong>es el conjunto de reglas de c&aacute;lculo y par&aacute;metros que se utilizar&aacute;n para determinar el importe, procedimiento de facturaci&oacute;n, y forma que pago que el cliente deber&aacute; satisfacer a Alt&aacute;n por la utilizaci&oacute;n de los Servicios y que se establecen en el &ldquo;Ap&eacute;ndice de T&eacute;rminos comerciales y Estructuras Tarifarias&rdquo; de cada Servicio.</p>
<p><strong>&ldquo;Evento de Incumplimiento del Cliente&rdquo; </strong>significa cualquiera de los eventos previstos en el Contrato que otorgan a Alt&aacute;n la facultad de rescindir el Contrato, sin considerar el periodo de subsanaci&oacute;n o remediaci&oacute;n, en su caso.</p>
<p><strong>&ldquo;FAC&rdquo; </strong>Hom&oacute;nimo del ingl&eacute;s Final Acceptance Certificate.</p>
<p><strong>&ldquo;Firewall&rdquo; </strong>es una parte de un sistema o una red que est&aacute; dise&ntilde;ada para bloquear el acceso no autorizado, permitiendo al mismo tiempo comunicaciones autorizadas.</p>
<p><strong>&ldquo;Fuerza Mayor&rdquo; </strong>tiene el significado que se le atribuye en la Cl&aacute;usula denominada &ldquo;Fuerza Mayor&rdquo;</p>
<p><strong>&ldquo;Funcionario P&uacute;blico&rdquo; </strong>tiene el significado que se le atribuye en la Cl&aacute;usula denominada &ldquo;Cumplimiento de Leyes; Mejores Pr&aacute;cticas&rdquo;.</p>
<p><strong>&ldquo;GMLC&rdquo; </strong>se refiere a Gateway Mobile Location Centre.</p>
<p><strong>&ldquo;Grupo de Inter&eacute;s Econ&oacute;mico&rdquo; </strong>significa el conjunto de sujetos de derecho con intereses comerciales y financieros afines que coordinan sus actividades para participar en los mercados y actividades econ&oacute;micas, a trav&eacute;s del control o influencia decisiva, directa o indirecta, que uno de sus integrantes ejerce sobre los dem&aacute;s.</p>
<p><strong>&ldquo;GTP&rdquo; </strong>se refiere a GPRS Tunneling Protocol. <strong>&ldquo;GUI&rdquo; </strong>se refiere a Graphical User Interface. <strong>&ldquo;HLR&rdquo; </strong>se refiere a Home Location Register.</p>
<p><strong>&ldquo;Hora Pico&rdquo; </strong>es el periodo de una hora en el que se presenta la mayor cantidad de tr&aacute;fico.</p>
<p><strong>&ldquo;HSS&rdquo; </strong>se refiere a Home Subscriber Server. &ldquo;<strong>IaaS</strong>&rdquo; se refiere a Infrastructure as a Service.</p>
<p><strong>&ldquo;IDA&rdquo; </strong>seg&uacute;n se define el t&eacute;rmino en las Reglas de Portabilidad Num&eacute;rica. <strong>&ldquo;IDD&rdquo; </strong>seg&uacute;n se define el t&eacute;rmino en las Reglas de Portabilidad Num&eacute;rica. <strong>&ldquo;IDO&rdquo; </strong>seg&uacute;n se define el t&eacute;rmino en las Reglas de Portabilidad Num&eacute;rica. <strong>&ldquo;IFT&rdquo; </strong>tiene el significado que se le atribuye en el apartado de Fundamentos. <strong>&ldquo;IMEI&rdquo; </strong>se refiere a International Mobile Equipment Identity.</p>
<p><strong>&ldquo;IMS&rdquo; </strong>se refiere a IP Multimedia Subsystem.</p>
<p><strong>&ldquo;IMSI&rdquo; </strong>se refiere a International Mobile Subscriber Identity.</p>
<p><strong>&ldquo;Incidencias&rdquo; </strong>es la afectaci&oacute;n de alg&uacute;n elemento tecnol&oacute;gico que impide el uso de alguno de los servicios mencionados en el presente contrato.</p>
<p><strong>&ldquo;Informaci&oacute;n Confidencial&rdquo; </strong>tiene el significado que se le atribuye en la Cl&aacute;usula denominada &ldquo;Confidencialidad y Protecci&oacute;n de Datos&rdquo;.</p>
<p><strong>&ldquo;Infraestructura de Alt&aacute;n&rdquo; </strong>significa el equipo, accesorios e infraestructura propiedad, arrendado o respecto del cual Alt&aacute;n tenga posesi&oacute;n o derecho de uso por cualquier causa o t&iacute;tulo.</p>
<p><strong>&ldquo;IoT&rdquo; </strong>se refiere a Internet de las Cosas &oacute; Internet of Things por sus siglas en ingl&eacute;s.</p>
<p><strong>&ldquo;IP&rdquo; </strong>se refiere a Internet Protocol.</p>
<p><strong>&ldquo;IP-SM-GW&rdquo; </strong>se refiere a IP Short Message Gateway.</p>
<p><strong>&ldquo;ISP&rdquo; </strong>se refiere a Internet Service Provider. <strong>&ldquo;IVA&rdquo; </strong>es el Impuesto al Valor Agregado. <strong>&ldquo;IVR&rdquo; </strong>se refiere a Interactive Voice Response.</p>
<p><strong>&ldquo;Legacy&rdquo; </strong>Termino usado para indicar tecnolog&iacute;a o est&aacute;ndar anterior al que se est&aacute; presentando.</p>
<p><strong>&ldquo;LDI&rdquo; </strong>se refiere a Larga Distancia Internacional.</p>
<p><strong>&ldquo;Ley Aplicable&rdquo; </strong>significa con respecto a una Persona, (i) cualquier ley, reglamento, tratado, norma, disposici&oacute;n, regla, sentencia, orden, decreto, Autorizaci&oacute;n Gubernamental o interpretaci&oacute;n de cualquiera de ellos por Autoridad Gubernamental, y (ii) cualquier directriz, lineamiento, pol&iacute;tica o cualquier otra resoluci&oacute;n o decisi&oacute;n de Autoridad Gubernamental que sea vinculante para dicha Persona.</p>
<p><strong>&ldquo;Leyes en Materia de Anticorrupci&oacute;n&rdquo; </strong>tiene el significado que se le atribuye en la Cl&aacute;usula denominada &ldquo;Cumplimiento de Leyes; Mejores Pr&aacute;cticas&rdquo;.</p>
<p><strong>&ldquo;LFTR&rdquo; </strong>significa la Ley Federal de Telecomunicaciones y Radiodifusi&oacute;n.</p>
<p><strong>&ldquo;Lista de Sanciones&rdquo; </strong>tiene el significado que se le atribuye en la Cl&aacute;usula denominada &ldquo;Cumplimiento de Leyes; Mejores Pr&aacute;cticas&rdquo;.</p>
<p><strong>&ldquo;LLD&rdquo; </strong>se refiere a Low Level Design.</p>
<p><strong>&ldquo;Location Update&rdquo; </strong>es el procedimiento a trav&eacute;s del cual un equipo terminal provee informaci&oacute;n sobre su localizaci&oacute;n geogr&aacute;fica a la Red Compartida.</p>
<p><strong>&ldquo;LPA&rdquo; </strong>Listo para adecuaci&oacute;n. Es la actividad posterior al t&eacute;rmino de una Obra Civil.</p>
<p><strong>&ldquo;LTE&rdquo; </strong>se refiere a Long Term Evolution. &ldquo;<strong>Mbps</strong>&rdquo; se refiere a Megabits por segundo. <strong>&ldquo;MCC&rdquo; </strong>se refiere a Mobile Country Code.</p>
<p><strong>&ldquo;M&eacute;xico&rdquo; </strong>significa los Estados Unidos Mexicanos.</p>
<p><strong>&ldquo;MHz&rdquo; </strong>se refiere a la unidad de medida de ciclos por segundo (megahertz)</p>
<p><strong>&ldquo;MIMO&rdquo; </strong>se refiere a Multiple Input Multiple Output. <strong>&ldquo;MME&rdquo; </strong>se refiere a Mobility Management Entity. &ldquo;<strong>MMS</strong>&rdquo; se refiere a Multimedia Message Service <strong>&ldquo;MNC&rdquo; </strong>se refiere a Mobile Network Code.</p>
<p><strong>&ldquo;MNP&rdquo; </strong>se refiere a Mobile Number Portability.</p>
<p><strong>&ldquo;MOC&rdquo; </strong>se refiere a Mobile Originating Call.</p>
<p><strong>&ldquo;MOCN&rdquo; </strong>se refiere a Multiple Operator Core Network, es el Proceso de compartici&oacute;n de la parte de RAN al Core de distintos Operadores.</p>
<p>&ldquo;<strong>MSC/MGW</strong>&rdquo; se refiere a Mobile Switching Center y a Media Gateway, son los elementos de red encargados del procesamiento del servicio de voz en redes 3G.</p>
<p><strong>&ldquo;MSISDN&rdquo; </strong>se refiere a Mobile Station Integrated Services Digital Network. <strong>&ldquo;mVoIP&rdquo; </strong>es el servicio de transmisi&oacute;n de voz por medio de VoIP de Alt&aacute;n. <strong>&ldquo;M2M&rdquo; </strong>se refiere a Machine to Machine.</p>
<p><strong>&ldquo;NAT&rdquo; </strong>se refiere a Network Address Translation. <strong>&ldquo;NOC&rdquo; </strong>es el Centro de Operaciones de Alt&aacute;n. <strong>&ldquo;OCS&rdquo; </strong>se refiere a Online Charging System.</p>
<p><strong>&ldquo;Oferta de Referencia&rdquo; </strong>tiene el significado que se le atribuye en el apartado de Fundamentos.</p>
<p><strong>&ldquo;Operador Internacional&rdquo; </strong>es un operador de redes de telecomunicaciones especializado en tr&aacute;fico en destinos internacionales.</p>
<p><strong>&ldquo;OSS&rdquo; </strong>se refiere a Operation Support System. Sistemas de red que est&aacute;n directamente vinculados a la red de telecomunicaciones (procesos de soporte para el mantenimiento del inventario de red, servicios de aprovisionamiento, configuraci&oacute;n de los elementos de red y software para la gesti&oacute;n de fallas).</p>
<p><strong>&ldquo;OTA&rdquo; </strong>se refiere a la programaci&oacute;n Over-the-Air.</p>
<p><strong>&ldquo;PAC&rdquo; </strong>Hom&oacute;nimo del ingl&eacute;s Provisional Acceptance Certificate.</p>
<p><strong>&ldquo;Parte&rdquo; </strong>significa de manera individual Alt&aacute;n o el Cliente, de conformidad con el Contrato.</p>
<p><strong>&ldquo;Parte Indemnizada&rdquo; </strong>tiene el significado que se le atribuye en la Cl&aacute;usula denominada &ldquo;Responsabilidad; Indemnizaci&oacute;n; L&iacute;mites de Responsabilidad&rdquo; del Contrato.</p>
<p><strong>&ldquo;Parte Indemnizante&rdquo; </strong>tiene el significado que se le atribuye en la Cl&aacute;usula denominada &ldquo;Responsabilidad; Indemnizaci&oacute;n; L&iacute;mites de Responsabilidad&rdquo; del Contrato.</p>
<p><strong>&ldquo;Partes&rdquo; </strong>significa de manera conjunta Alt&aacute;n y el Cliente.</p>
<p><strong>&ldquo;Parte Proveedora&rdquo; </strong>es la Parte que proporciona Informaci&oacute;n Confidencial a la otra.</p>
<p><strong>&ldquo;Parte Receptora&rdquo; </strong>es la Parte que recibe Informaci&oacute;n Confidencial de la otra.</p>
<p><strong>&ldquo;Partes Relacionadas&rdquo; </strong>tiene el significado que se le atribuye en la Cl&aacute;usula denominada &ldquo;Cumplimiento de Leyes; Mejores Pr&aacute;cticas&rdquo;.</p>
<p><strong>&ldquo;PCRF&rdquo; </strong>se refiere a Policy and Charging Rule Function.</p>
<p><strong>&ldquo;PDP&rdquo; </strong>se refiere a Packet Data Protocol.</p>
<p><strong>&ldquo;Periodo de Facturaci&oacute;n&rdquo; </strong>es el lapso de tiempo que tiene que transcurrir para emitir una factura al Cliente.</p>
<p><strong>&ldquo;Persona&rdquo; </strong>significa cualquier persona f&iacute;sica, persona moral, sociedad an&oacute;nima, sociedad de responsabilidad limitada, asociaci&oacute;n, asociaci&oacute;n en participaci&oacute;n, fideicomiso, organizaci&oacute;n no constituida o Autoridad Gubernamental.</p>
<p><strong>&ldquo;P-GW&rdquo;, &ldquo;PGW&rdquo; </strong>se refiere a Packet Gateway.</p>
<p><strong>&ldquo;Plataforma Web de Tarifas&rdquo; </strong>se refiere a la p&aacute;gina web con acceso seguro mediante el cual el Cliente y el IFT tendr&aacute;n acceso a las Tarifas y/o condiciones de los Servicios que el Cliente tenga contratados con Alt&aacute;n, as&iacute; como las Ofertas de Referencia y sus modificaciones.</p>
<p><strong>&ldquo;Plan de Negocio del Cliente&rdquo; </strong>es un documento que describe las proyecciones de tr&aacute;fico y Usuarios Finales debidamente segmentados y que el Cliente espera cursar a trav&eacute;s de la Red Compartida.</p>
<p><strong>&ldquo;Plan de Proyecto&rdquo; </strong>es una parte de la gesti&oacute;n de proyectos que se vale de cronogramas para planear y subsecuentemente informar el progreso dentro del entorno del proyecto.</p>
<p><strong>&ldquo;PLMN&rdquo; </strong>se refiere a Public Land Mobile Network.</p>
<p><strong>&ldquo;POP&rdquo; </strong>se refiere a Point of Presence.</p>
<p><strong>&ldquo;Portabilidad&rdquo; </strong>es el t&eacute;rmino que se le atribuye en las Reglas de Portabilidad Num&eacute;rica. &ldquo;<strong>PRB</strong>&rdquo; se refiere a Physical Resource Block.</p>
<p><strong>&ldquo;PROMTEL&rdquo; </strong>significa el Organismo Promotor de Inversiones en Telecomunicaciones.</p>
<p><strong>&ldquo;Propiedad Industrial&rdquo; </strong>significa todos los derechos de autor y/o de propiedad industrial relativos a patentes, marcas, logotipos, avisos comerciales, signos distintivos, denominaciones, secretos industriales, dise&ntilde;os y cualquier otra propiedad intelectual.</p>
<p><strong>&ldquo;PSTN&rdquo; </strong>se refiere a Public Switched Telephone Network.</p>
<p><strong>&ldquo;Radiobase&rdquo; </strong>es una instalaci&oacute;n fija de radio para la comunicaci&oacute;n media, baja o alta bidireccional. Se usa para comunicar con una o m&aacute;s radios m&oacute;viles o tel&eacute;fonos celulares.</p>
<p><strong>&ldquo;Recarga&rdquo; </strong>es equivalente a Recarga Electr&oacute;nica.</p>
<p><strong>&ldquo;Reclamaciones&rdquo; </strong>tiene el significado que se le atribuye en la Cl&aacute;usula denominada &ldquo;Responsabilidad; Indemnizaci&oacute;n; L&iacute;mites de Responsabilidad&rdquo; del Contrato.</p>
<p><strong>&ldquo;Red Compartida&rdquo; </strong>Es la red p&uacute;blica de telecomunicaciones destinada exclusivamente a comercializar capacidad, infraestructura o servicios de telecomunicaciones al mayoreo a otros concesionarios o comercializadores.</p>
<p><strong>&ldquo;Registro P&uacute;blico de Concesiones&rdquo; </strong>es el registro del IFT en el que se puede consultar informaci&oacute;n relativa a concesiones, permisos y autorizaciones, as&iacute; como informaci&oacute;n de actos realizados por los titulares de los mismos.</p>
<p><strong>&ldquo;Responsable Comercial&rdquo; </strong>es el individuo asignado por Alt&aacute;n para recibir y gestionar internamente las consultas y solicitudes de car&aacute;cter t&eacute;cnico y comercial del Cliente.</p>
<p><strong>&ldquo;Roaming Internacional&rdquo; </strong>es el servicio que se presta a operadores de red m&oacute;vil para permitir el uso del servicio m&oacute;vil en una red distinta de la principal y esta red est&aacute; en otro pa&iacute;s distinto al de origen.</p>
<p><strong>&ldquo;Router&rdquo; </strong>es un dispositivo que proporciona conectividad a nivel de red.</p>
<p><strong>&ldquo;RRC&rdquo; </strong>se refiere a Radio Resource Control <strong>&ldquo;RTP&rdquo; </strong>se refiere a Real Time Protocol. <strong>&ldquo;SBC&rdquo; </strong>se refiere a Session Border Controller.</p>
<p><strong>&ldquo;SCT&rdquo; </strong>significa la Secretar&iacute;a de Comunicaciones y Transportes.</p>
<p><strong>&ldquo;Servicios&rdquo; </strong>significa cualquier servicio de telecomunicaciones cuya prestaci&oacute;n se realiza a trav&eacute;s de la Red Compartida, incluyendo los Servicios Adicionales.</p>
<p><strong>&ldquo;Servicios Adicionales&rdquo; </strong>significa cualquier Servicio nuevo contratado a trav&eacute;s de la firma de nuevos Anexos que ser&aacute;n emitidos por Alt&aacute;n a solicitud del Cliente.</p>
<p><strong>&ldquo;Servicio Usuario Visitante&rdquo; </strong>es el servicio que se presta a operadores de red m&oacute;vil para permitir el uso del servicio m&oacute;vil en una red distinta de la principal y esta red est&aacute; en el mismo pa&iacute;s de la red origen.</p>
<p><strong>&ldquo;Servicio de Mensajes Cortos (SMS)&rdquo; </strong>es aqu&eacute;l por medio del cu&aacute;l se proporciona la transmisi&oacute;n de mensajes de texto de extensi&oacute;n reducida, generados desde diversas fuentes externas hasta los Equipos Terminales de los Usuarios Finales.</p>
<p><strong>&ldquo;Servicio de Datos&rdquo; </strong>consiste en la provisi&oacute;n de conexi&oacute;n inal&aacute;mbrica sobre la Red Compartida para el intercambio de datos, incluyendo el intercambio de datos por Internet.</p>
<p><strong>&ldquo;Servicio de telecomunicaciones de Movilidad&rdquo; </strong>es el Servicio de conectividad m&oacute;vil de la Red Compartida que incluye los Servicios de Datos y/o Voz y/o SMS.</p>
<p><strong>&ldquo;Servicio de telecomunicaciones de Internet Hogar y Telefon&iacute;a&rdquo; </strong>es el Servicio de conectividad en ubicaci&oacute;n determinada sobre la Red Compartida que incluye Servicios de Datos y Voz.</p>
<p><strong>&ldquo;Servicio de telecomunicaciones de IoT&rdquo; </strong>es el Servicio de conectividad sobre la Red Compartida para Dispositivos IoT.</p>
<p><strong>&ldquo;Servicio de Voz&rdquo; </strong>es la transmisi&oacute;n o recepci&oacute;n de voz a trav&eacute;s de la Red Compartida.</p>
<p><strong>&ldquo;sFTP&rdquo; </strong>se refiere a un protocolo de transferencia de archivos que utiliza SSH.</p>
<p><strong>&ldquo;S-GW&rdquo;, &ldquo;SGW&rdquo; </strong>se refiere a Signalling Gateway. <strong>&ldquo;SIGTRAN&rdquo; </strong>se refiere a Signalling Transport. <strong>&ldquo;SIP&rdquo; </strong>se refiere a Session Initiation Protocol.</p>
<p><strong>&ldquo;Sitio Rural Satelital&rdquo; </strong>es el conjunto de infraestructura activa y pasiva cuya ubicaci&oacute;n f&iacute;sica es conectada por un enlace de &uacute;ltima milla con tecnolog&iacute;a satelital hasta un telepuerto donde se interconecta con los sistemas y redes CORE de la operaci&oacute;n. Se utiliza para ofrecer cobertura de la Red Alt&aacute;n a localidades menores de 3,000 habitantes o localidades con un &iacute;ndice de marginaci&oacute;n &ldquo;muy alto&rdquo; y &ldquo;alto&rdquo;, de conformidad con el Consejo Nacional de Poblaci&oacute;n.</p>
<p><strong>&ldquo;SMPP&rdquo; </strong>se refiere a Short Message Peer to Peer protocol.</p>
<p><strong>&ldquo;SMS&rdquo; </strong>se refiere a Short Message Service.</p>
<p><strong>&ldquo;SMS-C&rdquo;, &ldquo;SMSC&rdquo; </strong>se refiere a Short Message Service Center.</p>
<p><strong>&ldquo;SRVCC&rdquo; </strong>Se refiere a Single Radio Voice Call Continuity, es el proceso para dar continuidad a una llamada de VoLTE sobre una red 3G sin interrupci&oacute;n del servicio.</p>
<p><strong>&ldquo;STP&rdquo; </strong>se refiere a Signalling Transfer Point.</p>
<p>&ldquo;<strong>Suspensi&oacute;n de Altas de Usuarios Finales&rdquo; </strong>Es el proceso por el cual Alt&aacute;n limita al Cliente la ejecuci&oacute;n del Alta de Usuarios Finales en la Red de Alt&aacute;n.</p>
<p><strong>&ldquo;TAC&rdquo; </strong>Se refiere a Tracking Area Code que es la identificaci&oacute;n de una zona o &aacute;rea geogr&aacute;fica que ser&aacute; configurada en el MME hacia los eNBs.</p>
<p><strong>&ldquo;TAP&rdquo; </strong>se refiere a Transferred Account Procedures.</p>
<p><strong>&ldquo;TAU&rdquo; </strong>Se refiere a Tracking Area Update.</p>
<p><strong>&ldquo;Tarifa&rdquo; </strong>es el valor espec&iacute;fico que en un momento dado toman los par&aacute;metros identificados en las Estructuras Tarifarias para calcular el importe que deber&aacute; pagar el Cliente por los Servicios, el cual est&aacute; registrado ante el IFT y se especifica en los Ap&eacute;ndices de Tarifas del Contrato.</p>
<p><strong>&ldquo;TAS&rdquo; </strong>se refiere a Telephony Application Server.</p>
<p><strong>&ldquo;TELECOMM&rdquo; </strong>significa Telecomunicaciones de M&eacute;xico.</p>
<p><strong>&ldquo;Terminaci&oacute;n&rdquo; </strong>es la interconexi&oacute;n del tr&aacute;fico de Voz y SMS iniciado en la Red Compartida con destino en otra red nacional, la cual genera para Alt&aacute;n un coste de terminaci&oacute;n<strong>.</strong></p>
<p><strong>&ldquo;TIIE&rdquo; </strong>es la Tasa de Inter&eacute;s Interbancaria de Equilibrio.</p>
<p><strong>&ldquo;Tr&aacute;nsito&rdquo; </strong>es la interconexi&oacute;n para el enrutamiento de Tr&aacute;fico de Voz y SMS iniciado o terminado en la Red Compartida con destino u originado en otra red nacional, la cual genera para Alt&aacute;n un coste de Tr&aacute;nsito.</p>
<p><strong>&ldquo;TSS&rdquo; </strong>Hom&oacute;nimo del ingl&eacute;s Technical Site Survey.</p>
<p><strong>&ldquo;URL&rdquo; </strong>se refiere a Uniform Resource Locator.</p>
<p><strong>&ldquo;Usuarios Finales&rdquo; </strong>significa las personas f&iacute;sicas o morales que utilizan los Servicios como destinatarios finales y que han firmado un contrato con el Cliente para la prestaci&oacute;n de los Servicios.</p>
<p><strong>&ldquo;VoIP&rdquo; </strong>se refiere a Voice Over Internet Protocol.</p>
<p><strong>&ldquo;VoLTE&rdquo; </strong>se refiere a Voice Over LTE.</p>
<p><strong>&ldquo;Voz&rdquo; </strong>se refiere a la comunicaci&oacute;n a trav&eacute;s de una llamada de voz, medida en minutos, que utiliza la tecnolog&iacute;a VoLTE o VoIP para su transmisi&oacute;n en la Red Compartida.</p>
<p>&nbsp;</p>
<p>[EL RESTO DE LA P&Aacute;GINA ES INTENCIONALMENTE DEJADO EN BLANCO; SIGUE P&Aacute;GINA DE FIRMAS]</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Anexo, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>

<p>ANEXO 4 SOLICITUD DE SERVICIOS</p>
<p>El presente documento es el Anexo 4 &ldquo;Solicitud de Servicios&rdquo; al que se refiere el Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las&nbsp; Partes&nbsp; el&nbsp; 7&nbsp; de&nbsp; diciembre&nbsp; de&nbsp; 2021.&nbsp; Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Anexo tienen el significado que se les atribuye en el Contrato o en el propio Anexo,&nbsp; seg&uacute;n&nbsp; corresponda. Para la interpretaci&oacute;n del presente Anexo, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Mecanismos electr&oacute;nicos para la Solicitud, Contrataci&oacute;n y Tr&aacute;mite de</u> <u>Servicios</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En caso de que el Cliente est&eacute; interesado en contratar alguno de los Servicios contemplados en cualquier Oferta de Referencia publicada, deber&aacute; realizar una solicitud de Servicios a Alt&aacute;n notificando su intenci&oacute;n de contrataci&oacute;n de los Servicios respectivos al siguiente correo electr&oacute;nico <u><a href="mailto:comercial@altanredes.com">comercial@altanredes.com</a></u> y deber&aacute; contactar al Responsable Comercial de Alt&aacute;n en los tel&eacute;fonos o correos electr&oacute;nicos se&ntilde;alados en la p&aacute;gina web<a href="https://www.altanredes.com/"> https://www.altanredes.com </a>o cualquier otro medio o herramienta que Alt&aacute;n o el Responsable Comercial haga disponible al Cliente. Alt&aacute;n informar&aacute; por escrito al Cliente respecto de la viabilidad o no de su solicitud de Servicios dentro de los 30 (treinta) D&iacute;as siguientes a su recepci&oacute;n por parte de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente ha solicitado los Servicios objeto del Contrato mediante la solicitud de Servicios que se acompa&ntilde;a a este Anexo, a trav&eacute;s de los mecanismos electr&oacute;nicos antes se&ntilde;alados.</li>
</ul>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADO EN BLANCO, SIGUE EL FORMATO DE SOLICITUD DE SERVICIOS]</p>
<p>&nbsp;</p>
<p>FORMATO DE SOLICITUD DE SERVICIOS</p>
<p>&nbsp;</p>
<ol>
<li>Mediante esta solicitud de Servicios el Cliente solicita los Servicios seleccionados en la Tabla 1 siguiente, quedando enterado de los productos y modalidad de integraci&oacute;n mencionados en esta solicitud:</li>
</ol>
<p>&nbsp;</p>
<p><u>Tabla 1. <strong>&ldquo;Solicitud de Productos Alt&aacute;n&rdquo;</strong>.</u></p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="246">
<p><strong>Producto</strong></p>
</td>
<td width="321">
<p><strong>Detalle de Producto</strong></p>
</td>
</tr>
<tr>
<td width="246">
<p>(&nbsp;&nbsp; )</p>
<p>&nbsp;</p>
<p>I - Movilidad SIM ALT&Aacute;N</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida para servicios de movilidad en modalidad de integraci&oacute;n SIM ALT&Aacute;N</p>
</td>
</tr>
<tr>
<td width="246">
<p>(&nbsp;&nbsp; )</p>
<p>&nbsp;</p>
<p>II &ndash; Movilidad SIM CLIENTE</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida para servicios de movilidad en modalidad de integraci&oacute;n SIM CLIENTE</p>
</td>
</tr>
<tr>
<td width="246">
<p>( X )</p>
<p>&nbsp;</p>
<p>III &ndash; INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
</td>
<td width="321">
<p>Producto de conectividad sobre la Red Compartida para servicios de Internet Hogar en ciertas ubicaciones (este producto solo se entrega en modalidad de Integraci&oacute;n SIM</p>
<p>ALT&Aacute;N)</p>
</td>
</tr>
<tr>
<td width="246">
<p>(&nbsp;&nbsp; )</p>
<p>&nbsp;</p>
<p>IV &ndash; INTERNET HOGAR SIM CLIENTE</p>
</td>
<td width="321">
<p>Producto de conectividad sobre la Red Compartida para servicios de Internet Hogar en ciertas ubicaciones (este producto solo se</p>
<p>entrega en modalidad de Integraci&oacute;n SIM CLIENTE)</p>
</td>
</tr>
<tr>
<td width="246">
<p>( &nbsp;)</p>
<p>&nbsp;</p>
<p>V &ndash; MOVILIDAD SIM ALT&Aacute;N CONTROL CLIENTE</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida para servicios de movilidad en modalidad de integraci&oacute;n SIM ALT&Aacute;N CONTROL CLIENTE</p>
</td>
</tr>
<tr>
<td width="246">
<p>(&nbsp;&nbsp; )</p>
<p>&nbsp;</p>
<p>VI &ndash; SERVICIO DE DATOS PRIORIZADOS EN MOVILIDAD SIM CLIENTE</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida para servicios de movilidad en modalidad de integraci&oacute;n SIM CLIENTE con Servicio de Datos Priorizados.</p>
</td>
</tr>
<tr>
<td width="246">
<p>( X )</p>
<p>&nbsp;</p>
<p>VII &ndash; MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS</p>
<p>EMPAQUETADOS CON MARGEN PORCENTUAL FIJO</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida para servicios de movilidad en modalidad de integraci&oacute;n SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO.</p>
</td>
</tr>
<tr>
<td width="246">
<p>(&nbsp;&nbsp; )</p>
<p>&nbsp;</p>
<p>VIII &ndash; SERVICIO DE DATOS PRIORIZADOS EN MOVILIDAD</p>
<p>SIM ALT&Aacute;N</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida para servicios de movilidad en modalidad de integraci&oacute;n SIM ALT&Aacute;N con Servicio de Datos Priorizados.</p>
</td>
</tr>
<tr>
<td width="246">
<p>(&nbsp; )</p>
<p>&nbsp;</p>
<p>IX &ndash; INTERNET DE LAS COSAS SIM ALT&Aacute;N</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida para servicios de Internet de las Cosas en modalidad de integraci&oacute;n SIM ALT&Aacute;N</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="246">
<p>(&nbsp;&nbsp; )</p>
<p>&nbsp;</p>
<p>X &ndash; SERVICIO DE CAPACIDAD DE RED DE ACCESO DE RADIO</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida (Huella Alt&aacute;n) para servicios de Capacidad de Red de Acceso de Radio.</p>
</td>
</tr>
<tr>
<td width="246">
<p>(&nbsp;&nbsp; )</p>
<p>&nbsp;</p>
<p>XI &ndash; SERVICIOS DE CONECTIVIDAD SIM ALT&Aacute;N</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida (Huella Alt&aacute;n) para servicios de Conectividad SIM Alt&aacute;n.</p>
</td>
</tr>
<tr>
<td width="246">
<p>(&nbsp;&nbsp; )</p>
<p>&nbsp;</p>
<p>XII &ndash; SERVICIOS DE LAN TO LAN LTE Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
</td>
<td width="321">
<p>Producto conectividad sobre la Red Compartida (Huella Alt&aacute;n) para servicios de LAN to LAN LTE y Telefon&iacute;a SIM Alt&aacute;n.</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><em>Marcar con &ldquo;X&rdquo; el(los) producto(s) solicitados</em></p>
<p><em>&nbsp;</em></p>
<p>El Cliente reconoce y acepta que los productos I &ndash; Movilidad SIM ALT&Aacute;N y II &ndash; Movilidad SIM CLIENTE son excluyentes entre s&iacute;, no pudiendo solicitar ambos.</p>
<p>&nbsp;</p>
<p>El Cliente reconoce y acepta que los productos III &ndash; INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N y IV &ndash; INTERNET HOGAR SIM CLIENTE son excluyentes entre s&iacute;, no pudiendo solicitar ambos.</p>
<p>&nbsp;</p>
<ol start="2">
<li>El Cliente entiende y acepta que, de acuerdo con la selecci&oacute;n hecha sobre los productos y modalidad solicitados en la Tabla 1 anterior, los siguientes Anexos y Ap&eacute;ndices formar&aacute;n parte integral del Contrato:</li>
</ol>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="138">
<p><strong>Producto</strong></p>
</td>
<td width="99">
<p><strong>Anexo</strong></p>
</td>
<td width="348">
<p><strong>Ap&eacute;ndices relacionados</strong></p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>I - Movilidad SIM Alt&aacute;n</p>
</td>
<td width="99">
<p>&nbsp;</p>
<p>Servicio Movilidad SIM ALT&Aacute;N</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico Movilidad SIM ALT&Aacute;N</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias Movilidad SIM ALT&Aacute;N</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas Movilidad SIM ALT&Aacute;N</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n Movilidad SIM ALT&Aacute;N</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias Movilidad SIM ALT&Aacute;N</p>
<p>vi)&nbsp;&nbsp; Proyecciones Movilidad SIM ALT&Aacute;N</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia Movilidad SIM</p>
<p>ALT&Aacute;N</p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>II - Movilidad SIM CLIENTE</p>
</td>
<td width="99">
<p>Servicio Movilidad SIM CLIENTE</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico Movilidad SIM CLIENTE</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias Movilidad SIM CLIENTE</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas Movilidad SIM CLIENTE</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="138">
<p><strong>Producto</strong></p>
</td>
<td width="99">
<p><strong>Anexo</strong></p>
</td>
<td width="348">
<p><strong>Ap&eacute;ndices relacionados</strong></p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
</td>
<td width="99">
<p>&nbsp;</p>
</td>
<td width="348">
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n Movilidad SIM CLIENTE</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias Movilidad SIM CLIENTE</p>
<p>vi)&nbsp;&nbsp; Proyecciones Movilidad SIM CLIENTE</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia Movilidad SIM</p>
<p>CLIENTE</p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>III - Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N</p>
</td>
<td width="99">
<p>&nbsp;</p>
<p>Servicio INTERNET HOGAR SIM ALT&Aacute;N</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>vi)&nbsp;&nbsp; Proyecciones INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia INTERNET HOGAR</p>
<p>Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>IV - Internet Hogar SIM CLIENTE</p>
</td>
<td width="99">
<p>&nbsp;</p>
<p>Servicio INTERNET HOGAR SIM CLIENTE</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico INTERNET HOGAR SIM CLIENTE</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias INTERNET HOGAR SIM CLIENTE</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas INTERNET HOGAR SIM CLIENTE</p>
<p>iv)&nbsp;&nbsp; Plan&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; de&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Proyecto&nbsp;&nbsp;&nbsp;&nbsp; e&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Implementaci&oacute;n INTERNET HOGAR SIM CLIENTE</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de</p>
<p>Incidencias INTERNET HOGAR SIM CLIENTE</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="138">
<p><strong>Producto</strong></p>
</td>
<td width="99">
<p><strong>Anexo</strong></p>
</td>
<td width="348">
<p><strong>Ap&eacute;ndices relacionados</strong></p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
</td>
<td width="99">
<p>&nbsp;</p>
</td>
<td width="348">
<p>vi)&nbsp;&nbsp; Proyecciones INTERNET HOGAR SIM CLIENTE</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia INTERNET HOGAR</p>
<p>SIM CLIENTE</p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>V - MOVILIDAD SIM ALT&Aacute;N CONTROL CLIENTE</p>
</td>
<td width="99">
<p>&nbsp;</p>
<p>Servicio Movilidad SIM ALT&Aacute;N CONTROL CLIENTE</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico Movilidad SIM ALT&Aacute;N CONTROL CLIENTE</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias Movilidad SIM ALT&Aacute;N CONTROL CLIENTE</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas Movilidad SIM ALT&Aacute;N CONTROL CLIENTE</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n Movilidad SIM ALT&Aacute;N CONTROL CLIENTE</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias Movilidad SIM ALT&Aacute;N CONTROL CLIENTE</p>
<p>vi)&nbsp;&nbsp; Proyecciones Movilidad SIM ALT&Aacute;N CONTROL CLIENTE</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia Movilidad SIM</p>
<p>ALT&Aacute;N CONTROL CLIENTE</p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>VI &ndash; SERVICIO DE DATOS PRIORIZADOS EN MOVILIDAD SIM CLIENTE</p>
</td>
<td width="99">
<p>&nbsp;</p>
<p>Servicio de Datos Priorizados en Movilidad SIM CLIENTE</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico Servicio de Datos Priorizados en Movilidad SIM CLIENTE</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias Servicio de Datos Priorizados en Movilidad SIM CLIENTE</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas Servicio de Datos Priorizados en Movilidad SIM CLIENTE</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n Servicio de Datos Priorizados en Movilidad SIM CLIENTE</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias Servicio de Datos Priorizados en Movilidad SIM CLIENTE</p>
<p>vi)&nbsp;&nbsp; Proyecciones Servicio de Datos Priorizados en</p>
<p>Movilidad SIM CLIENTE</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="141">
<p><strong>Producto</strong></p>
</td>
<td width="100">
<p><strong>Anexo</strong></p>
</td>
<td width="348">
<p><strong>Ap&eacute;ndices relacionados</strong></p>
</td>
</tr>
<tr>
<td width="141">
<p>&nbsp;</p>
</td>
<td width="100">
<p>&nbsp;</p>
</td>
<td width="348">
<p>vii) Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia Servicio de Datos</p>
<p>Priorizados en Movilidad SIM CLIENTE</p>
</td>
</tr>
<tr>
<td width="141">
<p>&nbsp;</p>
<p>VII &ndash; MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO</p>
</td>
<td width="100">
<p>&nbsp;</p>
<p>Servicio Movilidad SIM ALT&Aacute;N</p>
<p>Margen Porcentual Fijo sobre Precio de Referencia</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo</p>
<p>vi)&nbsp;&nbsp; Proyecciones Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados con Margen Porcentual Fijo</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia Movilidad SIM ALT&Aacute;N: Granel y Productos Empaquetados</p>
<p>con Margen Porcentual Fijo</p>
</td>
</tr>
<tr>
<td width="141">
<p>&nbsp;</p>
<p>VIII &ndash; SERVICIO DE DATOS PRIORIZADOS EN MOVILIDAD SIM ALT&Aacute;N</p>
</td>
<td width="100">
<p>&nbsp;</p>
<p>Servicio de Datos Priorizados en Movilidad SIM ALT&Aacute;N</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico Servicio de Datos Priorizados en Movilidad SIM ALT&Aacute;N</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias Servicio de Datos Priorizados en Movilidad SIM ALT&Aacute;N</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas Servicio de Datos Priorizados en Movilidad SIM ALT&Aacute;N</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n Servicio de</p>
<p>Datos Priorizados en Movilidad SIM ALT&Aacute;N</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="138">
<p><strong>Producto</strong></p>
</td>
<td width="99">
<p><strong>Anexo</strong></p>
</td>
<td width="348">
<p><strong>Ap&eacute;ndices relacionados</strong></p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
</td>
<td width="99">
<p>&nbsp;</p>
</td>
<td width="348">
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias Servicio de Datos Priorizados en Movilidad SIM ALT&Aacute;N</p>
<p>vi)&nbsp;&nbsp; Proyecciones Servicio de Datos Priorizados en Movilidad SIM ALT&Aacute;N</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia Servicio de Datos</p>
<p>Priorizados en Movilidad SIM ALT&Aacute;N</p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>IX &ndash; INTERNET DE LAS COSAS</p>
<p>SIM Alt&aacute;n</p>
</td>
<td width="99">
<p>&nbsp;</p>
<p>Servicio Internet de las Cosas SIM ALT&Aacute;N</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico INTERNET DE LAS COSAS SIM ALT&Aacute;N</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias INTERNET DE LAS COSAS SIM ALT&Aacute;N</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas INTERNET DE LAS COSAS SIM ALT&Aacute;N</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n INTERNET DE LAS COSAS SIM ALT&Aacute;N</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias INTERNET DE LAS COSAS SIM ALT&Aacute;N</p>
<p>vi)&nbsp;&nbsp; Proyecciones INTERNET DE LAS COSAS SIM ALT&Aacute;N</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia INTERNET DE LAS</p>
<p>COSAS SIM ALT&Aacute;N</p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>X &ndash; SERVICIO DE CAPACIDAD DE RED DE ACCESO DE RADIO</p>
</td>
<td width="99">
<p>&nbsp;</p>
<p>Servicio de Capacidad de Red de Acceso de Radio</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico Servicio de Capacidad de Red de Acceso de Radio</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias Servicio de Capacidad de Red de Acceso de Radio</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas Servicio de Capacidad de Red de Acceso de Radio</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n Servicio de</p>
<p>Capacidad de Red de Acceso de Radio</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="138">
<p><strong>Producto</strong></p>
</td>
<td width="99">
<p><strong>Anexo</strong></p>
</td>
<td width="348">
<p><strong>Ap&eacute;ndices relacionados</strong></p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
</td>
<td width="99">
<p>&nbsp;</p>
</td>
<td width="348">
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias Servicio de Capacidad de Red de Acceso de Radio</p>
<p>vi)&nbsp;&nbsp; Proyecciones Servicio de Capacidad de Red</p>
<p>de Acceso de Radio</p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>XI - Conectividad SIM Alt&aacute;n</p>
</td>
<td width="99">
<p>&nbsp;</p>
<p>Servicio Conectividad SIM ALT&Aacute;N</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico Conectividad SIM ALT&Aacute;N</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias Conectividad SIM ALT&Aacute;N</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas Conectividad SIM ALT&Aacute;N</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n Conectividad SIM ALT&Aacute;N</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias Conectividad SIM ALT&Aacute;N</p>
<p>vi)&nbsp;&nbsp; Proyecciones Conectividad SIM ALT&Aacute;N</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia Conectividad SIM</p>
<p>ALT&Aacute;N</p>
</td>
</tr>
<tr>
<td width="138">
<p>&nbsp;</p>
<p>XI &ndash; LAN to LAN</p>
<p>LTE y Telefon&iacute;a SIM Alt&aacute;n</p>
</td>
<td width="99">
<p>&nbsp;</p>
<p>Servicio LAN to LAN LTE</p>
<p>y Telefon&iacute;a SIM ALT&Aacute;N</p>
</td>
<td width="348">
<p>i)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Alcance T&eacute;cnico LAN to LAN LTE y Telefon&iacute;a SIM ALT&Aacute;N</p>
<p>ii)&nbsp;&nbsp;&nbsp;&nbsp; T&eacute;rminos Comerciales y Estructuras Tarifarias LAN to LAN LTE y Telefon&iacute;a SIM ALT&Aacute;N</p>
<p>iii)&nbsp;&nbsp;&nbsp; Tarifas LAN to LAN LTE y Telefon&iacute;a SIM ALT&Aacute;N</p>
<p>iv)&nbsp;&nbsp; Plan de Proyecto e Implementaci&oacute;n LAN to LAN LTE y Telefon&iacute;a SIM ALT&Aacute;N</p>
<p>v)&nbsp;&nbsp;&nbsp; Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias LAN to LAN LTE y Telefon&iacute;a SIM ALT&Aacute;N</p>
<p>vi)&nbsp;&nbsp; Proyecciones LAN to LAN LTE y Telefon&iacute;a SIM ALT&Aacute;N</p>
<p>vii)&nbsp; Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia LAN to LAN LTE y</p>
<p>Telefon&iacute;a SIM ALT&Aacute;N</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Anexo, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre</p>
<p>&nbsp;</p>
<p>de 2021.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>ANEXO 7</p>
<p>&nbsp;</p>
<p>SERVICIOS INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>&nbsp;</p>
<p>El presente documento es el Anexo 7 "Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; al que se refiere el Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se&nbsp;&nbsp; utilizan en el presente Anexo tienen el significado que se les atribuye en el Contrato o en el propio Anexo, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Anexo, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Objeto</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>EL objeto del presente Anexo es establecer los t&eacute;rminos y condiciones generales conforme a los cuales se regir&aacute; la prestaci&oacute;n del Servicio de INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N que Alt&aacute;n proporcionar&aacute; al</li>
<li>El alcance t&eacute;cnico, t&eacute;rminos y condiciones comerciales y Plan de Proyecto conforme a los cuales se prestar&aacute;n los Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N se describen y establecen en los siguientes Ap&eacute;ndices:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Ap&eacute;ndice 7.1 &ldquo;Alcance T&eacute;cnico INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 7.2 &ldquo;T&eacute;rminos Comerciales y Estructuras Tarifarias INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 7.3 &ldquo;Tarifas INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 7.4 &ldquo;Plan de Proyecto e Implementaci&oacute;n INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 5 &ldquo;Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias INTERNET HOGAR&rdquo;</li>
<li>Ap&eacute;ndice 7.6 &ldquo;Proyecciones INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
<li>Ap&eacute;ndice 7.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Vigencia</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Salvo que se d&eacute; por terminado de manera anticipada de conformidad con los t&eacute;rminos del Contrato, el presente Anexo y sus Ap&eacute;ndices tendr&aacute;n una vigencia de 3 (tres) a&ntilde;os contados a partir de la fecha de su firma, y se prorrogar&aacute;n autom&aacute;ticamente por periodos sucesivos de 1 (un) a&ntilde;o, a menos que cualquiera de las Partes notifique por escrito su deseo de no prorrogarlos con por lo menos 6 (seis) meses de anticipaci&oacute;n a la fecha de expiraci&oacute;n del plazo inicial de vigencia o de la pr&oacute;rroga vigente, seg&uacute;n sea el caso.</p>
<p>En ning&uacute;n caso la vigencia de este Anexo ser&aacute; superior a la vigencia del Contrato. [EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADO EN BLANCO,</p>
<p>SIGUE LA P&Aacute;GINA DE FIRMAS]</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Anexo, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 7.1 ALCANCE T&Eacute;CNICO</p>
<p>INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N</p>
<p>El presente documento es el Ap&eacute;ndice 7.1 &ldquo;Alcance T&eacute;cnico INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N&rdquo; al que se refiere el Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N&rdquo; del Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el&nbsp; &ldquo;<strong>Contrato</strong>&rdquo;)&nbsp; celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que se les atribuye en el Contrato&nbsp; o en el propio Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N&rdquo;</p>
<ul>
<li>este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice,&nbsp;&nbsp; las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del</li>
</ul>
<p>&nbsp;</p>
<h4><u>PRIMERA. Introducci&oacute;n</u></h4>
<p><strong>&nbsp;</strong></p>
<p>El presente Ap&eacute;ndice describe la soluci&oacute;n t&eacute;cnica y funcional del conjunto de servicios que Alt&aacute;n ofrece al Cliente para el Servicio de Conectividad INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N.</p>
<p>&nbsp;</p>
<p>El Servicio INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N es el Servicio que provee conectividad inal&aacute;mbrica en ciertas ubicaciones fijas, proporcionando acceso a internet y de forma optativa telefon&iacute;a, por parte de la Red Compartida, a trav&eacute;s de la provisi&oacute;n del servicio directamente por el Cliente. Asimismo, proporciona la plataforma que le permite al cliente gestionar el servicio como los m&oacute;dulos de gesti&oacute;n de estado de suscripci&oacute;n del Usuario Final, reportes y conciliaci&oacute;n de tr&aacute;fico, entre otros.</p>
<p>&nbsp;</p>
<p>El Servicio INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N se clasifica en las siguientes categor&iacute;as:</p>
<p>&nbsp;</p>
<ul>
<li>Servicio de Conectividad inal&aacute;mbrica en LTE para uso en ubicaci&oacute;n fija
<ul>
<li>Servicio de acceso a Internet</li>
<li>Opcionalmente, servicio de telefon&iacute;a a trav&eacute;s de la misma conectividad inal&aacute;mbrica.</li>
</ul>
</li>
<li>Servicios de gesti&oacute;n mayorista</li>
<li>Otros Servicios</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Cobertura del Servicio</u></h4>
<p><strong>&nbsp;</strong></p>
<p>La cobertura del Servicio INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N, as&iacute; como las funcionalidades descritas en este documento ser&aacute;n aplicables dentro de la Cobertura de la Red Compartida.</p>
<p>&nbsp;</p>
<p>Cada Usuario Final estar&aacute; asociada a un eNB espec&iacute;fico de forma que &uacute;nicamente el Servicio INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N estar&aacute; disponible cuando se encuentre en la zona de cobertura del eNB al que se encuentra vinculado.</p>
<p>&nbsp;</p>
<p>La vinculaci&oacute;n entre el Usuario Final y el eNB se realizar&aacute; por Alt&aacute;n a partir de las coordenadas declaradas como el domicilio del Usuario Final en la activaci&oacute;n o en un cambio de vinculaci&oacute;n, asignando a este el eNB donde con mayor probabilidad se prestar&aacute; el servicio.</p>
<p>&nbsp;</p>
<h4><u>TERCERA. Responsabilidad de las Partes</u></h4>
<p><strong>&nbsp;</strong></p>
<p>En las siguientes tablas se incluye un resumen de los elementos y responsabilidades funcionales involucrados en la prestaci&oacute;n del Servicio INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N, as&iacute; como la responsabilidad de cada Parte asociada a cada uno de ellos.</p>
<p>&nbsp;</p>
<p>Para el servicio de Conectividad Inal&aacute;mbrica en LTE para uso en ubicaci&oacute;n f&iacute;sica, las responsabilidades son las siguientes:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="349">
<p><strong>Infraestructura de red</strong></p>
</td>
<td width="104">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="123">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="349">
<p>eNB</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>MME</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>SGW</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>PGW</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>HSS</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>PCRF</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>DPI</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>CORE IMS para servicio de Telefon&iacute;a</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>MGW/MSC para servicio de Telefon&iacute;a</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>SBC para servicio de Telefon&iacute;a</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 1. Infraestructura de red</em></p>
<p><em>&nbsp;</em></p>
<p><em>&nbsp;</em></p>
<p><em>&nbsp;</em></p>
<table class="table">
<tbody>
<tr>
<td width="349">
<p><strong>Numeraci&oacute;n</strong></p>
</td>
<td width="104">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="123">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="349">
<p>MNC</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>IMSI</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>DNs</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>Numeraci&oacute;n corta</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<table class="table">
<tbody>
<tr>
<td width="349">
<p>IDD/IDO</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>IDA</p>
</td>
<td width="104">
<p>&ucirc;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 2. Numeraci&oacute;n</em></p>
<p><em>&nbsp;</em></p>
<table class="table">
<tbody>
<tr>
<td width="349">
<p><strong>Acceso a Internet</strong></p>
</td>
<td width="104">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="123">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="349">
<p>Direcciones IP P&uacute;blicas</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="349">
<p>CG-NAT/Firewall</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="349">
<p>DNS Internet</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 3. Acceso a Internet</em></p>
<p><em>&nbsp;</em></p>
<p>Consideraciones de la Tabla 3. Acceso a Internet:</p>
<p>&nbsp;</p>
<p>Si la salida a Internet es de Alt&aacute;n, Alt&aacute;n ser&aacute; el responsable de disponer los elementos mencionados en la tabla anterior y la cl&aacute;usula cuarta de este documento; en caso contrario, se manejar&aacute; mediante un acuerdo comercial espec&iacute;fico, y/o un acuerdo de proyecto especial, ambos sujetos a viabilidad t&eacute;cnica, donde se definan las responsabilidades del Cliente y alcance de las Partes en la soluci&oacute;n.</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="349">
<p><strong>Interconexi&oacute;n y Roaming</strong></p>
</td>
<td width="104">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="123">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="349">
<p>Interconexi&oacute;n de Voz a Redes Fijas y M&oacute;viles Nacionales</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="349">
<p>LDI</p>
</td>
<td width="104">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 4. Interconexi&oacute;n y Roaming</em></p>
<p><em>&nbsp;</em></p>
<p>Consideraciones de la Tabla 4. Interconexi&oacute;n y Roaming:</p>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente el Servicio de Larga Distancia Internacional (LDI) mediante el cual los Usuarios Finales del Cliente pueden hacer uso de los acuerdos vigentes que tiene Alt&aacute;n con Operadores Internacionales para la terminaci&oacute;n y recepci&oacute;n de llamadas de Voz con destino u originadas en redes m&oacute;viles o fijas fuera de M&eacute;xico.</li>
<li>En caso de que el Cliente requiera usar su propio servicio de Larga Distancia Internacional (LDI), se manejar&aacute; mediante un acuerdo comercial espec&iacute;fico, y/o un acuerdo de proyecto especial, ambos sujetos a viabilidad t&eacute;cnica, donde se definan las responsabilidades y alcance de las Partes en la soluci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="359">
<p><strong>Adquisici&oacute;n de SIMs y equipos</strong></p>
</td>
<td width="94">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="123">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="359">
<p>Proveedores comprobados de SIMs</p>
</td>
<td width="94">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="359">
<p>Listado de Routers LTE comprobados</p>
</td>
<td width="94">
<p>&uuml;</p>
</td>
<td width="123">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="359">
<p>Adquisici&oacute;n de SIMs</p>
</td>
<td width="94">
<p>&ucirc;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="359">
<p>Adquisici&oacute;n de Routers LTE</p>
</td>
<td width="94">
<p>&ucirc;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="359">
<p>Adquisici&oacute;n de dispositivos telef&oacute;nicos</p>
</td>
<td width="94">
<p>&ucirc;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 5. Adquisici&oacute;n de SIMs y equipos</em></p>
<p><em>&nbsp;</em></p>
<table class="table">
<tbody>
<tr>
<td width="364">
<p><strong>Servicios regulatorios</strong></p>
</td>
<td width="89">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="123">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="364">
<p>Intervenci&oacute;n legal</p>
</td>
<td width="89">
<p>&uuml;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="364">
<p>Geolocalizaci&oacute;n</p>
</td>
<td width="89">
<p>&uuml;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="364">
<p>Datos conservados</p>
</td>
<td width="89">
<p>&uuml;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="364">
<p>Llamadas de emergencia</p>
</td>
<td width="89">
<p>&uuml;</p>
</td>
<td width="123">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 6. Servicios regulatorios</em></p>
<p><em>&nbsp;</em></p>
<p>Alcance de la Coadyuvancia de Alt&aacute;n a los Servicios Regulatorios mencionados en la Tabla 6. Servicios regulatorios:</p>
<p>&nbsp;</p>
<ul>
<li>El Cliente ser&aacute; el responsable ante los requisitos de la Autoridad Designada para Servicios Regulatorios.</li>
<li>Los servicios regulatorios mencionados ser&aacute;n entregados a Cliente solo bajo demanda de una Autoridad Designada, previa gesti&oacute;n de la misma por el</li>
<li>Alt&aacute;n ofrecer&aacute; coadyuvancia al Cliente a trav&eacute;s de Soporte T&eacute;cnico para que pueda cumplir con dichos</li>
<li>Para la interpretaci&oacute;n de la tabla anterior las Partes se sujetar&aacute;n a lo estipulado en el documento Especificaciones Funcionales y de</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="416">
<p><strong>Servicios de valor agregado</strong></p>
</td>
<td width="85">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="76">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="416">
<p>IVR</p>
</td>
<td width="85">
<p>&ucirc;</p>
</td>
<td width="76">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="416">
<p>Buz&oacute;n de voz</p>
</td>
<td width="85">
<p>&uuml;</p>
</td>
<td width="76">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="416">
<p>OTA</p>
</td>
<td width="85">
<p>&uuml;</p>
</td>
<td width="76">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 7. Servicios de valor agregado</em></p>
<p><em>&nbsp;</em></p>
<p>Para el servicio de gesti&oacute;n mayorista, las responsabilidades son las siguientes:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="400">
<p><strong>Servicios de gesti&oacute;n mayorista</strong></p>
</td>
<td width="78">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="98">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="400">
<p>Administraci&oacute;n de Recursos de Numeraci&oacute;n</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
<td width="98">
<p>&ucirc;</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="400">
<p>Gesti&oacute;n de Estados de Suscripci&oacute;n de Usuario Final</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
<td width="98">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="400">
<p>Conciliaci&oacute;n mayorista de Tr&aacute;fico</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
<td width="98">
<p>&ucirc;</p>
</td>
</tr>
<tr>
<td width="400">
<p>Gesti&oacute;n de Portabilidad</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
<td width="98">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="400">
<p>Configuraci&oacute;n Mayorista de Ofertas Comerciales</p>
</td>
<td width="78">
<p>&uuml;</p>
</td>
<td width="98">
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 8. Servicios de gesti&oacute;n mayorista</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Alt&aacute;n ser&aacute; responsable de la Configuraci&oacute;n Mayorista de Ofertas Comerciales cuando el Cliente seleccione la Estructura Tarifaria Productos Empaquetados, seg&uacute;n se define en el Ap&eacute;ndice 7.2 &ldquo;T&Eacute;RMINOS COMERCIALES Y ESTRUCTURAS TARIFARIAS INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N. La solicitud por parte del Cliente para configurar m&aacute;s de treinta (30) ofertas, ser&aacute; evaluada t&eacute;cnicamente y sujeta a un acuerdo comercial entre las partes. Se considerar&aacute; una (1) oferta cada una de las l&iacute;neas del Formato de Configuraci&oacute;n de</li>
<li>El Cliente ser&aacute; el responsable de la Configuraci&oacute;n de Oferta Comercial Minorista como parte de su Gesti&oacute;n del Usuario</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="453">
<p><strong>Gesti&oacute;n Usuario Final</strong></p>
</td>
<td width="64">
<p><strong>Alt&aacute;n</strong></p>
</td>
<td width="58">
<p><strong>Cliente</strong></p>
</td>
</tr>
<tr>
<td width="453">
<p>Gesti&oacute;n Ciclo de Vida Usuario Final (Alta/Modificaci&oacute;n/ Baja)</p>
</td>
<td width="64">
<p>&ucirc;</p>
</td>
<td width="58">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="453">
<p>Medios de Cobro y Recargas</p>
</td>
<td width="64">
<p>&ucirc;</p>
</td>
<td width="58">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="453">
<p>Oferta Comercial Minorista y Servicios a Usuario Final</p>
</td>
<td width="64">
<p>&ucirc;</p>
</td>
<td width="58">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="453">
<p>Configuraci&oacute;n de Oferta Comercial Minorista</p>
</td>
<td width="64">
<p>&ucirc;</p>
</td>
<td width="58">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="453">
<p>Gesti&oacute;n de Incidencias Usuario Final y Call Center</p>
</td>
<td width="64">
<p>&ucirc;</p>
</td>
<td width="58">
<p>&uuml;</p>
</td>
</tr>
<tr>
<td width="453">
<p>Plataformas de:</p>
<p>&nbsp;</p>
<p>*&nbsp; Pasarela de Pagos</p>
<p>&nbsp;</p>
<p>*&nbsp; PAC (timbrado de facturas),</p>
<p>&nbsp;</p>
<p>*&nbsp; ERP (Finanzas)</p>
<p>*&nbsp; Log&iacute;stico, Marketing, Campa&ntilde;as, eShop/eCareWeb / Mobile APP&hellip;.</p>
</td>
<td width="64">
<p>&nbsp;</p>
<p>&ucirc;</p>
</td>
<td width="58">
<p>&nbsp;</p>
<p>&uuml;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 9. Servicios de gesti&oacute;n de Usuario Final</em></p>
<p><em>&nbsp;</em></p>
<p>El Cliente deber&aacute; asumir toda responsabilidad frente a los Usuarios Finales, debiendo responder por todas las actividades de Gesti&oacute;n del usuario Final tales como preventa,</p>
<p>&nbsp;</p>
<p>venta y postventa, incluyendo cualquier fraude o acto ilegal relacionado con o causado o efectuado por los Usuarios Finales, liberando a Alt&aacute;n de cualquier responsabilidad al respecto.</p>
<p>&nbsp;</p>
<h4><u>CUARTA. Servicios de Conectividad inal&aacute;mbrica en LTE para uso en ubicaci&oacute;n</u> <u>f&iacute;sica</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Los Servicios de Conectividad M&oacute;vil para el Servicio INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N incluyen el Servicio de Datos y opcionalmente el Servicio de Voz. Alt&aacute;n proporciona al Cliente estos servicios en la Cobertura de la Red Compartida, en igualdad de condiciones y sobre bases de no discriminaci&oacute;n respecto al resto de sus clientes.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Servicios de Datos.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n prestar&aacute; al Cliente el Servicio de Datos, a trav&eacute;s de los cuales los Usuarios Finales del Cliente podr&aacute;n transmitir y recibir paquetes de Datos hacia internet desde un Router LTE comprobado en la Cobertura de la Red Compartida.</p>
<p>&nbsp;</p>
<p>Para el establecimiento de una conexi&oacute;n de datos se abrir&aacute; un contexto de datos. Transcurrido un tiempo de 10 (diez) minutos sin que se produzca transmisi&oacute;n de Datos, Alt&aacute;n proceder&aacute; a cerrar el contexto de datos.</p>
<p>&nbsp;</p>
<ul>
<li>Acceso a Internet Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n ofrecer&aacute; el acceso a internet al Cliente utilizando sus plataformas para entregar el tr&aacute;fico de Datos a la red p&uacute;blica de internet. El Servicio incluye el servicio de DNS, firewall y CG-NAT (Network Address Translation) que permite la traducci&oacute;n de IPs privadas a IPs p&uacute;blicas en internet, as&iacute; como el ISP para que el Cliente cuente con navegaci&oacute;n en internet.</p>
<p>&nbsp;</p>
<ul>
<li>Acceso a Internet Cliente</li>
</ul>
<p>&nbsp;</p>
<p>Existe la opci&oacute;n donde el Cliente puede usar sus plataformas para proveer el acceso a internet para entregar el tr&aacute;fico de Datos a la red p&uacute;blica de internet. Para este escenario el Cliente debe proporcionar los servicios de DNS, firewall y CG-NAT (Network Address Translation) que permite la traducci&oacute;n de IPs privadas a IPs p&uacute;blicas en internet, as&iacute; como el ISP para contar con navegaci&oacute;n en Internet.</p>
<p>&nbsp;</p>
<p>En este caso el per&iacute;metro de la responsabilidad de Alt&aacute;n estar&aacute; descrito en Ap&eacute;ndice 7.5 &ldquo;Acuerdo de Nivel de Servicio y Gesti&oacute;n de Incidencias&rdquo;.</p>
<p>&nbsp;</p>
<ul>
<li>Servicios de Voz.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente el Servicio de conectividad de Voz para ubicaci&oacute;n fija, por el que los Usuarios Finales del Cliente podr&aacute;n realizar y recibir llamadas de Voz desde un dispositivo telef&oacute;nico fijo conectado a un router LTE comprobado por Alt&aacute;n para la prestaci&oacute;n de este servicio.</p>
<p>&nbsp;</p>
<p>Para la operaci&oacute;n de este servicio Alt&aacute;n dispondr&aacute; de un APN espec&iacute;fico para conexi&oacute;n a su Core IMS.</p>
<p>&nbsp;</p>
<p>Todo el tr&aacute;fico de Voz generado por los Usuarios Finales del Cliente ser&aacute; terminado o recibido por Alt&aacute;n utilizando sus rutas de interconexi&oacute;n propias con los diferentes operadores de M&eacute;xico, as&iacute; como con operadores nacionales e internacionales para las llamadas LDI.</p>
<p>&nbsp;</p>
<p>En relaci&oacute;n con lo anterior, se pueden presentar los siguientes escenarios de servicio:</p>
<p>&nbsp;</p>
<ul>
<li>Voz Saliente.
  <br />
  <ul>
  <li>Voz entre Usuarios Finales ambos en la Red Compartida: El Usuario Final del Cliente genera una llamada de Voz (VoLTE) desde su terminal en Cobertura de la Red Compartida con destino a otro Usuario Final de un Cliente de la Red Compartida, la cual ser&aacute; procesada y entregada por Alt&aacute;n.</li>
  <li>Voz hacia destino nacional: El Usuario Final del Cliente genera una llamada de voz desde su terminal en Cobertura de la Red Compartida, cuyo destino est&aacute; en otro Operador Nacional (m&oacute;vil o fijo), la cual ser&aacute; entregada por Alt&aacute;n. El Cliente podr&aacute; utilizar los acuerdos de interconexi&oacute;n de Alt&aacute;n para la terminaci&oacute;n de llamadas a nivel nacional (PSTN).</li>
  <li>Voz hacia destino internacional: El Usuario Final del Cliente genera una llamada de voz desde su terminal en Cobertura de la Red Compartida, cuyo destino est&aacute; en otro Operador Internacional (m&oacute;vil o fijo), la cual ser&aacute; entregada por Alt&aacute;n utilizando sus acuerdos de Interconexi&oacute;n para la terminaci&oacute;n de llamadas a nivel Internacional</li>
  </ul>
</li>
</ul>
<ul>
<li>Voz entrante.<br />
  <ul>
  <li>Voz entrante en la Red Compartida: El Usuario Final del Cliente en Cobertura de Alt&aacute;n recibe una llamada de Voz de otros usuarios finales dentro de la Red Compartida.</li>
  <li>Voz entrante nacional (Operador diferente a Alt&aacute;n): En el caso de llamadas de Voz terminadas en la Red Compartida, Alt&aacute;n recibe la llamada desde la PSTN/PLMN debido a que contiene su IDD y tendr&aacute; que analizar y procesar esta llamada antes de entregarla al Usuario</li>
  <li>Voz entrante internacional: En el caso de las llamadas Voz terminadas en la Red Compartida, Alt&aacute;n recibe la llamada desde sus propias interconexiones nacionales o internacionales (LDI).</li>
  </ul>
</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Llamadas de emergencia</li>
</ul>
<p>Las Partes acuerdan que para que los Usuarios Finales realicen llamadas de emergencia se usar&aacute; la mejor Red disponible que t&eacute;cnicamente sea posible utilizar, en el entendido de que los operadores de esa red deber&aacute;n cumplir con lo que establezca el IFT para tal efecto.</p>
<p>&nbsp;</p>
<p>Las Partes acuerdan que para que los Usuarios Finales realicen llamadas de emergencia, t&eacute;cnicamente debe estar disponible la Red de Alt&aacute;n.</p>
<p>&nbsp;</p>
<h4><u>QUINTA. Servicios de Gesti&oacute;n Mayorista</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Los Servicios de Gesti&oacute;n Mayorista son aquellos Servicios que Alt&aacute;n ofrece al Cliente a trav&eacute;s de Interfaces disponibles para que este sea capaz de habilitar y gestionar los Servicios de Conectividad del Servicio de INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N.</p>
<p>&nbsp;</p>
<p>La Plataforma de Gesti&oacute;n Mayorista de Alt&aacute;n est&aacute; conformada por los siguientes m&oacute;dulos principales:</p>
<p>&nbsp;</p>
<ul>
<li>Administraci&oacute;n de Recursos de Numeraci&oacute;n</li>
<li>Gesti&oacute;n Estados Subscripci&oacute;n Usuario Final</li>
<li>Conciliaci&oacute;n mayorista de Tr&aacute;fico</li>
<li>Gesti&oacute;n de Portabilidad</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><strong>Administraci&oacute;n de Recursos de Numeraci&oacute;n</strong></li>
</ul>
<p>El Cliente solicitar&aacute; a Alt&aacute;n, a trav&eacute;s del formulario "Solicitud de Provisi&oacute;n de nuevas SIMs", la generaci&oacute;n de un input file para que el fabricante de SIMs con el que el Cliente tiene un acuerdo comercial proceda a su fabricaci&oacute;n. Una vez que el fabricante ha generado las SIMs del Servicio INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N, le facilitar&aacute; a Alt&aacute;n los archivos OUT y CPS para que los cargue en su plataforma HSS.</p>
<p>&nbsp;</p>
<p>La provisi&oacute;n de SIMs se realiza de forma Numerada: En el momento de creaci&oacute;n de la SIM por parte del fabricante se le asigna la dupla IMSI y DN definitiva.</p>
<p>&nbsp;</p>
<ul>
<li><strong>Gesti&oacute;n Estados de Suscripci&oacute;n de los Usuarios Finales</strong></li>
</ul>
<p>El Cliente podr&aacute; gestionar, mediante una integraci&oacute;n con los interfaces proporcionados por Alt&aacute;n los siguientes estados de los Usuarios Finales a trav&eacute;s de la Interfaz de provisi&oacute;n de servicios:</p>
<p>&nbsp;</p>
<ul>
<li><strong>Estado Preactivo</strong>. El Usuario Final no puede usar los</li>
<li><strong>Estado Activo</strong>. Una vez se realice la activaci&oacute;n, el Usuario Final pasa de Estado Preactivo a Activo. El IMSIs puede usar los Servicios con</li>
<li><strong>Estado Suspendido Tr&aacute;fico Saliente</strong>. En este estado el Usuario Final no puede recibir ni emitir Datos. No puede emitir llamadas con excepci&oacute;n de los n&uacute;meros configurados como irrestrictos, y al call center del Cliente. Dependiendo de la gesti&oacute;n del Cliente, el Usuario Final puede pasar del Estado Suspendido Tr&aacute;fico Saliente al Activo, Suspendido Tr&aacute;fico Saliente y Entrante, Predesactivo o Desactivo.</li>
<li><strong>Estado Suspendido Tr&aacute;fico Saliente y Entrante</strong>. En este estado el Usuario Final no puede recibir ni emitir No puede recibir ni emitir llamadas con excepci&oacute;n de/hacia los n&uacute;meros configurados como irrestrictos, y el call center del Cliente. Dependiendo de la gesti&oacute;n del Cliente, el Usuario Final puede pasar del Estado Suspendido Tr&aacute;fico Saliente y Entrante al Activo Pre-Desactivo o Desactivo.</li>
<li><strong>Estado Pre-Desactivo. </strong>En este estado, los Usuarios Finales no podr&aacute;n hacer uso de ninguno de los servicios El Usuario Final permanecer&aacute; en este estado 365 d&iacute;as naturales hasta pasar al estado Desactivo, por lo cual durante este per&iacute;odo puede ser Reactivado.</li>
</ul>
<ul>
<li><strong>Estado Desactivo</strong>. Estado final, el Usuario Final es borrado del sistema y se reciclan de los recursos de numeraci&oacute;n asociados a la suscripci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><strong>Conciliaci&oacute;n mayorista de Tr&aacute;fico</strong></li>
</ul>
<p>Alt&aacute;n proporcionar&aacute; los CDR que muestran el consumo Datos para que el Cliente los recupere a trav&eacute;s de una conexi&oacute;n sFTP y pueda hacer el procesamiento de estos y utilizarlos como conciliaci&oacute;n de tr&aacute;fico entre ambas redes. Adem&aacute;s, pueden ser utilizados por el Cliente para generar al Usuario Final su pre-factura final.</p>
<p>&nbsp;</p>
<p>Para el Servicio de Datos se recolectar&aacute;n los registros de cada una de las sesiones de datos y su consumo. Este tipo de registros son llamados CDR y se colectan en el EPC, por lo que tambi&eacute;n estar&aacute;n disponibles para que el Cliente los recolecte y procese para la realizaci&oacute;n de la conciliaci&oacute;n mayorista.</p>
<p>&nbsp;</p>
<p>Para el cobro en l&iacute;nea del Servicio de Datos se utilizar&aacute; el OCS de Alt&aacute;n para que se haga el cobro en tiempo real.</p>
<p>&nbsp;</p>
<ul>
<li><strong>Voz</strong></li>
</ul>
<p>Para el servicio de Voz, todas las llamadas que se originan/terminan en el Core de IMS Alt&aacute;n generan un registro (CDR) con los datos primordiales que muestran los detalles de la llamada. Estos CDR se generan dentro del Core IMS y otros elementos de la Red Compartida y posteriormente se almacenan en un directorio compartido para que se utilicen en la conciliaci&oacute;n mayorista. Para el cobro en l&iacute;nea del Servicio de Voz se utilizar&aacute; el OCS de Alt&aacute;n para que se haga el cobro en tiempo real.</p>
<p>&nbsp;</p>
<ul>
<li><strong>Gesti&oacute;n de la Portabilidad</strong></li>
</ul>
<p>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente una herramienta que permita ejecutar y/o notificar la portabilidad de suscripciones de Usuarios Finales siguiendo en todo momento todos los preceptos legales aplicables para tal efecto.</p>
<p>&nbsp;</p>
<p>El Cliente deber&aacute; hacer la integraci&oacute;n directamente con el ABD y soportar todos los escenarios de Portabilidades en sus sistemas. En este escenario el Cliente debe notificar los cambios de portabilidades de Usuarios Finales a Alt&aacute;n a trav&eacute;s de la herramienta proporcionada por Alt&aacute;n.</p>
<p>&nbsp;</p>
<p>De forma alternativa, y en caso que el Cliente no logre tener disponible la integraci&oacute;n con el ABD, Alt&aacute;n dispondr&aacute; el sistema de gesti&oacute;n de portabilidades para el Cliente mediante dicha herramienta, la cual est&aacute;r&aacute; sincronizada con el ABD y realizar&aacute; la provisi&oacute;n hacia el Core de Alt&aacute;n. En este escenario, el Cliente ser&aacute; responsable por la ejecuci&oacute;n de la portabilidad.</p>
<p>&nbsp;</p>
<p>A continuaci&oacute;n se presentan las funcionalidades de portabilidad que deber&aacute;n ser ejecutadas por el Cliente:</p>
<p>&nbsp;</p>
<ul>
<li><strong>Portabilidad Entrante</strong></li>
</ul>
<p>Este proceso est&aacute; alineado con las Reglas de Portabilidad Num&eacute;rica emitidas por el IFT y le permite al Cliente completar todo el proceso de portabilidad, incluyendo, entre otros, los pasos para el alta y aprovisionamiento del Usuario Final entrante. Tambi&eacute;n le permite al Cliente gestionar el alta del recurso DN portado desde otro operador y darle seguimiento a su ciclo de vida.</p>
<p>&nbsp;</p>
<ul>
<li><strong>Portabilidad Saliente</strong></li>
</ul>
<p>Este proceso le permite al Cliente procesar las solicitudes salientes de portabilidad y completar el procesamiento de solicitud saliente. Permite tambi&eacute;n completar el borrado del aprovisionamiento del Usuario Final y dar de baja el recurso de DN portado hacia otro operador y dar seguimiento a su ciclo de vida.</p>
<p>&nbsp;</p>
<ul>
<li><strong>Reversa</strong></li>
</ul>
<p>Con esta funci&oacute;n un Usuario Final que fue portado de forma irregular o que determin&oacute; regresar a su red de origen es r&aacute;pidamente reinstalado con sus mismos par&aacute;metros originales sin necesidad de procesar una nueva alta.</p>
<p>&nbsp;</p>
<ul>
<li><strong>Cancelaci&oacute;n</strong></li>
</ul>
<p>En caso de que el Usuario Final decida cancelar su solicitud de portabilidad o el operador de destino no logre procesar la solicitud, el Cliente podr&aacute; ejecutar la funci&oacute;n de cancelaci&oacute;n tanto a nivel del sistema de Alt&aacute;n como en el ABD correspondiente.</p>
<p>&nbsp;</p>
<ul>
<li><strong>Devoluci&oacute;n Entrante</strong></li>
</ul>
<p>Este proceso permite dar seguimiento a los recursos de DN que han sido portados hacia otros operadores. En caso de que el Usuario Final cancele su servicio despu&eacute;s de haber sido portado, el sistema de portabilidad de Alt&aacute;n permite que se realice la funci&oacute;n de retorno de este recurso y lo reinstala al inventario disponible de acuerdo con las pol&iacute;ticas de uso.</p>
<p>&nbsp;</p>
<h4><u>SEXTA. Otros Servicios</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Vinculaci&oacute;n de IMEI</li>
</ul>
<p>Cada SIM estar&aacute; asociada a un Router LTE (IMEI) espec&iacute;fico de forma que un Usuario Final del Servicio INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N podr&aacute; cursar tr&aacute;fico de Datos cuando la SIM se encuentre instalada en el Router LTE (IMEI) en la cual est&aacute; vinculada y conectado al eNB espec&iacute;fico en el que se habilit&oacute; el Servicio.</p>
<p>&nbsp;</p>
<ul>
<li>Numeraci&oacute;n.</li>
</ul>
<p>Los recursos de numeraci&oacute;n de IMSIs y DN ser&aacute;n provistos por Alt&aacute;n al Cliente. El Cliente solicitar&aacute; a Alt&aacute;n un rango de IMSIs en base a sus proyecciones de tr&aacute;fico. Alt&aacute;n facilitar&aacute; un rango de IMSIs que permitan al Cliente cubrir con la demanda de Usuarios Finales incluida en el Ap&eacute;ndice 7.6 &ldquo;Proyecciones INTERNET HOGAR y TELEFONIA SIM ALT&Aacute;N&rdquo;</p>
<p>&nbsp;</p>
<p>Los DNs ser&aacute;n provistos por Alt&aacute;n a trav&eacute;s de una asignaci&oacute;n directa a los IMSIs que disponga el Cliente, a partir de las necesidades de asignaci&oacute;n de DNs por zonas geogr&aacute;ficas (NIR) reportadas por el Cliente para cumplir con su desarrollo comercial.</p>
<p>&nbsp;</p>
<p>El Cliente reconoce la importancia del cumplimiento de las previsiones de tr&aacute;fico y Usuarios Finales previamente mencionadas para facilitar la gesti&oacute;n y dimensionamiento, por parte de Alt&aacute;n, de sus sistemas, redes y gesti&oacute;n de la numeraci&oacute;n asignada (DNs) por zona geogr&aacute;fica (NIR).</p>
<p>&nbsp;</p>
<ul>
<li>Compra de SIMs</li>
</ul>
<p>El Cliente ser&aacute; responsable de la comercializaci&oacute;n y compra de las tarjetas SIMs. A tal efecto, Alt&aacute;n facilitar&aacute; el listado de fabricantes comprobados de tarjetas SIMs con las especificaciones t&eacute;cnicas de perfil el&eacute;ctrico y applets necesarios para su correcto funcionamiento en la Red Compartida.</p>
<p>&nbsp;</p>
<p>En caso de que el Cliente decida utilizar otro fabricante, Alt&aacute;n colaborar&aacute; con el Cliente para que este pueda dar la informaci&oacute;n suficiente y necesaria al fabricante de tarjetas SIMs para que estas SIMs puedan tener una correcta operaci&oacute;n en la Red Compartida y las caracter&iacute;sticas t&eacute;cnicas del presente Ap&eacute;ndice. Alt&aacute;n comprobar&aacute; al nuevo fabricante seleccionado por el Cliente, conforme a las pol&iacute;ticas y criterios aplicables de Alt&aacute;n y las Leyes Aplicables.</p>
<p>&nbsp;</p>
<ul>
<li>Terminales</li>
</ul>
<p>El Cliente ser&aacute; responsable de la comercializaci&oacute;n y compra de los Routers LTE y los dispositivos telef&oacute;nicos. Alt&aacute;n publicar&aacute; en su portal de internet y con una periodicidad mensual, un listado con los modelos y versiones de Routers LTE que se encuentran comprobados por Alt&aacute;n para su correcta operaci&oacute;n en la Red Compartida. El Cliente, &uacute;nicamente podr&aacute; utilizar y comercializar los modelos y versiones de Routers LTE incluidos en la citada lista y que son los &uacute;nicos que se pueden utilizar para el Producto INTERNET HOGAR Y TELEFONIA SIM ALTAN, oblig&aacute;ndose el Cliente a no utilizar ning&uacute;n Router LTE que no se encuentre en dicha lista. De no cumplirse esta condici&oacute;n, Alt&aacute;n se reserva el derecho a tomar las medidas que considere pertinentes para todos los usuarios del Cliente en Estado Activo con la finalidad de prevenir riesgos operativos y t&eacute;cnicos en la red.</p>
<p>&nbsp;</p>
<p>Las caracter&iacute;sticas m&iacute;nimas de los Routers LTE para ser comprobados por Alt&aacute;n son las siguientes:</p>
<p>&nbsp;</p>
<ul>
<li>Operar en la banda 28 del 3GPP (banda 700 MHZ)</li>
<li>Release 9 3GPP y/o superiores</li>
<li>Terminales categor&iacute;a LTE 4 con capacidad MIMO 2x2</li>
</ul>
<p>&nbsp;</p>
<p>En caso de que el Cliente desee utilizar otros Routers LTE para sus Usuarios Finales, Alt&aacute;n colaborar&aacute; con el Cliente para que &eacute;ste pueda dar la informaci&oacute;n suficiente y necesaria al fabricante de Routers LTE para que estos puedan tener una correcta operaci&oacute;n en la Red Compartida y las caracter&iacute;sticas t&eacute;cnicas del presente Ap&eacute;ndice. Alt&aacute;n comprobar&aacute; los modelos seleccionados por el Cliente, conforme a las pol&iacute;ticas y criterios aplicables de Alt&aacute;n y las Leyes Aplicables y una vez se cumplan los criterios se incorporar&aacute;n a la lista de Routers LTE comprobados.</p>
<p>&nbsp;</p>
<p>En caso de que el Cliente desee utilizar el servicio de Telefon&iacute;a, los Routers LTE deber&aacute;n contar con un puerto RJ11 para la conexi&oacute;n de un dispositivo telef&oacute;nico convencional de telefon&iacute;a fija, y con el software necesario para generar una sesi&oacute;n de Voz con la tecnolog&iacute;a dispuesta por Alt&aacute;n para ello.</p>
<p>&nbsp;</p>
<ul>
<li>EIR</li>
</ul>
<p>El EIR forma parte de la Infraestructura de ALT&Aacute;N, siendo Alt&aacute;n responsable de actualizar la base de datos EIR con aquellos c&oacute;digos IMEI de los Routers LTE que se han dado de alta como perdidos o robados.</p>
<p>&nbsp;</p>
<p>Para el Servicio de INTERNET HOGAR Y TELEFONIA SIM ALT&Aacute;N, Alt&aacute;n es responsable de cumplir con la Ley Federal de Telecomunicaciones y Radiodifusi&oacute;n en lo referente al bloqueo e intercambio de las listas de equipos reportados por los Usuarios Finales como extraviados o robados y no puedan ser utilizados con ning&uacute;n otro Operador M&oacute;vil en M&eacute;xico.</p>
<p>&nbsp;</p>
<p>El Cliente deber&aacute; notificar estas situaciones diariamente a Alt&aacute;n, por los mecanismos establecidos para tales efectos</p>
<p>&nbsp;</p>
<ul>
<li>Intervenci&oacute;n Legal.</li>
</ul>
<p>&nbsp;</p>
<p>Alt&aacute;n y el Cliente colaborar&aacute;n para la interceptaci&oacute;n e intervenci&oacute;n de las comunicaciones, &uacute;nicamente en caso de que sean requeridos, mediante una orden debidamente fundada y motivada conforme a las Leyes Aplicables, por alguna Autoridad competente.</p>
<p>&nbsp;</p>
<ul>
<li>Cobertura.</li>
</ul>
<p>Alt&aacute;n facilitar&aacute; al Cliente una herramienta de consulta de Cobertura de la Red Compartida.</p>
<p>&nbsp;</p>
<p>[EL RESTO DE LA P&Aacute;GINA ES DEJADO EN BLANCO INTENCIONALMENTE; SIGUE P&Aacute;GINA DE FIRMAS]</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Lega</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 7.2</p>
<p>&nbsp;</p>
<p>T&Eacute;RMINOS COMERCIALES Y ESTRUCTURAS TARIFARIAS INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>El presente documento es el Ap&eacute;ndice 7.2 &ldquo;T&eacute;rminos Comerciales y Estructuras Tarifarias Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N&rdquo; al que se refiere el Anexo 7 &ldquo;Servicio Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N&rdquo; del Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el&nbsp; &ldquo;<strong>Contrato</strong>&rdquo;)&nbsp; celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que se les atribuye&nbsp; en&nbsp; el&nbsp; Contrato, o en el propio Anexo 7 &ldquo;Servicio Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N&rdquo;, o&nbsp;&nbsp; en este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>

<h4><u>PRIMERA. Objeto y consideraciones generales</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El presente Ap&eacute;ndice tiene como objeto establecer los t&eacute;rminos comerciales y las Estructuras Tarifarias acordadas entre Alt&aacute;n y el Cliente para la prestaci&oacute;n del Servicio de conectividad en ubicaci&oacute;n determinada sobre la Red Compartida, denominado Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Consideraciones Generales:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Todas las Tarifas de los Servicios mencionados en el presente Ap&eacute;ndice, as&iacute; como sus vigencias y las unidades de medida son las indicadas en el Ap&eacute;ndice 7.3 &ldquo;Tarifas Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Estructuras Tarifarias para los Servicios Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N s&oacute;lo incluyen la prestaci&oacute;n de los Servicios para un uso homog&eacute;neo de los mismos en el &aacute;rea de Cobertura de Alt&aacute;n conforme a las previsiones de tr&aacute;fico mencionadas en el Ap&eacute;ndice 7.6 &ldquo;Proyecciones INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>De conformidad con lo establecido en la Cl&aacute;usula 14.2 del Contrato, las modificaciones sustanciales a este Ap&eacute;ndice deber&aacute;n ser aprobadas por el IFT previo a que sean v&aacute;lidas y surtan</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de un incremento en las Tarifas, Alt&aacute;n publicar&aacute; las nuevas Tarifas de acuerdo con lo establecido en el Ap&eacute;ndice 3 &ldquo;Tarifas Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N&rdquo;, sin embargo, las nuevas Tarifas ser&aacute;n aplicables y tendr&aacute;n efectos trascurridos 30 (treinta) D&iacute;as desde la fecha en que Alt&aacute;n las publique en la Plataforma Web de Tarifas.</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Consideraciones generales del Servicio Internet Hogar y Telefon&iacute;a SIM</u> <u>ALT&Aacute;N</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El tr&aacute;fico de Datos ser&aacute; contabilizado por sesiones de Datos sumando el tr&aacute;fico cursado por el Usuario Final en downlink (DL) y uplink (UL). Las sesiones de Datos se contabilizan por D&iacute;a.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El tr&aacute;fico de Voz ser&aacute; contabilizado por</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las siguientes definiciones son de aplicaci&oacute;n al Servicio Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>&ldquo;<strong>Ciclo Individual</strong>&rdquo; es la vigencia del Producto asociado a cada Usuario</li>
<li>&ldquo;<strong>Velocidad</strong>&rdquo; es la velocidad m&aacute;xima de navegaci&oacute;n de Datos downlink del Producto asociado a cada Usuario</li>
</ol>
<ul>
<li>&ldquo;<strong>Cuota de Datos</strong>&rdquo; es la cantidad de Datos incluida en el Producto que el Usuario Final podr&aacute; utilizar dentro del Ciclo</li>
</ul>
<ol>
<li>&ldquo;<strong>Cuota de Datos en Horario Restringido</strong>&rdquo; es la cantidad de Datos que el Usuario Final podr&aacute; utilizar dentro del Ciclo Individual y dentro de las horas que se especifiquen en el Producto</li>
<li>&ldquo;<strong>Producto</strong>&rdquo; es una Estructura Tarifaria de Datos y/o una Estructura Tarifaria de Voz aplicada a un Usuario Final y que, por tanto, tiene un Ciclo Individual asociado.</li>
<li>&ldquo;<strong>Consumo Excedente</strong>&rdquo; es la cantidad de Datos o minutos de voz que el Usuario Final consuma una vez superada la Cuota de Datos o el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente, dentro del Ciclo Individual, y para el caso de Datos a la misma Velocidad del</li>
</ol>
<ul>
<li>&ldquo;<strong>Consumo Excedente a Velocidad Reducida</strong>&rdquo; es la cantidad de Datos que el Usuario Final consuma una vez superada la Cuota de Datos o el Consumo Excedente de Datos, dentro del Ciclo Individual, y a una velocidad inferior a la Velocidad del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>&ldquo;<strong>Servicios de Tarificaci&oacute;n Adicional</strong>&rdquo;, son aquellos Servicios que se prestan con N&uacute;meros No Geogr&aacute;ficos que se utilizan con un prop&oacute;sito distinto al tradicional. Estos Servicios tienen el coste de Terminaci&oacute;n en la red del operador hu&eacute;sped, m&aacute;s el coste repercutido por el proveedor del Servicio de Tarificaci&oacute;n</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n pone a disposici&oacute;n del Cliente dos Estructuras Tarifarias de Datos para sus Usuarios Finales:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Estructura Tarifaria Paquetes de Datos, la cual se detalla en la Cl&aacute;usula</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Estructura Tarifaria Mixto Granel, la cual se detalla en la Cl&aacute;usula</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n pone a disposici&oacute;n del Cliente una Estructura Tarifaria de Voz para sus Usuarios Finales:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>a) Estructura Tarifaria Paquetes de Voz, la cual se detalla en la Cl&aacute;usula Quinta.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>El Cliente deber&aacute; elegir cu&aacute;l es la modalidad de Estructura Tarifaria que aplicar&aacute; a cada Usuario Final en el momento de realizar la contrataci&oacute;n y/o antes de que se inicie el siguiente Ciclo Individual, siguiendo las siguientes reglas de compatibilidad:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Para el Tr&aacute;fico del Servicio de Datos, el Cliente podr&aacute; escoger una Estructura Tarifaria diferente para cada Usuario</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Para el Tr&aacute;fico del Servicio de Voz, el Cliente podr&aacute; asignar a cada Usuario Final la Estructura Tarifaria Paquetes de Voz, siempre que tenga contratada alguna de las Estructuras Tarifarias de Datos: Paquetes de Datos o Mixto</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>La Estructura Tarifaria Paquetes de Voz, tomar&aacute; la misma modalidad y Ciclo Individual que la elegida para las Estructuras Tarifarias Paquetes de Datos o Mixto Granel.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>El Tr&aacute;fico de Datos y Voz mencionado en este Ap&eacute;ndice &uacute;nicamente estar&aacute; relacionado al &ldquo;Tr&aacute;fico en Cobertura&rdquo;, el cual es el tr&aacute;fico iniciado o recibido en la Cobertura de la Red Compartida, es decir, aquel tr&aacute;fico que hace uso de los recursos de la red de acceso radio compuesta por los eNB de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Tr&aacute;fico de Voz iniciado o recibido por los Usuarios Finales del Cliente se clasifica, para efectos de tarificaci&oacute;n, en dos tipos en funci&oacute;n del sentido del tr&aacute;fico:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>&ldquo;Tr&aacute;fico Saliente&rdquo;, es el tr&aacute;fico que el Usuario Final inicia dentro de la Cobertura de la Red Compartida y que termina dentro o fuera de la Cobertura de la Red Compartida. Las Tarifas de Tr&aacute;fico Saliente dentro de la Cobertura no incluyen el coste del Tr&aacute;nsito y la Terminaci&oacute;n hacia y en otras redes nacionales o internacionales, salvo en los casos previstos en la Estructura Tarifaria Paquetes de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>&ldquo;Tr&aacute;fico Entrante&rdquo;, es el tr&aacute;fico que el Usuario Final recibe dentro de la Cobertura de la Red Compartida. Este tr&aacute;fico no ser&aacute; facturado a los</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Las Estructuras Tarifarias incluidas en este Ap&eacute;ndice no son de aplicaci&oacute;n para productos y/o servicios Machine to Machine (M2M), Internet of Things (IoT), o comunicaci&oacute;n en formato de Datos entre m&aacute;quinas y/o equipos</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La Estructura Tarifaria que incluye Voz no es de aplicaci&oacute;n para servicios que por sus caracter&iacute;sticas pudieran ser considerados masivos, como centros de llamadas o conmutadores telef&oacute;nicos (PBX), entre otros. De la misma forma, el Cliente se hace responsable de evitar el mal uso del Servicio de Voz impidiendo, sin limitaciones, pr&aacute;cticas como simboxing o</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas detalladas en el Ap&eacute;ndice de Tarifas 7.3 &ldquo;Tarifas Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N&rdquo; podr&aacute;n ser con o sin acceso a Internet seg&uacute;n lo solicite el La modalidad de Tarifas con o sin acceso a Internet elegida por el Cliente ser&aacute; de aplicaci&oacute;n para todos sus Usuarios Finales.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n proveer&aacute; el Servicio de Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N con las velocidades m&aacute;ximas establecidas en las Tablas 1, 3, 5 y 7. En cualquier caso, la velocidad del Servicio est&aacute; sujeta a condiciones particulares, incluyendo, sin limitar, la ubicaci&oacute;n del Usuario Final, las caracter&iacute;sticas del Router LTE y la utilizaci&oacute;n de la Red Compartida.</li>
</ul>
<p>&nbsp;</p>
<h4><u>TERCERA. Estructura Tarifaria Paquetes de Datos</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En esta Estructura Tarifaria existir&aacute;n dos modalidades de contrataci&oacute;n, a las que aplican las reglas que a continuaci&oacute;n se indican para cada Periodo de Facturaci&oacute;n:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Modalidad en la que el Cliente podr&aacute; contratar para un Usuario Final, en un mismo Periodo de Facturaci&oacute;n, uno o m&aacute;s Productos de los indicados en la Tabla 1, y los podr&aacute; activar antes de la finalizaci&oacute;n del Ciclo Individual de cualquiera otro de los Productos contratados (en adelante, &ldquo;<strong>Multiactivaci&oacute;n</strong>&rdquo;). En la modalidad con Multiactivaci&oacute;n, el Cliente no podr&aacute; contratar Paquetes de Consumo</li>
</ol>
<p>&nbsp;</p>
<ol start="2">
<li>Modalidad en la que el Cliente podr&aacute; contratar para un Usuario Final, en un mismo Periodo de Facturaci&oacute;n, uno o m&aacute;s Productos de los indicados en la Tabla 1, sin embargo, solo los podr&aacute; activar siempre que haya finalizado el Ciclo Individual de cualquiera otro de los Productos En la modalidad sin Multiactivaci&oacute;n, el Cliente podr&aacute;, adem&aacute;s, contratar para un Usuario Final uno o m&aacute;s Paquetes de Consumo Excedente de entre los de la Tabla 2.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente podr&aacute; activar para un Usuario Final, en un mismo Periodo de Facturaci&oacute;n, una o varias modalidades de Consumo Excedente a Velocidad Reducida de entre las de la Tabla 3, solo para los Productos que se indican en dicha</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>En cada Periodo de Facturaci&oacute;n, el Cliente deber&aacute; elegir para cada Usuario Final la modalidad de contrataci&oacute;n con o sin Multiactivaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Los Productos para la Estructura Tarifaria Paquetes de Datos son los indicados en la Tabla 1 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="575">
<p><strong>Productos para la Estructura Tarifaria Paquetes de Datos</strong></p>
</td>
</tr>
<tr>
<td width="133">
<p>Velocidad del Producto (Mbps)</p>
</td>
<td width="161">
<p>Cuota de Datos &ndash; (GB</p>
<p>/ Usuario Final / Ciclo Individual)</p>
</td>
<td width="152">
<p>Tarifa (MXN / Cuota de Datos)</p>
</td>
<td width="129">
<p>&nbsp;</p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="133">
<p>[●]</p>
</td>
<td width="161">
<p>[●]</p>
</td>
<td width="152">
<p>[●]</p>
</td>
<td width="129">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="133">
<p>&hellip;</p>
</td>
<td width="161">
<p>&hellip;</p>
</td>
<td width="152">
<p>&hellip;</p>
</td>
<td width="129">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 1: Productos para la Estructura Tarifaria Paquetes de Datos.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Los Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Datos son los indicados en la Tabla 2 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="575">
<p><strong>Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Datos</strong></p>
</td>
</tr>
<tr>
<td width="192">
<p>Paquete de Consumo Excedente (GB)</p>
</td>
<td width="192">
<p>Tarifa por Paquete (MXN / Usuario Final)</p>
</td>
<td width="192">
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="192">
<p>[●]</p>
</td>
<td width="192">
<p>[●]</p>
</td>
<td width="192">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="192">
<p>&hellip;</p>
</td>
<td width="192">
<p>&hellip;</p>
</td>
<td width="192">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 2: Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Datos.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Las modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Paquetes de Datos son las indicadas en la Tabla 3 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="578">
<p><strong>Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Paquetes de Datos</strong></p>
</td>
</tr>
<tr>
<td width="151">
<p>Velocidad (kbps)</p>
</td>
<td width="123">
<p>Tarifa (MXN / GB)</p>
</td>
<td width="161">
<p>Cantidad de Datos (GB)</p>
</td>
<td width="143">
<p>Producto al que aplica</p>
</td>
</tr>
<tr>
<td width="151">
<p>[●]</p>
</td>
<td width="123">
<p>[●]</p>
</td>
<td width="161">
<p>0- [●]</p>
</td>
<td width="143">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="151">
<p>&hellip;</p>
</td>
<td width="123">
<p>&hellip;</p>
</td>
<td width="161">
<p>&hellip;</p>
</td>
<td width="143">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 3: Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Paquetes de Datos.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Los descuentos por cantidad de Usuarios Finales Activos Medios aplicables a la Estructura Tarifaria Paquetes de Datos son los indicados en la Tabla 4 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="575">
<p><strong>Descuento por cantidad de Usuarios Finales Activos Medios aplicable a la Estructura Tarifaria Paquetes de Datos</strong></p>
</td>
</tr>
<tr>
<td width="199">
<p>M&iacute;nimo (Usuarios Finales Activos Medios)</p>
</td>
<td width="205">
<p>M&aacute;ximo (Usuarios Finales Activos Medios)</p>
</td>
<td width="171">
<p>Descuento (%)</p>
</td>
</tr>
<tr>
<td width="199">
<p>[●]</p>
</td>
<td width="205">
<p>[●]</p>
</td>
<td width="171">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="199">
<p>&hellip;</p>
</td>
<td width="205">
<p>&hellip;</p>
</td>
<td width="171">
<p>&hellip;</p>
</td>
</tr>
<tr>
<td colspan="2" width="404">
<p>M&aacute;s de [●]</p>
</td>
<td width="171">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 4: Descuento por cantidad de Usuarios Finales Activos Medios aplicable a la Estructura Tarifaria Paquetes de Datos.</em></p>
<p><em>&nbsp;</em></p>
<ol>
<li>En cada Periodo de Facturaci&oacute;n se determinar&aacute; el porcentaje de descuento aplicable para el tramo correspondiente a los Usuarios Finales Activos Medios de dicho periodo de acuerdo con la Tabla 4, y se aplicar&aacute; sobre el monto a facturar por los conceptos de la Tabla 1</li>
</ol>
<p>&nbsp;</p>
<ul>
<li><u>Condiciones del Servicio y tarificaci&oacute;n de la Estructura Tarifaria Paquetes de Datos</u></li>
</ul>
<p>&nbsp;</p>
<ol>
<li><u>Renovaci&oacute;n del Producto</u>: Si antes del final del Ciclo Individual, el Cliente no ha notificado cu&aacute;l es el Producto a asignar para el siguiente Ciclo Individual, el Cliente instruye expresamente a Alt&aacute;n a que realice una suspensi&oacute;n del Servicio para ese Usuario Final hasta que el Cliente realice una nueva solicitud a Alt&aacute;n para contratar alg&uacute;n Producto de la Tabla 1 para dicho Usuario</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><u>Consumo Excedente y Consumo Excedente a Velocidad Reducida</u>: Una vez alcanzada la Cuota de Datos del Producto contratado de la Tabla 1, el Cliente podr&aacute; para cada Usuario Final: i) contratar un Paquete de Consumo Excedente de la Tabla 2; ii) activar una o m&aacute;s modalidades de Consumo Excedente a Velocidad Reducida de entre las de la Tabla 3 configuradas para su Producto; o</li>
</ol>
<p>iii) podr&aacute; solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto (suspensi&oacute;n, portal cautivo, u otras).</p>
<p>&nbsp;</p>
<h4><u>CUARTA. Estructura Tarifaria Mixto Granel</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En esta Estructura Tarifaria existir&aacute; una &uacute;nica modalidad de contrataci&oacute;n, a la que aplican las reglas que a continuaci&oacute;n se indican para cada Periodo de Facturaci&oacute;n:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>El Cliente podr&aacute; contratar para un Usuario Final, en un mismo Periodo de Facturaci&oacute;n, uno o m&aacute;s Productos de los indicados en la Tabla 5, sin embargo, solo los podr&aacute; activar siempre que haya finalizado el Ciclo Individual de cualquier otro de los Productos Es decir, en la Estructura Tarifaria Mixto Granel no ser&aacute; posible contratar con la modalidad con Multiactivaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente podr&aacute; activar para un Usuario Final, en un mismo Periodo de Facturaci&oacute;n, una o varias modalidades de Consumo Excedente a Velocidad Reducida de entre las de la Tabla 7, para los Productos que se indican en dicha tabla.</li>
<li>La tarificaci&oacute;n del Consumo Excedente de un Periodo de Facturaci&oacute;n se realizar&aacute; para todos los Usuarios Finales del Cliente de acuerdo a lo indicado en el apartado 4.3.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Los Productos de la Estructura Tarifaria Mixto Granel son los indicados en la Tabla 5</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="5" width="577">
<p><strong>Productos para la Estructura Tarifaria Mixto Granel</strong></p>
</td>
</tr>
<tr>
<td width="104">
<p>Velocidad del Producto (Mbps)</p>
</td>
<td width="148">
<p>Cuota de Datos &ndash; (GB / Usuario Final / Ciclo Individual)</p>
</td>
<td width="119">
<p>Tarifa (MXN / Cuota de Datos)</p>
</td>
<td width="95">
<p>L&iacute;mite M&aacute;ximo (GB)</p>
</td>
<td width="111">
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="104">
<p>[●]</p>
</td>
<td width="148">
<p>[●]</p>
</td>
<td width="119">
<p>[●]</p>
</td>
<td width="95">
<p>[●]</p>
</td>
<td width="111">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="104">
<p>&hellip;</p>
</td>
<td width="148">
<p>&hellip;</p>
</td>
<td width="119">
<p>&hellip;</p>
</td>
<td width="95">
<p>&nbsp;</p>
</td>
<td width="111">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 5: Productos para la Estructura Tarifaria Mixto Granel.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Se denomina &ldquo;<strong>Consumo Excedente Mixto Granel</strong>&rdquo; al Consumo Excedente que el Usuario Final puede consumir desde el final de la Cuota de Datos hasta el L&iacute;mite M&aacute;ximo de cada Producto fijado en la Tabla 5 (cantidad de Datos que en total se pueden</li>
</ul>
<p>&nbsp;</p>
<p>consumir a la Velocidad del Producto, en adelante &ldquo;<strong>L&iacute;mite M&aacute;ximo</strong>&rdquo;). El Consumo Excedente Mixto Granel se tarificar&aacute;, en cada Periodo de Facturaci&oacute;n, para todos los Usuarios Finales del Cliente incluidos en esta Estructura Tarifaria, aplicando las siguientes reglas:</p>
<p>&nbsp;</p>
<ol>
<li>Se calcular&aacute; el Consumo Excedente Medio Mixto Granel como el total de Datos de los Consumos Excedentes Mixto Granel de los Usuarios Finales del Cliente dividido por los Usuarios Finales Activos Medios, redondeado el resultado a la unidad de 1GB (en adelante &ldquo;<strong>Consumo Excedente Medio Mixto Granel</strong>&rdquo;). Para efectos de este c&aacute;lculo, &uacute;nicamente se considerar&aacute;n los Usuarios Finales del Cliente incluidos en esta Estructura</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Se calcular&aacute; el Precio Medio como la suma del producto del consumo de Datos de cada tramo de Consumo Excedente Medio Mixto Granel multiplicado por la Tarifa aplicable a dicho tramo en la Tabla 6 siguiente, hasta llegar al total del Consumo Excedente Medio Mixto Granel del Cliente, dividiendo dicha suma- producto por el Consumo Excedente Medio Mixto Granel (en adelante &ldquo;<strong>Precio Medio</strong>&rdquo;):</li>
</ol>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="575">
<p><strong>Consumo Excedente Medio Mixto Granel para la Estructura Tarifaria Mixto Granel</strong></p>
</td>
</tr>
<tr>
<td width="195">
<p>Consumo Excedente Medio Mixto Granel desde (GB)</p>
</td>
<td width="206">
<p>Consumo Excedente Medio Mixto Granel hasta (GB)</p>
</td>
<td width="174">
<p>Tarifa aplicable al tramo (MXN / GB)</p>
</td>
</tr>
<tr>
<td width="195">
<p>[●]</p>
</td>
<td width="206">
<p>[●]</p>
</td>
<td width="174">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="195">
<p>&hellip;</p>
</td>
<td width="206">
<p>&hellip;</p>
</td>
<td width="174">
<p>&hellip;</p>
</td>
</tr>
<tr>
<td colspan="2" width="401">
<p>M&aacute;s de [●]</p>
</td>
<td width="174">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 6: Consumo Excedente Medio Mixto Granel para la Estructura Tarifaria Mixto Granel.</em></p>
<p><em>&nbsp;</em></p>
<ol>
<li>Finalmente, se calcular&aacute; el monto a tarificar en cada Periodo de Facturaci&oacute;n por Consumo Excedente Mixto Granel del Cliente como la multiplicaci&oacute;n entre el Precio Medio y el total del Consumo Excedente Mixto Granel de todos los Usuarios Finales del Cliente incluidos en esta Estructura</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Las modalidades de Consumo Excedente a Velocidad Reducida de la Estructura Tarifaria Mixto Granel son las indicadas en la Tabla 7 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="575">
<p><strong>Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Mixto Granel</strong></p>
</td>
</tr>
<tr>
<td width="113">
<p>Velocidad (kbps)</p>
</td>
<td width="133">
<p>Tarifa (MXN / GB)</p>
</td>
<td width="174">
<p>Cantidad de Datos (GB)</p>
</td>
<td width="156">
<p>Producto al que aplica</p>
</td>
</tr>
<tr>
<td width="113">
<p>[●]</p>
</td>
<td width="133">
<p>[●]</p>
</td>
<td width="174">
<p>0- [●]</p>
</td>
<td width="156">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="113">
<p>&hellip;</p>
</td>
<td width="133">
<p>&hellip;</p>
</td>
<td width="174">
<p>&hellip;</p>
</td>
<td width="156">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 7: Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Mixto Granel.</em></p>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<ul>
<li>Los descuentos por cantidad de Usuarios Finales Activos Medios aplicables a la Estructura Tarifaria Mixto Granel est&aacute;n detallados en este Estos descuentos no son acumulables entre s&iacute; y se deber&aacute; seleccionar cu&aacute;l de ellos se quiere aplicar en cada Periodo de Facturaci&oacute;n.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los descuentos aplicables a los Productos para la Estructura Tarifaria Mixto Granel son los indicados en la Tabla 8 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="575">
<p><strong>Descuento por cantidad de Usuarios Finales Activos Medios aplicable a los Productos de la Estructura Tarifaria Mixto Granel</strong></p>
</td>
</tr>
<tr>
<td width="252">
<p>M&iacute;nimo (Usuarios Finales Activos Medios)</p>
</td>
<td width="202">
<p>M&aacute;ximo (Usuarios Finales Activos Medios)</p>
</td>
<td width="121">
<p>&nbsp;</p>
<p>Descuento (%)</p>
</td>
</tr>
<tr>
<td width="252">
<p>[●]</p>
</td>
<td width="202">
<p>[●]</p>
</td>
<td width="121">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="252">
<p>&hellip;</p>
</td>
<td width="202">
<p>&hellip;</p>
</td>
<td width="121">
<p>&hellip;</p>
</td>
</tr>
<tr>
<td colspan="2" width="454">
<p>M&aacute;s de [●]</p>
</td>
<td width="121">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 8: Descuento por cantidad de Usuarios Finales Activos Medios aplicable a los Productos de la Estructura Tarifaria Mixto Granel.</em></p>
<p><em>&nbsp;</em></p>
<ol>
<li>En cada Periodo de Facturaci&oacute;n se determinar&aacute; el porcentaje de descuento aplicable para el tramo correspondiente a los Usuarios Finales Activos Medios de dicho periodo de acuerdo con la Tabla 8, y se aplicar&aacute; sobre el monto a facturar por los conceptos de la Tabla 5</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Los descuentos aplicables al Consumo Excedente Mixto Granel para la Estructura Tarifaria Mixto Granel son los indicados en la Tabla 9 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="575">
<p><strong>Descuento por cantidad de Usuarios Finales Activos Medios aplicable al Consumo Excedente de la Estructura Tarifaria Mixto Granel</strong></p>
</td>
</tr>
<tr>
<td width="252">
<p>M&iacute;nimo (Usuarios Finales Activos Medios)</p>
</td>
<td width="202">
<p>M&aacute;ximo (Usuarios Finales Activos Medios)</p>
</td>
<td width="121">
<p>Descuento (%)</p>
</td>
</tr>
<tr>
<td width="252">
<p>[●]</p>
</td>
<td width="202">
<p>[●]</p>
</td>
<td width="121">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="252">
<p>&hellip;</p>
</td>
<td width="202">
<p>&hellip;</p>
</td>
<td width="121">
<p>&hellip;</p>
</td>
</tr>
<tr>
<td colspan="2" width="454">
<p>M&aacute;s de [●]</p>
</td>
<td width="121">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 9: Descuento por cantidad de Usuarios Finales Activos Medios aplicable al Consumo Excedente de la Estructura Tarifaria Mixto Granel.</em></p>
<p><em>&nbsp;</em></p>
<ol>
<li>En cada Periodo de Facturaci&oacute;n se determinar&aacute; el porcentaje de descuento aplicable para el tramo correspondiente a los Usuarios Finales Activos Medios de dicho periodo de acuerdo con la Tabla 9, y se aplicar&aacute; sobre el monto a facturar por los conceptos de la Tabla 6</li>
</ol>
<ul>
<li><u>Condiciones del Servicio y tarificaci&oacute;n de la Estructura Tarifaria Mixto Granel</u></li>
</ul>
<p>&nbsp;</p>
<ol>
<li><u>Renovaci&oacute;n de Producto</u>: Si antes del final del Ciclo Individual, el Cliente no ha notificado cu&aacute;l es el Producto a asignar para el siguiente Ciclo Individual, el Cliente instruye expresamente a Alt&aacute;n a que realice una suspensi&oacute;n del Servicio para ese Usuario Final hasta que el Cliente realice una nueva solicitud a Alt&aacute;n para contratar alg&uacute;n Producto de la Tabla 5 para dicho Usuario</li>
</ol>
<p>&nbsp;</p>
<ol start="4">
<li><u>Consumo Excedente Mixto Granel</u>: Una vez alcanzada la Cuota de Datos del Producto de la Tabla 5, los Consumos Excedentes ser&aacute;n tarificados de acuerdo con lo mencionado en el apartado 4.3 hasta alcanzar el L&iacute;mite M&aacute;ximo.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li><u>Reducci&oacute;n de Velocidad y Suspensi&oacute;n</u>: Una vez alcanzado el L&iacute;mite M&aacute;ximo del Producto, el Cliente podr&aacute; para cada Usuario Final: i) activar una o m&aacute;s modalidades de Consumo Excedente a Velocidad Reducida de entre las de la Tabla 7 configuradas para su Producto; o ii) podr&aacute; solicitar que se ejecute otra acci&oacute;n entre las configuradas para su Producto (suspensi&oacute;n, portal cautivo, u otras).</li>
</ol>
<p>&nbsp;</p>
<h4><u>QUINTA. Estructura Tarifaria Paquetes de Voz</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Cada Paquete de Voz incluye un consumo de Tr&aacute;fico de Voz hasta un l&iacute;mite m&aacute;ximo medido en minutos que el Usuario Final puede usar en su Ciclo Individual (en adelante &ldquo;L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente&rdquo;), tal como se define en la Tabla</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Asimismo, en cada Paquete de Voz, se incluyen consumos correspondientes al Tr&aacute;fico siguiente, excluyendo los Servicios de Tarifaci&oacute;n Adicional:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Tr&aacute;fico de Voz Saliente con destino Nacional, incluyendo los cargos de tr&aacute;nsito y terminaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Tr&aacute;fico de Voz Saliente con destino Larga Distancia Internacional a EUA y Canad&aacute;.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>La Estructura Tarifaria Paquetes de Voz s&oacute;lo se podr&aacute; contratar para Usuarios Finales que tienen contratada alguna de las Estructuras Tarifarias de Datos: Paquetes de Datos o Mixto Granel; y tendr&aacute;n el mismo Ciclo Individual y Modalidad al que est&aacute;n asociados.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los Productos para la Estructura Tarifaria Paquetes de Voz son los indicados en la Tabla 10 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="575">
<p><strong>Productos para la Estructura Tarifaria Paquetes de Voz</strong></p>
</td>
</tr>
<tr>
<td width="192">
<p>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Min / Usuario Final / Ciclo</p>
<p>Individual)</p>
</td>
<td width="192">
<p>Tarifa (MXN / L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente)</p>
</td>
<td width="192">
<p>&nbsp;</p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="192">
<p>[●]</p>
</td>
<td width="192">
<p>[●]</p>
</td>
<td width="192">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="192">
<p>&hellip;</p>
</td>
<td width="192">
<p>&hellip;</p>
</td>
<td width="192">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 10: Productos para la Estructura Tarifaria Paquetes de Voz.</em></p>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<ul>
<li>Los Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Voz son los indicados en la Tabla 11 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="575">
<p><strong>Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Voz</strong></p>
</td>
</tr>
<tr>
<td width="192">
<p>Paquete de Consumo Excedente (Min)</p>
</td>
<td width="192">
<p>Tarifa por Paquete de Voz (MXN / Usuario Final)</p>
</td>
<td width="192">
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="192">
<p>[●]</p>
</td>
<td width="192">
<p>[●]</p>
</td>
<td width="192">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="192">
<p>&hellip;</p>
</td>
<td width="192">
<p>&hellip;</p>
</td>
<td width="192">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 11: Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Voz.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li><u>Condiciones del Servicio y tarificaci&oacute;n de la Estructura Tarifaria Paquetes de Voz</u></li>
</ul>
<p>&nbsp;</p>
<ol start="11">
<li>a) <u>Consumo Excedente</u>: Una vez alcanzado el L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente del Producto contratado de la Tabla 10, el Cliente podr&aacute; para cada Usuario Final contratar un Paquete de Consumo Excedente de la Tabla 11.</li>
</ol>
<p>&nbsp;</p>
<h4><u>SEXTA. Otras Estructuras Tarifarias y condiciones de uso del Producto</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong><u>Plataformas de servicio del Cliente</u></strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El Tr&aacute;fico Saliente de Voz cursado por el Usuario Final cuyo destino sea el centro de atenci&oacute;n del Cliente (call center), o las plataformas de servicio del Cliente (buz&oacute;n de voz, IVR, marcaciones cortas, entre otras), ser&aacute; tarificado a precio cero siempre que en cada Periodo de Facturaci&oacute;n represente menos del porcentaje sobre el total de Tr&aacute;fico Saliente de Voz del Cliente que se indica en la Tabla 12 siguiente:</li>
</ul>
<p>&nbsp;</p>
<p><em>Tabla 12. Estructura Tarifaria para el Tr&aacute;fico Saliente de Voz con destino a plataformas de servicio del Cliente.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>El Tr&aacute;fico Saliente de Voz cursado por el Usuario Final cuyo destino sea el centro de atenci&oacute;n del Cliente (call center), o las plataformas de servicio del Cliente (buz&oacute;n de voz, IVR, marcaciones cortas, entre otras), que est&eacute; por encima del % que ser&aacute; tarificado a precio cero, y el cual se se&ntilde;ala en la Tabla 12 anterior, ser&aacute; tarificado conforme a lo se&ntilde;alado en la Tabla 13 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="575">
<p><strong>Estructura Tarifaria del Tr&aacute;fico Saliente de Voz Excedente con destino a plataformas de servicio del Cliente</strong></p>
</td>
</tr>
<tr>
<td width="184">
<p>&nbsp;</p>
<p>Min/Usuario Final</p>
</td>
<td width="211">
<p>&nbsp;</p>
<p>Tarifa (MXN / Min)</p>
</td>
<td width="180">
<p>&nbsp;</p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="184">
<p>[●]</p>
</td>
<td width="211">
<p>[●]</p>
</td>
<td width="180">
<p>Misma que la del Producto contratado</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 13. Estructura Tarifaria del Tr&aacute;fico Saliente de Voz Excedente con destino a plataformas de servicio del Cliente</em></p>
<h4>6.2.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <u>Servicios de Tarificaci&oacute;n Adicional</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El tr&aacute;fico de Voz que los Usuarios Finales del Cliente terminen en Servicios de Tarificaci&oacute;n Adicional, generar&aacute; Tarifas por el Servicio de Terminaci&oacute;n en Servicios de Tarificaci&oacute;n</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><br /> Este Servicio se pone a disposici&oacute;n del Cliente y ser&aacute; facturado por Alt&aacute;n al Cliente sumando a los cargos por Terminaci&oacute;n de Voz en Servicios de Tarificaci&oacute;n Adicional el cargo de gesti&oacute;n que se indica en la Tabla 14 siguiente:</li>
</ul>
<p><em>Tabla 14. Estructura Tarifaria para Terminaci&oacute;n en Servicios de Tarificaci&oacute;n Adicional.</em></p>
<p><em>&nbsp;</em></p>
<h4>6.3.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <u>Larga Distancia Internacional</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Los Servicios de Larga Distancia Internacional (&ldquo;LDI&rdquo;) ser&aacute;n tarificados conforme a las Tarifas estipuladas en la Tabla 15 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="575">
<p><strong>Estructura Tarifaria del Servicio de Voz LDI</strong></p>
</td>
</tr>
<tr>
<td width="299">
<p><strong>Destino / Regi&oacute;n</strong></p>
</td>
<td width="276">
<p><strong>Tarifa (MXN / Minuto)</strong></p>
</td>
</tr>
<tr>
<td width="299">
<p>Estados Unidos de Am&eacute;rica</p>
</td>
<td width="276">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="299">
<p>Canad&aacute;</p>
</td>
<td width="276">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="299">
<p>&hellip;</p>
</td>
<td width="276">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 15. Estructura Tarifaria del Servicio de Voz LDI.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Adicionalmente, el Cliente podr&aacute; acceder a un Producto de Voz en servicio de Larga Distancia Internacional de acuerdo con la Tabla 16 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="145">
<p>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente para el Servicio de Larga Distancia Internacional (Minutos / Paquete /</p>
<p>Ciclo Individual)</p>
</td>
<td width="150">
<p>&nbsp;</p>
<p>Destinos Incluidos</p>
</td>
<td width="139">
<p>&nbsp;</p>
<p>Tarifa (MXN / Paquete)</p>
</td>
<td width="141">
<p>&nbsp;</p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="145">
<p>[●]</p>
</td>
<td width="150">
<p>[●]</p>
</td>
<td width="139">
<p>[●]</p>
</td>
<td width="141">
<p>[●]</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 16. Productos Paquetes de Voz para el Servicio de Larga Distancia Internacional.</em></p>
<p><em>&nbsp;</em></p>
<h4>6.4.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <u>Productos de Datos en Horario Restringido</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El Cliente podr&aacute; contratar para los Usuarios Finales los Productos de Datos en Horario Restringido, seg&uacute;n las modalidades y requisitos incluidos en la Tabla 17. Estos Productos s&oacute;lo se pueden contratar como adici&oacute;n a un Producto de los definidos en las Tablas 1 y</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="6" width="575">
<p><strong>Tarifas Productos de Datos en Horario Restringido</strong></p>
</td>
</tr>
<tr>
<td rowspan="2" width="115">
<p>Velocidad del Producto al que aplica (Mbps)</p>
</td>
<td rowspan="2" width="109">
<p>Cuota de Datos en Horario Restringido (GB)</p>
</td>
<td rowspan="2" width="116">
<p>Tarifa (MXN / Cuota de Datos en Horario Restringido)</p>
</td>
<td colspan="2" width="157">
<p>Horario Restringido (Hora Local)</p>
</td>
<td rowspan="2" width="78">
<p>&nbsp;</p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="78">
<p>Desde</p>
</td>
<td width="78">
<p>Hasta</p>
</td>
</tr>
<tr>
<td width="115">
<p>[●]</p>
</td>
<td width="109">
<p>[●]</p>
</td>
<td width="116">
<p>[●]</p>
</td>
<td width="78">
<p>[●]</p>
</td>
<td width="78">
<p>[●]</p>
</td>
<td width="78">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="115">
<p>&hellip;</p>
</td>
<td width="109">
<p>&hellip;</p>
</td>
<td width="116">
<p>&hellip;</p>
</td>
<td width="78">
<p>&hellip;</p>
</td>
<td width="78">
<p>&hellip;</p>
</td>
<td width="78">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 17: Tarifas Productos de Datos en Horario Restringido</em></p>
<p><em>&nbsp;</em></p>
<h4>6.5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <u>Vinculaci&oacute;n del eNB y Router LTE (IMEI)</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Un Usuario Final s&oacute;lo podr&aacute; disfrutar del Servicio Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N si est&aacute; conectado a los eNB y al Router LTE (IMEI) que el Cliente le haya vinculado en la contrataci&oacute;n. El Cliente instruye expresamente a Alt&aacute;n a suspender el Servicio a un Usuario Final cuando se detecte que el tr&aacute;fico se est&aacute; produciendo desde un eNB o Router distintos de los vinculados. La vinculaci&oacute;n y su posible modificaci&oacute;n se realizar&aacute; seg&uacute;n lo incluido en el Ap&eacute;ndice 1 &ldquo;Alcance T&eacute;cnico Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N&rdquo;. No obstante, Alt&aacute;n ofrece las siguientes opciones para modificar la vinculaci&oacute;n:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><br /> Alt&aacute;n permitir&aacute; al Cliente que cada Usuario Final pueda hacer hasta 2 cambios de vinculaci&oacute;n de eNB sin costo cada 12 meses desde la activaci&oacute;n del Usuario Cada cambio adicional dentro de este lapso tendr&aacute; el costo mencionado en la Tabla 18 siguiente:</li>
</ul>
<p><em>Tabla 18: Tarifa cambio de vinculaci&oacute;n de eNB.</em></p>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<ol>
<li>Si el Cliente quiere que sus Usuarios Finales tengan la posibilidad de usar el Producto en m&aacute;s de un domicilio que implique otros eNB vinculados, deber&aacute; solicitarlo y Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente esta funcionalidad, en adelante &ldquo;<strong>Multi-domicilio</strong>&rdquo; con el costo mencionado en la Tabla 19 siguiente:</li>
</ol>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="575">
<p><strong>Tarifas funcionalidad &ldquo;Multi-domicilio&rdquo;</strong></p>
</td>
</tr>
<tr>
<td width="185">
<p>Producto al que aplica</p>
</td>
<td width="184">
<p>N&uacute;mero de Domicilios</p>
</td>
<td width="206">
<p>Tarifa (MXN)</p>
</td>
</tr>
<tr>
<td width="185">
<p>[●]</p>
</td>
<td width="184">
<p>[●]</p>
</td>
<td width="206">
<p>[●]</p>
</td>
</tr>
<tr>
<td width="185">
<p>&hellip;</p>
</td>
<td width="184">
<p>&hellip;</p>
</td>
<td width="206">
<p>&hellip;</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 19: Tarifas funcionalidad &ldquo;Multi-domicilio&rdquo;</em></p>
<p><em>&nbsp;</em></p>
<ol>
<li>El Servicio Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N no se garantiza en todos los domicilios con las mismas</li>
</ol>
<p>&nbsp;</p>
<h4><u>S&Eacute;PTIMA. Plataforma Mayorista</u></h4>
<p><br /> <strong>7.1.&nbsp;&nbsp;&nbsp; </strong>Alt&aacute;n tarificar&aacute; al Cliente un cargo recurrente por Usuario Final en cada Periodo de Facturaci&oacute;n mensual por concepto de Servicio de gesti&oacute;n de Plataforma Mayorista de acuerdo con lo establecido en la Tabla 20 siguiente. Este cargo se aplicar&aacute; por cada Usuario Final que en el Periodo de Facturaci&oacute;n haya estado alguna vez Activo, conforme a los Estados de Suscripci&oacute;n definidos en Ap&eacute;ndice 7.1 &ldquo;Alcance T&eacute;cnico Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N&rdquo;.</p>
<p>&nbsp;</p>
<p><em>Tabla 20: Estructura Tarifaria por Servicio de gesti&oacute;n de Plataforma Mayorista.</em></p>
<p><em>&nbsp;</em></p>
<h4><u>OCTAVA. Condiciones para la aplicaci&oacute;n de los descuentos por cantidad de</u> <u>Usuarios Finales Activos Medios en todas las Estructuras Tarifarias</u></h4>
<p><strong>&nbsp;</strong></p>
<p><strong>8.1. </strong>El n&uacute;mero de Usuarios Finales Activos Medios que se tomar&aacute;n en cuenta por Alt&aacute;n para la aplicaci&oacute;n de los descuentos establecidos en este Ap&eacute;ndice, en cualquiera de las Estructuras Tarifarias, se integrar&aacute; por la sumatoria de los Usuarios Finales Activos Medios del Cliente y de todas sus empresas afiliadas. Para efectos de este Ap&eacute;ndice, &ldquo;afiliada&rdquo; significa una empresa que controle al Cliente, una empresa que se encuentre y permanezca bajo el control del Cliente o una empresa que se encuentre y permanezca bajo el control com&uacute;n del Cliente y &ldquo;control&rdquo; tiene el significado que se le atribuye en la fracci&oacute;n III del art&iacute;culo 2 de la Ley del Mercado de Valores, es decir, la capacidad del Cliente de: i) imponer, directa o indirectamente, decisiones en las asambleas generales de accionistas, de socios u &oacute;rganos equivalentes, o nombrar o destituir a la mayor&iacute;a de los consejeros, administradores o sus equivalentes, de la afiliada; ii) mantener la titularidad de derechos que permitan, directa o indirectamente, ejercer el voto respecto de m&aacute;s del 50% (cincuenta por ciento) del capital social de la afiliada; o iii) dirigir, directa o indirectamente, la administraci&oacute;n, la estrategia o las principales pol&iacute;ticas de la afiliada, ya sea a trav&eacute;s de la propiedad de valores, por contrato o de cualquier otra forma.</p>
<p>&nbsp;</p>
<h4><u>NOVENA. Condiciones de facturaci&oacute;n aplicables a todas las Estructuras Tarifarias</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>La facturaci&oacute;n del Servicio Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N se realizar&aacute; de acuerdo con lo descrito en el Anexo 1 &ldquo;Facturaci&oacute;n y Garant&iacute;as&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n no proveer&aacute; servicios de Voz mVoIP ni mensajer&iacute;a SMS a trav&eacute;s del Servicio descrito en este Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMA. Costos por SIMs y Terminales</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>La adquisici&oacute;n, la comprobaci&oacute;n y cualquier otro costo relacionado con las SIMs y terminales mencionadas en el Ap&eacute;ndice 7.1 &ldquo;Alcance T&eacute;cnico Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N&rdquo; ser&aacute;n responsabilidad exclusiva del</li>
<li>Alt&aacute;n no ser&aacute; responsable de la relaci&oacute;n contractual/comercial entre el Cliente y el fabricante, por lo que el Cliente renuncia irrevocablemente a hacer cualquier reclamo a Alt&aacute;n derivado de lo anterior y se obliga a indemnizar y sacar en paz y a salvo a Alt&aacute;n de cualquier reclamaci&oacute;n que pudiera presentar el fabricante en contra de Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de&nbsp; diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="751">&nbsp;</td>
</tr>
<tr>
<td>&nbsp;</td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 7.3 TARIFAS</p>
<p>INTERNET HOGAR Y TELEFON&Iacute;A SIM ALTAN</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 7.3 &ldquo;Tarifas INTERNET HOGAR Y TELEFONIA SIM ALTAN&rdquo; al que se refiere el Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFONIA SIM ALTAN&rdquo; del Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que se les atribuye en el Contrato o en el propio Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFONIA SIM ALTAN&rdquo; o&nbsp;&nbsp; este Ap&eacute;ndice, seg&uacute;n corresponda.&nbsp; Para&nbsp; la&nbsp; interpretaci&oacute;n&nbsp; del&nbsp; presente&nbsp; Ap&eacute;ndice,&nbsp; las&nbsp; Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Objeto y consideraciones generales</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El presente Ap&eacute;ndice tiene como objeto establecer las Tarifas acordadas entre Alt&aacute;n y el Cliente para la prestaci&oacute;n de los Servicios de conectividad fija sobre la Red Compartida para INTERNET HOGAR Y TELEFONIA SIM ALTAN</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Consideraciones Generales:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas estar&aacute;n expresadas en Pesos Mexicanos (MXN) y no incluyen los impuestos aplicables en su caso, los cuales deber&aacute;n ser pagados por el Cliente de conformidad con las Leyes</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas de los Servicios establecidos bajo el presente Ap&eacute;ndice son v&aacute;lidas hasta que se comunique una actualizaci&oacute;n y se den de alta en la Plataforma Web de Tarifas de acuerdo con las condiciones establecidas en el apartado 1.3 de este Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>De conformidad con lo establecido en la Cl&aacute;usula 14.2 del Contrato, las modificaciones a este Ap&eacute;ndice no requieren de aprobaci&oacute;n previa del IFT. Sin embargo, Alt&aacute;n presentar&aacute; al IFT el presente Ap&eacute;ndice para su registro previo a que sea v&aacute;lido y surta</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n dar&aacute; publicidad y transparencia a las Tarifas entre sus clientes de acuerdo a lo que se indica a continuaci&oacute;n:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas establecidas en este Ap&eacute;ndice ser&aacute;n publicadas por Alt&aacute;n en una carpeta espec&iacute;fica para INTERNET HOGAR Y TELEFONIA SIM ALTAN ubicada en la Plataforma Web de Tarifas a la que tendr&aacute;n acceso restringido y seguro todos los clientes que tengan contratado el Servicio INTERNET HOGAR Y TELEFONIA SIM ALTAN. Asimismo, el IFT tambi&eacute;n dispondr&aacute; de acceso a la citada Plataforma Web de</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El identificador y la clave de acceso a la Plataforma Web de Tarifas ser&aacute;n entregadas por Alt&aacute;n a la persona designada por el Cliente en el mismo momento de la firma del presente Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente podr&aacute; solicitar, en todo momento dentro de la vigencia del Contrato, que le sean aplicadas las mejores Tarifas publicadas por Alt&aacute;n en la Plataforma Web de Tarifas, teniendo efectos dicha aplicaci&oacute;n a partir del D&iacute;a H&aacute;bil siguiente a la fecha de recepci&oacute;n por parte de Alt&aacute;n de dicha</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de un incremento en las Tarifas, Alt&aacute;n publicar&aacute; las nuevas Tarifas de acuerdo con lo establecido en los incisos (a) y (b) anteriores, sin embargo, las nuevas Tarifas ser&aacute;n aplicables y tendr&aacute;n efectos trascurridos 30 (treinta) D&iacute;as desde la fecha en que Alt&aacute;n las publique en la Plataforma Web de</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Tarifas para el Servicio Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Alt&aacute;n facturar&aacute; la totalidad de las Tarifas indicadas en las Tablas del presente Ap&eacute;ndice, en el momento en que se realice la activaci&oacute;n de los Servicios Internet Hogar y Telefon&iacute;a SIM ALT&Aacute;N o del consumo excedente mencionado en dichas</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Tarifas expresadas en este Ap&eacute;ndice son aplicables a la modalidad con acceso Internet incluido, y, por tanto dicho acceso a Internet es proporcionado por Alt&aacute;n, en los casos que</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n pone a disposici&oacute;n del Cliente dos Estructuras Tarifarias para el total de sus Usuarios Finales:
<ol>
<li>Estructura Tarifaria</li>
<li>Estructura Tarifaria Mixto</li>
<li>Estructura Tarifaria Paquetes de</li>
</ol>
</li>
</ul>
<p>&nbsp;</p>
<p>[EL RESTO DE ESTA P&Aacute;GINA ES INTENCIONALMENTE DEJADO EN BLANCO, SIGUE 2.4]</p>
<p>&nbsp;</p>
<h4>2.4&nbsp;&nbsp; <u>Estructura Tarifaria Paquetes de Datos</u></h4>
<ul>
<li><strong>Productos para la Estructura Tarifaria Paquetes de Datos</strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="643">
<p>Productos para la Estructura Tarifaria Paquetes de Datos</p>
</td>
</tr>
<tr>
<td width="123">
<p>Velocidad del Producto (Mbps)</p>
</td>
<td width="207">
<p>Cuota de Datos &ndash; (GB / Usuario Final / Ciclo Individual)</p>
</td>
<td width="156">
<p>Tarifa (MXN / Cuota de Datos)</p>
</td>
<td width="157">
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td rowspan="12" width="123">
<p><strong>&nbsp;</strong></p>
<p>5</p>
</td>
<td width="207">
<p>10</p>
</td>
<td width="156">
<p>65.00</p>
</td>
<td rowspan="12" width="157">
<p><strong>&nbsp;</strong></p>
<p>30 d&iacute;as, o una fecha de inicio una fecha de fin entre las que transcurre un mes natural</p>
</td>
</tr>
<tr>
<td width="207">
<p>20</p>
</td>
<td width="156">
<p>80.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>30</p>
</td>
<td width="156">
<p>93.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>40</p>
</td>
<td width="156">
<p>106.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>50</p>
</td>
<td width="156">
<p>119.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>60</p>
</td>
<td width="156">
<p>132.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>70</p>
</td>
<td width="156">
<p>145.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>80</p>
</td>
<td width="156">
<p>158.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>90</p>
</td>
<td width="156">
<p>171.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>100</p>
</td>
<td width="156">
<p>184.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>120</p>
</td>
<td width="156">
<p>186.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>140</p>
</td>
<td width="156">
<p>200.00</p>
</td>
</tr>
<tr>
<td rowspan="12" width="123">
<p><strong>&nbsp;</strong></p>
<p>10</p>
</td>
<td width="207">
<p>20</p>
</td>
<td width="156">
<p>125.00</p>
</td>
<td rowspan="12" width="157">
<p><strong>&nbsp;</strong></p>
<p>30 d&iacute;as, o una fecha de inicio una fecha de fin entre las que transcurre un mes natural</p>
</td>
</tr>
<tr>
<td width="207">
<p>30</p>
</td>
<td width="156">
<p>140.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>40</p>
</td>
<td width="156">
<p>155.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>50</p>
</td>
<td width="156">
<p>170.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>60</p>
</td>
<td width="156">
<p>180.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>70</p>
</td>
<td width="156">
<p>195.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>80</p>
</td>
<td width="156">
<p>215.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>90</p>
</td>
<td width="156">
<p>230.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>100</p>
</td>
<td width="156">
<p>245.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>110</p>
</td>
<td width="156">
<p>260.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>120</p>
</td>
<td width="156">
<p>275.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>150</p>
</td>
<td width="156">
<p>325.00</p>
</td>
</tr>
<tr>
<td rowspan="11" width="123">
<p><strong>&nbsp;</strong></p>
<p>20</p>
</td>
<td width="207">
<p>60</p>
</td>
<td width="156">
<p>300.00</p>
</td>
<td rowspan="11" width="157">
<p><strong>&nbsp;</strong></p>
<p>30 d&iacute;as, o una fecha de inicio una fecha de fin entre las que transcurre un mes natural</p>
</td>
</tr>
<tr>
<td width="207">
<p>70</p>
</td>
<td width="156">
<p>345.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>80</p>
</td>
<td width="156">
<p>385.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>90</p>
</td>
<td width="156">
<p>425.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>100</p>
</td>
<td width="156">
<p>465.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>110</p>
</td>
<td width="156">
<p>505.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>120</p>
</td>
<td width="156">
<p>540.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>130</p>
</td>
<td width="156">
<p>570.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>140</p>
</td>
<td width="156">
<p>600.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>150</p>
</td>
<td width="156">
<p>630.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>200</p>
</td>
<td width="156">
<p>800.00</p>
</td>
</tr>
<tr>
<td rowspan="5" width="123">
<p><strong>&nbsp;</strong></p>
<p>5</p>
</td>
<td width="207">
<p>10</p>
</td>
<td width="156">
<p>40.00</p>
</td>
<td rowspan="5" width="157">
<p>14 d&iacute;as, o una fecha de inicio una fecha de fin entre las que transcurren dos semanas</p>
</td>
</tr>
<tr>
<td width="207">
<p>20</p>
</td>
<td width="156">
<p>53.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>30</p>
</td>
<td width="156">
<p>66.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>40</p>
</td>
<td width="156">
<p>79.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>50</p>
</td>
<td width="156">
<p>92.00</p>
</td>
</tr>
<tr>
<td rowspan="5" width="123">
<p><strong>&nbsp;</strong></p>
<p>5</p>
</td>
<td width="207">
<p>5</p>
</td>
<td width="156">
<p>20.00</p>
</td>
<td rowspan="5" width="157">
<p><strong>&nbsp;</strong></p>
<p>7 d&iacute;as, o una fecha de inicio una fecha de fin entre las que transcurre una semana</p>
</td>
</tr>
<tr>
<td width="207">
<p>10</p>
</td>
<td width="156">
<p>26.50</p>
</td>
</tr>
<tr>
<td width="207">
<p>15</p>
</td>
<td width="156">
<p>33.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>20</p>
</td>
<td width="156">
<p>39.50</p>
</td>
</tr>
<tr>
<td width="207">
<p>25</p>
</td>
<td width="156">
<p>44.00</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td width="123">
<p>&nbsp;</p>
</td>
<td width="207">
<p>30</p>
</td>
<td width="156">
<p>46.50</p>
</td>
<td width="157">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td rowspan="4" width="123">
<p><strong>&nbsp;</strong></p>
<p>10</p>
</td>
<td width="207">
<p>5</p>
</td>
<td width="156">
<p>31.00</p>
</td>
<td rowspan="4" width="157">
<p>7 d&iacute;as, o una fecha de inicio una fecha de fin</p>
<p>entre las que transcurre una semana</p>
</td>
</tr>
<tr>
<td width="207">
<p>10</p>
</td>
<td width="156">
<p>39.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>15</p>
</td>
<td width="156">
<p>45.00</p>
</td>
</tr>
<tr>
<td width="207">
<p>20</p>
</td>
<td width="156">
<p>53.00</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 1: Productos para la Estructura Tarifaria Paquetes de Datos.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.4.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Datos</h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p>Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Datos</p>
</td>
</tr>
<tr>
<td width="186">
<p>Paquete de Consumo Excedente (GB)</p>
</td>
<td width="222">
<p>Tarifa por Paquete (MXN / Usuario Final)</p>
</td>
<td width="237">
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="186">
<p>1</p>
</td>
<td width="222">
<p>MXN 7</p>
</td>
<td rowspan="6" width="237">
<p><strong>&nbsp;</strong></p>
<p>Misma que la del Producto Paquetes de Datos contratado</p>
</td>
</tr>
<tr>
<td width="186">
<p>2</p>
</td>
<td width="222">
<p>MXN 13</p>
</td>
</tr>
<tr>
<td width="186">
<p>5</p>
</td>
<td width="222">
<p>MXN 30</p>
</td>
</tr>
<tr>
<td width="186">
<p>10</p>
</td>
<td width="222">
<p>MXN 50</p>
</td>
</tr>
<tr>
<td width="186">
<p>25</p>
</td>
<td width="222">
<p>MXN 120</p>
</td>
</tr>
<tr>
<td width="186">
<p>50</p>
</td>
<td width="222">
<p>MXN 200</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 2: Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Datos.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.4.3&nbsp;&nbsp;&nbsp;&nbsp; Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Paquetes de Datos</h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="645">
<p>Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Paquetes de Datos</p>
</td>
</tr>
<tr>
<td width="126">
<p>Velocidad (Kbps)</p>
</td>
<td width="128">
<p>Tarifa (MXN / GB)</p>
</td>
<td width="160">
<p>Cantidad de Datos (GB)</p>
</td>
<td width="231">
<p>Producto al que aplica</p>
</td>
</tr>
<tr>
<td rowspan="3" width="126">
<p><strong>&nbsp;</strong></p>
<p>1,024 Kbps</p>
</td>
<td rowspan="3" width="128">
<p><strong>&nbsp;</strong></p>
<p>1 MXN/ GB</p>
</td>
<td rowspan="3" width="160">
<p><strong>&nbsp;</strong></p>
<p>0-100 GB</p>
</td>
<td width="231">
<p>5 Mbps - 80GB, 90GB, 100GB</p>
</td>
</tr>
<tr>
<td width="231">
<p>10 Mbps - 100GB, 110GB, 120GB y</p>
<p>150GB</p>
</td>
</tr>
<tr>
<td width="231">
<p>20 Mbps - 100GB, 110GB, 120GB,</p>
<p>130GB, 140GB, 150GB y 200GB</p>
</td>
</tr>
<tr>
<td rowspan="2" width="126">
<p><strong>&nbsp;</strong></p>
<p>Desde 128 Kbps</p>
<p>hasta 512 Kbps inclusive</p>
</td>
<td rowspan="2" width="128">
<p><strong>&nbsp;</strong></p>
<p>0 MXN/GB</p>
</td>
<td rowspan="2" width="160">
<p><strong>&nbsp;</strong></p>
<p>0-60 GB</p>
</td>
<td width="231">
<p><strong>Desde 301 Kbps hasta 512 Kbps</strong>:</p>
<p>5 Mbps &ndash; 80 GB, 90 GB y 100 GB.</p>
<p>10 Mbps - 100GB, 110GB, 120GB y</p>
<p>150GB.</p>
<p>20 Mbps - 100GB, 110GB, 120GB,</p>
<p>130GB, 140GB, 150GB y 200GB.</p>
</td>
</tr>
<tr>
<td width="231">
<p><strong>Desde 128 Kbps hasta 300 Kbps</strong>: Todos</p>
</td>
</tr>
</tbody>
</table>
<p><strong>&nbsp;</strong></p>
<p><em>Tabla 3: Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Paquetes de Datos.</em></p>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<h4>2.4.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Descuentos por cantidad de Usuarios Finales Activos Medios aplicable a la Estructura Tarifaria Paquetes de Datos</h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p>Descuentos por cantidad de Usuarios Finales Activos Medios aplicable a la Estructura Tarifaria Paquetes de Datos</p>
</td>
</tr>
<tr>
<td width="223">
<p>M&iacute;nimo (Usuarios Finales Activos Medios)</p>
</td>
<td width="230">
<p>M&aacute;ximo (Usuarios Finales Activos Medios)</p>
</td>
<td width="192">
<p>Descuento (%)</p>
</td>
</tr>
<tr>
<td width="223">
<p>-</p>
</td>
<td width="230">
<p>40,000</p>
</td>
<td width="192">
<p>0.00%</p>
</td>
</tr>
<tr>
<td width="223">
<p>40,001</p>
</td>
<td width="230">
<p>65,000</p>
</td>
<td width="192">
<p>7.50%</p>
</td>
</tr>
<tr>
<td width="223">
<p>65,001</p>
</td>
<td width="230">
<p>100,000</p>
</td>
<td width="192">
<p>10.00%</p>
</td>
</tr>
<tr>
<td width="223">
<p>100,001</p>
</td>
<td width="230">
<p>150,000</p>
</td>
<td width="192">
<p>12.50%</p>
</td>
</tr>
<tr>
<td width="223">
<p>150,001</p>
</td>
<td width="230">
<p>300,000</p>
</td>
<td width="192">
<p>13.25%</p>
</td>
</tr>
<tr>
<td colspan="2" width="453">
<p>M&aacute;s de 300,000</p>
</td>
<td width="192">
<p>15.00%</p>
</td>
</tr>
</tbody>
</table>
<p><strong>&nbsp;</strong></p>
<p><em>Tabla 4: Descuentos por cantidad de Usuarios Finales Activos Medios aplicable a la Estructura Tarifaria Paquetes de Datos.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.5.&nbsp; <u>Estructura Tarifaria Mixto Granel</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Productos para la Estructura Tarifaria Mixto Granel</strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="5" width="645">
<p>Productos para la Estructura Tarifaria Mixto Granel</p>
</td>
</tr>
<tr>
<td width="104">
<p>Velocidad del Producto (Mbps)</p>
</td>
<td width="145">
<p>Cuota de Datos &ndash; (GB / Usuario Final / Ciclo Individual)</p>
</td>
<td width="107">
<p>Tarifa (MXN / Cuota de Datos)</p>
</td>
<td width="125">
<p>L&iacute;mite M&aacute;ximo (GB)</p>
</td>
<td width="164">
<p><strong>&nbsp;</strong></p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="104">
<p><strong>&nbsp;</strong></p>
<p>5 Mbps</p>
</td>
<td width="145">
<p><strong>&nbsp;</strong></p>
<p>40 GB / (SIM)</p>
</td>
<td width="107">
<p><strong>&nbsp;</strong></p>
<p>MXN 70 / (SIM)</p>
</td>
<td width="125">
<p>Como m&iacute;nimo 80 GB</p>
</td>
<td rowspan="4" width="164">
<p><strong>&nbsp;</strong></p>
<p>30 d&iacute;as, o una fecha de inicio una fecha de fin entre las que transcurre un mes natural</p>
</td>
</tr>
<tr>
<td width="104">
<p><strong>&nbsp;</strong></p>
<p>10 Mbps</p>
</td>
<td width="145">
<p><strong>&nbsp;</strong></p>
<p>40 GB / (SIM)</p>
</td>
<td width="107">
<p>MXN 145 / (SIM)</p>
</td>
<td width="125">
<p>Como m&iacute;nimo 100 GB</p>
</td>
</tr>
<tr>
<td rowspan="2" width="104">
<p><strong>&nbsp;</strong></p>
<p>20 Mbps</p>
</td>
<td width="145">
<p><strong>&nbsp;</strong></p>
<p>60 GB / (SIM)</p>
</td>
<td width="107">
<p>MXN 315 / (SIM)</p>
</td>
<td width="125">
<p>Como m&iacute;nimo 100 GB</p>
</td>
</tr>
<tr>
<td width="145">
<p><strong>&nbsp;</strong></p>
<p>120 GB / (SIM)</p>
</td>
<td width="107">
<p>MXN 570 / (SIM)</p>
</td>
<td width="125">
<p>Como m&iacute;nimo 120 GB</p>
</td>
</tr>
<tr>
<td width="104">
<p><strong>&nbsp;</strong></p>
<p>5 Mbps</p>
</td>
<td width="145">
<p><strong>&nbsp;</strong></p>
<p>10 GB / (SIM)</p>
</td>
<td width="107">
<p><strong>&nbsp;</strong></p>
<p>MXN 20 / (SIM)</p>
</td>
<td width="125">
<p>Como m&iacute;nimo 20 GB</p>
</td>
<td rowspan="2" width="164">
<p><strong>&nbsp;</strong></p>
<p>7 d&iacute;as, o una fecha de inicio una fecha de fin entre las que transcurre una semana</p>
</td>
</tr>
<tr>
<td width="104">
<p><strong>&nbsp;</strong></p>
<p>10 Mbps</p>
</td>
<td width="145">
<p><strong>&nbsp;</strong></p>
<p>10 GB / (SIM)</p>
</td>
<td width="107">
<p><strong>&nbsp;</strong></p>
<p>MXN 42 / (SIM)</p>
</td>
<td width="125">
<p>Como m&iacute;nimo 25 GB</p>
</td>
</tr>
</tbody>
</table>
<p><strong>&nbsp;</strong></p>
<p><em>Tabla 5: Productos para la Estructura Tarifaria Mixto Granel.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.5.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Consumo Excedente Medio Mixto Granel para la Estructura Tarifaria Mixto Granel</h4>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p>Consumo Excedente Medio Mixto Granel para la Estructura Tarifaria Mixto Granel</p>
</td>
</tr>
<tr>
<td width="230">
<p>Consumo Excedente Medio Mixto Granel desde (GB)</p>
</td>
<td width="241">
<p>Consumo Excedente Medio Mixto Granel hasta (GB)</p>
</td>
<td width="174">
<p>Tarifa aplicable al tramo (MXN / GB)</p>
</td>
</tr>
<tr>
<td width="230">
<p>0</p>
</td>
<td width="241">
<p>20</p>
</td>
<td width="174">
<p>MXN 2.50</p>
</td>
</tr>
<tr>
<td width="230">
<p>20+ 1 MB</p>
</td>
<td width="241">
<p>30</p>
</td>
<td width="174">
<p>MXN 2.00</p>
</td>
</tr>
<tr>
<td width="230">
<p>30+ 1 MB</p>
</td>
<td width="241">
<p>40</p>
</td>
<td width="174">
<p>MXN 1.00</p>
</td>
</tr>
<tr>
<td width="230">
<p>40+ 1 MB</p>
</td>
<td width="241">
<p>50</p>
</td>
<td width="174">
<p>MXN 1.00</p>
</td>
</tr>
<tr>
<td width="230">
<p>50+ 1 MB</p>
</td>
<td width="241">
<p>60</p>
</td>
<td width="174">
<p>MXN 2.00</p>
</td>
</tr>
<tr>
<td colspan="2" width="471">
<p>M&aacute;s de 60</p>
</td>
<td width="174">
<p>MXN 3.50</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 6: Consumo Excedente Medio Mixto Granel para la Estructura Tarifaria Mixto Granel.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.5.3&nbsp;&nbsp;&nbsp;&nbsp; Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Mixto Granel</h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="645">
<p>Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Mixto Granel</p>
</td>
</tr>
<tr>
<td width="167">
<p><strong>&nbsp;</strong></p>
<p>Velocidad (Kbps)</p>
</td>
<td width="94">
<p>Tarifa (MXN / GB)</p>
</td>
<td width="148">
<p><strong>&nbsp;</strong></p>
<p>Cantidad de Datos (GB)</p>
</td>
<td width="238">
<p><strong>&nbsp;</strong></p>
<p>Producto al que aplica</p>
</td>
</tr>
<tr>
<td width="167">
<p><strong>&nbsp;</strong></p>
<p>1,024 Kbps</p>
</td>
<td width="94">
<p><strong>&nbsp;</strong></p>
<p>1 MXN / GB</p>
</td>
<td width="148">
<p><strong>&nbsp;</strong></p>
<p>0-100 GB</p>
</td>
<td width="238">
<p>Aplica s&oacute;lo para productos con ciclos de</p>
<p>30 d&iacute;as y que cumplan con el l&iacute;mite m&aacute;ximo se&ntilde;alado en la tabla 5</p>
</td>
</tr>
<tr>
<td rowspan="2" width="167">
<p><strong>&nbsp;</strong></p>
<p>Desde 128 Kbps hasta 512 Kbps inclusive</p>
</td>
<td rowspan="2" width="94">
<p><strong>&nbsp;</strong></p>
<p>0 MXN / GB</p>
</td>
<td rowspan="2" width="148">
<p><strong>&nbsp;</strong></p>
<p>0-60 GB</p>
</td>
<td width="238">
<p><strong>Desde 301 Kbps hasta 512 Kbps</strong>: Aplica &uacute;nicamente a los productos que cumplan&nbsp; &nbsp;con&nbsp;&nbsp; los&nbsp;&nbsp; l&iacute;mites&nbsp;&nbsp;&nbsp; m&aacute;ximos establecidos en la Tabla 5.</p>
</td>
</tr>
<tr>
<td width="238">
<p><strong>Desde 128 Kbps hasta 300 Kbps</strong>: Todos</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 7: Modalidades de Consumo Excedente a Velocidad Reducida para la Estructura Tarifaria Mixto Granel.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.5.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Descuento por cantidad de Usuarios Finales Activos Medios aplicable a los Productos de la Estructura Tarifaria Mixto Granel</h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p>Descuento por cantidad de Usuarios Finales Activos Medios aplicable a los Productos de la Estructura Tarifaria Mixto Granel</p>
</td>
</tr>
<tr>
<td width="223">
<p>M&iacute;nimo (Usuarios Finales Activos Medios)</p>
</td>
<td width="230">
<p>M&aacute;ximo (Usuarios Finales Activos Medios)</p>
</td>
<td width="192">
<p>Descuento (%)</p>
</td>
</tr>
<tr>
<td width="223">
<p>-</p>
</td>
<td width="230">
<p>50,000</p>
</td>
<td width="192">
<p>0.0%</p>
</td>
</tr>
<tr>
<td colspan="2" width="453">
<p>M&aacute;s de 50,000</p>
</td>
<td width="192">
<p>2.5%</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 8: Descuento por cantidad de Usuarios Finales Activos Medios aplicable a los Productos de la Estructura Tarifaria Mixto Granel</em></p>
<p><em>&nbsp;</em></p>
<h4>2.5.5&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Descuento por cantidad de Usuarios Finales Activos Medios aplicable al Consumo Excedente Mixto Granel de la Estructura Tarifaria Mixto Granel</h4>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p>Descuento por cantidad de Usuarios Finales Activos Medios aplicable al Consumo Excedente de la Estructura Tarifaria Mixto Granel</p>
</td>
</tr>
<tr>
<td width="223">
<p>M&iacute;nimo (Usuarios Finales Activos Medios)</p>
</td>
<td width="230">
<p>M&aacute;ximo (Usuarios Finales Activos Medios)</p>
</td>
<td width="192">
<p>Descuento (%)</p>
</td>
</tr>
<tr>
<td width="223">
<p>-</p>
</td>
<td width="230">
<p>100,000</p>
</td>
<td width="192">
<p>0.00%</p>
</td>
</tr>
<tr>
<td width="223">
<p>100,001</p>
</td>
<td width="230">
<p>200,000</p>
</td>
<td width="192">
<p>20.00%</p>
</td>
</tr>
<tr>
<td width="223">
<p>200,001</p>
</td>
<td width="230">
<p>300,000</p>
</td>
<td width="192">
<p>30.00%</p>
</td>
</tr>
<tr>
<td width="223">
<p>300,001</p>
</td>
<td width="230">
<p>400,000</p>
</td>
<td width="192">
<p>40.00%</p>
</td>
</tr>
<tr>
<td width="223">
<p>400,001</p>
</td>
<td width="230">
<p>500,000</p>
</td>
<td width="192">
<p>42.50%</p>
</td>
</tr>
<tr>
<td width="223">
<p>500,001</p>
</td>
<td width="230">
<p>750,000</p>
</td>
<td width="192">
<p>45.00%</p>
</td>
</tr>
<tr>
<td width="223">
<p>750,001</p>
</td>
<td width="230">
<p>1,000,000</p>
</td>
<td width="192">
<p>47.50%</p>
</td>
</tr>
<tr>
<td colspan="2" width="453">
<p>M&aacute;s de 1,000,000</p>
</td>
<td width="192">
<p>50.00%</p>
</td>
</tr>
</tbody>
</table>
<p><strong>&nbsp;</strong></p>
<p><em>Tabla 9: Descuento por cantidad de Usuarios Finales Activos Medios aplicable al Consumo Excedente de la Estructura Tarifaria Mixto Granel</em></p>
<p><em>&nbsp;</em></p>
<h4>2.6.&nbsp; <u>Estructura Tarifaria Paquetes de Voz</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Los Productos para la Estructura Tarifaria Paquetes de Voz son los indicados en la Tabla 10 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p>Productos para la Estructura Tarifaria Paquetes de Voz</p>
</td>
</tr>
<tr>
<td width="215">
<p>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente (Min / Usuario Final / Ciclo Individual)</p>
</td>
<td width="215">
<p>Tarifa (MXN / L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente)</p>
</td>
<td width="215">
<p>&nbsp;</p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="215">
<p>1,000</p>
</td>
<td width="215">
<p>25.00</p>
</td>
<td width="215">
<p>Misma que la del Producto contratado</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 10: Productos para la Estructura Tarifaria Paquetes de Voz.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Los Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Voz son los indicados en la Tabla 11 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p>Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Voz</p>
</td>
</tr>
<tr>
<td width="215">
<p>Paquete de Consumo Excedente (Min)</p>
</td>
<td width="215">
<p>Tarifa por Paquete de Voz (MXN</p>
<p>/ Usuario Final)</p>
</td>
<td width="215">
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="215">
<p>100</p>
</td>
<td width="215">
<p>3.50</p>
</td>
<td width="215">
<p>Misma que la del Producto contratado</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 11: Paquetes de Consumo Excedente para la Estructura Tarifaria Paquetes de Voz.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.7.&nbsp; <u>Otras Estructuras Tarifarias y condiciones de uso del Producto</u></h4>
<ul>
<li><strong>Plataformas de servicio del Cliente</strong></li>
</ul>
<table class="table">
<tbody>
<tr>
<td width="84">&nbsp;</td>
</tr>
<tr>
<td>&nbsp;</td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
<p><em>Tabla 12. Estructura Tarifaria del Tr&aacute;fico Saliente de Voz con destino a plataformas de servicio del Cliente.</em></p>
<p><em>&nbsp;</em></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p>Estructura Tarifaria del Tr&aacute;fico Saliente de Voz Excedente con destino a plataformas de servicio del Cliente</p>
</td>
</tr>
<tr>
<td width="207">
<p><em>&nbsp;</em></p>
<p>Min/Usuario Final</p>
</td>
<td width="237">
<p><em>&nbsp;</em></p>
<p>Tarifa (MXN / Min)</p>
</td>
<td width="201">
<p><em>&nbsp;</em></p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="207">
<p>1</p>
</td>
<td width="237">
<p>0.05</p>
</td>
<td width="201">
<p>Misma que la del Producto contratado</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 13. Estructura Tarifaria del Tr&aacute;fico Saliente de Voz Excedente con destino a plataformas de servicio del Cliente</em></p>
<h4>2.7.2&nbsp; Servicio de Tarificaci&oacute;n Adicional</h4>
<p><em>Tabla 14. Estructura Tarifaria para Terminaci&oacute;n en Servicios de Tarificaci&oacute;n Adicional.</em></p>
<p><em>&nbsp;</em></p>
<h4>2.7.3&nbsp; Larga Distancia Internacional</h4>
<ul>
<li>Los Servicios de Larga Distancia Internacional (&ldquo;LDI&rdquo;) ser&aacute;n tarificados conforme a las Tarifas estipuladas en la Tabla 15 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="645">
<p>Estructura Tarifaria del Servicio de Voz LDI</p>
</td>
</tr>
<tr>
<td width="354">
<p>Destino / Regi&oacute;n</p>
</td>
<td width="291">
<p>Tarifa (MXN / Minuto)</p>
</td>
</tr>
<tr>
<td width="354">
<p>Estados Unidos de Am&eacute;rica</p>
</td>
<td width="291">
<p>0.065</p>
</td>
</tr>
<tr>
<td width="354">
<p>Canad&aacute;</p>
</td>
<td width="291">
<p>0.061</p>
</td>
</tr>
<tr>
<td width="354">
<p>LATAM Excl. Caribe</p>
</td>
<td width="291">
<p>1.30</p>
</td>
</tr>
<tr>
<td width="354">
<p>Caribe</p>
</td>
<td width="291">
<p>2.73</p>
</td>
</tr>
<tr>
<td width="354">
<p>Uni&oacute;n Europea</p>
</td>
<td width="291">
<p>2.63</p>
</td>
</tr>
<tr>
<td width="354">
<p>Resto de Europa</p>
</td>
<td width="291">
<p>2.76</p>
</td>
</tr>
<tr>
<td width="354">
<p>Resto del Mundo Excl. Destinos Especiales</p>
</td>
<td width="291">
<p>5.15</p>
</td>
</tr>
<tr>
<td width="354">
<p>Destinos Especiales</p>
</td>
<td width="291">
<p>5.32</p>
</td>
</tr>
<tr>
<td width="354">
<p>Satelital</p>
</td>
<td width="291">
<p>77.63</p>
</td>
</tr>
<tr>
<td width="354">
<p>Marcaciones Especiales</p>
</td>
<td width="291">
<p>6.29</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 15. Estructura Tarifaria del Servicio de Voz LDI.</em></p>
<p><em>&nbsp;</em></p>
<ul>
<li>Adicionalmente, el Cliente podr&aacute; acceder a un Producto de Voz en servicio de Larga Distancia Internacional de acuerdo con la Tabla 16 siguiente:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="4" width="645">
<p>Productos Paquetes de Voz para el Servicio de Larga Distancia Internacional</p>
</td>
</tr>
<tr>
<td width="174">
<p>L&iacute;mite M&aacute;ximo de Tr&aacute;fico de Voz Saliente para el Servicio de Larga Distancia Internacional (Minutos / Paquete / Ciclo Individual)</p>
</td>
<td width="150">
<p>&nbsp;</p>
<p>Destinos Incluidos</p>
</td>
<td width="78">
<p>&nbsp;</p>
<p>Tarifa (MXN /</p>
<p>Paquete)</p>
</td>
<td width="243">
<p>&nbsp;</p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="174">
<p>30</p>
</td>
<td width="150">
<p>Latinoam&eacute;rica</p>
</td>
<td width="78">
<p>35.00</p>
</td>
<td width="243">
<p>Misma que la del Producto contratado</p>
</td>
</tr>
<tr>
<td width="174">
<p>30</p>
</td>
<td width="150">
<p>Europa</p>
</td>
<td width="78">
<p>70.00</p>
</td>
<td width="243">
<p>Misma que la del Producto contratado</p>
</td>
</tr>
<tr>
<td width="174">
<p>30</p>
</td>
<td width="150">
<p>Resto del Mundo Excl. Destinos Especiales</p>
</td>
<td width="78">
<p>140.00</p>
</td>
<td width="243">
<p>Misma que la del Producto contratado</p>
</td>
</tr>
<tr>
<td width="174">
<p>30</p>
</td>
<td width="150">
<p>Destinos Especiales</p>
</td>
<td width="78">
<p>145.00</p>
</td>
<td width="243">
<p>Misma que la del Producto contratado</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 16. Productos Paquetes de Voz para el Servicio de Larga Distancia Internacional.</em></p>
<p><em>&nbsp;</em></p>
<p><em>&nbsp;</em></p>
<h4>2.7.4&nbsp;&nbsp; Tarifas Productos en Horario Restringido</h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="6" width="645">
<p><strong>Tarifas Productos de Datos en Horario Restringido</strong></p>
</td>
</tr>
<tr>
<td rowspan="2" width="128">
<p>Velocidad del Producto al que aplica (Mbps)</p>
</td>
<td rowspan="2" width="123">
<p>Cuota de Datos en Horario Restringido (GB)</p>
</td>
<td rowspan="2" width="131">
<p>Tarifa (MXN / Cuota de Datos en Horario Restringido)</p>
</td>
<td colspan="2" width="176">
<p>Horario Restringido (Hora Local)</p>
</td>
<td rowspan="2" width="88">
<p><strong>&nbsp;</strong></p>
<p>Ciclo Individual</p>
</td>
</tr>
<tr>
<td width="88">
<p>Desde</p>
</td>
<td width="88">
<p>Hasta</p>
</td>
</tr>
<tr>
<td width="128">
<p>5</p>
</td>
<td width="123">
<p>40</p>
</td>
<td width="131">
<p>15.00</p>
</td>
<td width="88">
<p>00:00</p>
</td>
<td width="88">
<p>06:00</p>
</td>
<td rowspan="3" width="88">
<p>Misma que la del Producto contratado</p>
</td>
</tr>
<tr>
<td width="128">
<p>10</p>
</td>
<td width="123">
<p>40</p>
</td>
<td width="131">
<p>25.00</p>
</td>
<td width="88">
<p>00:00</p>
</td>
<td width="88">
<p>06:00</p>
</td>
</tr>
<tr>
<td width="128">
<p>20</p>
</td>
<td width="123">
<p>60</p>
</td>
<td width="131">
<p>45.00</p>
</td>
<td width="88">
<p>00:00</p>
</td>
<td width="88">
<p>06:00</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 17: Tarifas Productos de Datos en Horario Restringido</em></p>
<p><em>&nbsp;</em></p>
<h4>2.7.5. Vinculaci&oacute;n de eNB y Router LTE (IMEI)</h4>
<p><em>Tabla 18: Tarifa cambio de vinculaci&oacute;n de eNB</em></p>
<p><em>&nbsp;</em></p>
<p><em>&nbsp;</em></p>
<h4>2.7.6&nbsp;&nbsp;&nbsp; Tarifas funcionalidad Multi-Domicilio</h4>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td colspan="3" width="645">
<p><strong>Tarifas funcionalidad &ldquo;Multi-domicilio&rdquo;</strong></p>
</td>
</tr>
<tr>
<td width="231">
<p>Producto al que aplica</p>
</td>
<td width="200">
<p>N&uacute;mero de Domicilios</p>
</td>
<td width="215">
<p>Tarifa (MXN)</p>
</td>
</tr>
<tr>
<td width="231">
<p>Todos</p>
</td>
<td width="200">
<p>3</p>
</td>
<td width="215">
<p>MXN 125 (Adicional a la Tarifa de cada Producto contratado)</p>
</td>
</tr>
</tbody>
</table>
<p><em>Tabla 19: Tarifas funcionalidad &ldquo;Multi-domicilio&rdquo;</em></p>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<h4>2.7.7. Plataforma Mayorista</h4>
<p><em>Tabla 20: Estructura Tarifaria por Servicio de gesti&oacute;n de Plataforma Mayorista</em></p>
<p><em>&nbsp;</em></p>
<p><em>&nbsp;</em></p>
<p>En prueba de conformidad y enteradas las Partes de su contenido y alcance legal, y reconociendo el Cliente expresamente que Alt&aacute;n ha entregado en este acto de firma el identificador y clave de acceso seguro a la Plataforma Web de Tarifas para INTERNET HOGAR Y TELEFON&Iacute;A SIM ALTAN, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 7.4</p>
<p>&nbsp;</p>
<p>PLAN DE PROYECTO E IMPLEMENTACI&Oacute;N INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>El presente documento es el Ap&eacute;ndice 7.4 &ldquo;Plan de Proyecto e Implementaci&oacute;n INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; al que se refiere el Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; del Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto&nbsp; con&nbsp; sus&nbsp; Anexos&nbsp; y&nbsp; Ap&eacute;ndices,&nbsp; el&nbsp; &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que se&nbsp; les atribuye en el Contrato o en el propio Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; o este&nbsp; Ap&eacute;ndice,&nbsp; seg&uacute;n&nbsp; corresponda.&nbsp; Para&nbsp; la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Objeto</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Este Ap&eacute;ndice tiene como objeto establecer el Plan de Proyecto&nbsp; acordado entre las Partes para logar la integraci&oacute;n y Puesta en Marcha del Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><br /> En la siguiente tabla se describe el Plan de Proyecto, incluyendo las responsabilidades, los requerimientos, actividades, pruebas de los Servicios INTERNET HOGAR Y TELEFON&Iacute;A&nbsp;&nbsp; SIM&nbsp;&nbsp; ALT&Aacute;N,&nbsp;&nbsp; dependencias&nbsp;&nbsp; de&nbsp;&nbsp; terceros&nbsp;&nbsp; y&nbsp;&nbsp; los&nbsp;&nbsp; tiempos correspondientes:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Plan de Proyecto tendr&aacute; los siguientes hitos:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Aceptaci&oacute;n del documento <em>Low Level Design </em>(LLD). Fecha: 15 de octubre de</li>
<li>Establecimiento de la primera sesi&oacute;n de datos de los Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N. Fecha: 29 de octubre de</li>
<li>Puesta en Marcha del Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N. Fecha: 8 de noviembre de</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Las Partes deber&aacute;n cumplir, en los tiempos establecidos, con cada una de las obligaciones a su cargo establecidas bajo el Plan de</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El &oacute;rgano encargado del seguimiento y cumplimiento del Plan de Proyecto es el Comit&eacute; de Puesta en Marcha, en t&eacute;rminos de lo establecido en el Anexo 2 &ldquo;Procedimientos Operativos&rdquo; del</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de que alguna de las Partes identifique alguna dificultad o demora durante la ejecuci&oacute;n del Plan de Proyecto, dicha Parte deber&aacute; reportarla, informando de manera justificada el detalle de la dificultad o problema que pueda causar la demora al Comit&eacute; de Puesta en Marcha, para que, en su caso, se tomen las medidas necesarias para asegurar que se cumpla la Puesta en Marcha del Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N en la fecha</li>
</ul>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de&nbsp; diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="746">&nbsp;</td>
</tr>
<tr>
<td>&nbsp;</td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="727">&nbsp;</td>
</tr>
<tr>
<td>&nbsp;</td>
<td>&nbsp;</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 7.5</p>
<p>&nbsp;</p>
<p>ACUERDO DE NIVEL DE SERVICIOS Y GESTI&Oacute;N DE INCIDENCIAS INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>El presente documento es el Ap&eacute;ndice 7.5 &ldquo;Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; al que se refiere el Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; del Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices,&nbsp;&nbsp;&nbsp;&nbsp; el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; se les atribuye en el Contrato o&nbsp; en&nbsp; el&nbsp; propio&nbsp; Anexo&nbsp; 7&nbsp; &ldquo;Servicios&nbsp; INTERNET&nbsp; HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; o este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Introducci&oacute;n</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El presente&nbsp; Ap&eacute;ndice&nbsp;&nbsp; establece&nbsp;&nbsp; los&nbsp;&nbsp; procedimientos&nbsp;&nbsp; para&nbsp;&nbsp; la&nbsp;&nbsp; gesti&oacute;n&nbsp;&nbsp; de incidencias y los factores que pueden influir en la calidad del Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N, as&iacute; como los par&aacute;metros y niveles objetivos de calidad que integran el Acuerdo de Nivel de Servicios</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los indicadores de calidad y de gesti&oacute;n de incidencias incluidos en la Cl&aacute;usula Segunda y el apartado 5.4 de este Ap&eacute;ndice, respectivamente,&nbsp; s&oacute;lo&nbsp; son&nbsp; de&nbsp; aplicaci&oacute;n para el &aacute;rea de Cobertura de la Red</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Para los efectos del presente Ap&eacute;ndice, se considera como incidencia todo aquel evento o problema que impida la prestaci&oacute;n del&nbsp; Servicio&nbsp; de&nbsp; INTERNET&nbsp; HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N de Alt&aacute;n al Cliente conforme a sus&nbsp; especificaciones o a el Acuerdo de Nivel de Servicio</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n proveer&aacute; el Servicio de INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N de forma no discriminatoria, con la misma calidad y en igualdad de condiciones con la que presta Servicios iguales a otros</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Indicadores de Calidad</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Indicadores de Calidad de la Red</li>
</ul>
<p>Para el Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N, Alt&aacute;n estar&aacute; obligada a cumplir con los siguientes indicadores de calidad, de acuerdo con lo establecido en el Contrato de APP:</p>
<table class="table">
<tbody>
<tr>
<td width="195">
<p>&nbsp;</p>
<p>Tasa de Transmisi&oacute;n de Datos del Enlace Descendente</p>
</td>
<td width="380">
<p>&nbsp;</p>
<p>Cantidad promedio de Datos descargada con respecto a 1 (un) segundo y que deber&aacute; ser de al menos 4 (cuatro) Megabits por segundo en el borde de Cobertura exterior (no en inmuebles) en Hora Pico de la Red Compartida</p>
</td>
</tr>
<tr>
<td width="195">
<p>&nbsp;</p>
<p>Tasa de Transmisi&oacute;n de Datos del Enlace Ascendente</p>
</td>
<td width="380">
<p>&nbsp;</p>
<p>Cantidad promedio de Datos enviada con respecto a 1 (un) segundo y que deber&aacute; ser de al menos 1 (un) Megabit por segundo en el borde de Cobertura en Hora Pico de la Red Compartida exterior (no en inmuebles)</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>Alt&aacute;n deber&aacute; cumplir con los par&aacute;metros de Calidad establecidos en las disposiciones contenidas en los Lineamientos que fijan los &iacute;ndices y par&aacute;metros de calidad aprobados por el IFT, o cualquier disposici&oacute;n que los modifique o sustituya.</p>
<p>&nbsp;</p>
<ul>
<li>Asimismo, Alt&aacute;n deber&aacute; cumplir con el indicador de calidad de las Interfases de Plataforma de Gesti&oacute;n Mayorista:</li>
</ul>
<p>&nbsp;</p>
<p>a) El indicador de calidad de las Interfases de Plataforma de Gesti&oacute;n Mayorista de Alt&aacute;n es el porcentaje de tiempo en que todos sus componentes se encuentran disponibles (seg&uacute;n se especifica en el Ap&eacute;ndice 7.1 &ldquo;Alcance T&eacute;cnico INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;) y se calcular&aacute; conforme a la siguiente f&oacute;rmula:</p>
<p>&nbsp;</p>
<p>% de disponibilidad = se calcula restando de 1 (uno) el siguiente cociente: suma de todos los eventos (entendiendo como un evento una interrupci&oacute;n del Servicio superior a 10 (diez) segundos consecutivos medidos en segundos incurridos en 1 (un) mes) dividido por el total de segundos de 1 (un) mes (2,592,000).</p>
<p>&nbsp;</p>
<p>b) El tiempo de indisponibilidad inicia desde el momento en que sea confirmada por el Centro de Operaciones (NOC). Al respecto, no se considerar&aacute;n como causales de indisponibilidad atribuibles a Alt&aacute;n y, por lo tanto, no est&aacute;n sujetas a los indicadores de calidad del Servicio, las siguientes:</p>
<p>&nbsp;</p>
<ol>
<li>Las fallas producidas en equipos y componentes diferentes a los suministrados por Alt&aacute;n.</li>
<li>Fallas imputables al Cliente en los elementos o plataformas de los que el Cliente es</li>
</ol>
<ul>
<li>La indisponibilidad debida a todas las labores de mantenimiento preventivo y a las labores de mantenimiento correctivo ocasionadas por hechos o actos no atribuibles a Alt&aacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>
  c) Alt&aacute;n estar&aacute; obligada a la siguiente disponibilidad para el Servicio de gesti&oacute;n mayorista:
</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="317">
<p>&nbsp;</p>
<p><strong>Indicador</strong></p>
</td>
<td width="258">
<p><strong>Compromiso de Disponibilidad del Servicio</strong></p>
</td>
</tr>
<tr>
<td width="317">
<p>Disponibilidad de las Interfases de la Plataforma de Gesti&oacute;n Mayorista</p>
</td>
<td width="258">
<p>99.5%</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>

<h4><u>TERCERA.&nbsp;&nbsp;&nbsp; Penalizaciones</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En caso de que para un determinado mes calendario la disponibilidad del servicio de gesti&oacute;n mayorista est&eacute; por debajo del valor definido en la tabla del apartado 2, inciso</li>
</ul>
<ol>
<li>c) anterior, se aplicar&aacute; una penalizaci&oacute;n que ser&aacute; resultante de aplicar el porcentaje de diferencia entre el compromiso de disponibilidad del Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N y la disponibilidad mensual, multiplicado por la cantidad monetaria, antes de impuestos, de la &uacute;ltima factura mensual emitida por parte de Alt&aacute;n al Cliente.</li>
</ol>
<ul>
<li>En caso de: (i) sanciones impuestas por la Procuradur&iacute;a Federal del Consumidor (en adelante &ldquo;<strong>PROFECO</strong>&rdquo;) al Cliente como resultado de una reclamaci&oacute;n de un Usuario Final en lo individual o de una reclamaci&oacute;n colectiva de un grupo de Usuarios Finales; (ii) sanciones impuestas por un tribunal civil competente al Cliente como resultado de una reclamaci&oacute;n de un Usuario Final en lo individual o de una acci&oacute;n colectiva de un grupo de Usuarios Finales; o (iii) sanciones impuestas por PROFECO al Cliente como resultado de una actuaci&oacute;n de oficio originada por fallas generalizadas o masivas; por una causa exclusiva y directamente imputable a Alt&aacute;n, siempre que haya sido acreditada fehacientemente por el Cliente, se proceder&aacute; de acuerdo con lo que se establece en esta Cl&aacute;usula.</li>
</ul>
<p>Alt&aacute;n pagar&aacute; al Cliente las sanciones correspondientes a que hace alusi&oacute;n el p&aacute;rrafo anterior, siempre y cuando el Cliente acredite con la Resoluci&oacute;n por parte de la autoridad competente que: (i) la falla en el Servicio que ocasion&oacute; la sanci&oacute;n por parte de PROFECO o el tribunal civil competente haya sido atribuible exclusivamente a Alt&aacute;n; (ii) el(los) Usuario(s) Final(es) respectivo(s) haya(n) presentado una reclamaci&oacute;n individual o colectiva en contra del Cliente ante PROFECO o un tribunal civil competente y se haya llevado a cabo y concluido un proceso de conciliaci&oacute;n con los Usuarios Finales afectados sin lograr eliminar la sanci&oacute;n, o que PROFECO haya impuesto de oficio al Cliente la obligaci&oacute;n de realizar una compensaci&oacute;n por una falla generalizada o masiva atribuible exclusivamente a Alt&aacute;n y que la misma haya sido debidamente acreditada mediante un resoluci&oacute;n con la fundamentaci&oacute;n y motivaci&oacute;n necesaria de acuerdo con la Ley Aplicable;</p>
<p>(iii) realiz&oacute; el pago de la sanci&oacute;n o compensaci&oacute;n a el(los) Usuario(s) Final(es) respectivo(s); y (iv) la falla no se debi&oacute;, directa o indirectamente, a un evento de Fuerza Mayor.</p>
<p>&nbsp;</p>
<p>La compensaci&oacute;n a pagar por Alt&aacute;n al Cliente con motivo de la sanci&oacute;n impuesta al Cliente conforme a la presente cl&aacute;usula estar&aacute; siempre limitada: (i) en caso de una sanci&oacute;n impuesta por PROFECO o un tribunal civil competente al Cliente derivado de una reclamaci&oacute;n de un Usuario Final individual, a la parte proporcional del precio pagado por el Cliente a Alt&aacute;n por el Servicio en el que ocurra la falla respecto al Usuario Final que presente la reclamaci&oacute;n correspondiente por el tiempo y/o periodo que se dej&oacute; de prestar el Servicio m&aacute;s el 20% (veinte por ciento) del monto del periodo de afectaci&oacute;n; o (ii) en</p>
<p>&nbsp;</p>
<p>caso de una compensaci&oacute;n impuesta de oficio por PROFECO al Cliente por una falla generalizada o masiva, de una sanci&oacute;n impuesta por PROFECO mediante la resoluci&oacute;n de una reclamaci&oacute;n colectiva o de una sanci&oacute;n impuesta por un tribunal civil competente mediante la sentencia que ponga fin a una acci&oacute;n colectiva, a la suma de las penalizaciones determinadas conforme al inciso (i) anterior respecto a los Usuarios Finales efectivamente afectados por la falla del Servicio correspondiente.</p>
<p>&nbsp;</p>
<p>En caso de que una de las Partes as&iacute; lo requiera, las Partes deber&aacute;n reunirse para analizar la posibilidad de impugnar la sanci&oacute;n impuesta por PROFECO o por el tribunal civil competente al Cliente. En caso de que Alt&aacute;n decida que procede interponer alg&uacute;n medio de defensa, impugnaci&oacute;n o acci&oacute;n al respecto, el pago de la sanci&oacute;n quedar&aacute; suspendido hasta que se resuelva de manera firme e inapelable el medio de defensa, impugnaci&oacute;n o acci&oacute;n respectivo o hasta que Alt&aacute;n decida que procede desistirse del mismo o transigir con la contraparte. Alt&aacute;n deber&aacute; cubrir los costos del asesoramiento legal que eventualmente se requiera de despachos de abogados externos, siempre y cuando los mismos hayan sido aprobados previamente y por escrito por Alt&aacute;n, as&iacute; como los gastos y costas de juicio que sean determinados por la autoridad administrativa o judicial competente. Ambas Partes colaborar&aacute;n de buena fe y har&aacute;n sus mejores esfuerzos para conseguir el resultado m&aacute;s beneficioso y minimizar los costos asociados a la eventual sanci&oacute;n y a la defensa legal, haci&eacute;ndose cargo cada una de las Partes de los costos de sus recursos internos dedicados a tal fin.</p>
<p>&nbsp;</p>
<p>PROFECO, ante la presencia de fallas generalizadas o notorias en la prestaci&oacute;n de servicios a los Usuarios Finales, puede establecer y/o proponer a los prestadores de servicios de telecomunicaciones como el Cliente, el implementar medidas compensatorias a los Usuarios Finales (en adelante las &ldquo;<strong>Medidas Compensatorias</strong>&rdquo;). Las Medidas Compensatorias, regularmente son implementadas por los diferentes prestadores de servicios de telecomunicaciones en atenci&oacute;n a la solicitud de PROFECO para evitar la imposici&oacute;n de sanciones y en beneficio de los Usuarios Finales y para evitar quejas o reclamaciones formales de los mismos, ya sean individuales o colectivas. Considerando lo anterior, las Partes est&aacute;n de acuerdo en que en caso de que la PROFECO solicite al Cliente la implementaci&oacute;n de una Medida Compensatoria como resultado de fallas en los Servicios atribuibles exclusiva y directamente a Alt&aacute;n, las Partes se reunir&aacute;n para revisar de manera conjunta y de buena fe dicha Medida Compensatoria a efecto de determinar de com&uacute;n acuerdo la mejor forma de atender a la misma, aplicando siempre los principios establecidos en esta cl&aacute;usula 3.2, y sin que ello implique responsabilidad de naturaleza alguna de Alt&aacute;n frente a PROFECO y/o cualesquier Usuarios Finales.</p>
<p>&nbsp;</p>
<ul>
<li>El monto de las sanciones a pagar por parte de Alt&aacute;n hacia el Cliente, se aplicar&aacute; como una nota de cr&eacute;dito sobre la factura del periodo de facturaci&oacute;n siguiente (antes de impuestos) que Alt&aacute;n emita al Cliente por los Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N. En caso de que se haya determinado como procedente el monto de la sanci&oacute;n impuesta al Cliente por causa atribuible exclusivamente a Alt&aacute;n, y que haya sido debidamente acreditada con la Resoluci&oacute;n por parte de la autoridad competente conforme a lo establecido en la Cl&aacute;usula 3.2 anterior y la nota de cr&eacute;dito no haya sido emitida por Alt&aacute;n, el Cliente tendr&aacute; la opci&oacute;n de requerir a Alt&aacute;n el pago de la sanci&oacute;n aplicable, en cuyo caso el pago deber&aacute; ser hecho por Alt&aacute;n dentro de los 30 (treinta) D&iacute;as siguientes a la fecha en que Alt&aacute;n reciba el requerimiento de pago del Cliente.</li>
</ul>
<p>&nbsp;</p>
<h4><u>CUARTA. Factores que Pueden Afectar la Calidad del Servicio INTERNET HOGAR</u> <u>Y TELEFON&Iacute;A SIM ALT&Aacute;N</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Dada la naturaleza de la propagaci&oacute;n inal&aacute;mbrica, la calidad del Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N se encuentra relacionada con la naturaleza de la se&ntilde;al de radio, quedando &eacute;sta fuera del alcance y control de Alt&aacute;n en muchas ocasiones. La propagaci&oacute;n de la se&ntilde;al radio depende de los obst&aacute;culos existentes entre la radiobase (eNB) y el equipo terminal del Usuario Final, pudi&eacute;ndose presentar variaciones por desvanecimiento, interferencias y perdidas de cobertura por la presencia de obst&aacute;culos, as&iacute; como de las condiciones climatol&oacute;gicas no favorables (ej. lluvia).</li>
</ul>
<ul>
<li>Alt&aacute;n &uacute;nicamente es responsable de la prestaci&oacute;n de los Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N conforme a lo expresamente establecido en el Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; y sus Ap&eacute;ndices. Cualquier situaci&oacute;n o concepto no contemplado en los instrumentos anteriores no ser&aacute; responsabilidad de Alt&aacute;n, incluyendo los factores externos a Alt&aacute;n que puedan afectar la calidad de los Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N.</li>
</ul>
<ul>
<li>La calidad de los Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N puede verse afectada por una mayor demanda de tr&aacute;fico o de Usuarios Finales de la originalmente prevista por el Cliente en el Ap&eacute;ndice 7.6 &ldquo;Proyecciones INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;. A tal efecto, el Cliente deber&aacute; reportar de manera regular dichas proyecciones de tr&aacute;fico.</li>
</ul>
<ul>
<li>Con la finalidad de mantener la integridad de la Red Compartida y no afectar a otro(s) cliente(s), Alt&aacute;n podr&aacute; suspender las activaciones en una determinada regi&oacute;n o localidad, sin responsabilidad alguna para Alt&aacute;n, en caso de que el tr&aacute;fico en dicha regi&oacute;n o localidad incluida en el formulario &ldquo;Proyecciones a 12 meses INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; mencionado en el Ap&eacute;ndice de 7.6 &ldquo;Proyecciones INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; exceda las proyecciones realizadas por el Cliente en m&aacute;s del 50% (cincuenta por ciento). La suspensi&oacute;n de las activaciones en dicha regi&oacute;n o localidad se realizar&aacute; 24 (veinticuatro) horas despu&eacute;s de que Alt&aacute;n notifique al Cliente la necesidad de la suspensi&oacute;n.</li>
</ul>
<p>Dicha suspensi&oacute;n permanecer&aacute; en vigor hasta que: (a) Alt&aacute;n pueda asegurar la integridad de la Red Compartida sin afectar a otros clientes; (b) Alt&aacute;n pueda resolver la carencia de numeraci&oacute;n o capacidad en la regi&oacute;n o localidad en la que se presente la afectaci&oacute;n; y (c) el Cliente entregue proyecciones corregidas mediante la presentaci&oacute;n de un nuevo formulario &ldquo;Proyecciones a 12 meses INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; conforme a lo establecido en el Ap&eacute;ndice 7.6 &ldquo;Proyecciones INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;.</p>
<p>&nbsp;</p>
<ul>
<li>En caso de un incremento significativo en la demanda de tr&aacute;fico y/o Usuarios Finales en un determinado eNB/sector, Alt&aacute;n ajustar&aacute; los par&aacute;metros t&eacute;cnicos para permitir la mejor experiencia del conjunto de Usuarios Finales del Cliente en la Red de Alt&aacute;n (sobresuscripci&oacute;n).</li>
</ul>
<p>&nbsp;</p>
<h4><u>QUINTA. Gesti&oacute;n de Incidencias</u></h4>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Incidencias del Cliente.</li>
</ul>
<p>&nbsp;</p>
<p>Se consideran Incidencias del Cliente aquellas que afectan a un Usuario Final o a un conjunto de Usuario Finales del Cliente, las cuales ser&aacute;n clasificadas conforme a lo siguiente:</p>
<p>&nbsp;</p>
<ol>
<li><u>Incidencias Cr&iacute;ticas.</u> Ser&aacute;n incidencias cr&iacute;ticas aquellas que impidan el uso del Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N para todos los Usuarios Finales o un grupo significativo del total de los Usuarios Finales del Cliente. De forma enunciativa, pero no limitativa, las incidencias cr&iacute;ticas incluyen:
<ol>
<li>Ca&iacute;da de elementos de red que brinden servicio masivo (ejemplo SGW, PGW, MME, DRA).</li>
<li>Ca&iacute;da del proveedor de acceso a internet</li>
</ol>
</li>
</ol>
<ul>
<li>Ca&iacute;da de 25 (veinticinco) o m&aacute;s radiobases (eNB).</li>
</ul>
<ol>
<li>Imposibilidad de Location Update en determinadas &aacute;reas.</li>
<li>Imposibilidad de realizar nuevas</li>
<li>Imposibilidad de realizar modificaciones en perfiles de Usuarios Finales en el Core de Alt&aacute;n.</li>
<li>Indisponibilidad del Centro de Operaciones (NOC) facilitado por Alt&aacute;n al Cliente por m&aacute;s de 1 (una)</li>
</ol>
<ol>
<li><u>Incidencias mayores. </u> Son las incidencias que suponen una degradaci&oacute;n grave en la prestaci&oacute;n normal de los Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N, incluyendo, sin limitar, las siguientes:
<ol>
<li>Indisponibilidad de la funcionalidad de modificaci&oacute;n de la dupla IMSI- eNB</li>
<li>Indisponibilidad de la funcionalidad de cambio de IMEI (Router LTE)</li>
</ol>
</li>
</ol>
<ul>
<li>Indisponibilidad para generaci&oacute;n de archivos input para generaci&oacute;n de nuevos lotes de SIMs</li>
</ul>
<ol>
<li><u>Incidencias Menores.</u> Son aquellas incidencias que:
<ol>
<li>No tienen un impacto directo en el Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N recibido por los Usuarios Finales del Cliente (e.g. disponibilidad de herramienta de cobertura de red).</li>
</ol>
</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Incidencias Reportadas por Alt&aacute;n.</li>
</ul>
<ol>
<li>Con el objetivo de mejorar la visibilidad sobre el estado de operaci&oacute;n y disponibilidad de la Red Compartida y evitar en la medida de lo posible que se abran m&uacute;ltiples tickets de incidencias por parte del Cliente, Alt&aacute;n proactivamente informar&aacute; al Cliente las incidencias en la Red</li>
<li>Dentro de dicho reporte se clasificar&aacute; el nivel de criticidad de la incidencia, as&iacute; como la fecha estimada de soluci&oacute;n, en caso de que est&eacute; disponible, realizando notificaciones de actualizaci&oacute;n seg&uacute;n se vaya progresando en la soluci&oacute;n. Una vez solucionada, tambi&eacute;n se reportar&aacute; el cierre de</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>Indicadores de Calidad de la Resoluci&oacute;n de</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Se definen los siguientes indicadores de calidad para la resoluci&oacute;n de incidencias:</li>
</ol>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="223">
<p><strong>Criticidad</strong></p>
</td>
<td width="351">
<p><strong>Tiempo De Resoluci&oacute;n</strong></p>
</td>
</tr>
<tr>
<td width="223">
<p>CR&Iacute;TICA</p>
</td>
<td width="351">
<p>30% en 6 hrs</p>
<p>50% en 8 hrs</p>
<p>90% en 10 hrs</p>
</td>
</tr>
<tr>
<td width="223">
<p>MAYOR</p>
</td>
<td width="351">
<p>50% en 12 hrs</p>
<p>90% en 24 hrs</p>
</td>
</tr>
<tr>
<td width="223">
<p>MENOR</p>
</td>
<td width="351">
<p>90% en 48 hrs</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<ol>
<li>El tiempo de resoluci&oacute;n de una incidencia se calcular&aacute; como el tiempo transcurrido entre la apertura del incidente en el Centro de Operaciones (NOC) de Alt&aacute;n y la notificaci&oacute;n al Cliente por parte de Alt&aacute;n, a trav&eacute;s de la herramienta disponible, de la resoluci&oacute;n de</li>
</ol>
<p>&nbsp;</p>
<p>Para efectos de los tiempos en la reparaci&oacute;n de incidencias, no se contabilizar&aacute;n:</p>
<p>&nbsp;</p>
<ol>
<li>Retrasos motivados por error del Cliente en la apertura de la incidencia, por falta de respuesta del Cliente ante cualquier requerimiento adicional de informaci&oacute;n o por la imposibilidad de comunicaci&oacute;n con Alt&aacute;n con el fin de solucionar la incidencia;</li>
<li>Todos aquellos retrasos injustificados por causa del Cliente; y/o</li>
</ol>
<ul>
<li>Fuerza</li>
</ul>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 7.6</p>
<p>&nbsp;</p>
<p>PROYECCIONES INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 7.6 &ldquo;Proyecciones INTERNET HOGARSIM ALT&Aacute;N&rdquo; al que se refiere el Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; del Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que se les atribuye en el&nbsp; Contrato&nbsp; o&nbsp; en&nbsp; el&nbsp; propio&nbsp; Anexo 7 &ldquo;Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; o este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Objeto</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Este Ap&eacute;ndice tiene como objeto establecer las proyecciones de tr&aacute;fico y Usuarios Finales acordadas entre Alt&aacute;n y el Cliente para la prestaci&oacute;n de los servicios de conectividad m&oacute;vil sobre la Red Compartida para el Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N.</p>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Previsiones de Usuarios Finales y Tr&aacute;fico</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El Cliente deber&aacute;, durante toda la vigencia del Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;, enviar a Alt&aacute;n y cumplir las previsiones de Usuarios Finales de conformidad con el procedimiento establecido en la Cl&aacute;usula Tercera del presente Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los servicios de conectividad m&oacute;vil sobre la Red Compartida para el Servicio INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N ser&aacute;n dimensionados con base en las proyecciones de tr&aacute;fico que el Cliente entregue por escrito a Alt&aacute;n, a trav&eacute;s de los medios establecidos para tales efectos.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>La siguiente tabla muestra el Plan de Negocio del Cliente, el cual incluye las proyecciones anuales de tr&aacute;fico a nivel agregado del Cliente para los primeros 3 (tres) a&ntilde;os, con base en las cuales se han dimensionado las integraciones mencionadas en el presente Ap&eacute;ndice:</li>
</ul>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="228">
<p>Concepto (en miles)</p>
</td>
<td width="64">
<p>A&ntilde;o 1</p>
</td>
<td width="64">
<p>A&ntilde;o 2</p>
</td>
<td width="64">
<p>A&ntilde;o 3</p>
</td>
</tr>
<tr>
<td width="228">
<p>Usuarios Finales</p>
</td>
<td width="64">
<p>360</p>
</td>
<td width="64">
<p>720</p>
</td>
<td width="64">
<p>1,080</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>Donde los Usuarios Finales (en miles) representan el n&uacute;mero de Usuarios Finales que tienen contratado un producto de INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N durante el &uacute;ltimo mes calendario de cada a&ntilde;o de ejecuci&oacute;n.</p>
<p>&nbsp;</p>
<h4><u>TERCERA. Proyecciones iniciales y actualizaci&oacute;n de Proyecciones</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Durante la vigencia del Anexo 7 &ldquo;Servicios INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;, el Cliente deber&aacute; enviar a Alt&aacute;n el formulario &ldquo;Proyecciones a 12 meses</li>
</ul>
<p>&nbsp;</p>
<p>INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; por los medios establecidos para tales efectos. Este formulario contiene las proyecciones de Usuarios Finales del Plan de Negocios del Cliente con detalle mensual de, al menos, los siguientes 4 (cuatro) trimestres. Dicho formato ser&aacute; proporcionado por Alt&aacute;n al Cliente.</p>
<p>&nbsp;</p>
<ul>
<li>El llenado de la informaci&oacute;n que debe incluirse en el formulario &ldquo;Proyecciones a</li>
</ul>
<p>12 meses INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; se realizar&aacute; de manera peri&oacute;dica cada 3 (tres) meses, iniciando a partir de la firma del presente Ap&eacute;ndice. A tal efecto, el Cliente se compromete a enviar el primer formulario de &ldquo;Proyecciones a 12 meses INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; dentro de un plazo de 10 (diez) D&iacute;as contados a partir de la fecha de firma del presente Ap&eacute;ndice (<u>Proyecciones iniciales</u>). A partir de ese momento, el Cliente deber&aacute; actualizar trimestralmente el formulario de &ldquo;Proyecciones a 12 meses INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; (<u>Actualizaci&oacute;n de Proyecciones</u>).</p>
<p>&nbsp;</p>
<ul>
<li>Una vez presentado el formulario de &ldquo;Proyecciones a 12 meses INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; para un determinado trimestre, las proyecciones detalladas en el mismo se considerar&aacute;n definitivas y por tanto no podr&aacute;n modificarse y formar&aacute;n parte del presente Ap&eacute;ndice.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Con el objetivo de preservar la calidad e integridad de la Red Compartida, y evitar la congesti&oacute;n de estaciones eNB, Alt&aacute;n se reserva el derecho a solicitar un mayor detalle geogr&aacute;fico del incluido inicialmente (estado/localidad) en las &ldquo;Proyecciones a 12 meses INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo;.</li>
</ul>
<p>&nbsp;</p>
<h4><u>CUARTA. Variaci&oacute;n de Tr&aacute;fico Real en Comparaci&oacute;n con las Proyecciones</u></h4>
<p><strong>&nbsp;</strong></p>
<p><strong>4.1 </strong>En caso de que exista variaciones entre el tr&aacute;fico real en comparaci&oacute;n con las proyecciones establecidas en este Ap&eacute;ndice y en los formularios de &ldquo;Proyecciones a 12 meses INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; antes mencionados, Alt&aacute;n podr&aacute; tomar las medidas que se establecen en el Ap&eacute;ndice 7.5 &ldquo;Acuerdo de Nivel de Servicios y Gesti&oacute;n de Incidencias&rdquo;.</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance legal, las Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de&nbsp; diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p>AP&Eacute;NDICE 7.7</p>
<p>&nbsp;</p>
<p>ALCANCE DE PRESTACI&Oacute;N DE SERVICIOS DE COADYUVANCIA PARA LA COLABORACI&Oacute;N CON LAS INSTANCIAS DE SEGURIDAD, PROCURACI&Oacute;N Y ADMINISTRACI&Oacute;N DE JUSTICIA</p>
<p>&nbsp;</p>
<p>SERVICIO DE INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N</p>
<p>&nbsp;</p>
<p>El presente documento es el Ap&eacute;ndice 7.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia&rdquo; al que se refiere el Anexo 7 &ldquo;Servicio de INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; del Contrato Marco de Prestaci&oacute;n de Servicios de Telecomunicaciones (junto con sus Anexos y Ap&eacute;ndices, el &ldquo;Contrato&rdquo;) celebrado entre&nbsp; las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que se utilizan en el presente Ap&eacute;ndice tienen el significado que se les atribuye en el Contrato o en el propio Anexo 7 &ldquo;Servicio de INTERNET HOGAR Y TELEFON&Iacute;A SIM ALT&Aacute;N&rdquo; o este Ap&eacute;ndice, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Ap&eacute;ndice, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>
<p>&nbsp;</p>
<h4><u>PRIMERA. Fundamentos.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En cumplimiento con lo dispuesto por los art&iacute;culos 16 de la Constituci&oacute;n Pol&iacute;tica de los Estados Unidos Mexicanos; 189 y 190 de la Ley Federal de Telecomunicaciones y Radiodifusi&oacute;n (&ldquo;<strong>LFTyR</strong>&rdquo;); 8, 16, 17, 18, 19, 26 y 27 de la Ley Federal Contra la Delincuencia; 177 y 178 bis del C&oacute;digo Penal Federal; 291, 292, 293, 294, 296, 301, 302 y 303, del C&oacute;digo Nacional de Procedimientos Penales (&ldquo;<strong>CNPP</strong>&rdquo;), publicado en el Diario Oficial de la Federaci&oacute;n (&ldquo;<strong>DOF</strong>&rdquo;) el 17 de junio de 2016, cuya &uacute;ltima modificaci&oacute;n fue publicada en el DOF el 8 de noviembre de 2019.; los Lineamientos de Colaboraci&oacute;n en Materia de Seguridad y Justicia (&ldquo;<strong>LCMSJ</strong>&rdquo;), expedidos por el Instituto Federal de Telecomunicaciones (&ldquo;<strong>IFT</strong>&rdquo;) y publicados en el DOF el 2 de diciembre de 2015, as&iacute; como sus respectivas modificaciones de fechas 28 de diciembre de 2017 y 2 de abril de 2018; as&iacute; como el art&iacute;culo 18, fracci&oacute;n XVIII de los Lineamientos para la Comercializaci&oacute;n de Servicios M&oacute;viles por parte de Operadores M&oacute;viles Virtuales (&ldquo;<strong>Lineamientos OMV</strong>&rdquo;), publicado en el DOF el 9 de marzo de 2016, y; de conformidad con el &ldquo;Acuerdo mediante el cual el Pleno del Instituto Federal de Telecomunicaciones emite respuesta a la Solicitud de Confirmaci&oacute;n de Criterio presentada por Alt&aacute;n Redes, A.P.I. de C.V. (en adelante &ldquo;<strong>Alt&aacute;n</strong>&rdquo;), respecto al alcance de aplicaci&oacute;n de los Lineamientos de Colaboraci&oacute;n en Materia de Seguridad y Justicia&rdquo; de fecha 22 de mayo de 2019, para cualquier Operador de Servicios de Telecomunicaciones, Concesionarios y Autorizados es obligatorio colaborar con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia, para lo cual se emite este Ap&eacute;ndice 7.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia&rdquo; (&ldquo;<strong>Acuerdo</strong>&rdquo;).</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Los efectos y la validez de este Ap&eacute;ndice est&aacute;n sujetos a la condici&oacute;n de que el IFT lo apruebe como parte de la Oferta de Referencia conforme a la Condici&oacute;n 12 de la Concesi&oacute;n de Alt&aacute;n, por lo que la respuesta negativa o el requerimiento de ajustes por parte del IFT ante la solicitud de Alt&aacute;n no podr&aacute; considerarse incumplimiento o</li>
</ul>
<p>&nbsp;</p>
<p>atribuirse a la falta o negligencia de cualquiera de las Partes, quienes quedar&aacute;n obligadas a realizar cualesquier ajustes requeridos por el IFT, en su caso.</p>
<p>&nbsp;</p>
<h4><u>SEGUNDA. Objeto.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>El objeto del presente Acuerdo es describir la coadyuvancia que ofrece Alt&aacute;n al &ldquo;<strong>Cliente</strong>&rdquo;, con la finalidad de establecer las obligaciones, responsabilidades y alcances que cada una de las partes deber&aacute; asumir para que puedan dar cumplimiento oportuno a las obligaciones en materia de colaboraci&oacute;n con la seguridad y justicia, que se desprende de la LFTyR y los LCMSJ, relacionadas con la atenci&oacute;n de alg&uacute;n requerimiento de <em>(i) </em>Datos Conservados (&ldquo;<strong>DC</strong>&rdquo;), <em>(ii) </em>Geolocalizaci&oacute;n (&ldquo;<strong>GL</strong>&rdquo;), e; <em>(iii) </em>Intervenci&oacute;n Legal de Comunicaciones (&ldquo;<strong>IL</strong>&rdquo;) por parte de una Autoridad Facultada o</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Asimismo, se identifican los responsables directos e indirectos en cada servicio, as&iacute; como el proceso y tiempos de respuesta, detallando tambi&eacute;n la secuencia l&oacute;gica del procedimiento que deber&aacute; seguirse para poder dar respuesta oportuna a los requerimientos de informaci&oacute;n provenientes de las Autoridades Facultadas y Designadas.</li>
</ul>
<p>&nbsp;</p>
<h4><u>TERCERA. Definiciones.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Las siguientes definiciones aplican de forma general al presente Ap&eacute;ndice:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>"<strong>Autoridades Facultadas</strong>", son el Ministerio P&uacute;blico y/o aquellas instancias de seguridad, procuraci&oacute;n de justicia y administraci&oacute;n de justicia que, conforme a sus atribuciones previstas en las leyes aplicables o en acuerdos delegatorios publicados en el DOF, cuenten con la facultad expresa para: i) requerir la GL en tiempo real de los equipos de comunicaci&oacute;n, as&iacute; como ii) la entrega de los DC por los Concesionarios y Autorizados, y iii) la IL, siempre y cuando cuenten con orden debidamente fundada y</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>&ldquo;<strong>Autoridades Designadas</strong>&rdquo;, es todo aquel servidor p&uacute;blico que haya sido designado por los titulares de las Autoridades Facultadas mediante acuerdos publicados en el DOF, de conformidad con lo dispuesto en el art&iacute;culo 189 de la LFTyR, para gestionar los requerimientos que, en los t&eacute;rminos establecidos en las leyes aplicables, se realicen a los Concesionarios y los Autorizados, y recibir la informaci&oacute;n</li>
</ol>
<p>&nbsp;</p>
<h4><u>CUARTA.&nbsp; Requerimientos de la Autoridad.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Geolocalizaci&oacute;n. </strong>La Autoridad Facultada o Autoridad Designada podr&aacute; requerir la GL en tiempo real de los equipos de comunicaci&oacute;n, siempre y cuando cuenten con orden debidamente fundada y motivada expedida por: <em>(i) </em>una Autoridad Judicial Federal (Juez Federal del orden Penal), o; <em>(ii) </em>en su caso, Juez de Control del Fuero Com&uacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>Excepcionalmente, el Ministerio P&uacute;blico podr&aacute; solicitar la informaci&oacute;n sin orden judicial, siempre y cuando obtenga en 48 (cuarenta y ocho) horas la ratificaci&oacute;n total o parcial, de conformidad con las excepciones del art&iacute;culo 303 del CNPP, a saber:</p>
<p>&nbsp;</p>
<ol>
<li>Cuando est&eacute; en peligro la integridad f&iacute;sica o la vida de una persona;</li>
</ol>
<ol>
<li>Se encuentre en riesgo el objeto del delito;</li>
</ol>
<ol>
<li>Hechos relacionados con la privaci&oacute;n ilegal de la libertad;</li>
</ol>
<ol>
<li>Secuestro;</li>
</ol>
<ol>
<li>Extorsi&oacute;n, o;</li>
</ol>
<ol>
<li>Delincuencia</li>
</ol>
<ul>
<li><strong>Datos Conservados. </strong>La Autoridad Facultada o Designada podr&aacute; requerir la entrega de los DC por los Concesionarios y Autorizados, siempre y cuando cuenten con orden debidamente fundada y motivada expedida por: <em>(i) </em>una Autoridad Judicial Federal (Juez Federal del orden Penal), o; <em>(ii) </em>en su caso, Juez de Control del Fuero Com&uacute;n.</li>
</ul>
<p>&nbsp;</p>
<p>Excepcionalmente, el Ministerio P&uacute;blico podr&aacute; solicitar la informaci&oacute;n sin orden judicial, siempre y cuando obtenga en 48 (cuarenta y ocho) horas la ratificaci&oacute;n total o parcial, de conformidad con las excepciones del art&iacute;culo 303 del CNPP, a saber:</p>
<p>&nbsp;</p>
<ol>
<li>Cuando est&eacute; en peligro la integridad f&iacute;sica o la vida de una persona;</li>
</ol>
<ol>
<li>Se encuentre en riesgo el objeto del delito;</li>
</ol>
<ol>
<li>Hechos relacionados con la privaci&oacute;n ilegal de la libertad;</li>
</ol>
<ol>
<li>Secuestro;</li>
</ol>
<ol>
<li>Extorsi&oacute;n, o;</li>
</ol>
<ol>
<li>Delincuencia</li>
</ol>
<ul>
<li><strong>Intervenci&oacute;n de Comunicaciones. </strong>La Autoridad Facultada podr&aacute; requerir la IL de comunicaciones, siempre y cuando cuente con orden debidamente fundada y motivada expedida por una autoridad Judicial Federal (Juez Federal del orden Penal). Si no se cumple la condici&oacute;n se&ntilde;alada en el presente p&aacute;rrafo, <u>en ning&uacute;n momento Alt&aacute;n estar&aacute; obligada a compartir la informaci&oacute;n solicitada</u>.</li>
</ul>
<p>&nbsp;</p>
<h4><u>QUINTA. Opciones del Cliente.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>En tanto el Cliente no cuente con los medios y la infraestructura necesarios para dar respuesta oportuna a los requerimientos de las Autoridades Facultadas y/o Delegadas, Alt&aacute;n queda obligado<sup><a href="#_bookmark19">1 </a></sup>a prestarle los servicios necesarios para que el Cliente, de forma directa, pueda cumplir en tiempo y forma (la &ldquo;<strong>Opci&oacute;n B</strong>&rdquo;).</li>
</ul>
<ul>
<li>En el caso de que el Cliente s&iacute; cuente con la infraestructura y medios necesarios para dar respuesta oportuna a los requerimientos de las Autoridades Facultadas y/o Delegadas, el Cliente no podr&aacute; hacer uso de los servicios que Alt&aacute;n dispone a trav&eacute;s del presente Acuerdo y Alt&aacute;n no tendr&aacute; ni asumir&aacute; por la suscripci&oacute;n del presente ninguna de las obligaciones y/o responsabilidades materia del presente Acuerdo (la &ldquo;<strong>Opci&oacute;n A</strong>&rdquo;).</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de que el Cliente cuente parcialmente con la infraestructura y medios necesarios para dar respuesta a alguno de los requerimientos de las Autoridades Facultadas y/o Delegadas, pero requiera contratar a Alt&aacute;n alguno de los servicios establecidos en el presente Acuerdo (DC y/o GL, y/o IL) para los cuales no cuente con la infraestructura y medios necesarios, Alt&aacute;n podr&aacute; alternativamente prestarle los servicios contratados para que el Cliente pueda cumplir en tiempo y forma. En este &uacute;ltimo caso, el Cliente deber&aacute; atenerse a lo establecido en el presente Acuerdo, en lo que resulte aplicable (la &ldquo;<strong>Opci&oacute;n C</strong>&rdquo;).</li>
</ul>
<p>&nbsp;</p>
<h4><u>SEXTA. Obligaciones de Alt&aacute;n.</u></h4>
<p><strong>&nbsp;</strong></p>
<p>En raz&oacute;n y para la instrumentaci&oacute;n y aplicaci&oacute;n de todo lo anterior, el Cliente selecciona en este acto los servicios (de forma alternativa o conjuntiva DC y/o GL, y/o IL en t&eacute;rminos de los art&iacute;culos 1961 y 1962 del C&oacute;digo Civil Federal) que necesita y desea contratar, por no contar con los medios y la infraestructura necesarios para dar respuesta oportuna a los requerimientos de las Autoridades Facultadas y/o Delegadas, de acuerdo con la Tabla 1 siguiente.</p>
<p>&nbsp;</p>
<p>El Cliente puede elegir la Opci&oacute;n A, para lo cual Alt&aacute;n no tendr&aacute; responsabilidad alguna frente al Cliente.</p>
<p>&nbsp;</p>
<p>El Cliente puede elegir la Opci&oacute;n B o la Opci&oacute;n C con cualesquiera de las opciones C.1, C.2., y C.3. que requiera.</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="472">
<p><strong>Opciones de Servicio(s) de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia</strong></p>
</td>
<td width="117">
<p><strong>Opci&oacute;n seleccionada</strong></p>
<p><strong>por el Cliente</strong></p>
</td>
</tr>
<tr>
<td colspan="2" width="472">
<p><strong>Opci&oacute;n A. </strong>Ning&uacute;n servicio para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia salvo por la conexi&oacute;n establecida en el Contrato de Integraci&oacute;n para que el Cliente acceda directamente a toda la informaci&oacute;n que puede ser requerida por Autoridades</p>
<p>Delegadas y Facultadas en t&eacute;rminos de este Ap&eacute;ndice y los Lineamientos aplicables.</p>
</td>
<td width="117">
<p>&nbsp;</p>
<p>( )</p>
</td>
</tr>
<tr>
<td colspan="2" width="472">
<p><strong>Opci&oacute;n B. </strong>Todos los servicios para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia (a elecci&oacute;n del Cliente todos los servicios C.1, C.2. y C.3. , descritos en la Opci&oacute;n C abajo.)</p>
</td>
<td width="117">
<p>&nbsp;</p>
<p>( X )</p>
</td>
</tr>
<tr>
<td width="316">
<p><strong>Opci&oacute;n C. </strong>Alguno o algunos de los servicios para la Colaboraci&oacute;n con las Instancias de Seguridad,</p>
</td>
<td width="156">
<p>C.1. Datos</p>
<p>Conservados (DC)</p>
</td>
<td width="117">
<p>( )</p>
</td>
</tr>
<tr>
<td width="316">&nbsp;</td>
<td width="156">&nbsp;</td>
<td width="117">&nbsp;</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>1 Lineamiento Primero, p&aacute;rrafo tercero de los Lineamientos de Colaboraci&oacute;n en Materia de Seguridad y Justicia, publicados en el DOF el 2 de diciembre de 2015.</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td colspan="2" width="472">
<p><strong>Opciones de Servicio(s) de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia</strong></p>
</td>
<td width="117">
<p><strong>Opci&oacute;n seleccionada por el Cliente</strong></p>
</td>
</tr>
<tr>
<td rowspan="2" width="316">
<p>Procuraci&oacute;n y Administraci&oacute;n de Justicia, (a elecci&oacute;n del Cliente, C.1, C.2., y/o C.3.)</p>
</td>
<td width="156">
<p>C.2. Geolocalizaci&oacute;n (GL)</p>
</td>
<td width="117">
<p>&nbsp;</p>
<p>( )</p>
</td>
</tr>
<tr>
<td width="156">
<p>C.3. Intervenci&oacute;n Legal de comunicaciones (IL)</p>
</td>
<td width="117">
<p>( )</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><em>Tabla 1. Servicio(s) de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia seleccionados por el Cliente.</em></p>
<p><em>&nbsp;</em></p>
<p><em>&nbsp;</em></p>
<h4><u>S&Eacute;PTIMA. Reglas Generales de la Colaboraci&oacute;n en materia de Seguridad y Justicia.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li><strong>Obligaciones, Responsabilidades y alcance de la Coadyuvancia en la gesti&oacute;n de requerimientos de Colaboraci&oacute;n en materia de Seguridad y Justicia</strong></li>
</ul>
<p><strong>&nbsp;</strong></p>
<ol>
<li>Los requerimientos de Colaboraci&oacute;n con la Seguridad y Justicia s&oacute;lo pueden ser solicitados por una Autoridad Facultada o Autoridad</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Ambas Partes acuerdan que, en materia de colaboraci&oacute;n con la seguridad y la justicia, las obligaciones y responsabilidades de cada una de ellas ser&aacute;n las establecidas en el presente Acuerdo, as&iacute; como en las disposiciones reglamentarias en lo que resulten aplicables en materia de colaboraci&oacute;n de seguridad y justicia y no se encuentre expresamente establecido en el presente Acuerdo para regir la relaci&oacute;n entre las</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>En el presente Acuerdo, se establecen las obligaciones y responsabilidades para cada una de las Partes involucradas en la prestaci&oacute;n de servicios de Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de</li>
</ol>
<p>&nbsp;</p>
<h4>7.2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Procedimiento general para la gesti&oacute;n de requerimientos de Colaboraci&oacute;n con la Seguridad y Justicia</h4>
<p><strong>&nbsp;</strong></p>
<p>En los casos en que el Cliente reciba un oficio por parte de la Autoridad Facultada o Autoridad Designada, por el que se ordena la entrega de determinada informaci&oacute;n sobre GL y/o sobre DC, y/o la IL de comunicaciones, se observar&aacute;n las disposiciones siguientes:</p>
<p>&nbsp;</p>
<ol>
<li>Es obligaci&oacute;n del Cliente llevar a cabo la validaci&oacute;n y an&aacute;lisis legal sobre el requerimiento; es decir, el Cliente deber&aacute; asegurarse que el oficio est&eacute; debidamente fundado y motivado, y que la Autoridad que emiti&oacute; el requerimiento sea una Autoridad Facultada o Designada, liberando a Alt&aacute;n de cualquier responsabilidad que se genere por el desahogo del requerimiento que haya sido previamente validado por el Cliente.</li>
</ol>
<ol>
<li>Con la finalidad de coadyuvar tanto con el Cliente como con las Autoridades Facultadas y Designadas, Alt&aacute;n establecer&aacute; el siguiente correo electr&oacute;nico<u><a href="mailto:seguridadyjusticia@altanredes.comc"> seguridadyjusticia@altanredes.com </a></u>como canal de comunicaci&oacute;n y recepci&oacute;n de informaci&oacute;n, el cual estar&aacute; disponible las 24 horas del d&iacute;a los 7 d&iacute;as de las semana; en los casos en que el Cliente no disponga de las plataformas y/o herramientas que le permitan responder de manera oportuna a los requerimientos de la Autoridad Facultada o Designada. El Cliente enviar&aacute; &uacute;nicamente al correo previsto en este p&aacute;rrafo toda solicitud y comunicaci&oacute;n relacionada con el presente</li>
</ol>
<p>El Cliente se obliga a enviar todo comunicado relacionado con el presente Acuerdo desde el correo <u><a href="mailto:miguel@elux.com.mx">miguel@elux.com.mx</a></u>, mismo que ser&aacute; la &uacute;nica direcci&oacute;n electr&oacute;nica desde la cual Alt&aacute;n podr&aacute; dar contestaci&oacute;n al Cliente.</p>
<p>&nbsp;</p>
<p>Toda solicitud de informaci&oacute;n, sin excepci&oacute;n alguna, deber&aacute; contener la siguiente informaci&oacute;n para ser atendida:</p>
<p>&nbsp;</p>
<ol>
<li>el Formato de Coadyuvancia adjunto al presente Ap&eacute;ndice;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Copia del Oficio de Requerimiento; es decir, el Acuerdo emitido por Autoridad Facultada o Autoridad Designada, por el cual se hace la solicitud formal al Cliente en t&eacute;rminos del art&iacute;culo 189 de la LFTyR, por el que se ordena GL, y/o entrega de Datos Conservados, y/o la IL de comunicaciones; el cual deber&aacute; cumplir con los siguientes requisitos:
  <ul>
  <li>Fecha y lugar;</li>
  <li>Nombre y cargo del servidor p&uacute;blico requirente e Instituci&oacute;n a la que pertenece;</li>
  <li>Fecha en que se public&oacute; en el DOF la designaci&oacute;n de la Autoridad Designada;</li>
  <li>Estar fundado y motivado;</li>
  <li>Nombre y cargo de la Autoridad Judicial que autoriza, adjuntando dicha autorizaci&oacute;n;</li>
  <li>Se&ntilde;alar los sujetos de intervenci&oacute;n;</li>
  <li>Identificaci&oacute;n del lugar(es) donde se realizar&aacute;, si es posible;</li>
  <li>Objeto de la solicitud:
    <ul>
      <li>GL, y/o;</li>
      <li>Entrega de DC, y/o;</li>
      <li>IL de comunicaciones.</li>
    </ul>
  </li>
  <li>Tipo de comunicaci&oacute;n que ser&aacute; intervenida;</li>
  <li>Periodo por el que se solicita la informaci&oacute;n;</li>
  <li>N&uacute;mero(s) telef&oacute;nico(s) a diez d&iacute;gitos, IMSI o IMEI objeto del requerimiento; y</li>
  <li>Denominaci&oacute;n o Raz&oacute;n Social del</li>
  <li>Formatos en el que se requiere sea entregada la informaci&oacute;n (por ejemplo "pdf", ".xls" o ".csv");</li>
  <li>Sello de la Instituci&oacute;n; y</li>
  <li>Firma aut&oacute;grafa o electr&oacute;nica del servidor p&uacute;blico</li>
  </ul>
</li>
</ol>
</li>
<li>La declaraci&oacute;n de haber realizado la validaci&oacute;n del requerimiento, con la leyenda <em>&ldquo;Bajo protesta de decir verdad, el requerimiento que se adjunta al presente correo ha sido validado y es procedente, por lo cual se libera a Alt&aacute;n de cualquier responsabilidad que se genere por la atenci&oacute;n al mismo&rdquo;.</em></li>
</ul>
<p><em>&nbsp;</em></p>
<p>El Cliente reconoce expresamente que en caso de no incluir la informaci&oacute;n requerida en el presente numeral 7.2, <u>Alt&aacute;n no ser&aacute; responsable de la entrega</u> <u>de la informaci&oacute;n</u>.</p>
<p>&nbsp;</p>
<ol>
<li>Los tiempos de atenci&oacute;n por parte de Alt&aacute;n para la entrega de la informaci&oacute;n solicitada por el Cliente son los se&ntilde;alados en la columna III de la Tabla 2, en los casos en que el Cliente no disponga de las plataformas y/o herramientas que le permitan responder de manera oportuna a los requerimientos de la Autoridad Facultada o Designada, tal como se describe a continuaci&oacute;n:</li>
</ol>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="121">
<p><strong>I. Plazo de respuesta</strong></p>
<p><strong>se&ntilde;alado en el requerimiento</strong></p>
</td>
<td width="121">
<p><strong>II. Plazo del Cliente contado</strong></p>
<p><strong>a partir de la recepci&oacute;n del</strong></p>
<p><strong>requerimiento</strong></p>
</td>
<td width="137">
<p><strong>III. Plazo de Alt&aacute;n a partir de la</strong></p>
<p><strong>recepci&oacute;n de la solicitud por parte</strong></p>
<p><strong>del Cliente</strong></p>
</td>
<td width="154">
<p><strong>IV. Plazo del Cliente para enviar la respuesta a la</strong></p>
<p><strong>Autoridad Facultada</strong></p>
</td>
</tr>
<tr>
<td width="121">
<p>1 hora</p>
</td>
<td width="121">
<p>15 minutos</p>
</td>
<td width="137">
<p>30 minutos Para este caso, el correo deber&aacute; ser marcado en &ldquo;Asunto&rdquo; como &ldquo;<strong>URGENTE [*] N&Uacute;MERO&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; DE</strong></p>
<p><strong>OFICIO&rdquo; </strong>para que se pueda atender de manera inmediata. En adici&oacute;n, el Cliente deber&aacute; llamar al tel&eacute;fono <strong><u>(55) 8633</u> <u>6166</u> </strong>para informar a Alt&aacute;n que tiene un requerimiento con tiempo de respuesta</p>
<p>de 1 hora.</p>
</td>
<td width="154">
<p>15 minutos</p>
</td>
</tr>
<tr>
<td width="121">
<p>24 horas</p>
</td>
<td width="121">
<p>4 horas</p>
</td>
<td width="137">
<p>14 horas</p>
</td>
<td width="154">
<p>6 horas</p>
</td>
</tr>
<tr>
<td width="121">
<p>48 horas</p>
</td>
<td width="121">
<p>8 horas</p>
</td>
<td width="137">
<p>24 horas</p>
</td>
<td width="154">
<p>16 horas</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><em>Tabla 2. Tiempos de Respuesta</em></p>
<p>&nbsp;</p>
<p><em>&nbsp;</em></p>
<p>En caso de que la solicitud de Autoridad prevea plazos superiores a los establecidos en la Tabla 2 precedente, los tiempos de atenci&oacute;n por parte de Alt&aacute;n para la entrega de la informaci&oacute;n solicitada por el Cliente, correspondientes a la columna III, nunca podr&aacute;n ser menores al triple del Plazo del Cliente previsto en la columna II de la Tabla 2 anterior, ni menores a los plazos definidos cuando el Plazo de respuesta se&ntilde;alado en el requerimiento sea de 48 horas.</p>
<p>&nbsp;</p>
<p>Lo anterior, se establece de conformidad con los LCMSJ vigentes a 2019, por lo que derivado de cualquier modificaci&oacute;n que pudiera sufrir la LFTyR y/o los LCMSJ, se deber&aacute;n ajustar los plazos de respuesta con la finalidad de dar cumplimiento oportuno a las Autoridades Facultadas y Delegadas en materia de seguridad y justicia.</p>
<p>&nbsp;</p>
<ol>
<li>Una vez recibida la informaci&oacute;n enlistada en el inciso b) anterior, y dentro del Plazo del Cliente seg&uacute;n se indica en la Tabla 2 precedente, Alt&aacute;n proceder&aacute; a dar respuesta al Cliente dentro del Plazo de Alt&aacute;n. Dicha respuesta ser&aacute; enviada al Cliente por correo electr&oacute;nico a la cuenta indicada por el Cliente en el inciso</li>
<li>b) anterior, que es el <u>&uacute;nico</u> correo autorizado y notificado a Alt&aacute;n, con la finalidad de que el Cliente la utilice para dar contestaci&oacute;n formal a la Autoridad Facultada y/o Designada y recibir cualquier respuesta en t&eacute;rminos del presente Acuerdo. El Cliente reconoce y acepta que la cuenta deber&aacute; tener una capacidad de almacenamiento no menor a 500 MB y para documentos adjuntos de 10 MB, en caso contrario el Cliente reconoce y acepta que Alt&aacute;n no ser&aacute; responsable por la falta de recepci&oacute;n de la respuesta por parte de Alt&aacute;n. En caso de que el Cliente no cumpla con el Plazo del Cliente, el Cliente ser&aacute; el &uacute;nico responsable y deber&aacute; sacar en paz y a salvo a Alt&aacute;n de cualquier</li>
</ol>
<p>&nbsp;</p>
<ol start="7">
<li>En caso de que el Cliente no adjunte copia del requerimiento de la Autoridad Facultada y/o Designada, y/o incumpla con lo establecido en el inciso b) del presente numeral 2, Alt&aacute;n no podr&aacute; dar contestaci&oacute;n al correo electr&oacute;nico ni al env&iacute;o de informaci&oacute;n, por lo que el &uacute;nico responsable de cualquier procedimiento y/o sanci&oacute;n que se llegar&aacute; a imponer por incumplir con las Obligaciones en materia de colaboraci&oacute;n con la Seguridad y la Justicia ser&aacute; el Cliente, siendo este &uacute;ltimo el &uacute;nico responsable y deber&aacute; sacar en paz y a salvo a Alt&aacute;n de ese incumplimiento.</li>
</ol>
<p>&nbsp;</p>
<p>Asimismo, Alt&aacute;n notificar&aacute; al Cliente que se ha excedido el tiempo de entrega de la informaci&oacute;n enlistada en la presente Cl&aacute;usula con la siguiente leyenda:</p>
<p>&nbsp;</p>
<p>&ldquo;<em>Alt&aacute;n Redes notifica a ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V. (en lo sucesivo, el &ldquo;Cliente&rdquo;) del incumplimiento del Plazo del Cliente se&ntilde;alado en la Tabla 2 del Ap&eacute;ndice 7.7 Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y Administraci&oacute;n de Justicia, suscrito entre Alt&aacute;n Redes y el Cliente el d&iacute;a 7 de diciembre de 2021, por lo que el Cliente es el &uacute;nico responsable de las sanciones que pudieran generarse por el incumplimiento del oficio de requerimiento adjunto al presente correo, por lo que el Cliente se obliga a sacar y mantener en paz y a salvo a Alt&aacute;n Redes de cualquier controversia y/o contingencia que se pudiera generar por dicho incumplimiento.</em>&rdquo;</p>
<p>&nbsp;</p>
<ol>
<li>Derivado de lo anterior, ambas Partes acuerdan que la responsabilidad de Alt&aacute;n, s&oacute;lo ser&aacute; aplicable cuando incumpla en su obligaci&oacute;n de proporcionar al Cliente la informaci&oacute;n solicitada por la Autoridad Facultada o Designada en tiempo y/o en forma, de acuerdo con los tiempos acordados para su cumplimiento en los t&eacute;rminos de la Tabla 2 precedente, y con los mejores recursos tecnol&oacute;gicos que le sea posible, en los t&eacute;rminos y condiciones se&ntilde;alados en el presente Ap&eacute;ndice. El &uacute;nico obligado en entregar la informaci&oacute;n a las Autoridades Facultadas o Delegadas ser&aacute; el</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>En el supuesto de que Alt&aacute;n requiera de un plazo mayor a los estipulados en la Tabla 2 &ldquo;Tiempos de Respuesta&rdquo;, para dar atenci&oacute;n espec&iacute;fica a alg&uacute;n requerimiento por parte de las Autoridades Facultadas y/o Designadas en materia de seguridad y justicia, podr&aacute; comunicarlo de manera inmediata al Cliente y se&ntilde;alar el tiempo en que podr&iacute;a retrasarse la entrega de la informaci&oacute;n y por el que solicitar&iacute;a una extensi&oacute;n de los plazos previstos en la Columna II de la Tabla 2 precedente. Lo anterior para que el Cliente solicite a la autoridad una pr&oacute;rroga y no incurrir en alg&uacute;n incumplimiento. La pr&oacute;rroga solo se entender&aacute; otorgada de forma expresa y deber&aacute; de ser comunicada al efecto por el Cliente a Alt&aacute;n tan pronto como sea en su caso otorgada por las Autoridades Facultadas o Delegadas. En el caso de que habi&eacute;ndose otorgado la pr&oacute;rroga por dichas Autoridades Facultadas y/o Delegadas, la misma no fuere notificada a Alt&aacute;n, Alt&aacute;n no tendr&aacute; ninguna responsabilidad por no cumplir con los t&eacute;rminos de la misma o con los t&eacute;rminos del requerimiento original. En caso de que Alt&aacute;n requiera un plazo mayor en t&eacute;rminos del presente inciso, y el Cliente no solicite a la Autoridad una pr&oacute;rroga, Alt&aacute;n no tendr&aacute; ninguna responsabilidad por no cumplir con los t&eacute;rminos del requerimiento</li>
</ol>
<p>&nbsp;</p>
<h4><u>OCTAVA. Procedimiento para el Servicio de entrega de Datos Conservados para</u> <u>Colaboraci&oacute;n con la Seguridad y Justicia</u>.</h4>
<p><strong>&nbsp;</strong></p>
<p>El Cliente deber&aacute; observar los requisitos previstos en el numeral 7.2 precedente para dar respuesta oportuna a un requerimiento de DC, y seguir el siguiente procedimiento:</p>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar&aacute; que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar al correo electr&oacute;nico <u><a href="mailto:seguridadyjusticia@altanredes.com">seguridadyjusticia@altanredes.com</a></u> el Formato de Coadyuvancia y el requerimiento respectivo dentro del Plazo del Cliente se&ntilde;alado en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Dentro del Plazo de Alt&aacute;n a que hace alusi&oacute;n la Tabla 2, columna III del presente Acuerdo, ser&aacute; enviada al correo electr&oacute;nico designado por el Cliente la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<p>detalle de las llamadas en formato PDF, el cual, estar&aacute; integrado por la siguiente informaci&oacute;n: (i) n&uacute;mero de l&iacute;nea; (ii) tipo de servicio (iii) n&uacute;mero A; (iv) n&uacute;mero B; (v) fecha; (vi) hora; (vii) duraci&oacute;n en segundos de la llamada, y (viii) ubicaci&oacute;n geogr&aacute;fica.</p>
<p>&nbsp;</p>
<ol>
<li>Concluida la entrega de informaci&oacute;n de acuerdo con lo anterior, Alt&aacute;n enviar&aacute; un reporte de Conclusi&oacute;n de Actividades en formato de Microsoft Word al correo electr&oacute;nico designado por el</li>
</ol>
<p>&nbsp;</p>
<h4><u>NOVENA. Procedimiento para el Servicio de Geolocalizaci&oacute;n para Colaboraci&oacute;n con</u> <u>la Seguridad y Justicia</u>.</h4>
<p><strong>&nbsp;</strong></p>
<p>Se define la GL como la ubicaci&oacute;n geogr&aacute;fica de un Usuario Final del Cliente en la red de Alt&aacute;n, en una fecha y hora espec&iacute;fica.</p>
<p>&nbsp;</p>
<p>Los requerimientos de GL para Colaboraci&oacute;n con la Seguridad y Justicia pueden catalogarse en las siguientes modalidades:</p>
<p>&nbsp;</p>
<ul>
<li><u>Servicio de Geolocalizaci&oacute;n Hist&oacute;rica</u>: cuando se solicitan para fechas y/u horas registradas en el pasado (hasta m&aacute;ximo veinticuatro meses) de acuerdo con los LCMSJ.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><u>Servicio de Geolocalizaci&oacute;n en Tiempo Real</u>: cuando se solicita que sean reportadas en el momento mismo del requerimiento, y/o cuando se mantenga un monitoreo por un espacio de tiempo</li>
</ul>
<p>&nbsp;</p>
<ul>
<li><u>Servicio de Geolocalizaci&oacute;n por tiempo determinado</u>: cuando se solicita que se mantenga un monitoreo por un espacio de tiempo</li>
</ul>
<p>&nbsp;</p>
<h4>9.1.&nbsp;&nbsp;&nbsp;&nbsp; Servicio de Geolocalizaci&oacute;n Hist&oacute;rica</h4>
<p><strong>&nbsp;</strong></p>
<p>El Cliente deber&aacute; observar los requisitos previstos en el numeral 7.2 precedente para dar respuesta oportuna a un requerimiento de GL hist&oacute;rica, y seguir el siguiente procedimiento:</p>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar dentro del Plazo del Cliente, al correo electr&oacute;nico<u><a href="mailto:seguridadyjusticia@altanredes.com"> seguridadyjusticia@altanredes.com </a></u>el Formato de Coadyuvancia y el requerimiento respectivo dentro del plazo se&ntilde;alado en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Dentro del Plazo de Alt&aacute;n a que hace alusi&oacute;n la Tabla 2, columna III del presente Acuerdo, ser&aacute; enviada en formato de Microsoft Word al correo electr&oacute;nico designado</li>
</ol>
<p>&nbsp;</p>
<p>por el Cliente la informaci&oacute;n respecto de la ubicaci&oacute;n digital del Usuario Final, que se corresponde con el identificador de celda para el servicio m&oacute;vil provisto por Alt&aacute;n.</p>
<p>&nbsp;</p>
<h4>9.2.&nbsp;&nbsp;&nbsp;&nbsp; Servicio de Geolocalizaci&oacute;n en Tiempo Real</h4>
<p><strong>&nbsp;</strong></p>
<p>El Cliente deber&aacute; observar los requisitos previstos en el numeral 7.2 precedente para dar respuesta oportuna a un requerimiento de GL en tiempo real, y seguir el siguiente procedimiento:</p>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de Coadyuvancia</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar al correo electr&oacute;nico <u><a href="mailto:seguridadyjusticia@altanredes.com">seguridadyjusticia@altanredes.com</a></u> el Formato de Coadyuvancia y el requerimiento respectivo dentro del Plazo del Cliente se&ntilde;alado en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Dentro del Plazo de Alt&aacute;n a que hace alusi&oacute;n la Tabla 2, columna III del presente Acuerdo, ser&aacute; enviada en formato de Microsoft Word al correo electr&oacute;nico designado por el Cliente la informaci&oacute;n respecto de las coordenadas geogr&aacute;ficas determinadas por los valores manifestados en Latitud y Longitud en el momento en que sea recibida por Alt&aacute;n.</li>
</ol>
<p>&nbsp;</p>
<h4>9.3.&nbsp;&nbsp;&nbsp;&nbsp; Servicio de Geolocalizaci&oacute;n por tiempo determinado</h4>
<p><strong>&nbsp;</strong></p>
<p>En todo caso el Cliente deber&aacute; observar los requisitos previstos en el numeral 7.2 precedente para dar respuesta oportuna a un requerimiento de GL por tiempo determinado, y seguir el siguiente procedimiento:</p>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de Coadyuvancia</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar al correo electr&oacute;nico <u><a href="mailto:seguridadyjusticia@altanredes.com">seguridadyjusticia@altanredes.com</a></u> el Formato de Coadyuvancia y el requerimiento respectivo dentro del Plazo del Cliente establecido en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Al comienzo de la GL por tiempo determinado, Alt&aacute;n enviar&aacute; un Reporte de Inicio de Actividades en formato de Microsoft Word al correo electr&oacute;nico designado por el Cliente.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Las coordenadas solicitadas en el Requerimiento por la Autoridad Facultada se enviar&aacute;n de manera autom&aacute;tica al Correo del Cliente, durante el periodo de tiempo determinado y periodicidad definida en dicho</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Al t&eacute;rmino de la GL por tiempo determinado definido por la Autoridad Facultada, Alt&aacute;n enviar&aacute; al Correo del Cliente un Reporte de Conclusi&oacute;n de Actividades en formato de Word.</li>
</ol>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMA. Procedimiento para el Servicio de Intervenci&oacute;n Legal de comunicaciones</u> <u>para Colaboraci&oacute;n con la Seguridad y Justicia.</u></h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>La Intervenci&oacute;n Legal es el servicio de entrega a las autoridades del contenido de una comunicaci&oacute;n de un Usuario Final sobre la red de Alt&aacute;n, siempre y cuando medie una orden judicial debidamente fundada y motivada, por una Autoridad Facultada (en este caso, s&oacute;lo por mandamiento de Juez Federal Penal Especializado en Cateos, Arraigos e Intervenci&oacute;n de Comunicaciones).</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Alt&aacute;n no realiza ning&uacute;n tipo de almacenamiento del contenido de las comunicaciones intervenidas, y por tanto la compartici&oacute;n de la misma s&oacute;lo podr&aacute; realizarse mediante el requerimiento de la Autoridad Facultada al Cliente de Alt&aacute;n y el &uacute;nico facultado para almacenar dicha informaci&oacute;n ser&aacute; la Autoridad</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>Se debe tener en cuenta que toda la informaci&oacute;n cursada por los Usuarios Finales sobre la red de Alt&aacute;n est&aacute; encriptada en cualquiera de sus servicios y el &uacute;nico facultado para desencriptar el contenido es la Autoridad Facultada que ha realizado el</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>El Cliente deber&aacute; observar los requisitos previstos en el numeral 2 precedente para dar respuesta oportuna a un requerimiento de IL, y seguir el siguiente procedimiento:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>Una vez que el Cliente es notificado del requerimiento, este deber&aacute; llevar a cabo la validaci&oacute;n del mismo y analizar las facultades de la Autoridad que emiti&oacute; el requerimiento.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Llenar&aacute; el Formato de Coadyuvancia</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Verificar que la informaci&oacute;n contenida en el Formato de Coadyuvancia contenga la informaci&oacute;n del</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Enviar al correo electr&oacute;nico <u><a href="mailto:seguridadyjusticia@altanredes.com">seguridadyjusticia@altanredes.com </a></u>el Formato de Coadyuvancia y el requerimiento respectivo dentro del Plazo del Cliente se&ntilde;alado en la Tabla 2, columna II del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Dentro del Plazo de Alt&aacute;n a que hace alusi&oacute;n la Tabla 2, columna III del presente Acuerdo, se habilitar&aacute; la IL del n&uacute;mero solicitado y se le dar&aacute; acceso a la Autoridad Facultada, durante el tiempo determinado en la Orden de Intervenci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<p>Al comienzo de la IL, Alt&aacute;n enviar&aacute; un Reporte de Inicio de Actividades en formato de Microsoft Word al correo electr&oacute;nico designado por el Cliente.</p>
<p>&nbsp;</p>
<p>Concluido el plazo de la intervenci&oacute;n, Alt&aacute;n enviar&aacute; un reporte de Conclusi&oacute;n de Actividades en formato de Microsoft Word al correo electr&oacute;nico designado por el Cliente para que &eacute;ste de contestaci&oacute;n formal al requerimiento de la Autoridad Facultada.</p>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO PRIMERA. Obligaciones y Responsabilidades de las Partes.</u></h4>
<p><strong>&nbsp;</strong></p>
<p><strong>11.1 Obligaciones y Responsabilidades de Alt&aacute;n</strong></p>
<p><strong>&nbsp;</strong></p>
<ol>
<li>Alt&aacute;n contar&aacute; con las herramientas necesarias para prestar al Cliente los servicios necesarios para que este &uacute;ltimo de forma directa pueda cumplir de manera oportuna con los requerimientos de informaci&oacute;n que se desprenden de los ordenamientos jur&iacute;dicos en materia de colaboraci&oacute;n con las instancias de seguridad, procuraci&oacute;n y administraci&oacute;n de justicia, con relaci&oacute;n al presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Alt&aacute;n informar&aacute; a las Autoridades Facultadas y Designadas que cuenta con un &Aacute;rea Responsable en t&eacute;rminos de lo dispuesto por la LFTyR, para atender las solicitudes de IL de comunicaciones, GL, Entrega y Conservaci&oacute;n de DC, de manera inmediata y con la suficiencia</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Alt&aacute;n pondr&aacute; a disposici&oacute;n del Cliente un correo electr&oacute;nico para la atenci&oacute;n de requerimientos de informaci&oacute;n en materia de seguridad y justicia de Autoridades Facultadas y Designadas, sobre i) DC, ii) GL, y iii) &oacute;rdenes judiciales para la IL de comunicaciones. Alt&aacute;n ser&aacute; responsable de procesar y generar la informaci&oacute;n recibida a trav&eacute;s de dicho correo, siempre y cuando el Cliente cumpla con los requisitos y plazos establecidos en el presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Alt&aacute;n coadyuvar&aacute; con el Cliente para la atenci&oacute;n de requerimientos de las Autoridades Facultadas y Designadas en materia de seguridad y justicia con la mayor diligencia posible, en los t&eacute;rminos y condiciones del presente</li>
</ol>
<p>&nbsp;</p>
<h4>11.2.&nbsp; Obligaciones y Responsabilidades del Cliente</h4>
<p><strong>&nbsp;</strong></p>
<ol>
<li>El Cliente es el responsable de recibir y gestionar oportunamente los requerimientos de informaci&oacute;n provenientes de la Autoridad Facultada y/o</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente deber&aacute; responder de forma directa, a su entera responsabilidad, los requerimientos de las Autoridades Facultadas y Designadas; es decir, el Cliente ser&aacute; el &uacute;nico responsable de dar contestaci&oacute;n a los requerimientos en materia de seguridad y justicia.</li>
</ol>
<ol>
<li>El Cliente ser&aacute; el &uacute;nico responsable de atender los requerimientos de informaci&oacute;n de las Autoridades Facultadas o Designadas, en las que se soliciten datos personales del Usuario Final. En todo momento, el Cliente deber&aacute; cumplir el tratamiento y manejo adecuado de los datos personales que haya obtenido de sus usuarios por motivo de su operaci&oacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente ser&aacute; el &uacute;nico responsable de validar legalmente que el requerimiento se encuentre debidamente fundado y motivado, as&iacute; como emitido por una Autoridad Facultada o Designada. Es importante enfatizar que en ning&uacute;n momento Alt&aacute;n ser&aacute; responsable de lo anterior, y por lo tanto no realizar&aacute; ning&uacute;n tipo de an&aacute;lisis legal de los requerimientos notificados por la Autoridad Facultada a sus Clientes, siendo &eacute;stos &uacute;ltimos los &uacute;nicos responsables de la validaci&oacute;n del requerimiento y, en su caso, de tomar la decisi&oacute;n de responder y aportar la informaci&oacute;n solicitada. Alt&aacute;n &uacute;nicamente pondr&aacute; dicha informaci&oacute;n a disposici&oacute;n del Cliente dentro de los t&eacute;rminos correspondientes para que &eacute;ste, a su criterio, decida entregarla o no a la Autoridad Facultada o</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente deber&aacute; disponer de las plataformas y/o herramientas propias que lo habiliten para dar respuesta oportuna a los requerimientos emitidos por la Autoridad Facultada o</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>En caso de que el Cliente no disponga de las plataformas y/o herramientas que le permitan responder de manera oportuna a los requerimientos de la Autoridad Facultada o Designada en relaci&oacute;n con los DC y/o GL, deber&aacute; solicitar formalmente a Alt&aacute;n la informaci&oacute;n requerida, de conformidad con lo dispuesto en el presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Para el supuesto previsto en el inciso anterior, el Cliente se obliga a solicitar la informaci&oacute;n del requerimiento por parte de la Autoridad Facultada o Delegada, dentro de los plazos establecidos en la Tabla 2 del presente Acuerdo, para que Alt&aacute;n pueda entregar la informaci&oacute;n solicitada en el requerimiento de informaci&oacute;n, mismo que deber&aacute; ser previamente validado jur&iacute;dicamente por el</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente libera a Alt&aacute;n de toda responsabilidad por el procesamiento y la entrega de la informaci&oacute;n relacionada con los requerimientos en materia de colaboraci&oacute;n con la seguridad y la</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente pagar&aacute; a Alt&aacute;n las Tarifas se&ntilde;aladas en el presente Ap&eacute;ndice, por brindar al Cliente la informaci&oacute;n solicitada por la Autoridad Facultada o Designada, para dar contestaci&oacute;n a los requerimientos en materia de colaboraci&oacute;n con la seguridad y la justicia.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El Cliente es responsable del tratamiento y manejo adecuado de los datos personales que obtenga con motivo de su operaci&oacute;n, cumpliendo al efecto con la legislaci&oacute;n aplicable y su aviso de privacidad en cumplimiento con la Ley Federal de Datos Personales en Posesi&oacute;n de los Particulares y su Reglamento. En caso de cualquier reclamo relacionado con el tratamiento de datos personales, el Cliente deber&aacute; indemnizar, defender y sacar en paz y a salvo a Alt&aacute;n de cualquier monto que este &uacute;ltimo tenga que pagar por multas y/o indemnizaciones o por cualquier otro concepto, derivadas de procesos administrativos, civiles o transacciones que resuelvan el o los reclamos</li>
</ol>
<p>&nbsp;</p>
<p>Esta responsabilidad de indemnizar, defender y sacar en paz y a salvo a Alt&aacute;n por parte del Cliente estar&aacute; limitada a un monto equivalente al total de 3 (tres) contraprestaciones mensuales devengadas en favor de Alt&aacute;n conforme a lo calculado y dispuesto por la cl&aacute;usula 6.4 del Contrato.</p>
<p>&nbsp;</p>
<ol start="6">
<li>El Cliente deber&aacute; indemnizar, defender y sacar en paz y a salvo a Alt&aacute;n de cualquier controversia o reclamaci&oacute;n derivada del incumplimiento por parte del Cliente de sus obligaciones en materia de colaboraci&oacute;n con la seguridad y la justicia, hasta por un monto equivalente al total de 3 (tres) contraprestaciones mensuales devengadas en favor de Alt&aacute;n conforme a lo calculado y dispuesto por la cl&aacute;usula 6.4 del</li>
</ol>
<p>&nbsp;</p>
<h4>11.3.&nbsp; Responsabilidades aplicables a las Obligaciones de Alt&aacute;n.</h4>
<p><strong>&nbsp;</strong></p>
<p>Respecto de los LMCSJ, y al amparo de los art&iacute;culos 14 y 16 constitucionales, las Partes se obligan rec&iacute;procamente a indemnizarse y a sacarse en paz y a salvo de los da&ntilde;os y perjuicios que cada una de ellas cause, por su culpa o negligencia, a la otra. En lo particular las Partes acuerdan que:</p>
<p>&nbsp;</p>
<ul>
<li>En el caso de que el Cliente elija las Opciones B o C con cualquiera de sus opciones previstas en la Tabla 1 del presente Acuerdo, Alt&aacute;n indemnizar&aacute; y sacar&aacute; en paz y a salvo al Cliente de los da&ntilde;os y perjuicios que &eacute;ste experimente, en el caso de que i) Alt&aacute;n no atienda en tiempo y forma la solicitud del Cliente para coadyuvar con el requerimiento de informaci&oacute;n expedido por una Autoridad Facultada o Delegada, seg&uacute;n corresponda, siempre que ii) est&eacute; debidamente fundada y motivada, por la que se requiera directamente al Cliente, y iii) que cumpla con todos los requisitos de la secci&oacute;n 3.2</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En el caso planteado en la presente Cl&aacute;usula, la responsabilidad de Alt&aacute;n s&oacute;lo operar&aacute; cuando los da&ntilde;os y perjuicios que sufra el Cliente <u>a) sean consecuencia directa, inmediata y exclusiva del incumplimiento, b) se deban a culpa y/o negligencia de Alt&aacute;n en t&eacute;rminos de los art&iacute;culos 1910 y 2110 del C&oacute;digo Civil Federal, y c) lo anterior, sea debidamente acreditado en la sentencia respectiva contra la que no sea admisible recurso legal alguno</u>.</li>
</ul>
<p>&nbsp;</p>
<p>Lo anterior, en el entendido de que por consecuencia de la falta de atenci&oacute;n oportuna por parte de Alt&aacute;n se impute responsabilidad al Cliente mediante sentencia firme que no admita recurso legal alguno, y en donde se muestre entre</p>
<p>&nbsp;</p>
<p>la comunicaci&oacute;n de las Partes que la omisi&oacute;n para atender el requerimiento de informaci&oacute;n en cuesti&oacute;n fue responsabilidad de Alt&aacute;n, siempre que se acredite en la sentencia respectiva que:</p>
<p>&nbsp;</p>
<ol>
<li>El incumplimiento del Cliente que ocasion&oacute; la sanci&oacute;n haya sido atribuible de manera inmediata, directa y exclusivamente a Alt&aacute;n;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El incumplimiento de Alt&aacute;n para con el Cliente en la atenci&oacute;n espec&iacute;fica de los requerimientos de las Autoridades Facultadas y Designadas en materia de seguridad y justicia, se verifique siempre que:</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>La informaci&oacute;n haya sido requerida directamente al Cliente, y que el oficio por el cual se solicita dicha informaci&oacute;n fue dirigido exclusivamente al Cliente;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los oficios de requerimientos estuvieron debidamente fundados y motivados conforme a derecho;</li>
</ol>
<p>&nbsp;</p>
<ol start="2">
<li>Alt&aacute;n fue debidamente notificado conforme a lo establecido por el numeral 2.2 del presente Acuerdo, cumpliendo con todo los requisitos y plazos previstos ah&iacute; establecidos, y;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Los oficios de requerimientos fueron confirmados respecto de todo lo anterior y autorizadas por parte del Cliente para su tr&aacute;mite por Alt&aacute;n.</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>El incumplimiento al presente Acuerdo no se debi&oacute;, directa o indirectamente, a un evento de Fuerza</li>
</ul>
<p>&nbsp;</p>
<p>En el caso de que el Cliente elija las Opciones B o C con cualquiera de sus opciones previstas en la Tabla 1 del presente Acuerdo, la responsabilidad por parte de Alt&aacute;n para con el Cliente estar&aacute; siempre y en todo caso limitada a un monto equivalente al total de 3 (tres) contraprestaciones mensuales devengadas en favor de Alt&aacute;n conforme a lo calculado y dispuesto por la cl&aacute;usula 6.4 del Contrato.</p>
<p>&nbsp;</p>
<p>Bajo este supuesto, en ning&uacute;n caso Alt&aacute;n ser&aacute; responsable para con el Cliente por da&ntilde;os consecuenciales, punitivos, indirectos, da&ntilde;o moral, ni cualesquier otros distintos a los da&ntilde;os y perjuicios directamente relacionados y comprobados por el Cliente como consecuencia de un incumplimiento.</p>
<p>&nbsp;</p>
<ul>
<li>En caso de que una de las Partes as&iacute; lo requiera, las Partes deber&aacute;n reunirse para analizar la posibilidad de impugnar la sanci&oacute;n impuesta por la Autoridad Facultada o Designada. En caso de que las partes decidan que procede interponer alg&uacute;n medio de defensa, impugnaci&oacute;n o acci&oacute;n al respecto, el pago de la sanci&oacute;n quedar&aacute; suspendido hasta que se resuelva de manera firme e inapelable el medio de defensa, impugnaci&oacute;n o acci&oacute;n respectivo o hasta que las partes decidan que procede desistirse del mismo o transigir con la Lo anterior sin perjuicio del derecho de ambas partes para impugnar cualquier resoluci&oacute;n o acto de autoridad que afecte sus intereses, mismo que no quedar&aacute; limitado en caso alguno.</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En caso de que el Cliente, a solicitud o no de Alt&aacute;n, obtenga una pr&oacute;rroga en t&eacute;rminos de lo previsto por la secci&oacute;n 7.2, inciso g) <em>in fine, </em>la responsabilidad s&oacute;lo aplicar&aacute;n en caso de incumplimiento con lo previsto en el presente Acuerdo, a partir de la conclusi&oacute;n de la pr&oacute;rroga que sea en su caso otorgada por la Autoridad Facultada y/o</li>
</ul>
<p>&nbsp;</p>
<h4>11.4.&nbsp; Responsabilidades aplicables a la Obligaciones de Alt&aacute;n para el caso en que el Cliente elija la Opci&oacute;n A.</h4>
<p><strong>&nbsp;</strong></p>
<ul>
<li>Respecto de los LMCSJ, y al amparo de los art&iacute;culos 14 y 16 constitucionales, las Partes se obligan rec&iacute;procamente a indemnizarse y a sacarse en paz y a salvo de los da&ntilde;os y perjuicios que cada una de ellas cause, por su culpa o negligencia, a la otra. En lo particular las Partes acuerdan que:</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En el caso de que el Cliente elija la Opci&oacute;n A de la Tabla 1 del presente Ap&eacute;ndice, Alt&aacute;n indemnizar&aacute; y sacar&aacute; en paz y a salvo al Cliente de los da&ntilde;os y perjuicios que &eacute;ste experimente, en el caso de que la conexi&oacute;n presente inconvenientes t&eacute;cnicos atribuibles &uacute;nicamente a Alt&aacute;n que impida que el Cliente pueda acceder y obtener la informaci&oacute;n requerida seg&uacute;n el requerimiento de la Autoridad Facultada y/o</li>
</ul>
<p>&nbsp;</p>
<ul>
<li>En el caso descrito en el presente numeral 4.2, la responsabilidad de Alt&aacute;n s&oacute;lo operar&aacute; cuando los da&ntilde;os y perjuicios que sufra el Cliente <u>a) sean consecuencia directa, inmediata y exclusiva de los inconvenientes t&eacute;cnicos atribuibles &uacute;nicamente a Alt&aacute;n previstos en el p&aacute;rrafo precedente, b) se deban a culpa y/o negligencia de Alt&aacute;n en t&eacute;rminos de los art&iacute;culos 1910 y 2110 del C&oacute;digo Civil Federal, y c) lo anterior, sea debidamente acreditado en la sentencia respectiva contra la que no sea admisible recurso legal alguno</u>.</li>
</ul>
<p>&nbsp;</p>
<p>Lo anterior, en el entendido de que por consecuencia de los inconvenientes t&eacute;cnicos atribuibles &uacute;nicamente a Alt&aacute;n no atendidos o resueltos por parte de Alt&aacute;n se impute responsabilidad al Cliente mediante sentencia firme que no admita recurso legal alguno, y en donde se muestre entre la comunicaci&oacute;n de las Partes que los inconvenientes t&eacute;cnicos no fueron atendidos o resueltos por parte de Alt&aacute;n.</p>
<p>&nbsp;</p>
<ul>
<li>En el caso de que el Cliente elija la Opci&oacute;n A de la Tabla 1 del presente Acuerdo, Alt&aacute;n &uacute;nicamente responder&aacute; de los da&ntilde;os y perjuicios de acuerdo con lo anterior, siempre que adicionalmente a lo previsto en el numeral 11.2 precedente, se acredite en la sentencia respectiva que:</li>
</ul>
<p>&nbsp;</p>
<ol>
<li>El incumplimiento del Cliente que ocasion&oacute; la sanci&oacute;n haya sido atribuible de manera inmediata, directa y exclusivamente a Alt&aacute;n;</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>El incumplimiento de Alt&aacute;n para con el Cliente en la atenci&oacute;n espec&iacute;fica de los requerimientos de las Autoridades Facultadas y Designadas en materia de seguridad y justicia, se verifique siempre que los inconvenientes t&eacute;cnicos atribuibles &uacute;nicamente a Alt&aacute;n no fueron atendidos o resueltos por parte de Alt&aacute;n;</li>
</ol>
<p>&nbsp;</p>
<ul>
<li>El incumplimiento al presente Acuerdo no se debi&oacute;, directa o indirectamente, a un evento de Fuerza</li>
</ul>
<p>&nbsp;</p>
<p>En el caso de que el Cliente elija la Opci&oacute;n A, de la Tabla 1 del presente Acuerdo, la responsabilidad por parte de Alt&aacute;n para con el Cliente estar&aacute; siempre y en todo caso limitada a un monto equivalente al total de 3 (tres) contraprestaciones mensuales devengadas en favor de Alt&aacute;n conforme a lo calculado y dispuesto por la cl&aacute;usula 6.4 del Contrato.</p>
<p>&nbsp;</p>
<p>En el caso de que el Cliente elija la Opci&oacute;n A, de la Tabla 1 del presente Acuerdo, en ning&uacute;n caso Alt&aacute;n ser&aacute; responsable para con el Cliente por da&ntilde;os consecuenciales, punitivos, indirectos, da&ntilde;o moral, ni cualesquier otros distintos a los da&ntilde;os y perjuicios directamente relacionados y comprobados por el Cliente como consecuencia de un incumplimiento.</p>
<p>&nbsp;</p>
<ul>
<li>En caso de que una de las Partes as&iacute; lo requiera, las Partes deber&aacute;n reunirse para analizar la posibilidad de impugnar la sanci&oacute;n impuesta por la Autoridad Facultada o Designada. En caso de que las partes decidan que procede interponer alg&uacute;n medio de defensa, impugnaci&oacute;n o acci&oacute;n al respecto, el pago de la sanci&oacute;n quedar&aacute; suspendido hasta que se resuelva de manera firme e inapelable el medio de defensa, impugnaci&oacute;n o acci&oacute;n respectivo o hasta que las partes decidan que procede desistirse del mismo o transigir con la Lo anterior sin perjuicio del derecho de ambas partes para impugnar cualquier resoluci&oacute;n o acto de autoridad que afecte sus intereses, mismo que no quedar&aacute; limitado en caso alguno.</li>
</ul>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO SEGUNDA. Tarifas</u></h4>
<p><strong>&nbsp;</strong></p>
<p>En caso de que el Cliente utilice los servicios contemplados en el presente Ap&eacute;ndice, deber&aacute; pagar las tarifas enlistadas en el mismo, las cuales estar&aacute;n sujetas a la legislaci&oacute;n fiscal aplicable, causando el Impuesto al Valor Agregado (IVA), as&iacute; como cualquier otro impuesto que resulte aplicable, por la gesti&oacute;n de requerimientos de Colaboraci&oacute;n con la Seguridad y Justicia siguientes: <strong><em>(i) </em></strong>GL en tiempo real; <strong><em>(ii) </em></strong>GL por tiempo determinado; <strong><em>(iii) </em></strong>Entrega de DC, y; <strong><em>(iv) </em></strong>IL de las comunicaciones.</p>
<p>&nbsp;</p>
<p>Las tarifas por cada env&iacute;o de correo electr&oacute;nico al Cliente con la informaci&oacute;n solicitada a Alt&aacute;n (&ldquo;<strong>costo por evento</strong>&rdquo;) para dar contestaci&oacute;n al requerimiento de la Autoridad Facultada ser&aacute;n las que se indican a continuaci&oacute;n:</p>
<p>&nbsp;</p>
<ol>
<li>GL en tiempo El costo por evento ser&aacute; de $0.60 (sesenta centavos de peso M.N.), Impuesto al Valor Agregado (&ldquo;IVA&rdquo;) incluido.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>GL por un periodo de tiempo determinado. El costo por evento ser&aacute; de $0.88 (ochenta y ocho centavos de peso M.N.) IVA</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Entrega de datos conservados. El costo por evento ser&aacute; de $0.88 (ochenta y ocho centavos de peso M.N.) IVA</li>
</ol>
<p>&nbsp;</p>
<ol start="2">
<li>Intervenci&oacute;n de las comunicaciones. El costo por cada IL ser&aacute; de $ 2.00 (dos pesos M.N.) IVA</li>
</ol>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO TERCERA. Confidencialidad</u></h4>
<p><strong>&nbsp;</strong></p>
<p>Las Partes guardar&aacute;n estricta confidencialidad, respecto de la informaci&oacute;n que mutuamente se proporcionen o por aquella a la que tengan acceso con motivo de la ejecuci&oacute;n del presente Ap&eacute;ndice, debiendo asegurarse que la informaci&oacute;n que se proporcione por el personal que cada una designe, sea manejada bajo estricta confidencialidad.</p>
<p>&nbsp;</p>
<p>Las obligaciones contempladas en esta cl&aacute;usula permanecer&aacute;n vigentes y ser&aacute;n exigibles a&uacute;n en el caso de que las Partes dieran por terminado el presente Acuerdo, por un per&iacute;odo de 2 (dos) a&ntilde;os siguientes a su terminaci&oacute;n, en cumplimiento con la fracci&oacute;n II, del art&iacute;culo 190 de la LFTyR; y el sexto p&aacute;rrafo, del numeral 3, del considerando Quinto de los LCMSJ.</p>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO CUARTA. Causas de Terminaci&oacute;n Anticipada</u></h4>
<p><strong>&nbsp;</strong></p>
<p>El presente Ap&eacute;ndice podr&aacute; darse por terminado sin culpa por cualquiera de las Partes &uacute;nicamente bajo los siguientes supuestos:</p>
<p>&nbsp;</p>
<ol>
<li>En caso de destrucci&oacute;n total o parcial de la infraestructura que haga imposible la prestaci&oacute;n de los servicios del presente</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>La terminaci&oacute;n del presente Acuerdo por cualquiera de la Partes previa notificaci&oacute;n a la otra Parte por lo menos 30 (treinta) d&iacute;as</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>En caso de que el Cliente realice la portaci&oacute;n de la base total de sus usuarios para que utilicen los servicios en una red diferente a la de Alt&aacute;n.</li>
</ol>
<p>&nbsp;</p>
<ol>
<li>Que el Cliente cuente con la plataforma y/o software para dar contestaci&oacute;n a los requerimientos relacionados con las obligaciones en materia de seguridad y</li>
</ol>
<p>&nbsp;</p>
<h4><u>D&Eacute;CIMO QUINTA. Matriz de Escalamiento</u></h4>
<p><strong>&nbsp;</strong></p>
<p>En caso de que el Cliente no reciba en los plazos se&ntilde;alados en la Tabla 2 la informaci&oacute;n solicitada, el Cliente deber&aacute; atender la siguiente matriz:</p>
<p>&nbsp;</p>
<table class="table">
<tbody>
<tr>
<td width="246">
<p><strong>Nivel</strong></p>
</td>
<td width="142">
<p><strong>Contacto</strong></p>
</td>
<td width="135">
<p><strong>Plazo de Alt&aacute;n</strong></p>
</td>
</tr>
<tr>
<td width="246">
<p>Responsable Seguridad y Justicia</p>
</td>
<td width="142">
<p>(55) 8633 6166</p>
</td>
<td width="135">
<p>1 hora</p>
</td>
</tr>
<tr>
<td width="246">
<p>Director de Cuenta</p>
</td>
<td width="142">
<p>(729) 518 3107</p>
</td>
<td width="135">
<p>2 horas</p>
</td>
</tr>
<tr>
<td width="246">
<p>Director Comercial</p>
</td>
<td width="142">
<p>(55) 2601 3977</p>
</td>
<td width="135">
<p>3 horas</p>
</td>
</tr>
<tr>
<td width="246">
<p>Director General</p>
</td>
<td width="142">
<p>(55) 2601 3951</p>
</td>
<td width="135">
<p>5 horas</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p>[EL RESTO DE LA P&Aacute;GINA HA SIDO INTENCIONALMENTE DEJADO EN BLANCO; SIGUE P&Aacute;GINA DE FIRMAS]</p>
<p>&nbsp;</p>
<p>En prueba de conformidad y enteradas de su contenido y alcance&nbsp; legal,&nbsp; las&nbsp; Partes firman por triplicado el presente Ap&eacute;ndice, en la Ciudad de M&eacute;xico, el d&iacute;a 7 de diciembre de 2021.</p>
<p>&nbsp;</p>
<p>ALT&Aacute;N</p>
<h4>ALT&Aacute;N REDES, S.A.P.I. DE C.V.</h4>
<p>&nbsp;</p>
<p>CLIENTE</p>
<h4>ELUX MOBILE DE M&Eacute;XICO, S.A. DE C.V.</h4>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Gabriel Cejudo Funes</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>Nombre: </strong>Miguel Adri&aacute;n &Aacute;lvarez Manzo</p>
<p><strong>Cargo: </strong>Representante Legal</p>
<p>&nbsp;</p>
<p><strong>FORMATO DE COADYUVANCIA</strong></p>
<p><strong>&nbsp;</strong></p>
<table class="table">
<tbody>
<tr>
<td width="604">
<p><strong>Denominaci&oacute;n o Raz&oacute;n social del Cliente:</strong></p>
<p><strong><u>&nbsp;</u></strong><strong><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong><strong>_<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>_<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>1. Declaro bajo protesta de decir verdad que se ha realizado la validaci&oacute;n de las competencias y facultades de la Autoridad y del Oficio; y que el mismo se encuentra debidamente fundado</strong></p>
<p><strong>y motivado, mismo que se ha emitido por una Autoridad en ejercicio de sus funciones de investigaci&oacute;n de delitos y en su esfera de competencia.</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>2. Se&ntilde;ale el tipo de obligaci&oacute;n en materia de seguridad </strong>Localizaci&oacute;n geogr&aacute;fica de los equipos terminales. Entrega de datos conservados.</p>
<p>Intervenci&oacute;n de comunicaciones.</p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>3. N&uacute;mero(s) telef&oacute;nico(s) a diez d&iacute;gitos objeto del Oficio o IMEI (&uacute;nicamente aplica para entrega de datos conservados)<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>_<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>4. Fecha [<u> &nbsp;&nbsp;&nbsp;&nbsp; /&nbsp;&nbsp;&nbsp; </u>_/<u>&nbsp;&nbsp; </u>&nbsp;_]&nbsp; y&nbsp; hora [<u>&nbsp; &nbsp;/&nbsp;&nbsp;&nbsp; </u>] de recepci&oacute;n del Oficio y fecha [<u>&nbsp; </u>&nbsp;_/<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; /&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>] y hora [<u>&nbsp; &nbsp;/&nbsp;&nbsp;&nbsp; </u>] de env&iacute;o del Oficio por parte del Cliente a Alt&aacute;n.</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>5. Descripci&oacute;n del Oficio</strong></p>
<p><strong>N&uacute;mero&nbsp; del Oficio: ___________________________________________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>Autoridad: nombre<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>y cargo &nbsp;<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>&nbsp;Fecha y hora del Oficio [_ /_ /_ ]</strong></p>
<p><strong>Delito: _______________________________________________________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>AP / Carpeta de Investigaci&oacute;n __________________________________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>6.&nbsp;&nbsp;&nbsp; </strong><strong>Periodo a intervenir (Orden de Intervenci&oacute;n) / monitorear (geolocalizaci&oacute;n) o periodo de b&uacute;squeda (entrega de datos conservados):</strong></p>
<p><strong>Fecha del [<u> &nbsp;&nbsp;&nbsp;&nbsp; /&nbsp;&nbsp;&nbsp; </u>_/<u>&nbsp;&nbsp;&nbsp; </u>_] y hora [<u>&nbsp; &nbsp;/&nbsp;&nbsp;&nbsp; </u>] hasta [<u>&nbsp;&nbsp;&nbsp; </u>_/<u>&nbsp;&nbsp;&nbsp; </u>_/<u>&nbsp;&nbsp;&nbsp; </u>_] y hora [<u>&nbsp; &nbsp;/&nbsp;&nbsp;&nbsp; </u>].</strong></p>
<p><strong>6.1&nbsp;&nbsp;&nbsp; </strong><strong>En caso de ser Orden de Intervenci&oacute;n Legal:</strong></p>
<p><strong>N&uacute;mero de Orden de Intervenci&oacute;n Legal _________________________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>Autoridad: Nombre<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>__ y Cargo _____________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>N&uacute;mero(s) telef&oacute;nico(s) a diez d&iacute;gitos objeto del Oficio ____________________ <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p><strong>En caso de presentarse una ampliaci&oacute;n del plazo concedido por la Autoridad Facultada se&ntilde;alar el Oficio/Orden origen de la Intervenci&oacute;n: _<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>_</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>Mediante este Formato de Coadyuvancia, el Cliente solicita los servicios seleccionados en el numeral 2 del presente, quedando enterado de los alcances, responsabilidades y tarifas de los mismos, en t&eacute;rminos del Ap&eacute;ndice 7.7 &ldquo;Alcance de Prestaci&oacute;n de Servicios de Coadyuvancia para la Colaboraci&oacute;n con las Instancias de Seguridad, Procuraci&oacute;n y</strong></p>
<p><strong>Administraci&oacute;n de Justicia&rdquo;.</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>Bajo protesta de decir verdad, declaro que toda la informaci&oacute;n se&ntilde;alada en el presente Formato de Coadyuvancia es copia fiel del contenido del requerimiento judicial y el Cliente declara que ser&aacute; el &uacute;nico responsable de validar las competencias y facultades de la Autoridad y del requerimiento, por lo cual libera a Alt&aacute;n de cualquier responsabilidad que se genere en la atenci&oacute;n del mismo.</strong></p>
</td>
</tr>
<tr>
<td width="604">
<p><strong>&nbsp;</strong></p>
<p><strong>CLIENTE</strong></p>
<p><strong><u>&nbsp;</u></strong><strong><u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong><strong>_<u> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u></strong></p>
<p>Nombre: Apoderado:</p>
</td>
</tr>
</tbody>
</table>
<p>&nbsp;</p>
<p><strong>&nbsp;</strong></p>
<p>ANEXO 11</p>
<p>&nbsp;</p>
<p>MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO</p>
<p>&nbsp;</p>
<p>El presente documento es el Anexo 11 &ldquo;Servicios MOVILIDAD SIM ALT&Aacute;N: GRANEL Y PRODUCTOS EMPAQUETADOS CON MARGEN PORCENTUAL FIJO &rdquo; al que se refiere</p>
<p>El Contrato Marco de&nbsp; Prestaci&oacute;n&nbsp; de&nbsp; Servicios&nbsp; de&nbsp; Telecomunicaciones&nbsp; (junto&nbsp; con&nbsp; sus Anexos y Ap&eacute;ndices, el &ldquo;<strong>Contrato</strong>&rdquo;) celebrado entre las Partes el 7 de diciembre de 2021. Los t&eacute;rminos con inicial may&uacute;scula que&nbsp; se&nbsp; utilizan&nbsp; en&nbsp; el&nbsp; presente&nbsp; Anexo&nbsp; tienen el significado que se les atribuye en el Contrato o en el propio Anexo, seg&uacute;n corresponda. Para la interpretaci&oacute;n del presente Anexo, las Partes se sujetar&aacute;n a lo estipulado en la Cl&aacute;usula 1.4 del Contrato.</p>

  </div>
</template>

<script>
export default {
}
</script>
